webpackJsonp([2],{

/***/ "+/ZX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("hWpz");

var _GoogleAuthComponent = __webpack_require__("ZGnZ");

var _GoogleAuthComponent2 = _interopRequireDefault(_GoogleAuthComponent);

var _FacebookAuthComponent = __webpack_require__("I71r");

var _FacebookAuthComponent2 = _interopRequireDefault(_FacebookAuthComponent);

var _ExpediaAuthComponent = __webpack_require__("T/3Q");

var _ExpediaAuthComponent2 = _interopRequireDefault(_ExpediaAuthComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SocialLoginComponent = function (_Component) {
    _inherits(SocialLoginComponent, _Component);

    function SocialLoginComponent(props) {
        _classCallCheck(this, SocialLoginComponent);

        var _this = _possibleConstructorReturn(this, (SocialLoginComponent.__proto__ || Object.getPrototypeOf(SocialLoginComponent)).call(this, props));

        _this.state = {
            emailAddress: _this.props.emailAddress,
            loggedIn: false,
            error: '',
            googleToken: null,
            facebookToken: null
        };
        _this.displayExpediaAuthComponent = _this.displayExpediaAuthComponent.bind(_this);
        return _this;
    }

    _createClass(SocialLoginComponent, [{
        key: 'displayExpediaAuthComponent',
        value: function displayExpediaAuthComponent() {
            if (this.props.expediaIconDisplayed === true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'SocialLoginIcons__icon' },
                    _react2.default.createElement(_ExpediaAuthComponent2.default, {
                        actionLocation: this.props.actionLocation,
                        enableLoading: this.props.enableLoading,
                        disableLoading: this.props.disableLoading,
                        lingua: this.props.lingua,
                        handleError: this.props.handleError,
                        onClose: this.props.onClose,
                        handleLoginSuccess: this.props.handleLoginSuccess,
                        updatePage: this.props.updatePage,
                        setAuthJson: this.props.setAuthJson,
                        performBulkPageUpdate: this.props.performBulkPageUpdate,
                        site: this.props.site,
                        useNewEndpoints: this.props.useNewEndpoints,
                        emailAddress: this.state.emailAddress,
                        expediaIconDisplayed: this.props.expediaIconDisplayed
                    })
                );
            }
            return _react2.default.createElement('div', null);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    { className: 'SocialLoginComponent text-center' },
                    ' ',
                    this.props.lingua.read('lex.social.or.text'),
                    ' ',
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        'SocialLoginComponent'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'SocialLoginIcons' },
                    this.displayExpediaAuthComponent(),
                    _react2.default.createElement(
                        'div',
                        { className: 'SocialLoginIcons__icon' },
                        _react2.default.createElement(_GoogleAuthComponent2.default, {
                            actionLocation: this.props.actionLocation,
                            enableLoading: this.props.enableLoading,
                            disableLoading: this.props.disableLoading,
                            lingua: this.props.lingua,
                            handleError: this.props.handleError,
                            onClose: this.props.onClose,
                            handleLoginSuccess: this.props.handleLoginSuccess,
                            updatePage: this.props.updatePage,
                            setAuthJson: this.props.setAuthJson,
                            performBulkPageUpdate: this.props.performBulkPageUpdate,
                            site: this.props.site,
                            useNewEndpoints: this.props.useNewEndpoints,
                            emailAddress: this.state.emailAddress,
                            expediaIconDisplayed: this.props.expediaIconDisplayed
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'SocialLoginIcons__icon' },
                        _react2.default.createElement(_FacebookAuthComponent2.default, {
                            actionLocation: this.props.actionLocation,
                            enableLoading: this.props.enableLoading,
                            disableLoading: this.props.disableLoading,
                            lingua: this.props.lingua,
                            handleError: this.props.handleError,
                            locale: this.props.locale,
                            onClose: this.props.onClose,
                            handleLoginSuccess: this.props.handleLoginSuccess,
                            updatePage: this.props.updatePage,
                            setAuthJson: this.props.setAuthJson,
                            performBulkPageUpdate: this.props.performBulkPageUpdate,
                            site: this.props.site,
                            useNewEndpoints: this.props.useNewEndpoints,
                            emailAddress: this.state.emailAddress,
                            expediaIconDisplayed: this.props.expediaIconDisplayed
                        })
                    )
                )
            );
        }
    }]);

    return SocialLoginComponent;
}(_react.Component);

exports.default = SocialLoginComponent;
//# sourceMappingURL=SocialLoginComponent.js.map

/***/ }),

/***/ "+C4P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUESTION__16 = void 0;
var QUESTION__16 = '<svg data-id="SVG_QUESTION__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke="none" fill="currentColor" d="M8.8 11.6a.8.8 0 1 1-1.5 0 .8.8 0 0 1 1.5 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8z"/><path stroke-linecap="round" stroke-linejoin="round" d="M6 6a2 2 0 1 1 2.7 2c-.4 0-.7.5-.7 1v.2"/></g></svg>';
exports.QUESTION__16 = QUESTION__16;

/***/ }),

/***/ "+ac8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("kaHf");

var _ResetPasswordComponent = __webpack_require__("r9xh");

var _ResetPasswordComponent2 = _interopRequireDefault(_ResetPasswordComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResetPasswordPageComponent = function (_Component) {
    _inherits(ResetPasswordPageComponent, _Component);

    function ResetPasswordPageComponent() {
        _classCallCheck(this, ResetPasswordPageComponent);

        return _possibleConstructorReturn(this, (ResetPasswordPageComponent.__proto__ || Object.getPrototypeOf(ResetPasswordPageComponent)).apply(this, arguments));
    }

    _createClass(ResetPasswordPageComponent, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'border-border-color' },
                _react2.default.createElement(_ResetPasswordComponent2.default, { lingua: this.props.lingua, updatePage: this.props.updatePage })
            );
        }
    }]);

    return ResetPasswordPageComponent;
}(_react.Component);

exports.default = ResetPasswordPageComponent;
//# sourceMappingURL=ResetPasswordPageComponent.js.map

/***/ }),

/***/ "+iKg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/3uU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDropdown = __webpack_require__("CVj+");

var _edap = __webpack_require__("6kQN");

var _edap2 = _interopRequireDefault(_edap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguageSelector = function (_Component) {
    _inherits(LanguageSelector, _Component);

    /* istanbul ignore next */
    function LanguageSelector(props) {
        _classCallCheck(this, LanguageSelector);

        var _this = _possibleConstructorReturn(this, (LanguageSelector.__proto__ || Object.getPrototypeOf(LanguageSelector)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    _createClass(LanguageSelector, [{
        key: 'handleChange',
        value: function handleChange(event, languageCode) {
            event.preventDefault();
            this.getLanguageNameByCode(languageCode);

            this.props.onChange(languageCode);
        }
    }, {
        key: 'handleDropdownShow',
        value: function handleDropdownShow() {
            (0, _edap2.default)({
                eventaction: 'display language dropdown clicked'
            });
        }
    }, {
        key: 'getLanguageNameByCode',
        value: function getLanguageNameByCode(languageCode) {
            var currentLanguage = this.props.languages.filter(function (language) {
                return language.languageCode === languageCode;
            })[0];
            this.languageName = currentLanguage ? currentLanguage.languageName : '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            this.getLanguageNameByCode(this.props.languageCode);
            var _props = this.props,
                title = _props.title,
                languages = _props.languages;

            return _react2.default.createElement(
                'div',
                { className: 'preference-selector preference-selector--language form-group' },
                _react2.default.createElement(
                    'div',
                    { className: 'preference-selector__title' },
                    title
                ),
                _react2.default.createElement(
                    _reactDropdown.Dropdown,
                    {
                        srOnlyLabel: true,
                        label: 'Language Selector',
                        buttonChildren: _react2.default.createElement(
                            'span',
                            { className: 'preference-selector__selected-option' },
                            this.languageName
                        ),
                        id: 'language-selector',
                        name: 'language-selector',
                        onDropdownShow: this.handleDropdownShow
                    },
                    languages.map(function (language) {
                        return _react2.default.createElement(_reactDropdown.DropdownItem, {
                            link: '#',
                            text: language.languageName,
                            key: language.languageCode,
                            onClick: function onClick(event) {
                                return _this2.handleChange(event, language.languageCode);
                            } // eslint-disable-line react/jsx-no-bind
                        });
                    })
                )
            );
        }
    }]);

    return LanguageSelector;
}(_react.Component);

LanguageSelector.propTypes = {
    title: _propTypes2.default.string,
    languageCode: _propTypes2.default.string,
    languages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        languageCode: _propTypes2.default.string,
        languageName: _propTypes2.default.string
    })),
    onChange: _propTypes2.default.func
};
LanguageSelector.defaultProps = {
    title: 'Language',
    languageCode: 'en_US',
    languages: [],
    onChange: function onChange() {} };
exports.default = LanguageSelector;
//# sourceMappingURL=LanguageSelector.js.map

/***/ }),

/***/ "/Tvs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/roH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/s9T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("I+n6");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TandCComponent = function (_Component) {
    _inherits(TandCComponent, _Component);

    function TandCComponent(props) {
        _classCallCheck(this, TandCComponent);

        return _possibleConstructorReturn(this, (TandCComponent.__proto__ || Object.getPrototypeOf(TandCComponent)).call(this, props));
    }

    _createClass(TandCComponent, [{
        key: 'render',
        value: function render() {
            var text = this.props.multiUserEnabled ? '' + this.props.lingua.read('copyright') : this.props.lingua.read('facebook.promise') + ' ' + this.props.lingua.read('copyright');
            return _react2.default.createElement(
                'div',
                { className: 'TandCComponent text-center col-xs-12' },
                _react2.default.createElement('label', { dangerouslySetInnerHTML: { __html: text } })
            );
        }
    }]);

    return TandCComponent;
}(_react.Component);

exports.default = TandCComponent;
//# sourceMappingURL=TandCComponent.js.map

/***/ }),

/***/ "/vpO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("GiK3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/react-transition-group/Transition.js
var Transition = __webpack_require__("TAxY");
var Transition_default = /*#__PURE__*/__webpack_require__.n(Transition);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-loading-overlay/lib/esm/LoadingOverlay.css
var esm_LoadingOverlay = __webpack_require__("fXoq");
var LoadingOverlay_default = /*#__PURE__*/__webpack_require__.n(esm_LoadingOverlay);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-loading-overlay/lib/esm/LoadingOverlay.js
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }







var LoadingOverlay_LoadingOverlay =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(LoadingOverlay, _Component);

  function LoadingOverlay() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleExit = function () {
      if (_this.props.onLoadingStop) {
        _this.props.onLoadingStop();
      }
    };

    _this.renderOverlay = function (state) {
      if (state === 'exited') {
        return false;
      }

      var transitionStyles = {
        entered: {
          'in': true
        }
      };
      var loadingClasses = classnames_default()('LoadingOverlay', 'fade', transitionStyles[state]);
      return react_default.a.createElement("div", {
        role: "status",
        className: loadingClasses
      }, react_default.a.createElement("ul", {
        "aria-hidden": true,
        className: "LoadingOverlay__ul"
      }, react_default.a.createElement("li", {
        className: "LoadingOverlay__li LoadingOverlay__li--1 bg-brand"
      }), react_default.a.createElement("li", {
        className: "LoadingOverlay__li LoadingOverlay__li--2 bg-brand"
      }), react_default.a.createElement("li", {
        className: "LoadingOverlay__li LoadingOverlay__li--3 bg-brand"
      }), react_default.a.createElement("li", {
        className: "LoadingOverlay__li LoadingOverlay__li--4 bg-brand"
      })));
    };

    return _this;
  }

  var _proto = LoadingOverlay.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        loading = _this$props.loading,
        transition = _this$props.transition,
        transitionAppear = _this$props.transitionAppear;
    return react_default.a.createElement(Transition_default.a, {
      appear: transitionAppear && transition,
      in: loading,
      timeout: 500,
      onExited: this.handleExit,
      enter: transition,
      exit: transition,
      unmountOnExit: true
    }, function (state) {
      return _this2.renderOverlay(state);
    });
  };

  return LoadingOverlay;
}(react["Component"]);

LoadingOverlay_LoadingOverlay.propTypes = {
  /** Flag for displaying LoadingOverlay.  */
  loading: prop_types_default.a.bool,

  /** Optional event handler to fire after a LoadingOverlay has been dismissed */
  onLoadingStop: prop_types_default.a.func,

  /** Flag for enabling transitions */
  transition: prop_types_default.a.bool,

  /** Option Flag for enabling transitions when the component appears */
  transitionAppear: prop_types_default.a.bool
};
LoadingOverlay_LoadingOverlay.defaultProps = {
  transition: true,
  transitionAppear: true,
  loading: true
};
/* harmony default export */ var lib_esm_LoadingOverlay = (LoadingOverlay_LoadingOverlay);
//# sourceMappingURL=LoadingOverlay.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-loading-overlay/lib/esm/LoadingOverlayWrapper.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function LoadingOverlayWrapper__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





function LoadingOverlayWrapper(ComposedComponent) {
  return (
    /*#__PURE__*/
    function (_Component) {
      LoadingOverlayWrapper__inheritsLoose(_class, _Component);

      function _class() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = _class.prototype;

      _proto.render = function render() {
        var _this$props = this.props,
            loading = _this$props.loading,
            className = _this$props.className,
            rest = _objectWithoutProperties(_this$props, ["loading", "className"]);

        var status = loading ? 'status' : '';
        var composeComponentClasses = classnames_default()({
          'position-relative': loading
        }, className);
        return react_default.a.createElement(ComposedComponent, _extends({
          className: composeComponentClasses,
          role: status,
          "aria-hidden": loading
        }, rest), react_default.a.createElement(lib_esm_LoadingOverlay, {
          loading: loading
        }));
      };

      return _class;
    }(react["Component"])
  );
}

/* harmony default export */ var esm_LoadingOverlayWrapper = (LoadingOverlayWrapper);
//# sourceMappingURL=LoadingOverlayWrapper.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-loading-overlay/lib/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LoadingOverlay", function() { return lib_esm_LoadingOverlay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LoadingOverlayWrapper", function() { return esm_LoadingOverlayWrapper; });



//# sourceMappingURL=index.js.map

/***/ }),

/***/ "0NKa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GEAR__16 = void 0;
var GEAR__16 = '<svg data-id="SVG_GEAR__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M9.3 14.2l-.1.8H6.8l-.1-.8a1.3 1.3 0 0 0-2.1-.9l-.7.5-1.7-1.7.5-.7a1.3 1.3 0 0 0-.9-2L1 9.1V6.8l.8-.1a1.3 1.3 0 0 0 .9-2.1l-.5-.7 1.7-1.7.7.5a1.3 1.3 0 0 0 2-.9l.2-.8h2.4l.1.8a1.3 1.3 0 0 0 2.1.9l.7-.5 1.7 1.7-.5.7a1.3 1.3 0 0 0 .9 2l.8.2v2.4l-.8.1a1.3 1.3 0 0 0-.9 2.1l.5.7-1.7 1.7-.7-.5"/><path d="M5.5 8a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0z"/></g></svg>';
exports.GEAR__16 = GEAR__16;

/***/ }),

/***/ "0pa/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1gbD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SVGDefinitions =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(SVGDefinitions, _Component);

  function SVGDefinitions() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SVGDefinitions.prototype;

  _proto.joinDefinitions = function joinDefinitions() {
    var svgs = this.props.data.svgs;
    var definitions = '';

    for (var def in svgs) {
      if (svgs.hasOwnProperty(def)) {
        definitions += svgs[def];
      }
    }

    return {
      __html: definitions
    };
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
      width: "0",
      height: "0",
      style: {
        'display': 'none'
      },
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, !this.props.data.loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs", {
      dangerouslySetInnerHTML: this.joinDefinitions()
    }) // eslint-disable-line react/no-danger
    , __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs", null, this.props.children));
  };

  return SVGDefinitions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SVGDefinitions.propTypes = {
  /** GraphQL Data for SVG Definitions */
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    svgs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
  }).isRequired
};
SVGDefinitions.defaultProps = {
  data: {
    svgs: {}
  }
};
/* harmony default export */ __webpack_exports__["default"] = (SVGDefinitions);
//# sourceMappingURL=SVGDefinitions.js.map

/***/ }),

/***/ "1olO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__("GiK3");

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),

/***/ "1whP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Nav = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Flags = __webpack_require__("QDAn");

var _Help = __webpack_require__("4gma");

var _Inbox = __webpack_require__("P0Ca");

var _Login = __webpack_require__("bzaB");

var _Scratchpad = __webpack_require__("g3iV");

var _Traveler = __webpack_require__("zYMv");

var _urlSearchParams = __webpack_require__("5mUy");

var _urlSearchParams2 = _interopRequireDefault(_urlSearchParams);

var _reactGlobalizationSelector = __webpack_require__("f6Le");

var _reactGlobalizationSelector2 = _interopRequireDefault(_reactGlobalizationSelector);

__webpack_require__("kyi2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Nav = exports.Nav = (_temp2 = _class = function (_React$Component) {
    _inherits(Nav, _React$Component);

    function Nav() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Nav);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Nav.__proto__ || Object.getPrototypeOf(Nav)).call.apply(_ref, [this].concat(args))), _this), _this.handleChangeGlobalSelector = function (locale, siteUrl, currency) {
            var countryCode = locale.split('_')[1].toLowerCase();
            var origin = void 0;
            var params = void 0;

            if (window && window.location) {
                if (countryCode === _this.props.countryCode) {
                    origin = window.location.protocol + '//' + window.location.host + window.location.pathname;
                    params = new _urlSearchParams2.default(window.location.search);
                } else {
                    origin = siteUrl.replace(/\/$/, '');
                    params = new _urlSearchParams2.default();
                }

                params.set('gx-locale', locale);
                params.set('gx-currency', currency);

                window.location.assign(origin + '?' + params.toString());
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Nav, [{
        key: 'renderGlobalSelector',
        value: function renderGlobalSelector() {
            if (!this.props.renderCountryLanguageSelector && !this.props.renderCurrencySelector) {
                return null;
            }

            return _react2.default.createElement(_reactGlobalizationSelector2.default, _extends({
                className: 'site-header-nav__dropdown'
            }, this.props.globalizationSelector, {
                countryCode: this.props.countryCode,
                currencyCode: this.props.currencyCode,
                languageCode: this.props.languageCode,
                onGlobalSelectorChange: this.handleChangeGlobalSelector,
                renderCountryLanguageSelector: this.props.renderCountryLanguageSelector,
                renderCurrencySelector: this.props.renderCurrencySelector
            }));
        }
    }, {
        key: 'renderExtraNav',
        value: function renderExtraNav() {
            if (!this.props.extraNav) {
                return null;
            }

            if (!this.props.extraNav.items) {
                return null;
            }

            return this.props.extraNav.items.map(function (item, index) {
                return _react2.default.createElement(
                    'a',
                    {
                        className: 'site-header-nav__link ' + item.cssClass,
                        'data-bypass': 'true',
                        href: item.link,
                        key: index
                    },
                    item.text
                );
            });
        }
    }, {
        key: 'renderFlags',
        value: function renderFlags() {
            if (!this.props.flags) {
                return null;
            }

            return _react2.default.createElement(_Flags.Flags, this.props.flags);
        }
    }, {
        key: 'renderHelp',
        value: function renderHelp() {
            if (!this.props.help) {
                return null;
            }

            return _react2.default.createElement(_Help.Help, _extends({}, this.props.help, { openLinksInNewWindow: this.props.openLinksInNewWindow }));
        }
    }, {
        key: 'renderInbox',
        value: function renderInbox() {
            if (!this.props.traveler || !this.props.inbox) {
                return null;
            }

            return _react2.default.createElement(
                'a',
                { className: 'site-header-nav__link', 'data-bypass': 'true', href: this.props.inbox.link },
                _react2.default.createElement(_Inbox.Inbox, this.props.inbox)
            );
        }
    }, {
        key: 'renderInternalTools',
        value: function renderInternalTools() {
            if (!this.props.internalTools) {
                return null;
            }

            return this.props.internalTools;
        }
    }, {
        key: 'renderLogin',
        value: function renderLogin() {
            if (!this.props.login) {
                return null;
            }

            return _react2.default.createElement(_Login.Login, this.props.login);
        }
    }, {
        key: 'renderScratchpad',
        value: function renderScratchpad() {
            if (!this.props.scratchpad) {
                return null;
            }

            return _react2.default.createElement(
                'a',
                { className: 'site-header-nav__link', 'data-bypass': 'true', href: this.props.scratchpad.link },
                _react2.default.createElement(_Scratchpad.Scratchpad, this.props.scratchpad)
            );
        }
    }, {
        key: 'renderTraveler',
        value: function renderTraveler() {
            if (!this.props.traveler) {
                return null;
            }

            return _react2.default.createElement(_Traveler.Traveler, this.props.traveler);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'site-header-nav', role: 'navigation' },
                this.renderScratchpad(),
                this.renderInbox(),
                this.renderLogin(),
                this.renderTraveler(),
                this.renderHelp(),
                this.renderExtraNav(),
                this.renderInternalTools(),
                this.props.feedbackComponent,
                this.renderFlags(),
                this.renderGlobalSelector()
            );
        }
    }]);

    return Nav;
}(_react2.default.Component), _class.propTypes = {
    openLinksInNewWindow: _propTypes2.default.bool
}, _temp2);
//# sourceMappingURL=Nav.js.map

/***/ }),

/***/ "29Zd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _knotty = __webpack_require__("6q9T");

var _knotty2 = _interopRequireDefault(_knotty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var knottyLogger = void 0;

var ClientLogger = function () {
    function ClientLogger() {
        _classCallCheck(this, ClientLogger);
    }

    _createClass(ClientLogger, null, [{
        key: 'initialize',
        value: function initialize(options) {
            knottyLogger = (0, _knotty2.default)(options);
        }
    }, {
        key: 'logInfo',
        value: function logInfo(msg) {
            return knottyLogger.logInfo(msg);
        }
    }, {
        key: 'logError',
        value: function logError(msg) {
            return knottyLogger.logError(msg);
        }
    }, {
        key: 'logException',
        value: function logException(msg) {
            return knottyLogger.logException(msg);
        }
    }]);

    return ClientLogger;
}();

exports.default = ClientLogger;
//# sourceMappingURL=clientLogger.js.map

/***/ }),

/***/ "2YJb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FlagsMenu = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var React = _interopRequireWildcard(_react);

var _reactSvg = __webpack_require__("CWk1");

var _CHEVRON_LEFT__ = __webpack_require__("ZULV");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlagsMenu = exports.FlagsMenu = function (_React$Component) {
    _inherits(FlagsMenu, _React$Component);

    function FlagsMenu() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FlagsMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FlagsMenu.__proto__ || Object.getPrototypeOf(FlagsMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickBack = function () {
            _this.props.setActiveMenu('tray');
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FlagsMenu, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: 'site-header-tray__menu' },
                React.createElement(
                    'div',
                    { className: 'site-header-tray__menu-header' },
                    React.createElement(
                        'span',
                        {
                            className: 'site-header-tray__menu-back',
                            onClick: this.handleClickBack,
                            onKeyPress: this.handleClickBack,
                            role: 'button',
                            tabIndex: 0
                        },
                        React.createElement(_reactSvg.SVGIcon, { markup: _CHEVRON_LEFT__.CHEVRON_LEFT__12 }),
                        ' ',
                        this.props.flags.back
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'site-header-tray__menu-items' },
                    this.props.flags.items.map(function (item) {
                        return React.createElement(
                            'a',
                            { className: 'site-header-tray__menu-item-link site-header-tray__menu-item-link--flag ' + item.countryCode, 'data-bypass': 'true', href: item.link, key: item.countryCode + '-' + item.link },
                            React.createElement('i', { 'aria-hidden': 'true', className: 'site-header-tray__menu-item-icon flag-' + item.countryCode }),
                            React.createElement(
                                'span',
                                { className: 'site-header-tray__menu-item-text' },
                                item.text
                            )
                        );
                    })
                )
            );
        }
    }]);

    return FlagsMenu;
}(React.Component);
//# sourceMappingURL=FlagsMenu.js.map

/***/ }),

/***/ "3IRH":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "4/3X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ "41N5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SiteHeaderConnector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SiteHeader = __webpack_require__("CtGM");

var _SiteHeader2 = _interopRequireDefault(_SiteHeader);

var _urlSearchParams = __webpack_require__("5mUy");

var _urlSearchParams2 = _interopRequireDefault(_urlSearchParams);

__webpack_require__("h8D/");

var _lodash = __webpack_require__("y3TV");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SiteHeaderConnector = exports.SiteHeaderConnector = (_temp = _class = function (_React$Component) {
    _inherits(SiteHeaderConnector, _React$Component);

    function SiteHeaderConnector(props) {
        _classCallCheck(this, SiteHeaderConnector);

        var _this = _possibleConstructorReturn(this, (SiteHeaderConnector.__proto__ || Object.getPrototypeOf(SiteHeaderConnector)).call(this, props));

        _this.state = _extends({}, props.data);
        return _this;
    }

    _createClass(SiteHeaderConnector, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.fetchUserData) {
                this.getUserData();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            if (this.props.fetchUserData !== props.fetchUserData && props.fetchUserData) {
                this.getUserData(props);
            }
        }
    }, {
        key: 'formatDataUrl',
        value: function formatDataUrl(dataUrl) {
            dataUrl = dataUrl.startsWith('/') ? dataUrl : '/' + dataUrl;
            dataUrl = dataUrl.endsWith('/') ? dataUrl : dataUrl + '/';

            return dataUrl;
        }
    }, {
        key: 'getUserData',
        value: function getUserData() {
            var _this2 = this;

            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            var dataUrl = this.formatDataUrl(props.dataUrl);
            var url = '' + dataUrl + props.bceHeaderUrl;
            var params = new _urlSearchParams2.default();

            params.append('site', props.siteName);

            /* istanbul ignore else */
            if (props.fullLocale) {
                params.append('locale', props.fullLocale);
            }

            /* istanbul ignore else */
            if (props.isInverse) {
                params.append('feature', 'theme-inverse');
            }

            /* istanbul ignore else */
            if ((0, _lodash2.default)(window, '__ABACUS__.HA_GX_COUNTRY_LANGUAGE_SELECTOR.value') >= 1 || (0, _lodash2.default)(window, '__ABACUS__.HA_GX_COUNTRY_LANGUAGE_SELECTOR_NL.value') === 1) {
                params.append('feature', 'country-language-selector');
            }

            var currencySelectorVariant = (0, _lodash2.default)(window, '__ABACUS__.HA_GX_CURRENCY_SELECTOR.value');
            /* istanbul ignore else */
            if (currencySelectorVariant === 1) {
                params.append('feature', 'currency-selector');
            } else if (currencySelectorVariant === 2) {
                params.append('feature', 'currency-selector2');
            }

            var request = new Request(url + '?' + params, {
                credentials: 'same-origin'
            });

            // eslint-disable-next-line complexity
            return fetch(request).then(function (response) {
                return response.json();
            }).then(function (response) {
                var data = response && response.header;

                if (data) {
                    if (data.traveler || data.owner) {
                        data.login = false;
                    }

                    if (!data.flags) {
                        data.flags = null;
                    }

                    if (!data.globalizationSelector) {
                        data.globalizationSelector = null;
                    }
                    _this2.setState(data);
                }
            }).catch( /* istanbul ignore next */function (error) {
                console.log(error); // eslint-disable-line no-console
            });
        }
    }, {
        key: 'render',
        value: function render() {
            /**
             * @type {any} siteHeaderProps
             */
            var _props = this.props,
                children = _props.children,
                siteHeaderProps = _objectWithoutProperties(_props, ['children']);

            delete siteHeaderProps.data;
            delete siteHeaderProps.dataUrl;
            delete siteHeaderProps.fetchUserData;

            return _react2.default.createElement(
                _SiteHeader2.default,
                _extends({}, siteHeaderProps, this.state),
                children
            );
        }
    }]);

    return SiteHeaderConnector;
}(_react2.default.Component), _class.propTypes = {
    bceHeaderUrl: _propTypes2.default.string,
    currencyCode: _propTypes2.default.string,
    dataUrl: _propTypes2.default.string,
    displayTrayJewel: _propTypes2.default.bool,
    fetchUserData: _propTypes2.default.bool,
    fullLocale: _propTypes2.default.string,
    isInverse: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool,
    logoutRedirectUrl: _propTypes2.default.string,
    mobileBreakpoint: _propTypes2.default.number,
    openLinksInNewWindow: _propTypes2.default.bool,
    siteName: _propTypes2.default.string,
    withoutCountryLanguageSelector: _propTypes2.default.bool,
    withoutCurrencySelector: _propTypes2.default.bool,
    withoutFlags: _propTypes2.default.bool,
    withoutHelpLinks: _propTypes2.default.bool,
    withoutInbox: _propTypes2.default.bool,
    withoutListYourProperty: _propTypes2.default.bool,
    withoutLogin: _propTypes2.default.bool,
    withoutScratchpad: _propTypes2.default.bool,
    withoutSearch: _propTypes2.default.bool,
    withoutTraveler: _propTypes2.default.bool
}, _class.defaultProps = {
    bceHeaderUrl: 'bceHeader',
    currencyCode: 'JPY',
    dataUrl: '/api/header',
    displayTrayJewel: false,
    fetchUserData: true,
    fullLocale: 'en_US_HA',
    isMobile: false,
    mobileBreakpoint: 991,
    siteName: 'homeaway_us'
}, _temp);
//# sourceMappingURL=SiteHeaderConnector.js.map

/***/ }),

/***/ "4JXe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__("KSGD"));

var _addClass = _interopRequireDefault(__webpack_require__("8+5l"));

var _removeClass = _interopRequireDefault(__webpack_require__("A4of"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _Transition = _interopRequireDefault(__webpack_require__("TAxY"));

var _PropTypes = __webpack_require__("QzNM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "4gma":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Help = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDropdown = __webpack_require__("CVj+");

var _reactSvg = __webpack_require__("CWk1");

var _CHEVRON_DOWN__ = __webpack_require__("kTPm");

var _QUESTION__ = __webpack_require__("+C4P");

__webpack_require__("miw2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Help = exports.Help = (_temp2 = _class = function (_React$Component) {
    _inherits(Help, _React$Component);

    function Help() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Help);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Help.__proto__ || Object.getPrototypeOf(Help)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (item, index) {
            if (item.cssClass === 'divider') {
                return _react2.default.createElement('li', { className: 'divider', key: index });
            }

            if (item.cssClass === 'nav-header') {
                return _react2.default.createElement(
                    'li',
                    { className: 'Dropdown__header', key: index },
                    item.text
                );
            }

            var rel = void 0;
            var target = void 0;

            if (_this.props.openLinksInNewWindow) {
                rel = 'noopener noreferrer';
                target = '_blank';
            }

            return _react2.default.createElement(
                'li',
                { key: index, role: 'none' },
                _react2.default.createElement(
                    'a',
                    { 'data-bypass': 'true', href: item.link, rel: rel, role: 'menuitem', target: target },
                    item.text
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Help, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                items = _props.items,
                label = _props.label;


            if (!items) {
                return null;
            }

            var id = 'site-header__help';

            var toggle = _react2.default.createElement(
                'button',
                {
                    'aria-expanded': 'false',
                    'aria-haspopup': 'true',
                    className: 'site-header-nav__toggle Dropdown__toggle',
                    id: id
                },
                _react2.default.createElement(_reactSvg.SVGIcon, { inlineFlex: true, markup: _QUESTION__.QUESTION__16 }),
                _react2.default.createElement(
                    'span',
                    { className: 'site-header-nav__icon-label' },
                    label
                ),
                _react2.default.createElement(_reactSvg.SVGIcon, { className: 'Dropdown__toggle-icon', inlineFlex: true, markup: _CHEVRON_DOWN__.CHEVRON_DOWN__16 })
            );

            return _react2.default.createElement(
                _reactDropdown.Dropdown,
                { className: 'site-header-nav__dropdown', customToggle: toggle, dropdownRight: true, id: id, label: this.props.label },
                this.props.items.map(this.renderItem)
            );
        }
    }]);

    return Help;
}(_react2.default.Component), _class.propTypes = {
    openLinksInNewWindow: _propTypes2.default.bool
}, _temp2);
//# sourceMappingURL=Help.js.map

/***/ }),

/***/ "52QJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PERSON__16 = void 0;
var PERSON__16 = '<svg data-id="SVG_PERSON__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M5.8 8.3a5.7 5.7 0 0 0-3.6 5.3m11.6 0a5.8 5.8 0 0 0-3.6-5.3"/><path d="M11 6.2a3 3 0 1 1-6 0v-.8a3 3 0 1 1 6 0v.8z"/></g></svg>';
exports.PERSON__16 = PERSON__16;

/***/ }),

/***/ "5mUy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
Copyright (C) 2015-2017 Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/


function URLSearchParams(query) {
  var
    index, key, value,
    pairs, i, length,
    dict = Object.create(null)
  ;
  this[secret] = dict;
  if (!query) return;
  if (typeof query === 'string') {
    if (query.charAt(0) === '?') {
      query = query.slice(1);
    }
    for (
      pairs = query.split('&'),
      i = 0,
      length = pairs.length; i < length; i++
    ) {
      value = pairs[i];
      index = value.indexOf('=');
      if (-1 < index) {
        appendTo(
          dict,
          decode(value.slice(0, index)),
          decode(value.slice(index + 1))
        );
      } else if (value.length){
        appendTo(
          dict,
          decode(value),
          ''
        );
      }
    }
  } else {
    if (isArray(query)) {
      for (
        i = 0,
        length = query.length; i < length; i++
      ) {
        value = query[i];
        appendTo(dict, value[0], value[1]);
      }
    } else {
      for (key in query) {
         appendTo(dict, key, query[key]);
      }
    }
  }
}

var
  isArray = Array.isArray,
  URLSearchParamsProto = URLSearchParams.prototype,
  find = /[!'\(\)~]|%20|%00/g,
  plus = /\+/g,
  replace = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  },
  replacer = function (match) {
    return replace[match];
  },
  secret = '__URLSearchParams__:' + Math.random()
;

function appendTo(dict, name, value) {
  if (name in dict) {
    dict[name].push('' + value);
  } else {
    dict[name] = isArray(value) ? value : ['' + value];
  }
}

function decode(str) {
  return decodeURIComponent(str.replace(plus, ' '));
}

function encode(str) {
  return encodeURIComponent(str).replace(find, replacer);
}

URLSearchParamsProto.append = function append(name, value) {
  appendTo(this[secret], name, value);
};

URLSearchParamsProto.delete = function del(name) {
  delete this[secret][name];
};

URLSearchParamsProto.get = function get(name) {
  var dict = this[secret];
  return name in dict ? dict[name][0] : null;
};

URLSearchParamsProto.getAll = function getAll(name) {
  var dict = this[secret];
  return name in dict ? dict[name].slice(0) : [];
};

URLSearchParamsProto.has = function has(name) {
  return name in this[secret];
};

URLSearchParamsProto.set = function set(name, value) {
  this[secret][name] = ['' + value];
};

URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
  var dict = this[secret];
  Object.getOwnPropertyNames(dict).forEach(function(name) {
    dict[name].forEach(function(value) {
      callback.call(thisArg, value, name, this);
    }, this);
  }, this);
};

/*
URLSearchParamsProto.toBody = function() {
  return new Blob(
    [this.toString()],
    {type: 'application/x-www-form-urlencoded'}
  );
};
*/

URLSearchParamsProto.toJSON = function toJSON() {
  return {};
};

URLSearchParamsProto.toString = function toString() {
  var dict = this[secret], query = [], i, key, name, value;
  for (key in dict) {
    name = encode(key);
    for (
      i = 0,
      value = dict[key];
      i < value.length; i++
    ) {
      query.push(name + '=' + encode(value[i]));
    }
  }
  return query.join('&');
};

URLSearchParams = (module.exports = global.URLSearchParams || URLSearchParams);

(function (URLSearchParamsProto) {

  var iterable = (function () {
    try {
      return !!Symbol.iterator;
    } catch(error) {
      return false;
    }
  }());

  // mostly related to issue #24
  if (!('forEach' in URLSearchParamsProto)) {
    URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
      var names = Object.create(null);
      this.toString()
          .replace(/=[\s\S]*?(?:&|$)/g, '=')
          .split('=')
          .forEach(function (name) {
            if (!name.length || name in names) return;
            (names[name] = this.getAll(name)).forEach(function(value) {
              callback.call(thisArg, value, name, this);
            }, this);
          }, this);
    };
  }

  if (!('keys' in URLSearchParamsProto)) {
    URLSearchParamsProto.keys = function keys() {
      var items = [];
      this.forEach(function(value, name) { items.push(name); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('values' in URLSearchParamsProto)) {
    URLSearchParamsProto.values = function values() {
      var items = [];
      this.forEach(function(value) { items.push(value); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('entries' in URLSearchParamsProto)) {
    URLSearchParamsProto.entries = function entries() {
      var items = [];
      this.forEach(function(value, name) { items.push([name, value]); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
    URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
  }

  if (!('sort' in URLSearchParamsProto)) {
    URLSearchParamsProto.sort = function sort() {
      var
        entries = this.entries(),
        entry = entries.next(),
        done = entry.done,
        keys = [],
        values = Object.create(null),
        i, key, value
      ;
      while (!done) {
        value = entry.value;
        key = value[0];
        keys.push(key);
        if (!(key in values)) {
          values[key] = [];
        }
        values[key].push(value[1]);
        entry = entries.next();
        done = entry.done;
      }
      // not the champion in efficiency
      // but these two bits just do the job
      keys.sort();
      for (i = 0; i < keys.length; i++) {
        this.delete(keys[i]);
      }
      for (i = 0; i < keys.length; i++) {
        key = keys[i];
        this.append(key, values[key].shift());
      }
    };
  }

}(URLSearchParams.prototype));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "6Ssj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAIL__16 = void 0;
var MAIL__16 = '<svg data-id="SVG_MAIL__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M12.5 6L8.7 9c-.4.4-1 .4-1.4.1L2.8 5.6a1.1 1.1 0 0 0-1.8 1v5.2c0 .6.5 1.1 1.1 1.1H15V4.2c0-.6-.5-1.1-1.1-1.1H1"/></svg>';
exports.MAIL__16 = MAIL__16;

/***/ }),

/***/ "6ihM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6kQN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = triggerEdapEvent;
function triggerEdapEvent(eventData) {
    var eventName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'generic.event';

    window.edap.push(function (edapInstance) {
        edapInstance.trigger(eventName, _extends({
            eventcategory: 'regional settings'
        }, eventData));
    });
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "6pa0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6q9T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable no-console,no-undefined */

/**
 * @module
 * Knotty
 * @description
 * A JS module for posting client-side exceptions and developer-authored
 * messages to the server.
 */

var debounce = __webpack_require__("y1vT");

var createLog = __webpack_require__("NZwV");
var postLogs = debounce(__webpack_require__("f8jN"), 1000);

/**
 * @name buildKnotty
 * @description
 * A tool for posting client side exception logs and developer-authored info/error logs to the
 * server. Returns an object with methods for posting exceptions, errors, and info logs.
 * @param {object} option
 * @param {string} options.token - A 256-bit CSRF token
 * @param {string=} [options.tokenName=crumb] - What property of the POSTed payload should contain the CSRF token?
 * @param {string=} [options.errorRoute=/errors] - Route to post exception logs
 * @param {string=} [options.clientLogRoute=/cl] - Route to post info/error level logs
 * @return {object} Object with Knotty methods
 *
 * @example
 * ```js
 * const buildKnotty = require('knotty');
 * const knotty = buildKnotty({
 *     token: '01lVpP0rqBNCqdty2sZ63OVrUmhwaE5tWybJPKv4l06',
 *     errorRoute: '/careers/errors',
 *     clientLogRoute: '/careers/cl',
 * });
 * // Functions for posting info/error level logs are available on knotty.
 * knotty.logError('There\'s a snake in my boot!');
 * knotty.logInfo('I\'m a cowboy! Howdy Howdy Howdy');
 * // The module version of Knotty doesn't attach an exception handler to `window.onerror`
 * // automatically. To match the behavior of the browser script, do
 * window.onerror = knotty.logException;
 * ```
 */

function buildKnotty() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var logs = {
        exception: [],
        client: []
    };

    options.tokenName = options.tokenName || 'crumb';
    options.errorRoute = options.errorRoute || '/errors';
    options.clientLogRoute = options.clientLogRoute || '/cl';

    /**
     * @name
     * makeLogger
     * @private
     * @description
     * Returns a function for logging errors and client messages to the server.
     * @param {string} route - Where should logs be posted?
     * @param {array} innerLogs - A reference to an array of logs to be posted
     * @param {string} logType - What type of log is this? ex: 'exception', 'info', 'error'.
     *                           Logs of type 'exception' are treated as if they were
     *                           created by window.onerror.  Other log types are considered to
     *                           be created by the developer.
     * @return {function}
     */

    function makeLogger(route, innerLogs, logType) {
        return function knottyPostLogs() {
            var tokenOptions = { value: options.token, name: options.tokenName };
            // For developer-authored logs, one argument (message) is required.

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            if (logType !== 'exception' && !args[0]) {
                throw new Error('[knotty] A message is required');
            }
            innerLogs.push(createLog(args, logType));
            postLogs(route, innerLogs, logType, tokenOptions, function postLogsCallback(err) {
                if (err) {
                    console.log('[knotty] There was a problem posting ' + logType + ' logs to ' + route);
                }
                innerLogs = [];
                return;
            });
        };
    }

    return {
        /**
         * @name
         * knotty#logException
         * @description
         * A function for posting caught exceptions to the server
         * @param {string} message
         */

        logException: makeLogger(options.errorRoute, logs.exception, 'exception'),

        /**
         * @name
         * knotty#logError
         * @description
         * A function for posting developer-generated error logs to the server.
         * @param {string} message
         */

        logError: makeLogger(options.clientLogRoute, logs.client, 'error'),

        /**
         * @name
         * knotty#logInfo
         * @description
         * A function for posting developer-generated info logs to the server.
         * @param {string} message
         */

        logInfo: makeLogger(options.clientLogRoute, logs.client, 'info')
    };
}

module.exports = buildKnotty;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "7guQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("S7o0");

var _reactFormComponents = __webpack_require__("hyOf");

var _reactButtons = __webpack_require__("WAAH");

var _reactLoadingOverlay = __webpack_require__("/vpO");

var _api = __webpack_require__("cGdw");

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogInComponent = function (_Component) {
    _inherits(LogInComponent, _Component);

    function LogInComponent(props) {
        _classCallCheck(this, LogInComponent);

        var _this = _possibleConstructorReturn(this, (LogInComponent.__proto__ || Object.getPrototypeOf(LogInComponent)).call(this, props));

        _this.state = {
            emailAddress: _this.props.emailAddress,
            password: '',
            loggedIn: false,
            errorMsg: '',
            resetPassword: false,
            rememberMe: false,
            disableLogin: false
        };
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleCheck = _this.handleCheck.bind(_this);
        _this.submitForm = _this.submitForm.bind(_this);
        _this.checkStatus = _this.checkStatus.bind(_this);
        _this.resetPassword = _this.resetPassword.bind(_this);
        _this.buttonClicked = _this.buttonClicked.bind(_this);
        _this.editEmail = _this.editEmail.bind(_this);
        return _this;
    }

    _createClass(LogInComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: {
                    actionlocation: this.props.actionLocation,
                    eventaction: 'login.visible',
                    eventcategory: 'lex',
                    eventlabel: 'ums'
                }
            });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.stopPropagation();
            event.preventDefault();
        }
    }, {
        key: 'handleChange',
        value: function handleChange(event) {
            this.setState(_defineProperty({}, event.target.name, event.target.value));
        }
    }, {
        key: 'handleCheck',
        value: function handleCheck(event) {
            this.setState(_defineProperty({}, event.target.name, event.target.checked));
        }
    }, {
        key: 'handleError',
        value: function handleError(error, errorTitle) {
            this.edapLoginError();
            this.props.handleError(error, errorTitle);
        }
    }, {
        key: 'edapLoginError',
        value: function edapLoginError() {
            (0, _edapWrapper2.default)().push({
                name: 'login.failure',
                data: { loginsource: 'lex', logintype: 'ums', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
        }
    }, {
        key: 'loginSuccess',
        value: function loginSuccess(json) {
            this.setState({ loggedIn: true });
            (0, _edapWrapper2.default)().push({
                name: 'login.success',
                data: { loginsource: 'lex', logintype: 'ums', publicuuid: json.publicUuid, actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.props.setAuthJson(json);
            this.props.onClose();
        }
    }, {
        key: 'checkStatus',
        value: function checkStatus(response) {
            var _this2 = this;

            switch (response.status) {
                case 200:
                    response.json().then(function (json) {
                        _this2.loginSuccess(json);
                    });
                    break;
                case 401:
                    this.props.disableLoading();
                    this.edapLoginError();
                    this.setState({ errorMsg: this.props.lingua.read('lex.password.error') });
                    break;
                case 403:
                    // this is the response we get when user is locked out of account
                    this.props.disableLoading();
                    this.handleError(this.props.lingua.read('lex.password.reset.warning'), this.props.lingua.read('lex.warning.title'));
                    this.setState({ resetPassword: true, errorMsg: '' });
                    break;
                case 423:
                    // this is the response we get when blocked status of Deleted, Permanent Substandard, Spammer, Substandard, Suspicious, Fraud
                    this.props.disableLoading();
                    this.handleError(this.props.lingua.read('error.authentication.user.blocked'), this.props.lingua.read('lex.warning.title'));
                    this.setState({ resetPassword: false, errorMsg: '', disableLogin: true });
                    break;
                default:
                    this.props.disableLoading();
                    this.handleError(this.props.lingua.read('error.generic'), '');
                    break;
            }
        }
    }, {
        key: 'editEmail',
        value: function editEmail(e) {
            e.stopPropagation();
            e.preventDefault();
            this.props.updatePage('initial');
        }
    }, {
        key: 'buttonClicked',
        value: function buttonClicked() {
            var _this3 = this;

            this.props.enableLoading();
            if (this.state.resetPassword === true) {
                setTimeout(function () {
                    _this3.resetPassword();
                }, 800);
            } else {
                setTimeout(function () {
                    _this3.submitForm();
                }, 800);
            }
        }
    }, {
        key: 'submitForm',
        value: function submitForm() {
            (0, _edapWrapper2.default)().push({
                name: 'login.attempt',
                data: { loginsource: 'lex', logintype: 'ums', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            if (this.props.useNewEndpoints) {
                (0, _api.apiPost)('/auth/aam/v3/authenticate', {
                    userName: this.state.emailAddress,
                    secret: this.state.password,
                    authType: 'HOMEAWAY',
                    rememberMe: this.state.rememberMe
                }).then(this.checkStatus);
            } else {
                (0, _api.apiPost)('/auth/v2/authenticate', {
                    emailAddress: this.state.emailAddress,
                    password: this.state.password,
                    createTicketGrantingTicket: true,
                    service: this.props.service,
                    rememberMe: this.state.rememberMe
                }).then(this.checkStatus);
            }
        }
    }, {
        key: 'resetPassword',
        value: function resetPassword() {
            var _this4 = this;

            var url = '/auth/aam/v3/password/reset';
            var body = {
                'emailAddress': this.state.emailAddress,
                serviceUrl: this.props.service
            };

            (0, _api.apiPost)(url, body).then(function (response) {
                if (response.status === 204) {
                    _this4.props.updatePage('passwordreset');
                } else {
                    _this4.props.handleError(_this4.props.lingua.read('error.generic'), '');
                }
                _this4.props.disableLoading();
            });
        }
    }, {
        key: 'getPasswordClasses',
        value: function getPasswordClasses() {
            return 'form-group floating-label ' + (this.state.password === '' ? '' : 'not-empty') + ' has-feedback ' + (this.state.errorMsg === '' ? '' : 'has-error');
        }
    }, {
        key: 'getPasswordContent',
        value: function getPasswordContent() {
            var passwordFieldClasses = this.getPasswordClasses();
            var disableLoginButton = !this.state.password || this.state.disableLogin;

            return _react2.default.createElement(
                'div',
                { className: 'PasswordField' },
                _react2.default.createElement(
                    'div',
                    { className: passwordFieldClasses },
                    _react2.default.createElement(
                        'label',
                        null,
                        this.props.lingua.read('lex.password.prompt')
                    ),
                    _react2.default.createElement('input', { type: this.props.passwordType, className: 'form-control', 'aria-label': this.props.lingua.read('lex.password.prompt'),
                        name: 'password', onChange: this.handleChange, value: this.state.password, autoComplete: 'on',
                        disabled: this.state.disableLogin, autoFocus: true
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'PasswordShow', onClick: this.props.showHidePassword },
                        this.props.passwordType === 'input' ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: this.state.errorMsg === '' ? '' : 'help-block' },
                        this.state.errorMsg
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'RememberMe' },
                    _react2.default.createElement(_reactFormComponents.Checkbox, {
                        name: 'rememberMe',
                        label: this.props.lingua.read('lex.login.remember'),
                        checked: this.state.rememberMe,
                        onChange: this.handleCheck,
                        size: 'sm',
                        inline: true
                    })
                ),
                _react2.default.createElement(
                    _reactButtons.ButtonPrimary,
                    { type: 'submit', label: this.props.lingua.read('account.signin.link.text'), onClick: this.buttonClicked, disabled: disableLoginButton, className: 'btn-lg' },
                    _react2.default.createElement(_reactLoadingOverlay.LoadingOverlay, { loading: this.props.isWaiting })
                )
            );
        }
    }, {
        key: 'getResetPasswordContent',
        value: function getResetPasswordContent() {
            var passwordFieldClasses = this.getPasswordClasses();
            return _react2.default.createElement(
                'div',
                { className: 'PasswordField' },
                _react2.default.createElement(
                    'div',
                    { className: passwordFieldClasses },
                    _react2.default.createElement(
                        'label',
                        null,
                        this.props.lingua.read('lex.password.prompt')
                    ),
                    _react2.default.createElement('input', { type: this.props.passwordType, className: 'form-control', 'aria-label': this.props.lingua.read('lex.password.prompt'),
                        name: 'password', onChange: this.handleChange, value: this.state.password, autoComplete: 'on', disabled: true, autoFocus: true
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'PasswordDisabled', onClick: this.props.showHidePassword },
                        this.props.passwordType === 'input' ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'RememberMe' },
                    _react2.default.createElement(_reactFormComponents.Checkbox, {
                        name: 'rememberMe',
                        label: this.props.lingua.read('lex.login.remember'),
                        checked: this.state.rememberMe,
                        onChange: this.handleCheck,
                        size: 'sm',
                        inline: true
                    })
                ),
                _react2.default.createElement(
                    _reactButtons.ButtonPrimary,
                    { type: 'submit', label: this.props.lingua.read('resetPassword.title'), onClick: this.buttonClicked, className: 'btn-lg' },
                    _react2.default.createElement(_reactLoadingOverlay.LoadingOverlay, { loading: this.props.isWaiting })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var passwordFieldSetup = this.state.resetPassword === true ? this.getResetPasswordContent() : this.getPasswordContent();
            var resetPasswordLink = this.state.resetPassword === true || this.state.disableLogin === true ? null : _react2.default.createElement(_reactButtons.ButtonLink, { className: 'Link', label: this.props.lingua.read('lex.password.forgot.link'), onClick: this.resetPassword });
            return _react2.default.createElement(
                'div',
                { className: 'LogInComponent text-center' },
                _react2.default.createElement(
                    'form',
                    { onSubmit: this.handleSubmit },
                    !this.props.multiUserEnabled && _react2.default.createElement(
                        'a',
                        { onClick: this.editEmail, className: 'edit-email', href: '' },
                        this.props.lingua.read('lex.email.edit')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'EmailField' },
                        _react2.default.createElement(_reactFormComponents.FormInput, {
                            id: 'lex-emailAddress',
                            name: 'emailAddress',
                            className: 'email-address',
                            label: this.props.lingua.read('form.placeholder.emailAddress'),
                            value: this.state.emailAddress,
                            onChange: this.handleChange,
                            type: 'email',
                            autoComplete: 'on',
                            disabled: true
                        })
                    ),
                    passwordFieldSetup
                ),
                resetPasswordLink
            );
        }
    }]);

    return LogInComponent;
}(_react.Component);

exports.default = LogInComponent;
//# sourceMappingURL=LogInComponent.js.map

/***/ }),

/***/ "8+5l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("R6lU");

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__("Hgtn"));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ "9Lxt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Orx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("9Lxt");

var _reactLoadingOverlay = __webpack_require__("/vpO");

var _reactAlerts = __webpack_require__("anT4");

var _reactButtons = __webpack_require__("WAAH");

var _api = __webpack_require__("cGdw");

var _password = __webpack_require__("Wgkp");

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangePasswordComponent = function (_Component) {
    _inherits(ChangePasswordComponent, _Component);

    function ChangePasswordComponent(props) {
        _classCallCheck(this, ChangePasswordComponent);

        var _this = _possibleConstructorReturn(this, (ChangePasswordComponent.__proto__ || Object.getPrototypeOf(ChangePasswordComponent)).call(this, props));

        _this.state = {
            password: '',
            confirmPassword: '',
            ticketId: _this.props.ticketId,
            loggedIn: false,
            loading: false,
            passwordType: 'password',
            confirmPasswordType: 'password',
            pwdReqMet: false
        };

        _this.handleChange = _this.handleChange.bind(_this);
        _this.submitForm = _this.submitForm.bind(_this);
        _this.checkStatus = _this.checkStatus.bind(_this);
        _this.validateFields = _this.validateFields.bind(_this);
        _this.showHide = _this.showHide.bind(_this);
        _this.triggerSubmit = _this.triggerSubmit.bind(_this);
        return _this;
    }

    _createClass(ChangePasswordComponent, [{
        key: 'showHide',
        value: function showHide(e) {
            e.preventDefault();
            e.stopPropagation();
            var control = event.target.id;
            var shouldHide = control === 'passwordType' ? this.state.passwordType === 'input' : this.state.confirmPasswordType === 'input';
            var action = shouldHide ? 'hide' : 'show';
            var eventaction = control === 'passwordType' ? action + 'Pwd.click' : action + 'ConfirmPwd.click';
            (0, _edapWrapper2.default)().push({
                name: 'generic.click',
                data: { eventcategory: 'lex.auth', eventaction: eventaction, actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.setState(_defineProperty({}, control, shouldHide ? 'password' : 'input'));
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.stopPropagation();
            event.preventDefault();
        }
    }, {
        key: 'handleChange',
        value: function handleChange(event) {
            this.setState(_defineProperty({}, event.target.name, event.target.value));
        }
    }, {
        key: 'handleError',
        value: function handleError(error) {
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: { eventaction: 'passwordchange.failure', eventcategory: 'lex', eventlabel: 'ums', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.props.handleError(error);
        }
    }, {
        key: 'isValidPassword',
        value: function isValidPassword() {
            return !(0, _password.validate)({ p: this.state.password }, _password.validatePasswordConstraint);
        }
    }, {
        key: 'passwordsMatch',
        value: function passwordsMatch() {
            if (this.state.confirmPassword === this.state.password) {
                return true;
            }
            return false;
        }
    }, {
        key: 'validateFields',
        value: function validateFields() {
            if (this.state.password === '' || this.state.confirmPassword === '') {
                return false;
            }
            return true;
        }
    }, {
        key: 'triggerSubmit',
        value: function triggerSubmit(e) {
            var _this2 = this;

            e.preventDefault();
            this.props.enableLoading();
            setTimeout(function () {
                _this2.submitForm();
            }, 800);
        }
    }, {
        key: 'submitForm',
        value: function submitForm() {
            if (!this.isValidPassword() || !this.passwordsMatch()) {
                this.props.disableLoading();
                return;
            }
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: { eventaction: 'passwordchange.attempt', eventcategory: 'lex', eventlabel: 'ums', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            (0, _api.apiPost)('/auth/aam/v3/password/change', {
                newPassword: this.state.password,
                confirmedPassword: this.state.confirmPassword,
                ticketId: this.state.ticketId
            }).then(this.checkStatus);
        }
    }, {
        key: 'checkStatus',
        value: function checkStatus(response) {
            switch (response.status) {
                case 200:
                    this.changeSuccess();
                    break;
                case 400:
                    // passwords don't match or invalid or bad format shouldn't happen since we validate UI
                    this.props.disableLoading();
                    this.handleError(this.props.lingua.read('lex.password.invalid'));
                    break;
                case 401:
                    // ticket id was invalid
                    this.props.disableLoading();
                    this.handleError(this.props.lingua.read('lex.ticket.invalid'));
                    break;
                case 417:
                    this.props.disableLoading();
                    this.handleError(this.props.lingua.read('lex.password.previous'));
                    break;
                case 422:
                    // password length too long/short shouldn't happen since we validate UI
                    this.props.disableLoading();
                    this.handleError(this.props.lingua.read('ums.validation.password.length', _password.pwdLengthOptions, 'validation'));
                    break;
                default:
                    this.props.disableLoading();
                    this.handleError(this.props.lingua.read('error.generic'));
                    break;
            }
        }
    }, {
        key: 'changeSuccess',
        value: function changeSuccess() {
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: {
                    eventaction: 'passwordChange.success',
                    eventcategory: 'lex',
                    eventlabel: 'ums',
                    actionlocation: this.props.actionLocation
                },
                options: { 'delayProcessing': true }
            });
            this.props.updatePage('success');
        }
    }, {
        key: 'getPasswordContent',
        value: function getPasswordContent() {
            var passwordFieldClasses = 'form-group floating-label ' + (this.state.password === '' ? '' : 'not-empty') + ' has-feedback';
            return _react2.default.createElement(
                'div',
                { className: passwordFieldClasses },
                _react2.default.createElement(
                    'label',
                    null,
                    this.props.lingua.read('lex.password.change.prompt')
                ),
                _react2.default.createElement('input', { type: this.state.passwordType, className: 'form-control', 'aria-label': this.props.lingua.read('lex.password.change.prompt'),
                    name: 'password', onChange: this.handleChange, value: this.state.password, autoComplete: 'new-password'
                }),
                _react2.default.createElement(
                    'span',
                    { id: 'passwordType', className: 'PasswordShow', onClick: this.showHide },
                    this.state.passwordType === 'input' ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')
                ),
                this.state.password === '' && _react2.default.createElement(_reactAlerts.InlineMessage, { id: 'pwdMessage', type: 'help', message: this.props.lingua.read('lex.password.requirements', _password.pwdLengthOptions) }),
                this.state.password !== '' && _react2.default.createElement(_reactAlerts.InlineMessage, { id: 'pwdMessage', type: this.isValidPassword() ? 'success' : 'danger', message: this.props.lingua.read('lex.password.requirements', _password.pwdLengthOptions) })
            );
        }
    }, {
        key: 'getConfirmPwdContent',
        value: function getConfirmPwdContent() {
            var confirmPasswordFieldClasses = 'form-group floating-label ' + (this.state.confirmPassword === '' ? '' : 'not-empty') + ' has-feedback';
            return _react2.default.createElement(
                'div',
                { className: confirmPasswordFieldClasses },
                _react2.default.createElement(
                    'label',
                    null,
                    this.props.lingua.read('lex.password.confirm')
                ),
                _react2.default.createElement('input', { type: this.state.confirmPasswordType, className: 'form-control', 'aria-label': this.props.lingua.read('lex.password.confirm'),
                    name: 'confirmPassword', onChange: this.handleChange, value: this.state.confirmPassword, autoComplete: 'confirm-password'
                }),
                _react2.default.createElement(
                    'span',
                    { id: 'confirmPasswordType', className: 'PasswordShow', onClick: this.showHide },
                    this.state.confirmPasswordType === 'input' ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')
                ),
                this.state.confirmPassword !== '' && _react2.default.createElement(_reactAlerts.InlineMessage, { id: 'confirmPwdMessage', type: this.passwordsMatch() ? 'success' : 'danger',
                    message: this.props.lingua.read('lex.password.change.confirm' + (this.passwordsMatch() ? '' : '.error'))
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var passwordContent = this.getPasswordContent();
            var confirmPwdContent = this.getConfirmPwdContent();
            return _react2.default.createElement(
                'div',
                { className: 'ChangePasswordComponent' },
                _react2.default.createElement(
                    'form',
                    { onSubmit: this.triggerSubmit, noValidate: true },
                    passwordContent,
                    confirmPwdContent,
                    _react2.default.createElement(
                        'div',
                        { className: 'Save_button text-center' },
                        _react2.default.createElement(
                            _reactButtons.ButtonPrimary,
                            { type: 'submit', label: this.props.lingua.read('lex.password.change.button'), disabled: !this.validateFields() },
                            _react2.default.createElement(_reactLoadingOverlay.LoadingOverlay, { loading: this.props.isWaiting })
                        )
                    )
                )
            );
        }
    }]);

    return ChangePasswordComponent;
}(_react.Component);

exports.default = ChangePasswordComponent;
//# sourceMappingURL=ChangePasswordComponent.js.map

/***/ }),

/***/ "A4of":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ "A95e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FACEBOOK_COLOR__24 = void 0;
var FACEBOOK_COLOR__24 = '<svg data-id="SVG_FACEBOOK_COLOR__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 22v-9.2H7V9.5h2.5v-3c0-2.3 1.5-4.5 5-4.5 1.4 0 2.5.2 2.5.2l-.1 3.1h-2.2c-1.3 0-1.4.7-1.4 1.7v2.5H17l-.3 3.3h-3.4V22H9.5z" stroke="none" fill="#3B5998" fill-rule="evenodd"/></svg>';
exports.FACEBOOK_COLOR__24 = FACEBOOK_COLOR__24;

/***/ }),

/***/ "ACPw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AUAB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _ButtonIconBase = _interopRequireDefault(__webpack_require__("ICDg"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ButtonIcon(props) {
  var buttonClasses = (0, _classnames.default)('btn-default', props.className);
  return _react.default.createElement(_ButtonIconBase.default, _extends({}, props, {
    className: buttonClasses
  }));
}

ButtonIcon.propTypes = _extends({}, _ButtonIconBase.default.propTypes);
ButtonIcon.defaultProps = _extends({}, _ButtonIconBase.default.defaultProps);
var _default = ButtonIcon;
exports.default = _default;
//# sourceMappingURL=ButtonIcon.js.map

/***/ }),

/***/ "AYO3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _HeaderSectionComponent = __webpack_require__("F1Vd");

var _HeaderSectionComponent2 = _interopRequireDefault(_HeaderSectionComponent);

var _TandCComponent = __webpack_require__("/s9T");

var _TandCComponent2 = _interopRequireDefault(_TandCComponent);

var _CalloutCardComponent = __webpack_require__("um2z");

var _CalloutCardComponent2 = _interopRequireDefault(_CalloutCardComponent);

var _SocialLoginDisplayComponent = __webpack_require__("d4xY");

var _SocialLoginDisplayComponent2 = _interopRequireDefault(_SocialLoginDisplayComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SocialLoginPageComponent = function (_Component) {
    _inherits(SocialLoginPageComponent, _Component);

    function SocialLoginPageComponent(props) {
        _classCallCheck(this, SocialLoginPageComponent);

        var _this = _possibleConstructorReturn(this, (SocialLoginPageComponent.__proto__ || Object.getPrototypeOf(SocialLoginPageComponent)).call(this, props));

        _this.state = {
            emailAddress: _this.props.emailAddress,
            firstName: _this.props.firstName,
            currentPage: _this.props.currentPage,
            authAccountType: _this.props.authAccountType,
            error: '',
            errorTitle: ''
        };
        _this.handleError = _this.handleError.bind(_this);
        return _this;
    }

    _createClass(SocialLoginPageComponent, [{
        key: 'handleError',
        value: function handleError(error) {
            this.setState({ error: error });
        }
    }, {
        key: 'render',
        value: function render() {
            var cardContent = _react2.default.createElement(_SocialLoginDisplayComponent2.default, {
                lingua: this.props.lingua,
                emailAddress: this.props.emailAddress,
                authAccountType: this.props.authAccountType,
                performBulkPageUpdate: this.props.performBulkPageUpdate,
                service: this.props.service,
                handleError: this.handleError,
                onClose: this.props.onClose,
                site: this.props.site,
                setAuthJson: this.props.setAuthJson,
                useNewEndpoints: this.props.useNewEndpoints,
                token: this.props.token,
                multiUserEnabled: this.props.multiUserEnabled,
                updatePage: this.props.updatePage
            });

            return _react2.default.createElement(
                'div',
                { className: 'SocialLogInPageDisplayComponent' },
                _react2.default.createElement(_HeaderSectionComponent2.default, { header: this.props.lingua.read('lex.header.login') }),
                _react2.default.createElement(_CalloutCardComponent2.default, { content: cardContent, error: this.state.error, errorTitle: this.state.errorTitle, authAccountType: this.props.authAccountType, performBulkPageUpdate: this.props.performBulkPageUpdate }),
                _react2.default.createElement(_TandCComponent2.default, { lingua: this.props.lingua, multiUserEnabled: this.props.multiUserEnabled })
            );
        }
    }]);

    return SocialLoginPageComponent;
}(_react.Component);

exports.default = SocialLoginPageComponent;
//# sourceMappingURL=SocialLoginPageComponent.js.map

/***/ }),

/***/ "C+pt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GOOGLE_COLOR__24 = void 0;
var GOOGLE_COLOR__24 = '<svg data-id="SVG_GOOGLE_COLOR__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M21.86 12.23c0-.71-.07-1.4-.19-2.05h-9.54v3.87h5.45a4.6 4.6 0 0 1-2.02 3.02v2.5h3.28a9.69 9.69 0 0 0 3.02-7.34z" stroke="none" fill="#4688F1"/><path d="M12.13 22c2.74 0 5.03-.9 6.7-2.42l-3.27-2.51c-.9.6-2.07.95-3.43.95a6.03 6.03 0 0 1-5.67-4.12H3.08v2.6c1.66 3.26 5.1 5.5 9.05 5.5z" stroke="none" fill="#3AA757"/><path d="M6.46 13.9a5.94 5.94 0 0 1 0-3.8V7.5H3.08a9.89 9.89 0 0 0 0 9l3.38-2.6z" stroke="none" fill="#F9BB2D"/><path d="M12.13 5.98c1.49 0 2.82.5 3.87 1.5l2.91-2.88A9.8 9.8 0 0 0 12.13 2C8.17 2 4.74 4.24 3.08 7.5l3.38 2.6a6.03 6.03 0 0 1 5.67-4.12z" stroke="none" fill="#E7453C"/></g></svg>';
exports.GOOGLE_COLOR__24 = GOOGLE_COLOR__24;

/***/ }),

/***/ "CCKR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CThN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _SuccessComponent = __webpack_require__("mbiX");

var _SuccessComponent2 = _interopRequireDefault(_SuccessComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SuccessPageComponent = function (_Component) {
    _inherits(SuccessPageComponent, _Component);

    function SuccessPageComponent(props) {
        _classCallCheck(this, SuccessPageComponent);

        var _this = _possibleConstructorReturn(this, (SuccessPageComponent.__proto__ || Object.getPrototypeOf(SuccessPageComponent)).call(this, props));

        _this.state = {
            emailAddress: _this.props.emailAddress,
            currentPage: _this.props.currentPage
        };
        return _this;
    }

    _createClass(SuccessPageComponent, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_SuccessComponent2.default, {
                lingua: this.props.lingua,
                emailAddress: this.props.emailAddress,
                firstName: this.props.firstName,
                onClose: this.props.onClose,
                successContext: this.props.successContext
            });
        }
    }]);

    return SuccessPageComponent;
}(_react.Component);

exports.default = SuccessPageComponent;
//# sourceMappingURL=SuccessPageComponent.js.map

/***/ }),

/***/ "CVj+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("GiK3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-svg/lib/esm/index.js
var esm = __webpack_require__("CWk1");
var esm_default = /*#__PURE__*/__webpack_require__.n(esm);

// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/index.js + 313 modules
var lib_esm = __webpack_require__("QnUD");

// CONCATENATED MODULE: ./node_modules/@homeaway/react-dropdown/lib/esm/components/DropdownItem/DropdownItem.js
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




/**
 * DropdownItem
 *
 */

var DropdownItem_DropdownItem =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(DropdownItem, _Component);

  function DropdownItem(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = DropdownItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        link = _this$props.link,
        dataBypass = _this$props.dataBypass,
        text = _this$props.text,
        svgMarkup = _this$props.svgMarkup,
        svgId = _this$props.svgId,
        rest = _objectWithoutProperties(_this$props, ["link", "dataBypass", "text", "svgMarkup", "svgId"]);

    var finalIconMarkup;

    if (svgMarkup) {
      finalIconMarkup = react_default.a.createElement(esm["SVGIcon"], {
        inlineFlex: true,
        className: "icon-color",
        markup: svgMarkup
      });
    } else if (svgId) {
      finalIconMarkup = react_default.a.createElement(esm["SVGIcon"], {
        inlineFlex: true,
        className: "icon-color",
        id: svgId
      });
    }

    if (link) {
      return react_default.a.createElement("li", rest, react_default.a.createElement("a", {
        "data-bypass": dataBypass,
        href: link
      }, finalIconMarkup, " ", text));
    }

    return react_default.a.createElement("li", rest, text);
  };

  return DropdownItem;
}(react["Component"]);

DropdownItem_DropdownItem.propTypes = {
  /** Flag for if <a> tag needs a data-bypass attribute; for use in legacy ThinSPA apps */
  dataBypass: prop_types_default.a.bool,

  /** URL of the DropdownItem.*/
  link: prop_types_default.a.string,

  /** Text (or markup) to display on the DropdownItem. */
  text: prop_types_default.a.node,

  /** For direct imports, use the SVG markup from @homeaway/svg-defs module */
  svgMarkup: prop_types_default.a.string,

  /** ID name of SVG from an SVG Definition block, the xlink:href of the SVG you want. Used in the 'use' tag to grab it's definition from the SVG Definitions */
  svgId: prop_types_default.a.string
};
DropdownItem_DropdownItem.defaultProps = {
  dataBypass: false
};
/* harmony default export */ var components_DropdownItem_DropdownItem = (DropdownItem_DropdownItem);
//# sourceMappingURL=DropdownItem.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/index.js + 9 modules
var react_buttons_lib_esm = __webpack_require__("WAAH");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-dropdown/lib/esm/components/DropdownBase/DropdownBase.css
var DropdownBase_DropdownBase = __webpack_require__("ysCC");
var DropdownBase_default = /*#__PURE__*/__webpack_require__.n(DropdownBase_DropdownBase);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-dropdown/lib/esm/components/DropdownBase/DropdownBase.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function DropdownBase__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }










var DropdownBase_DropdownBase_DropdownBase =
/*#__PURE__*/
function (_Component) {
  DropdownBase__inheritsLoose(DropdownBase, _Component);

  function DropdownBase() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.renderToggle = function () {
      var customToggle = _this.props.customToggle;

      if (customToggle) {
        return _this.renderCustomToggle();
      }

      return _this.renderDefaultToggle();
    };

    _this.renderDefaultToggle = function () {
      var _this$props = _this.props,
          id = _this$props.id,
          label = _this$props.label,
          onDropdownClick = _this$props.onDropdownClick,
          buttonChildren = _this$props.buttonChildren,
          srOnlyLabel = _this$props.srOnlyLabel,
          open = _this$props.open,
          noArrow = _this$props.noArrow;
      var toggleClasses = classnames_default()('Dropdown__toggle', 'border-border-color', 'border--contrast', {
        'Dropdown__toggle--open': open
      });
      var toggleIconClasses = classnames_default()('Dropdown__toggle-icon', {
        'Dropdown__toggle-icon--open': open
      });
      return react_default.a.createElement(react_buttons_lib_esm["Button"], {
        id: id,
        onClick: onDropdownClick,
        "aria-haspopup": "true",
        label: label,
        "aria-expanded": open,
        srOnlyLabel: srOnlyLabel,
        className: toggleClasses
      }, buttonChildren, !noArrow && react_default.a.createElement(esm["SVGIcon"], {
        className: toggleIconClasses,
        markup: lib_esm["CHEVRON_DOWN__12"]
      }));
    };

    _this.renderCustomToggle = function () {
      var _this$props2 = _this.props,
          label = _this$props2.label,
          onDropdownClick = _this$props2.onDropdownClick,
          customToggle = _this$props2.customToggle,
          open = _this$props2.open;
      var clone = react_default.a.cloneElement(customToggle, {
        onClick: onDropdownClick,
        'aria-haspopup': true,
        'aria-expanded': open,
        label: label
      });
      return clone;
    };

    _this.blurHandler = function (e) {
      var currentTarget = e.currentTarget;
      var relatedTarget = e.relatedTarget || typeof document !== 'undefined' && document.activeElement;

      if (!currentTarget.contains(relatedTarget)) {
        _this.props.onBlur();
      }
    };

    _this.windowClickHandler = function (e) {
      var _this$props3 = _this.props,
          open = _this$props3.open,
          onBlur = _this$props3.onBlur,
          onTouch = _this$props3.onTouch;

      if (open && _this.rootElem && e && e.target && !_this.rootElem.contains(e.target)) {
        if (e.type === 'mouseup') {
          onBlur();
        } else {
          onTouch();
        }
      }
    };

    _this.addWindowListeners = function () {
      if (typeof window !== 'undefined') {
        window.document.addEventListener('mouseup', _this.windowClickHandler);

        if ('ontouchstart' in window) {
          window.document.addEventListener('touchstart', _this.windowClickHandler);
        }
      }
    };

    _this.removeWindowListeners = function () {
      if (typeof window !== 'undefined') {
        window.document.removeEventListener('mouseup', _this.windowClickHandler);

        if ('ontouchstart' in window) {
          window.document.removeEventListener('touchstart', _this.windowClickHandler);
        }
      }
    };

    _this.setRootElem = function (elem) {
      _this.rootElem = elem;
    };

    return _this;
  }

  var _proto = DropdownBase.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.addWindowListeners();
    }

    if (prevProps.open && !this.props.open) {
      this.removeWindowListeners();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeWindowListeners();
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        id = _this$props4.id,
        children = _this$props4.children,
        links = _this$props4.links,
        className = _this$props4.className,
        dropdownRight = _this$props4.dropdownRight,
        open = _this$props4.open,
        maxHeight = _this$props4.maxHeight;
    var dropdownClasses = classnames_default()('Dropdown', {
      'Dropdown--open': open
    }, className);
    var menuClasses = classnames_default()('Dropdown__menu', {
      'Dropdown__menu--open': open,
      'Dropdown__menu--right': dropdownRight,
      'Dropdown__menu--overflow': !!maxHeight
    });
    return react_default.a.createElement("div", {
      className: dropdownClasses,
      onBlur: this.blurHandler,
      tabIndex: "-1",
      ref: this.setRootElem,
      role: "presentation"
    }, this.renderToggle(), react_default.a.createElement("ul", {
      className: menuClasses,
      style: {
        maxHeight: maxHeight
      },
      role: "menu",
      "aria-labelledby": id
    }, links && links.map(function (link, i) {
      return react_default.a.createElement(components_DropdownItem_DropdownItem, _extends({
        key: i
      }, link));
    }), children));
  };

  return DropdownBase;
}(react["Component"]);

DropdownBase_DropdownBase_DropdownBase.propTypes = {
  /** id attribute of the Dropdown. Used for aria-labeledby value of dropdown list. */
  id: prop_types_default.a.string.isRequired,

  /** Text to display on the Dropdown button. */
  label: prop_types_default.a.node.isRequired,

  /** Array of links to generate.  Shape contains: `link`, `text`, and `cssClass`. */
  links: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    link: prop_types_default.a.string,
    text: prop_types_default.a.string,
    className: prop_types_default.a.string
  })),

  /** Flag to control if the Dropdown is open via an external state management. */
  open: prop_types_default.a.bool,

  /** Child content of Dropdown button if not using standard label prop. */
  buttonChildren: prop_types_default.a.node,

  /** Render the toggle as a custom React component. */
  customToggle: prop_types_default.a.element,

  /** Flag to specify that the button label is Screen Reader only. Usually used with props.buttonChildren. */
  srOnlyLabel: prop_types_default.a.bool,

  /** Flag to keep the arrow icon from appearing to the right of the text. */
  noArrow: prop_types_default.a.bool,

  /** Flag to keep have the dropdown menu open from the right. */
  dropdownRight: prop_types_default.a.bool,

  /** callback for when the dropdown is clicked */
  onDropdownClick: prop_types_default.a.func,

  /** callback for touch devices tapping off of the dropdown / dropdown list */
  onTouch: prop_types_default.a.func,

  /** callback for when the dropdown / dropdown list loses focus */
  onBlur: prop_types_default.a.func,

  /** Set max height of the dropdown menu */
  maxHeight: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
};
DropdownBase_DropdownBase_DropdownBase.defaultProps = {
  maxHeight: ''
};

//# sourceMappingURL=DropdownBase.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-dropdown/lib/esm/components/Dropdown/Dropdown.js
function Dropdown__extends() { Dropdown__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Dropdown__extends.apply(this, arguments); }

function Dropdown__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var Dropdown_Dropdown =
/*#__PURE__*/
function (_Component) {
  Dropdown__inheritsLoose(Dropdown, _Component);

  function Dropdown(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.closeDropdown = function () {
      _this.setState({
        open: false
      });
    };

    _this.handleDropdownClick = function () {
      var open = _this.state.open;

      if (open) {
        _this.setState({
          open: false
        });
      } else {
        _this.setState({
          open: true
        });
      }
    };

    _this.state = {
      open: props.open || false
    };
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.ignoreNextProps) {
      return;
    }

    if (nextProps.open) {
      this.setState({
        open: true
      });
    } else {
      this.setState({
        open: false
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.open !== prevState.open) {
      if (this.state.open) {
        if (this.props.onDropdownShow) {
          this.props.onDropdownShow();
        }
      } else if (this.props.onDropdownHide) {
        this.props.onDropdownHide();
      }
    }
  };

  _proto.render = function render() {
    return react_default.a.createElement(DropdownBase_DropdownBase_DropdownBase, Dropdown__extends({}, this.props, {
      onTouch: this.closeDropdown,
      onBlur: this.closeDropdown,
      onDropdownClick: this.handleDropdownClick,
      open: this.state.open
    }));
  };

  return Dropdown;
}(react["Component"]);

Dropdown_Dropdown.propTypes = {
  /** id attribute of the Dropdown. Used for aria-labeledby value of dropdown list. */
  id: prop_types_default.a.string.isRequired,

  /** Text to display on the Dropdown button. */
  label: prop_types_default.a.node.isRequired,

  /** Array of links to generate.  Shape contains: `link`, `text`, and `cssClass`. */
  links: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    link: prop_types_default.a.string,
    text: prop_types_default.a.string,
    className: prop_types_default.a.string
  })),

  /** Event handler to fire when dropdown has opened. */
  onDropdownShow: prop_types_default.a.func,

  /** Event handler to fire when dropdown has closed. */
  onDropdownHide: prop_types_default.a.func,

  /** Flag to control if the Dropdown is open via an external state management. */
  open: prop_types_default.a.bool,

  /** Child content of Dropdown button if not using standard label prop. */
  buttonChildren: prop_types_default.a.node,

  /** Render the toggle as a custom React component. */
  customToggle: prop_types_default.a.element,

  /** Flag to specify that the button label is Screen Reader only. Usually used with props.buttonChildren. */
  srOnlyLabel: prop_types_default.a.bool,

  /** Flag to keep the arrow icon from appearing to the right of the text. */
  noArrow: prop_types_default.a.bool,

  /** Flag to keep have the dropdown menu open from the right. */
  dropdownRight: prop_types_default.a.bool,

  /** Flag to keep the component open upon children updating */
  ignoreNextProps: prop_types_default.a.bool,

  /** Set max height of the dropdown menu */
  maxHeight: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
};

//# sourceMappingURL=Dropdown.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-dropdown/lib/esm/components/DropdownControlled/DropdownControlled.js



function DropdownControlled(props) {
  return react_default.a.createElement(DropdownBase_DropdownBase_DropdownBase, props);
}
DropdownControlled.propTypes = {
  /** id attribute of the Dropdown. Used for aria-labeledby value of dropdown list. */
  id: prop_types_default.a.string.isRequired,

  /** Text to display on the Dropdown button. */
  label: prop_types_default.a.node.isRequired,

  /** Array of links to generate.  Shape contains: `link`, `text`, and `cssClass`. */
  links: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    link: prop_types_default.a.string,
    text: prop_types_default.a.string,
    className: prop_types_default.a.string
  })),

  /** Flag to control if the Dropdown is open via an external state management. */
  open: prop_types_default.a.bool,

  /** Child content of Dropdown button if not using standard label prop. */
  buttonChildren: prop_types_default.a.node,

  /** Render the toggle as a custom React component. */
  customToggle: prop_types_default.a.element,

  /** Flag to specify that the button label is Screen Reader only. Usually used with props.buttonChildren. */
  srOnlyLabel: prop_types_default.a.bool,

  /** Flag to keep the arrow icon from appearing to the right of the text. */
  noArrow: prop_types_default.a.bool,

  /** Flag to keep have the dropdown menu open from the right. */
  dropdownRight: prop_types_default.a.bool,

  /** callback for when the dropdown is clicked */
  onDropdownClick: prop_types_default.a.func,

  /** callback for touch devices tapping off of the dropdown / dropdown list */
  onTouch: prop_types_default.a.func,

  /** callback for when the dropdown / dropdown list loses focus */
  onBlur: prop_types_default.a.func,

  /** Set max height of the dropdown menu */
  maxHeight: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
};
//# sourceMappingURL=DropdownControlled.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-dropdown/lib/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Dropdown", function() { return Dropdown_Dropdown; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DropdownControlled", function() { return DropdownControlled; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DropdownItem", function() { return components_DropdownItem_DropdownItem; });



/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all your work in component and subcomponent files.
**/


//# sourceMappingURL=index.js.map

/***/ }),

/***/ "CWk1":
/***/ (function(module, exports, __webpack_require__) {

/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
**/
var SVGDefinitions = __webpack_require__("1gbD").default;

var SVGIcon = __webpack_require__("MRHp").default;

module.exports = {
  SVGDefinitions: SVGDefinitions,
  SVGIcon: SVGIcon
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "Cmpj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CtGM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _abacusClientUtils = __webpack_require__("k4AA");

var _abacusClientUtils2 = _interopRequireDefault(_abacusClientUtils);

var _reactDetermineIfMobile = __webpack_require__("IlRX");

var _reactDetermineIfMobile2 = _interopRequireDefault(_reactDetermineIfMobile);

var _reactSvg = __webpack_require__("CWk1");

var _MENU__ = __webpack_require__("J9Bc");

var _ListYourProperty = __webpack_require__("MUld");

var _Logo = __webpack_require__("k4Yh");

var _Nav = __webpack_require__("1whP");

var _Tray = __webpack_require__("s3LP");

var _reactFeedback = __webpack_require__("I+kC");

var _reactFeedback2 = _interopRequireDefault(_reactFeedback);

__webpack_require__("bf7X");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO: consider how best to integrate A/B test state
// let multivtest = require('@homeaway/stab-multivtest-utils');

var SiteHeader = (_temp = _class = function (_React$Component) {
    _inherits(SiteHeader, _React$Component);

    function SiteHeader(props) {
        _classCallCheck(this, SiteHeader);

        var _this = _possibleConstructorReturn(this, (SiteHeader.__proto__ || Object.getPrototypeOf(SiteHeader)).call(this, props));

        _this.determineAvatar = function (traveler) {
            if (traveler && traveler.avatar && !traveler.avatar.image) {
                traveler.avatar.image = _this.props.defaultAvatar;
            }

            return traveler;
        };

        _this.updateLogoutUrl = function (traveler) {
            if (!traveler || !traveler.items) {
                return;
            }

            var itemIndex = void 0;
            var item = void 0;

            traveler.items.forEach(function (currentItem, i) {
                if (currentItem.cssClass === 'se-traveler-logout') {
                    itemIndex = i;
                    item = currentItem;
                }
            });

            if (!_this.props.logoutRedirectUrl || !item) {
                return;
            }

            var serviceRE = /(^.*service=)(.*)/;

            // update traveler's logout link to use logoutUrl prop instead
            var newServiceParameter = encodeURIComponent(_this.props.logoutRedirectUrl);
            item.link = item.link.replace(serviceRE, '$1' + newServiceParameter);
            item.linkUpdated = true;
            traveler.items[itemIndex] = item;
        };

        _this.handleToggleOpenTray = function () {
            var body = document.querySelector('body');

            _this.setState({
                isTrayOpen: !_this.state.isTrayOpen
            }, function () {
                // FIXME: Not ideal, but this gives us the desired in/out animation
                /* istanbul ignore next */
                if (_this.state.isTrayOpen) {
                    body.classList.add('site-header-tray-open', 'site-header-tray-fixed');
                } else {
                    body.classList.remove('site-header-tray-open');
                    setTimeout(function () {
                        return body.classList.remove('site-header-tray-fixed');
                    }, 500);
                }
                _this.props.onTrayChange(_this.state.isTrayOpen);
            });
        };

        _this.feedbackComponent = function (_ref) {
            var _ref$className = _ref.className,
                className = _ref$className === undefined ? '' : _ref$className,
                _ref$feedbackTabClass = _ref.feedbackTabClassList,
                feedbackTabClassList = _ref$feedbackTabClass === undefined ? '' : _ref$feedbackTabClass;
            return _react2.default.createElement(_reactFeedback2.default, { className: className, feedbackTabClassList: feedbackTabClassList, lingua: _this.props.feedbackComponentLingua });
        };

        var hasSearch = !!props.features && !!props.features.search;

        _this.state = {
            hasSearch: hasSearch,
            isTrayOpen: props.isTrayOpen
        };
        return _this;
    }

    /* istanbul ignore next */


    _createClass(SiteHeader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // @ts-ignore
            if (window && window.__ABACUS__) {
                var experimentNames = ['HA_GX_COUNTRY_LANGUAGE_SELECTOR', 'HA_GX_COUNTRY_LANGUAGE_SELECTOR_NL', 'HA_GX_CURRENCY_SELECTOR'];

                for (var _iterator = experimentNames, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                    var _ref2;

                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref2 = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref2 = _i.value;
                    }

                    var experimentName = _ref2;

                    // @ts-ignore
                    if (window.__ABACUS__[experimentName]) {
                        _abacusClientUtils2.default.evaluateExperimentAndLog(experimentName);
                    }
                }
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            if (this.props.isTrayOpen !== props.isTrayOpen) {
                this.setState({
                    isTrayOpen: props.isTrayOpen
                });
            }
        }
    }, {
        key: 'render',


        // eslint-disable-next-line complexity
        value: function render() {
            var _props = this.props,
                feedbackComponentLingua = _props.feedbackComponentLingua,
                displayTrayJewel = _props.displayTrayJewel;


            var siteHeaderTrayToggleClass = 'site-header__tray-toggle hidden-md hidden-lg';
            if (displayTrayJewel) {
                siteHeaderTrayToggleClass += ' display-jewel';
            }
            return _react2.default.createElement(
                'div',
                { className: this.className },
                this.props.isMobile && !this.props.withoutTray && _react2.default.createElement(_Tray.Tray, {
                    countryCode: this.countryCode,
                    currencyCode: this.currencyCode,
                    currencySelector: this.currencySelector,
                    extraNav: this.props.extraNav,
                    feedbackComponent: feedbackComponentLingua && this.feedbackComponent({ className: 'site-header-tray__menu-item-link' }) // adding classnames of surrounding elements to feedback-component so it can inherit and fit in new context
                    , flags: this.flags,
                    globalizationSelector: this.props.globalizationSelector,
                    handleToggleOpen: this.handleToggleOpenTray,
                    help: this.help,
                    inbox: this.travelerInbox,
                    inverse: this.props.isInverse,
                    isOpen: this.state.isTrayOpen,
                    languageCode: this.languageCode,
                    login: this.login,
                    lyp: !this.props.withoutListYourProperty && this.props.lyp,
                    openLinksInNewWindow: this.props.openLinksInNewWindow,
                    renderCountryLanguageSelector: !this.props.withoutCountryLanguageSelector,
                    renderCurrencySelector: !this.props.withoutCurrencySelector,
                    scratchpad: this.scratchpad,
                    traveler: this.traveler
                }),
                !this.props.withoutTray && _react2.default.createElement(
                    'a',
                    {
                        className: siteHeaderTrayToggleClass,
                        onClick: this.handleToggleOpenTray,
                        onKeyPress: this.handleToggleOpenTray,
                        role: 'button',
                        tabIndex: 0
                    },
                    _react2.default.createElement(_reactSvg.SVGIcon, { markup: _MENU__.MENU__24 })
                ),
                this.props.logo && _react2.default.createElement(_Logo.Logo, _extends({}, this.props.logo, {
                    hasSearch: this.state.hasSearch,
                    image: this.logoImage,
                    partnerLogo: this.props.partnerLogo
                })),
                _react2.default.createElement(
                    'div',
                    { className: 'site-header__flex-spacer' },
                    this.props.children
                ),
                !this.props.isMobile && !this.props.withoutNav && _react2.default.createElement(_Nav.Nav, {
                    countryCode: this.countryCode,
                    currencyCode: this.currencyCode,
                    currencySelector: this.currencySelector,
                    extraNav: this.props.extraNav,
                    feedbackComponent: feedbackComponentLingua && this.feedbackComponent({ className: 'site-header-nav__link site-header-nav__dropdown' }) // adding classnames of surrounding elements to feedback-component so it can inherit and fit in new context
                    , flags: this.flags,
                    globalizationSelector: this.props.globalizationSelector,
                    help: this.help,
                    inbox: this.travelerInbox,
                    internalTools: this.props.internalTools,
                    isInverse: this.props.isInverse,
                    languageCode: this.languageCode,
                    login: this.login,
                    openLinksInNewWindow: this.props.openLinksInNewWindow,
                    renderCountryLanguageSelector: !this.props.withoutCountryLanguageSelector,
                    renderCurrencySelector: !this.props.withoutCurrencySelector,
                    scratchpad: this.scratchpad,
                    traveler: this.traveler
                }),
                !this.props.isMobile && this.props.lyp && !this.props.withoutListYourProperty && _react2.default.createElement(_ListYourProperty.ListYourProperty, _extends({}, this.props.lyp, {
                    isInverse: this.props.isInverse
                }))
            );
        }
    }, {
        key: 'className',
        get: function get() {
            return (0, _classnames2.default)('site-header', this.props.isInverse && 'site-header--inverse', 'border-border-color', this.props.siteName);
        }
    }, {
        key: 'countryCode',
        get: function get() {
            return this.props.fullLocale && this.props.fullLocale.split('_')[1].toLowerCase();
        }
    }, {
        key: 'currencyCode',
        get: function get() {
            return this.props.currencyCode;
        }
    }, {
        key: 'currencySelector',
        get: function get() {
            return this.props.currencySelector;
        }
    }, {
        key: 'flags',
        get: function get() {
            if (this.props.withoutFlags) {
                return false;
            }

            return this.props.flags;
        }
    }, {
        key: 'help',
        get: function get() {
            if (this.props.withoutHelpLinks && this.props.help) {
                var help = _extends({}, this.props.help);

                help.items = help.items.slice(0, 6);

                return help;
            }

            return this.props.help;
        }
    }, {
        key: 'languageCode',
        get: function get() {
            return this.props.fullLocale.substr(0, 5);
        }
    }, {
        key: 'login',
        get: function get() {
            if (this.props.withoutLogin) {
                return false;
            }

            if (this.props.login && this.props.travelerLoginClickHandler) {
                this.props.login.travelerLoginClickHandler = this.props.travelerLoginClickHandler;
            }

            return this.props.login;
        }

        // TODO: Remove this and return this.props.logo.image when the data
        // provided by the header service contains the correct vrbo logo image

    }, {
        key: 'logoImage',
        get: function get() {
            if (this.props.siteName === 'vrbo' && !this.props.isInverse) {
                return this.props.vrboLogoImage;
            }

            return this.props.logo.image;
        }
    }, {
        key: 'scratchpad',
        get: function get() {
            if (this.props.withoutScratchpad) {
                return false;
            }

            return this.props.scratchpad;
        }
    }, {
        key: 'traveler',
        get: function get() {
            if (this.props.withoutTraveler) {
                return false;
            }

            // defensive copy to protect props as updateLogoutUrl and determineAvatar are destructive
            var traveler = typeof this.props.traveler !== 'undefined' ? JSON.parse(JSON.stringify(this.props.traveler)) : this.props.traveler;

            this.updateLogoutUrl(traveler);

            return this.determineAvatar(traveler);
        }
    }, {
        key: 'travelerInbox',
        get: function get() {
            if (this.props.withoutInbox) {
                return false;
            }

            return this.props.travelerInbox;
        }

        // Allow passing in custom classnames so that
        // feedback-component is more flexible when rendering
        // within contexts outside of its default use case.

    }]);

    return SiteHeader;
}(_react2.default.Component), _class.propTypes = {
    currencyCode: _propTypes2.default.string,
    displayTrayJewel: _propTypes2.default.bool,
    fullLocale: _propTypes2.default.string,
    homeAwayWhiteLogoImage: _propTypes2.default.string,
    inverseVrboLogoImage: _propTypes2.default.string,
    isFlagsDisabled: _propTypes2.default.bool,
    isInverse: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool,
    isTrayOpen: _propTypes2.default.bool,
    logoutRedirectUrl: _propTypes2.default.string,
    onTrayChange: _propTypes2.default.func,
    openLinksInNewWindow: _propTypes2.default.bool,
    vrboLogoImage: _propTypes2.default.string,
    withoutCountryLanguageSelector: _propTypes2.default.bool,
    withoutCurrencySelector: _propTypes2.default.bool,
    withoutFlags: _propTypes2.default.bool,
    withoutHelpLinks: _propTypes2.default.bool,
    withoutInbox: _propTypes2.default.bool,
    withoutListYourProperty: _propTypes2.default.bool,
    withoutLogin: _propTypes2.default.bool,
    withoutNav: _propTypes2.default.bool,
    withoutScratchpad: _propTypes2.default.bool,
    withoutSearch: _propTypes2.default.bool,
    withoutTraveler: _propTypes2.default.bool,
    withoutTray: _propTypes2.default.bool
}, _class.defaultProps = {
    defaultAvatar: '//csvcus.homeaway.com/rsrcs/cdn-logos/2.10.3/bce/brand/misc/default-profile-pic.svg',
    displayTrayJewel: false,
    features: {},
    fullLocale: 'en_US_HA',
    homeAwayWhiteLogoImage: '//csvcus.homeaway.com/rsrcs/cdn-logos/2.9.2/bce/moniker/homeaway_us/logo-bceheader-white.svg',
    isInverse: false,
    onTrayChange: function onTrayChange() {},
    withoutCountryLanguageSelector: true,
    withoutCurrencySelector: true,
    vrboLogoImage: '//csvcus.homeaway.com/rsrcs/cdn-logos/2.9.2/bce/moniker/vrbo/logo.svg'
}, _temp);
exports.default = (0, _reactDetermineIfMobile2.default)(SiteHeader);
//# sourceMappingURL=SiteHeader.js.map

/***/ }),

/***/ "DwxB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MessageReader = __webpack_require__("odsh");
var CATEGORY = 'messages';

/**
 * Read a message via a key and variable options object
 * @param key String
 * @param options Object containing name/value pairs
 * @category lingua key category
 */
function read(key, options, category) {
    // eslint-disable-line complexity
    if (typeof category === 'undefined') {
        return MessageReader.read(key, options, CATEGORY);
    }
    /* istanbul ignore next */
    return MessageReader.read(key, options, category);
}

/**
 * Determine if a key is supported for the current locale
 * @param key String
 * @return keyExists Boolean
 */
function exists(key) {
    return MessageReader.exists(key, CATEGORY);
}

module.exports = {
    read: read,
    exists: exists
};
//# sourceMappingURL=lingua.message.js.map

/***/ }),

/***/ "F1Vd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("mjTi");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderSectionComponent = function (_Component) {
    _inherits(HeaderSectionComponent, _Component);

    function HeaderSectionComponent() {
        _classCallCheck(this, HeaderSectionComponent);

        return _possibleConstructorReturn(this, (HeaderSectionComponent.__proto__ || Object.getPrototypeOf(HeaderSectionComponent)).apply(this, arguments));
    }

    _createClass(HeaderSectionComponent, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'HeaderSection' },
                _react2.default.createElement(
                    'h2',
                    { className: 'card__content text-300 text-white' },
                    this.props.header
                )
            );
        }
    }]);

    return HeaderSectionComponent;
}(_react.Component);

exports.default = HeaderSectionComponent;
//# sourceMappingURL=HeaderSectionComponent.js.map

/***/ }),

/***/ "G0gq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("0pa/");

var _reactButtons = __webpack_require__("WAAH");

var _api = __webpack_require__("cGdw");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatePasswordComponent = function (_Component) {
    _inherits(CreatePasswordComponent, _Component);

    function CreatePasswordComponent(props) {
        _classCallCheck(this, CreatePasswordComponent);

        var _this = _possibleConstructorReturn(this, (CreatePasswordComponent.__proto__ || Object.getPrototypeOf(CreatePasswordComponent)).call(this, props));

        _this.state = {
            emailAddress: _this.props.emailAddress
        };
        _this.returnToResetPassword = _this.returnToResetPassword.bind(_this);
        return _this;
    }

    _createClass(CreatePasswordComponent, [{
        key: 'returnToResetPassword',
        value: function returnToResetPassword() {
            var _this2 = this;

            var url = '/auth/aam/v3/password/reset';
            var body = {
                'emailAddress': this.state.emailAddress,
                serviceUrl: this.props.service
            };

            (0, _api.apiPost)(url, body).then(function (_ref) {
                var status = _ref.status;

                if (status === 204) {
                    _this2.props.updatePage('passwordreset');
                } else {
                    _this2.props.handleError(_this2.props.lingua.read('error.generic'), '');
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.displayButton === true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'text-center' },
                    _react2.default.createElement(_reactButtons.ButtonPrimary, { className: 'Create-password-btn', label: this.props.lingua.read('lex.password.create.mu'), onClick: this.returnToResetPassword })
                );
            }
            return _react2.default.createElement(
                'div',
                { className: 'text-center' },
                _react2.default.createElement(_reactButtons.ButtonLink, { className: 'Link', label: this.props.lingua.read('lex.password.create.option'), onClick: this.returnToResetPassword })
            );
        }
    }]);

    return CreatePasswordComponent;
}(_react.Component);

exports.default = CreatePasswordComponent;
//# sourceMappingURL=CreatePasswordComponent.js.map

/***/ }),

/***/ "GL8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEvaluationDataWithException = getEvaluationDataWithException;
exports.getEmptyEvaluationData = getEmptyEvaluationData;

var _EvaluationData = __webpack_require__("qwsy");

var _EvaluationData2 = _interopRequireDefault(_EvaluationData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEvaluationDataWithException() {
    return new _EvaluationData2.default({
        entityId: 'INVALID_ENTITY_ID',
        experimentKey: {
            experimentId: 99991,
            experimentName: 'INVALID_EXPERIMENT_NAME'
        },
        experimentInstanceId: 99990,
        bucket: {
            bucketValue: 0,
            calculationType: {
                typeIdentifier: 'F'
            }
        },
        value: 0,
        exception: true
    });
}

function getEmptyEvaluationData() {
    return new _EvaluationData2.default({});
}
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "H63A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HfJ9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Button = _interopRequireDefault(__webpack_require__("r3Qk"));

exports.Button = _Button.default;

var _ButtonPrimary = _interopRequireDefault(__webpack_require__("cF5y"));

exports.ButtonPrimary = _ButtonPrimary.default;

var _ButtonOverlay = _interopRequireDefault(__webpack_require__("tjWm"));

exports.ButtonOverlay = _ButtonOverlay.default;

var _ButtonLink = _interopRequireDefault(__webpack_require__("Ij4d"));

exports.ButtonLink = _ButtonLink.default;

var _ButtonIcon = _interopRequireDefault(__webpack_require__("AUAB"));

exports.ButtonIcon = _ButtonIcon.default;

var _ButtonIconPrimary = _interopRequireDefault(__webpack_require__("xjgv"));

exports.ButtonIconPrimary = _ButtonIconPrimary.default;

var _ButtonIconOverlay = _interopRequireDefault(__webpack_require__("heEr"));

exports.ButtonIconOverlay = _ButtonIconOverlay.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "Hgtn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ "I+kC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("GiK3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-feedback/lib/esm/components/FeedbackLinks/FeedbackLinks.js

function FeedbackLinks(props) {
  return react_default.a.createElement("div", null, react_default.a.createElement("div", {
    className: "panel panel-default"
  }, react_default.a.createElement("div", {
    className: "panel-heading"
  }, react_default.a.createElement("h3", {
    className: "panel-title"
  }, react_default.a.createElement("a", {
    href: props.lingua.reviewLink,
    target: "_blank"
  }, props.lingua.reviewLinkText, react_default.a.createElement("span", {
    className: "sr-only"
  }, props.lingua.externalLinkSrText))))), react_default.a.createElement("div", {
    className: "panel panel-default"
  }, react_default.a.createElement("div", {
    className: "panel-heading"
  }, react_default.a.createElement("h3", {
    className: "panel-title"
  }, react_default.a.createElement("a", {
    href: props.lingua.helpLink,
    target: "_blank"
  }, props.lingua.helpLinkText, react_default.a.createElement("span", {
    className: "sr-only"
  }, props.lingua.externalLinkSrText))))), !props.disableSiteFeedback && react_default.a.createElement("div", {
    className: "panel panel-default"
  }, react_default.a.createElement("div", {
    className: "panel-heading",
    onClick: props.opinionLabInstance.createLauncher,
    role: "presentation"
  }, react_default.a.createElement("h3", {
    className: "panel-title"
  }, react_default.a.createElement("a", {
    href: "#",
    target: "_blank"
  }, props.lingua.supportLinkText, react_default.a.createElement("span", {
    className: "sr-only"
  }, props.lingua.externalLinkSrText))))));
}
//# sourceMappingURL=FeedbackLinks.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-modal/lib/esm/index.js + 6 modules
var esm = __webpack_require__("XSjK");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-feedback/lib/esm/components/FeedbackTab/FeedbackTab.css
var FeedbackTab = __webpack_require__("LuCE");
var FeedbackTab_default = /*#__PURE__*/__webpack_require__.n(FeedbackTab);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-feedback/lib/esm/components/FeedbackTab/FeedbackTab.js



function FeedbackTab_FeedbackTab(props) {
  var _classnames;

  var classNames = classnames_default()(props.className, (_classnames = {}, _classnames["Feedback Feedback--" + props.tabPosition] = !props.className, _classnames));
  return react_default.a.createElement("div", null, props.children, react_default.a.createElement("div", {
    id: "Feedback",
    className: classNames
  }, react_default.a.createElement("div", {
    "aria-label": props.tabText,
    "aria-haspopup": "true",
    "aria-expanded": props.isOpen,
    "aria-controls": "react-feedback",
    role: "button",
    tabIndex: "0",
    onClick: props.onClick,
    onKeyPress: props.onPress,
    className: props.feedbackTabClassList
  }, props.tabText)));
}
//# sourceMappingURL=FeedbackTab.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-feedback/lib/esm/utils/OpinionLab.js
var HAV_COOKIE_NAME = 'hav';
var ADL_WHITELIST = ['appname', 'appversion', 'sessionid', 'visitorid', 'fssessionurl'];

var OpinionLab =
/*#__PURE__*/
function () {
  function OpinionLab() {
    var _this = this;

    this.getCookie = function (name) {
      var cookieRegExp = new RegExp(name + "=([^;]+)");
      var value = cookieRegExp.exec(document.cookie);
      return value !== null ? decodeURIComponent(value[1]) : null;
    };

    this.checkState = function (cb, script) {
      var state = script.readyState;

      if (!state || /complete/.test(state)) {
        return cb;
      }

      return function () {
        throw new Error('OpinionLab global object not present');
      };
    };

    this.loadScript = function (cb, source) {
      if (document.getElementById('opinionlab')) {
        return;
      }

      var script = document.createElement('script');
      var src = source || '//csvcus.homeaway.com/rsrcs/stab-feedback/1.2.2/javascripts/opinionlab/oo_engine.min.js';
      script.type = 'text/javascript';
      script.onload = _this.checkState(cb, script);
      script.id = 'opinionlab';
      script.src = src;
      (document.body || document.head).appendChild(script);
      return script; // eslint-disable-line consistent-return
    };

    this.createLauncher = function (event) {
      OpinionLab.cleanUpFormElement();
      var windowOOo = window.OOo;

      if (windowOOo) {
        var options = {
          customVariables: {}
        };
        var ADL = window.analyticsdatalayer;

        if (ADL) {
          // It is necessary to encode ADL values
          // because the presence of commas will break
          // OL's parser resulting in loss of the ADL
          // custom variable
          ADL_WHITELIST.forEach(function (key) {
            if (ADL[key]) {
              options.customVariables[key] = encodeURIComponent(ADL[key]);
            }
          });
        }

        if (typeof document !== 'undefined' && document.cookie.indexOf(HAV_COOKIE_NAME) !== -1) {
          options.customVariables[HAV_COOKIE_NAME] = encodeURIComponent(_this.getCookie(HAV_COOKIE_NAME));
        }

        windowOOo.oo_feedback = new windowOOo.Ocode(options);
        windowOOo.oo_feedback.show(event);
      } else {
        throw new Error('OpinionLab global object not loaded');
      }
    };
  }

  OpinionLab.cleanUpFormElement = function cleanUpFormElement() {
    var olFormElements = document.querySelectorAll('[target="OnlineOpinion"]');

    if (olFormElements.length) {
      olFormElements.forEach(function (element) {
        return element.remove();
      });
    }
  };

  return OpinionLab;
}();

/* harmony default export */ var utils_OpinionLab = (OpinionLab);
//# sourceMappingURL=OpinionLab.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-feedback/lib/esm/components/Feedback/Feedback.js
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }








var Feedback_Feedback =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Feedback, _Component);

  function Feedback(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleOpen = function () {
      _this.handleOpenAndLoad();
    };

    _this.handleOnPress = function (e) {
      var code = e.charCode || e.keyCode;

      if (code === 32 || code === 13) {
        // Check if enter key or space bar were pressed
        _this.handleOpenAndLoad();
      }
    };

    _this.handleClose = function () {
      _this.setState({
        isOpen: false
      });

      utils_OpinionLab.cleanUpFormElement();
    };

    _this.handleOpenAndLoad = function () {
      var currentisOpen = _this.state.isOpen;

      _this.setState({
        isOpen: !currentisOpen
      });

      if (!_this.props.disableSiteFeedback) {
        _this.opinionLabInstance.loadScript();
      }
    };

    _this.setDialogFocus = function () {
      if (typeof document !== 'undefined') {
        document.getElementById('react-feedback').focus();
      }
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  var _proto = Feedback.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.opinionLabInstance = new utils_OpinionLab();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        tabPosition = _this$props.tabPosition,
        lingua = _this$props.lingua,
        feedbackTabClassList = _this$props.feedbackTabClassList,
        disableSiteFeedback = _this$props.disableSiteFeedback,
        className = _this$props.className;
    return react_default.a.createElement(FeedbackTab_FeedbackTab, {
      isOpen: this.state.isOpen,
      onClick: this.handleOpen,
      onPress: this.handleOnPress,
      tabText: lingua.tabText,
      tabPosition: tabPosition,
      feedbackTabClassList: feedbackTabClassList,
      className: className
    }, react_default.a.createElement(esm["default"], {
      id: "react-feedback",
      isOpen: this.state.isOpen,
      onClose: this.handleClose,
      onModalOpen: this.setDialogFocus,
      title: lingua.title
    }, react_default.a.createElement(FeedbackLinks, {
      lingua: lingua,
      opinionLabInstance: this.opinionLabInstance,
      disableSiteFeedback: disableSiteFeedback
    })));
  };

  return Feedback;
}(react["Component"]);

Feedback_Feedback.propTypes = {
  /** Object containing lingua translations for the current locale. It is assumed that the parent app will prepare and provide the lingua object matching the shape seen here. */
  lingua: prop_types_default.a.shape({
    tabText: prop_types_default.a.string,
    title: prop_types_default.a.string,
    reviewLink: prop_types_default.a.string,
    reviewLinkText: prop_types_default.a.string,
    helpLink: prop_types_default.a.string,
    helpLinkText: prop_types_default.a.string,
    supportLinkText: prop_types_default.a.string,
    externalLinkSrText: prop_types_default.a.string
  }),

  /** Desired position on screen to render the feedback tab. Valid options are: left, right, and bottom */
  tabPosition: prop_types_default.a.oneOf(['bottom', 'right', 'left']),

  /** allows consuming app to customize the feedback tab via a string of classnames that will be applied to the feedback tab */
  feedbackTabClassList: prop_types_default.a.string,

  /** Disable rendering of OpinionLab site feedback option which also prevents loading associated scripts */
  disableSiteFeedback: prop_types_default.a.bool
};
Feedback_Feedback.defaultProps = {
  lingua: {
    tabText: 'Feedback',
    title: 'Feedback',
    reviewLink: 'https://help.homeaway.com/articles/How-do-I-submit-a-review',
    reviewLinkText: 'I would like to leave a review for a property',
    helpLink: 'https://help.homeaway.com/',
    helpLinkText: 'I have an issue or question and would like some help',
    supportLinkText: 'I want to leave a comment for this web site',
    externalLinkSrText: 'Opens in a new window'
  },
  tabPosition: 'bottom',
  feedbackTabClassList: 'Feedback__tab btn btn-default',
  disableSiteFeedback: false
};
/* harmony default export */ var components_Feedback_Feedback = (Feedback_Feedback);
//# sourceMappingURL=Feedback.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-feedback/lib/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "default", function() { return components_Feedback_Feedback; });
/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
**/

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "I+n6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I71r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _facebook = __webpack_require__("P8LM");

var _reactButtons = __webpack_require__("WAAH");

var _reactSvg = __webpack_require__("CWk1");

var _FACEBOOK__ = __webpack_require__("OPbx");

var _FACEBOOK_COLOR__ = __webpack_require__("A95e");

var _reactLoadScript = __webpack_require__("gkR1");

var _reactLoadScript2 = _interopRequireDefault(_reactLoadScript);

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

var _api = __webpack_require__("cGdw");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clientLogger = __webpack_require__("29Zd");

var _clientLogger2 = _interopRequireDefault(_clientLogger);

var _AuthAccountTypes = __webpack_require__("ku0b");

var _AuthAccountTypes2 = _interopRequireDefault(_AuthAccountTypes);

var _ums = __webpack_require__("t0XK");

var _ums2 = _interopRequireDefault(_ums);

__webpack_require__("H63A");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FacebookAuthComponent = function (_Component) {
    _inherits(FacebookAuthComponent, _Component);

    _createClass(FacebookAuthComponent, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                actionLocation: _propTypes2.default.string,
                enableLoading: _propTypes2.default.func,
                disableLoading: _propTypes2.default.func
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                enableLoading: function enableLoading() {},
                disableLoading: function disableLoading() {}
            };
        }
    }]);

    function FacebookAuthComponent(props) {
        _classCallCheck(this, FacebookAuthComponent);

        // Window doesn't exist server side so this is needed, we need to pass a valid host name or component will not load in catalyst app!
        var _this = _possibleConstructorReturn(this, (FacebookAuthComponent.__proto__ || Object.getPrototypeOf(FacebookAuthComponent)).call(this, props));

        var hostName = typeof window !== 'undefined' ? window.location.hostname : 'localhost.com';
        var hostSettings = (0, _facebook.get)(hostName, _this.props.locale);
        _this.state = {
            settings: hostSettings,
            scriptUrl: 'https://connect.facebook.net/' + hostSettings.locale + '/sdk.js',
            // these are all the fields facebook gives you for free
            // being explicit as light box never makes this call
            scope: 'public_profile,email',
            loggedIn: false,
            locale: _this.props.locale
        };
        // per https://developers.facebook.com/docs/javascript/quickstart
        var appId = _this.state.settings.appId;
        if (typeof window !== 'undefined') {
            // Window doesn't exist server side so this is needed or app will fail
            window.fbAsyncInit = function () {
                try {
                    window.FB.init({
                        appId: appId,
                        autoLogAppEvents: true,
                        xfbml: false,
                        version: 'v2.10',
                        oauth: true,
                        status: true
                    });
                } catch (error) {
                    _clientLogger2.default.logError('An error has occurred while trying to initialize FB script: ' + error);
                }
            };
        }
        _this.onClickFB = _this.onClickFB.bind(_this);
        _this.authFacebook = _this.authFacebook.bind(_this);
        _this.authenticate = _this.authenticate.bind(_this);
        _this.register = _this.register.bind(_this);
        _this.loginAttempt = _this.loginAttempt.bind(_this);
        _this.loginFailure = _this.loginFailure.bind(_this);
        _this.loginSuccess = _this.loginSuccess.bind(_this);
        _this.checkStatus = _this.checkStatus.bind(_this);
        _this.failLogin = _this.failLogin.bind(_this);
        _this.facebookAuthStatus = _this.facebookAuthStatus.bind(_this);
        _this.displayFacebookLabel = _this.displayFacebookLabel.bind(_this);
        _this.handleScriptError = _this.handleScriptError.bind(_this);
        _this.handleScriptLoad = _this.handleScriptLoad.bind(_this);
        _this.handleFacebookError = _this.handleFacebookError.bind(_this);
        if (_this.props.token) {
            _this.register(_this.props.token, _this.props.emailAddress);
        }
        return _this;
    }

    _createClass(FacebookAuthComponent, [{
        key: 'loginSuccess',
        value: function loginSuccess(json) {
            this.setState({ loggedIn: true });
            (0, _edapWrapper2.default)().push({
                name: 'login.success',
                data: { logintype: 'facebook', loginsource: 'lex', publicuuid: json.publicUuid, actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.props.setAuthJson(json);
            this.props.onClose();
        }
    }, {
        key: 'loginFailure',
        value: function loginFailure() {
            this.setState({ loggedIn: false });
            (0, _edapWrapper2.default)().push({
                name: 'login.failure',
                data: { logintype: 'facebook', loginsource: 'lex', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.props.handleError(this.props.lingua.read('error.generic'));
        }
    }, {
        key: 'loginAttempt',
        value: function loginAttempt() {
            (0, _edapWrapper2.default)().push({
                name: 'login.attempt',
                data: { logintype: 'facebook', loginsource: 'lex', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
        }
    }, {
        key: 'handleScriptError',
        value: function handleScriptError() {
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: {
                    eventaction: 'lexFacebookAuth.facebookScriptError',
                    eventcategory: 'lexFacebookAuth',
                    actionlocation: this.props.actionLocation
                }
            });
        }
    }, {
        key: 'handleFacebookError',
        value: function handleFacebookError() {
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: {
                    eventaction: 'lexFacebookAuth.facebookScriptResponseError',
                    eventcategory: 'lexFacebookAuth',
                    actionlocation: this.props.actionLocation
                }
            });
        }
    }, {
        key: 'handleScriptLoad',
        value: function handleScriptLoad() {
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: {
                    eventaction: 'lexFacebookAuth.facebookScriptLoad',
                    eventcategory: 'lexFacebookAuth',
                    actionlocation: this.props.actionLocation
                }
            });
        }
    }, {
        key: 'handleJson',
        value: function handleJson(json, email, token) {
            if (json) {
                if (_AuthAccountTypes2.default.isNotUndefined(json.authType)) {
                    var SIGNUP = this.checkAuthType(json.authType, _AuthAccountTypes2.default.SIGNUP);
                    if (SIGNUP && _ums2.default.isTCRequired(this.props.site)) {
                        // this is the SignUp scenario, so we need to update the pageName to TermsAndConditions only for the required EU brands
                        var pageName = 'TermsAndConditions';
                        this.props.performBulkPageUpdate(pageName, email, _AuthAccountTypes2.default.FACEBOOK, token);
                        this.props.disableLoading();
                    } else {
                        var umsOnly = this.checkAuthType(json.authType, _AuthAccountTypes2.default.UMS);
                        if (SIGNUP || umsOnly) {
                            this.register(token, email);
                        } else {
                            this.authenticate(token, email);
                        }
                    }
                }
            }
        }
    }, {
        key: 'checkAuthType',
        value: function checkAuthType(accountType, loginType) {
            return accountType.some(function (t) {
                return t === loginType;
            });
        }
    }, {
        key: 'facebookAuthStatus',
        value: function facebookAuthStatus(token, email) {
            var _this2 = this;

            var payload = {
                accessToken: token,
                authType: 'FACEBOOK'
            };

            return new Promise(function (resolve, reject) {
                (0, _api.apiPost)('/auth/aam/v3/token/status', payload).then(function (response) {
                    if (response.status >= 200 && response.status < 400) {
                        response.json().then(function (json) {
                            _this2.handleJson(json, email, token);
                            return resolve();
                        });
                    }
                }).catch(function (e) {
                    // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                    if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                        _this2.loginFailure();
                    }
                    return reject(e);
                });
            });
        }
    }, {
        key: 'authenticate',
        value: function authenticate(token, email) {
            var _this3 = this;

            if (this.props.useNewEndpoints) {
                var payload = {
                    'userName': email,
                    'authType': 'FACEBOOK',
                    'secret': token,
                    'rememberMe': true
                };

                return new Promise(function (resolve, reject) {
                    (0, _api.apiPost)('/auth/aam/v3/authenticate', payload).then(function (response) {
                        _this3.checkStatus(response, resolve, reject);
                    }).catch(function (e) {
                        _this3.failLogin(e, reject);
                    });
                });
            }
            return this.register(token, email);
        }
    }, {
        key: 'register',
        value: function register(token, email) {
            var _this4 = this;

            if (this.props.useNewEndpoints) {
                var _payload = {
                    userName: email,
                    secret: token,
                    authType: 'FACEBOOK',
                    rememberMe: true
                };
                return new Promise(function (resolve, reject) {
                    (0, _api.apiPost)('/auth/aam/v3/register', _payload).then(function (response) {
                        _this4.checkStatus(response, resolve, reject);
                    }).catch(function (e) {
                        return _this4.failLogin(e, reject);
                    });
                });
            }
            var payload = {
                email: email,
                createTicketGrantingTicket: true,
                service: window.location.href,
                oAuthToken: token,
                oAuthType: 'FACEBOOK',
                tmDeviceIdKey: '00000000-0000-0000-0000-000000000000'
            };
            return new Promise(function (resolve, reject) {
                (0, _api.apiPost)('/auth/v2/authenticate', payload).then(function (response) {
                    _this4.checkStatus(response, resolve, reject);
                }).catch(function (e) {
                    return _this4.failLogin(e, reject);
                });
            });
        }
    }, {
        key: 'failLogin',
        value: function failLogin(e, reject) {
            this.props.disableLoading();
            this.loginFailure();
            return reject(e);
        }
    }, {
        key: 'checkStatus',
        value: function checkStatus(response, resolve, reject) {
            var _this5 = this;

            if (response.status >= 200 && response.status < 400) {
                response.json().then(function (json) {
                    _this5.loginSuccess(json);
                });
                return resolve();
            }
            this.props.disableLoading();
            this.loginFailure();
            return reject();
        }
    }, {
        key: 'authFacebook',
        value: function authFacebook(response) {
            if (response.authResponse) {
                var component = this;
                /* istanbul ignore next */
                window.FB.api('/me', { fields: 'email' }, function (me) {
                    var token = response.authResponse.accessToken;
                    var email = me.email;
                    component.props.enableLoading();
                    component.facebookAuthStatus(token, email);
                });
            } else {
                this.handleFacebookError();
            }
        }
    }, {
        key: 'displayFacebookLabel',
        value: function displayFacebookLabel() {
            if (this.props.expediaIconDisplayed === true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'Facebook_label' },
                    _react2.default.createElement(
                        'label',
                        null,
                        this.props.lingua.read('lex.facebook.icon.label')
                    )
                );
            }
            return _react2.default.createElement('div', null);
        }
    }, {
        key: 'displayAppropriateButton',
        value: function displayAppropriateButton() {
            if (typeof this.props.authStatus !== 'undefined') {
                return _react2.default.createElement(
                    'div',
                    { className: 'SocialButtons__icon' },
                    _react2.default.createElement(
                        _reactButtons.ButtonPrimary,
                        { label: '', block: true, className: 'btn--facebook btn-block', onClick: this.onClickFB },
                        _react2.default.createElement(_reactSvg.SVGIcon, { className: 'btn--spacing', inlineFlex: true, markup: _FACEBOOK__.FACEBOOK__24 }),
                        _react2.default.createElement(
                            'span',
                            null,
                            this.props.lingua.read('lex.social.login.with.card.message.facebook')
                        )
                    )
                );
            }
            return _react2.default.createElement(
                'div',
                { className: 'small' },
                _react2.default.createElement(_reactButtons.ButtonIcon, { circle: true, svgMarkup: _FACEBOOK_COLOR__.FACEBOOK_COLOR__24, label: 'Facebook', onClick: this.onClickFB }),
                this.displayFacebookLabel()
            );
        }
    }, {
        key: 'onClickFB',
        value: function onClickFB() {
            this.loginAttempt();
            try {
                window.FB.login(this.authFacebook, { scope: this.state.scope, auth_type: 'rerequest' });
            } catch (error) {
                _clientLogger2.default.logError('An error has occurred while trying to login via FB: ' + error);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactLoadScript2.default, {
                    url: this.state.scriptUrl,
                    onError: this.handleScriptError,
                    onLoad: this.handleScriptLoad
                }),
                this.displayAppropriateButton()
            );
        }
    }]);

    return FacebookAuthComponent;
}(_react.Component);

exports.default = FacebookAuthComponent;
//# sourceMappingURL=FacebookAuthComponent.js.map

/***/ }),

/***/ "ICDg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _react = _interopRequireWildcard(__webpack_require__("GiK3"));

var _ButtonBase = _interopRequireDefault(__webpack_require__("N7cN"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _reactSvg = __webpack_require__("CWk1");

__webpack_require__("CCKR");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ButtonIcon =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ButtonIcon, _Component);

  function ButtonIcon() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ButtonIcon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        svgMarkup = _this$props.svgMarkup,
        svgId = _this$props.svgId,
        circle = _this$props.circle,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, ["svgMarkup", "svgId", "circle", "className"]);

    var buttonIconClassName = (0, _classnames.default)('btn-icon', 'ButtonIcon', className, {
      'btn-icon-circle': circle
    });
    var finalIconMarkup;

    if (svgMarkup) {
      finalIconMarkup = _react.default.createElement(_reactSvg.SVGIcon, {
        useFill: true,
        className: "flex-center",
        markup: svgMarkup
      });
    } else if (svgId) {
      finalIconMarkup = _react.default.createElement("span", {
        className: "flex-center"
      }, _react.default.createElement(_reactSvg.SVGIcon, {
        useFill: true,
        id: svgId
      }));
    }

    return _react.default.createElement(_ButtonBase.default, _extends({
      srOnlyLabel: true,
      className: buttonIconClassName
    }, rest), finalIconMarkup, this.props.children);
  };

  return ButtonIcon;
}(_react.Component);

ButtonIcon.propTypes = _extends({}, _ButtonBase.default.propTypes, {
  /** SVG markup from @homeaway/svg-defs module. Please reference directly from lib/defs/ */
  svgMarkup: _propTypes.default.string,

  /** ID name of SVG from an SVG Definition block, the xlink:href of the SVG you want. Used in the 'use' tag to grab it's definition from the SVG Definitions */
  svgId: _propTypes.default.string,

  /** Flag to determine if this component should also have className .btn-icon-circle */
  circle: _propTypes.default.bool
});
var _default = ButtonIcon;
exports.default = _default;
//# sourceMappingURL=ButtonIconBase.js.map

/***/ }),

/***/ "Ib56":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _clientLogger = __webpack_require__("29Zd");

var _clientLogger2 = _interopRequireDefault(_clientLogger);

var _api = __webpack_require__("cGdw");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lexVersion = '0.11.4';

function loadLingua(locale) {
    return new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(0).then((function (require) {
            resolve(__webpack_require__("Xv+h")("./" + locale));
        }).bind(null, __webpack_require__)).catch(function (error) {
            _clientLogger2.default.logError('Unexpected error while trying to load lingua keys error=' + error);
        });
    });
}

function loadConfig(locale, context) {
    // Window doesn't exist server side so this is needed, we need to pass a valid host name or component will not load in catalyst app!
    var hostPath = typeof window !== 'undefined' && typeof window.location !== 'undefined' && typeof window.location.origin !== 'undefined' ? window.location.origin : 'http://localhost:8080';
    var configUrl = hostPath + '/auth/ui/lex/config?context=' + context;
    var options = { locale: locale, lexVersion: lexVersion };
    return new Promise(function (resolve) {
        (0, _api.apiPost)(configUrl, options).then(function (response) {
            if (response.status === 200) {
                response.json().then(resolve);
            } else {
                resolve({});
            }
        }).catch(function () {
            resolve({});
        });
    });
}

module.exports = {
    loadLingua: loadLingua, loadConfig: loadConfig
};
//# sourceMappingURL=dynamic.load.js.map

/***/ }),

/***/ "Ij4d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _ButtonBase = _interopRequireDefault(__webpack_require__("N7cN"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ButtonLink(props) {
  var buttonClasses = (0, _classnames.default)('btn-link', props.className);
  return _react.default.createElement(_ButtonBase.default, _extends({}, props, {
    className: buttonClasses
  }));
}

ButtonLink.propTypes = _extends({}, _ButtonBase.default.propTypes);
ButtonLink.defaultProps = _extends({}, _ButtonBase.default.defaultProps);
var _default = ButtonLink;
exports.default = _default;
//# sourceMappingURL=ButtonLink.js.map

/***/ }),

/***/ "IlRX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("GiK3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/@homeaway/raf-optimized/lib/transpiled/index.js
var transpiled = __webpack_require__("pick");
var transpiled_default = /*#__PURE__*/__webpack_require__.n(transpiled);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-determine-if-mobile/lib/esm/components/DetermineIfMobile/DetermineIfMobile.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





function DetermineIfMobile(WrappedComponent, mobileBreakpoint) {
  var _class, _temp;

  if (mobileBreakpoint === void 0) {
    mobileBreakpoint = 767;
  }

  var HAS_WINDOW = typeof window !== 'undefined';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(_class, _Component);

    function _class(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.resizeCallback = function (sizeObj) {
        var isMobile = _this.isMobileByWindow(sizeObj.width);

        if (isMobile !== _this.state.isMobile) {
          _this.setState({
            isMobile: isMobile
          });
        }
      };

      _this.state = {
        isMobile: _this.isMobile(props)
      };
      return _this;
    }

    var _proto = _class.prototype;

    _proto.componentDidMount = function componentDidMount() {
      if (HAS_WINDOW) {
        this.clearResize = Object(transpiled["resize"])(this.resizeCallback);
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (HAS_WINDOW) {
        this.clearResize();
      }
    }
    /**
     * resizeCallback()
     * Callback function implemented by @homeaway/raf-optimized resize() registration
     * @param {obj} sizeObj - contains "width" and "height" properties
     */
    ;

    /**
     * isMobile()
     * Determine if component is mobile when we are not sure if we are in browser or node environment
     * @param {obj} props
     */
    _proto.isMobile = function isMobile(props) {
      if (HAS_WINDOW) {
        return this.isMobileByWindow(false);
      }

      return this.isMobileByProps(props);
    }
    /**
     * isMobileByProps()
     * Determine if component is mobile when are not in a browser environment
     * @param {obj} props
     */
    ;

    _proto.isMobileByProps = function isMobileByProps(props) {
      return props.isMobile || false;
    }
    /**
     * isMobileByWindow()
     * Determine if component is mobile when are in a browser environment
     * @param {false|int} width - provided on optimized resize() events from @homeaway/raf-optimized
     */
    ;

    _proto.isMobileByWindow = function isMobileByWindow(width) {
      if (width === void 0) {
        width = false;
      }

      if (!width) {
        width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      }

      return width <= this.props.mobileBreakpoint;
    };

    _proto.render = function render() {
      return react_default.a.createElement(WrappedComponent, _extends({}, this.props, {
        isMobile: this.state.isMobile
      }));
    };

    return _class;
  }(react["Component"]), _class.propTypes = {
    /** Point at which mobile vs desktop views are switched. Anything below or equal to this number will result in mobile view. */
    mobileBreakpoint: prop_types_default.a.number,

    /** Force value. This is useful for server-side rendering when you know if it is mobile. It helps prevent react's server/client mismatch warnings. */
    isMobile: prop_types_default.a.bool
  }, _class.defaultProps = {
    mobileBreakpoint: mobileBreakpoint
  }, _temp;
}

/* harmony default export */ var DetermineIfMobile_DetermineIfMobile = (DetermineIfMobile);
//# sourceMappingURL=DetermineIfMobile.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-determine-if-mobile/lib/esm/index.js

/* harmony default export */ var esm = __webpack_exports__["default"] = (DetermineIfMobile_DetermineIfMobile);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "IrSq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSvg = __webpack_require__("CWk1");

var _svgDefs = __webpack_require__("QnUD");

__webpack_require__("yQn5");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PreferencePanel = function (_Component) {
    _inherits(PreferencePanel, _Component);

    function PreferencePanel(props) {
        _classCallCheck(this, PreferencePanel);

        return _possibleConstructorReturn(this, (PreferencePanel.__proto__ || Object.getPrototypeOf(PreferencePanel)).call(this, props));
    }

    _createClass(PreferencePanel, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                countryCode = _props.countryCode,
                locale = _props.locale,
                languageName = _props.languageName,
                currency = _props.currency,
                languageSelectorOnly = _props.languageSelectorOnly,
                renderCountryLanguageSelector = _props.renderCountryLanguageSelector,
                renderCurrencySelector = _props.renderCurrencySelector,
                onClick = _props.onClick;

            var languageCode = locale.substr(0, 2).toUpperCase();
            return _react2.default.createElement(
                'div',
                { className: 'globalization-selector-preference', onClick: onClick, onKeyPress: onClick, role: 'button', tabIndex: '0' },
                _react2.default.createElement(
                    'div',
                    { className: 'clearfix' },
                    renderCountryLanguageSelector && _react2.default.createElement(
                        'div',
                        { className: 'preference-item' },
                        !languageSelectorOnly && _react2.default.createElement(
                            'div',
                            { className: 'preference-item__country preference-item__language' },
                            _react2.default.createElement('i', { className: 'flag-' + countryCode + ' preference-item__flag', 'aria-hidden': 'true' }),
                            _react2.default.createElement(
                                'span',
                                { className: 'preference-item__text' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'visible-lg-inline' },
                                    languageName
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'hidden-lg' },
                                    languageCode
                                )
                            )
                        ),
                        languageSelectorOnly && _react2.default.createElement(
                            'div',
                            { className: 'preference-item__language' },
                            _react2.default.createElement(_reactSvg.SVGIcon, { className: 'globalization-selector-preference__svg', markup: _svgDefs.GLOBE__24, inlineFlex: true }),
                            _react2.default.createElement(
                                'span',
                                { className: 'preference-item__text' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'visible-lg-inline' },
                                    languageName
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'hidden-lg' },
                                    languageCode
                                )
                            )
                        )
                    ),
                    renderCountryLanguageSelector && renderCurrencySelector && _react2.default.createElement('div', { className: 'preference-item preference-item__separator' }),
                    renderCurrencySelector && _react2.default.createElement(
                        'div',
                        { className: 'preference-item' },
                        _react2.default.createElement(
                            'div',
                            { className: 'visible-lg-inline' },
                            currency.code + ' (' + currency.symbol + ')'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'hidden-lg' },
                            currency.symbol
                        )
                    )
                )
            );
        }
    }]);

    return PreferencePanel;
}(_react.Component);

PreferencePanel.propTypes = {
    currency: _propTypes2.default.object,
    currencyName: _propTypes2.default.string,
    currencySymbol: _propTypes2.default.string,
    countryCode: _propTypes2.default.string,
    locale: _propTypes2.default.string,
    languageName: _propTypes2.default.string,
    renderCountryLanguageSelector: _propTypes2.default.bool,
    renderCurrencySelector: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};
PreferencePanel.defaultProps = {
    currency: { code: 'USD', symbol: 'US$', name: 'US Dollar' },
    currencyName: 'US Dollar',
    currencySymbol: '$',
    countryCode: 'USA',
    locale: 'en_US',
    languageName: 'English',
    renderCountryLanguageSelector: true,
    renderCurrencySelector: true,
    onClick: function onClick() {}
};
exports.default = PreferencePanel;
//# sourceMappingURL=PreferencePanel.js.map

/***/ }),

/***/ "J1tJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorBoundary = function (_Component) {
    _inherits(ErrorBoundary, _Component);

    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);

        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

        _this.logException = _this.logException.bind(_this);
        return _this;
    }

    _createClass(ErrorBoundary, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // this is needed to catch errors thrown even if rendering succeeded
            window.addEventListener('error', this.logException);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('error', this.logException);
        }
    }, {
        key: 'componentDidCatch',
        value: function componentDidCatch(error, info) {
            // this will only catch errors thrown if rendering failed, that's why we have the window event listener
            this.props.clientLogger.logError(error);
            this.props.clientLogger.logError(info.componentStack);
        }
    }, {
        key: 'logException',
        value: function logException(e) {
            this.props.clientLogger.logException(e.message);
            this.props.clientLogger.logException(e.error.stack);
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);

    return ErrorBoundary;
}(_react.Component);

exports.default = ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map

/***/ }),

/***/ "J9Bc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MENU__24 = void 0;
var MENU__24 = '<svg data-id="SVG_MENU__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.5 12h-15m15 6.5h-15m15-13h-15" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
exports.MENU__24 = MENU__24;

/***/ }),

/***/ "JRJL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jq3D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHEVRON_RIGHT__16 = void 0;
var CHEVRON_RIGHT__16 = '<svg data-id="SVG_CHEVRON_RIGHT__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M6 13l4.6-5L6 3"/></svg>';
exports.CHEVRON_RIGHT__16 = CHEVRON_RIGHT__16;

/***/ }),

/***/ "LGuY":
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ "LuCE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ME9r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PreferencePanel = __webpack_require__("IrSq");

var _PreferencePanel2 = _interopRequireDefault(_PreferencePanel);

var _CurrencySelector = __webpack_require__("suT3");

var _CurrencySelector2 = _interopRequireDefault(_CurrencySelector);

var _CountryLanguageSelector = __webpack_require__("xWqb");

var _CountryLanguageSelector2 = _interopRequireDefault(_CountryLanguageSelector);

var _reactModal = __webpack_require__("XSjK");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _edap = __webpack_require__("6kQN");

var _edap2 = _interopRequireDefault(_edap);

__webpack_require__("SHWX");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalizationSelector = function (_Component) {
    _inherits(GlobalizationSelector, _Component);

    /* istanbul ignore next */
    function GlobalizationSelector(props) {
        _classCallCheck(this, GlobalizationSelector);

        var _this = _possibleConstructorReturn(this, (GlobalizationSelector.__proto__ || Object.getPrototypeOf(GlobalizationSelector)).call(this, props));

        _this.handleOpen = _this.handleOpen.bind(_this);
        _this.handleModalOpen = _this.handleModalOpen.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this.handleUpdate = _this.handleUpdate.bind(_this);
        _this.handleLanguageSelectorChange = _this.handleLanguageSelectorChange.bind(_this);
        _this.handleCountrySelectorChange = _this.handleCountrySelectorChange.bind(_this);
        _this.handleCurrencySelectorChange = _this.handleCurrencySelectorChange.bind(_this);
        _this.state = _this.getStateDataByProps(_this.props);
        return _this;
    }

    _createClass(GlobalizationSelector, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState(this.getStateDataByProps(nextProps));
        }
    }, {
        key: 'handleOpen',
        value: function handleOpen() {
            this.setState({
                isOpen: true,
                currencyInSelector: this.state.currencyInSelector
            });
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            var languages = this.getLanguagesByCountryCode(this.props.countryLanguageSelector, this.state.countryCodeInPreference);
            this.setState({
                isOpen: false,
                countryCodeInSelector: this.state.countryCodeInPreference,
                languages: languages,
                languageCodeInSelector: this.state.languageCodeInPreference,
                currencyInSelector: this.state.currencyInPreference
            });

            if (this.state.renderCurrencySelector) {
                this.setState({
                    currencyInSelector: this.state.currencyInPreference
                });
            }
        }
    }, {
        key: 'handleModalOpen',
        value: function handleModalOpen() {
            (0, _edap2.default)({
                eventaction: 'regional settings modal opened'
            });

            if (this.state.renderCountryLanguageSelector) {
                if (!this.state.languageSelectorOnly) {
                    (0, _edap2.default)({
                        eventaction: 'display country dropdown seen'
                    });
                }

                (0, _edap2.default)({
                    eventaction: 'display language dropdown seen'
                });
            }

            if (this.state.renderCurrencySelector) {
                (0, _edap2.default)({
                    eventaction: 'display currency dropdown seen'
                });
            }
        }
    }, {
        key: 'handleModalClose',
        value: function handleModalClose() {
            (0, _edap2.default)({
                eventaction: 'regional settings modal closed'
            });
        }
    }, {
        key: 'handleUpdate',
        value: function handleUpdate() {
            var _this2 = this;

            if (this.state.renderCurrencySelector) {
                this.setState({
                    currencyInPreference: this.getCurrencyFromCurrencyCode(this.props.currencySelector, this.state.currencyCodeSelected),
                    isOpen: false
                });

                (0, _edap2.default)({
                    eventaction: 'display currency updated',
                    eventlabel: this.state.currencyCodeSelected
                });
            }

            if (this.state.renderCountryLanguageSelector) {
                var selectedCountry = this.props.countryLanguageSelector.countries.filter(function (country) {
                    return country.countryCode === _this2.state.countryCodeInSelector;
                })[0];
                var languageName = selectedCountry.languages.filter(function (language) {
                    return language.languageCode === _this2.state.languageCodeInSelector;
                })[0].languageName;
                this.setState({
                    countryCodeInPreference: this.state.countryCodeInSelector,
                    languageCodeInPreference: this.state.languageCodeInSelector,
                    languageName: languageName,
                    isOpen: false
                });

                if (!this.state.languageSelectorOnly) {
                    (0, _edap2.default)({
                        eventaction: 'display country updated',
                        eventlabel: this.state.countryCodeInPreference
                    });
                }

                (0, _edap2.default)({
                    eventaction: 'display language updated',
                    eventlabel: this.state.languageCodeInSelector
                });

                this.props.onGlobalSelectorChange(this.state.languageCodeInSelector, selectedCountry.siteUrl, this.state.currencyCodeSelected);
            }

            this.props.onGlobalSelectorChange(this.state.languageCodeInSelector, null, this.state.currencyCodeSelected);
        }
    }, {
        key: 'handleLanguageSelectorChange',
        value: function handleLanguageSelectorChange(languageCodeInSelector) {
            this.setState({ languageCodeInSelector: languageCodeInSelector });
        }
    }, {
        key: 'handleCountrySelectorChange',
        value: function handleCountrySelectorChange(countryCodeInSelector) {
            var languages = this.getLanguagesByCountryCode(this.props.countryLanguageSelector, countryCodeInSelector);
            this.setState({
                countryCodeInSelector: countryCodeInSelector,
                languages: languages,
                languageCodeInSelector: languages[0].languageCode
            });
        }
    }, {
        key: 'handleCurrencySelectorChange',
        value: function handleCurrencySelectorChange(currencyCodeSelected) {
            this.setState({
                currencyInSelector: this.getCurrencyFromCurrencyCode(this.props.currencySelector, currencyCodeSelected),
                currencyCodeSelected: currencyCodeSelected
            });
        }
    }, {
        key: 'getCurrencyFromCurrencyCode',
        value: function getCurrencyFromCurrencyCode(currencySelector, currencyCode) {
            if (!currencySelector) {
                return null;
            }
            return currencySelector.currencies.filter(function (currency) {
                return currencyCode === currency.code;
            })[0];
        }
    }, {
        key: 'getStateDataByProps',
        value: function getStateDataByProps(props) {
            var languages = this.getLanguagesByCountryCode(props.countryLanguageSelector, props.countryCode);
            var supportedLanguages = languages ? languages.filter(function (language) {
                return props.languageCode === language.languageCode;
            }) : null;
            var languageName = supportedLanguages && supportedLanguages.length ? supportedLanguages[0].languageName : null;
            var currencyCode = this.getCurrencyFromCurrencyCode(props.currencySelector, props.currencyCode);
            return {
                isOpen: false,
                languages: languages,
                countryCodeInSelector: props.countryCode,
                languageCodeInSelector: props.languageCode,
                countryCodeInPreference: props.countryCode,
                languageCodeInPreference: props.languageCode,
                languageName: languageName,
                currencyInSelector: currencyCode,
                currencyInPreference: currencyCode,
                currencyCodeSelected: props.currencyCode,
                renderCountryLanguageSelector: props.renderCountryLanguageSelector && !!props.countryLanguageSelector && !!languageName,
                renderCurrencySelector: props.renderCurrencySelector && !!props.currencySelector && !!currencyCode,
                languageSelectorOnly: props.countryLanguageSelector && (props.languageSelectorOnly || props.countryLanguageSelector.countries.length === 1)
            };
        }
    }, {
        key: 'getLanguagesByCountryCode',
        value: function getLanguagesByCountryCode(countryLanguageSelector, countryCode) {
            if (!countryLanguageSelector) {
                return null;
            }
            var supportedCountries = countryLanguageSelector.countries.filter(function (country) {
                return country.countryCode === countryCode;
            });
            if (supportedCountries && supportedCountries.length) {
                return countryLanguageSelector.countries.filter(function (country) {
                    return country.countryCode === countryCode;
                })[0].languages;
            }
            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                translations = _props.translations,
                countryLanguageSelector = _props.countryLanguageSelector,
                currencySelector = _props.currencySelector;

            var renderPreference = this.state.renderCurrencySelector || this.state.renderCountryLanguageSelector;
            return _react2.default.createElement(
                'div',
                { className: 'globalization-selector' },
                renderPreference && _react2.default.createElement(_PreferencePanel2.default, {
                    currency: this.state.currencyInPreference,
                    countryCode: this.state.countryCodeInPreference,
                    locale: this.state.languageCodeInPreference,
                    languageName: this.state.languageName,
                    onClick: this.handleOpen,
                    change: translations.change,
                    languageSelectorOnly: this.state.languageSelectorOnly,
                    renderCountryLanguageSelector: this.state.renderCountryLanguageSelector,
                    renderCurrencySelector: this.state.renderCurrencySelector
                }),
                _react2.default.createElement(
                    _reactModal2.default,
                    {
                        id: 'globalization-selector-modal',
                        isOpen: this.state.isOpen,
                        onClose: this.handleClose,
                        title: translations.globalTitle,
                        isWorkflow: true,
                        footer: _react2.default.createElement(
                            'button',
                            { className: 'btn btn-primary btn-block', onClick: this.handleUpdate },
                            translations.update
                        ),
                        onModalOpen: this.handleModalOpen,
                        onModalClose: this.handleModalClose
                    },
                    this.state.renderCountryLanguageSelector && _react2.default.createElement(_CountryLanguageSelector2.default, {
                        translations: translations,
                        countries: countryLanguageSelector.countries,
                        languages: this.state.languages,
                        countryCode: this.state.countryCodeInSelector,
                        languageCode: this.state.languageCodeInSelector,
                        languageSelectorOnly: this.state.languageSelectorOnly,
                        handleCountrySelectorChange: this.handleCountrySelectorChange,
                        handleLanguageSelectorChange: this.handleLanguageSelectorChange
                    }),
                    this.state.renderCurrencySelector && _react2.default.createElement(_CurrencySelector2.default, {
                        title: translations.chooseCurrency,
                        currency: this.state.currencyInSelector,
                        disclaimer: translations.currencyDisclaimer,
                        currencyList: currencySelector.currencies,
                        onChange: this.handleCurrencySelectorChange
                    })
                )
            );
        }
    }]);

    return GlobalizationSelector;
}(_react.Component);

GlobalizationSelector.propTypes = {
    /* country language currency details for current site */
    currencyCode: _propTypes2.default.string,
    currencyName: _propTypes2.default.string,
    currencySymbol: _propTypes2.default.string,
    countryCode: _propTypes2.default.string,
    languageCode: _propTypes2.default.string,
    renderCurrencySelector: _propTypes2.default.bool,
    renderCountryLanguageSelector: _propTypes2.default.bool,
    countryLanguageSelector: _propTypes2.default.shape({
        countries: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            countryCode: _propTypes2.default.string,
            countryName: _propTypes2.default.string,
            siteUrl: _propTypes2.default.string,
            languages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
                languageCode: _propTypes2.default.string,
                languageName: _propTypes2.default.string
            }))
        }))
    }),
    currencySelector: _propTypes2.default.shape({
        currencies: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            code: _propTypes2.default.string,
            symbol: _propTypes2.default.string,
            name: _propTypes2.default.string
        }))
    }),
    /* text to display on the selector */
    translations: _propTypes2.default.shape({
        globalTitle: _propTypes2.default.string,
        currency: _propTypes2.default.string,
        country: _propTypes2.default.string,
        chooseCurrency: _propTypes2.default.string,
        chooseCountry: _propTypes2.default.string,
        chooseLanguage: _propTypes2.default.string,
        update: _propTypes2.default.string,
        change: _propTypes2.default.string
    }),
    onGlobalSelectorChange: _propTypes2.default.func
};
GlobalizationSelector.defaultProps = {
    currencyCode: 'USD',
    currencyName: 'US Dollar',
    currencySymbol: 'US$',
    countryCode: 'us',
    languageCode: 'en_US',
    renderCurrencySelector: false,
    renderCountryLanguageSelector: true,
    translations: {
        globalTitle: 'Regional settings',
        chooseCurrency: 'Currency',
        chooseCountry: 'Country',
        chooseLanguage: 'Language',
        currencyDisclaimer: "Please note: You will still be charged in the owner's currency.",
        update: 'Update',
        change: 'Change'
    },
    onGlobalSelectorChange: function onGlobalSelectorChange() {} };
exports.default = GlobalizationSelector;
//# sourceMappingURL=GlobalizationSelector.js.map

/***/ }),

/***/ "MRHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SVGIcon_css__ = __webpack_require__("Xjo9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SVGIcon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SVGIcon_css__);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var SVGIcon =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(SVGIcon, _Component);

  function SVGIcon() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SVGIcon.prototype;

  _proto.determineMarkup = function determineMarkup() {
    var _this$props = this.props,
        markup = _this$props.markup,
        data = _this$props.data;

    if (markup) {
      return markup;
    }

    if (data.svgs) {
      return data.svgs[Object.keys(data.svgs)[0]];
    }

    return null;
  };

  _proto.determineSvgSize = function determineSvgSize(haystack) {
    var svgId = 'XX'; // User is using either markup or GraphQL

    if (haystack) {
      var search = haystack.match(/id="(\S+)"/); // length of two or more indicates there has been a match an ID has been fetched in (\S+) capture

      if (search) {
        // [1] index position will be the (\S+) capture
        svgId = search[1];
      }
    } // User is using a Defined SVG and thus passing in an id


    if (this.props.id) {
      svgId = this.props.id;
    } // String.endsWith not supported by IE :/


    return svgId.substring(svgId.length - 2);
  };

  _proto.render = function render() {
    var _classNames;

    // If GraphQL is being used, we may end up in a state where the data is still loading.
    if (this.props.data.loading) {
      return null;
    }

    var _this$props2 = this.props,
        id = _this$props2.id,
        strokeWidth = _this$props2.strokeWidth,
        inline = _this$props2.inline,
        inlineFlex = _this$props2.inlineFlex,
        className = _this$props2.className; // String.endsWith not supported by ID :/

    var svgMarkup = this.determineMarkup();
    var svgSize = this.determineSvgSize(svgMarkup);
    var svgClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('SVGIcon', (_classNames = {}, _classNames["SVGIcon--" + svgSize + "px"] = !isNaN(svgSize), _classNames["SVGIcon--stroke-width-" + strokeWidth] = strokeWidth, _classNames['SVGIcon--inline'] = inline, _classNames['SVGIcon--inline-flex'] = inlineFlex, _classNames), className);
    var xlinkHref = "#SVG_" + id; // If SVG markup is being passed in, render it within in a span.

    if (svgMarkup) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: svgClasses,
        dangerouslySetInnerHTML: {
          __html: svgMarkup
        }
      }) // eslint-disable-line react/no-danger
      ;
    } // If SVG Definition enum is passed in, render an SVG via <use>.


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
      className: svgClasses
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", {
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      xlinkHref: xlinkHref
    }));
  };

  return SVGIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SVGIcon.propTypes = {
  /** For using an SVG from an SVG Definition block, the xlink:href of the SVG you want. Used in the 'use' tag to grab it's defintion from the SVG Defintions */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**  For direct Imports, use this prop to pass in inline SVG markup */
  markup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**  For direct GraphQL queries, the individual SVG markup */
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    svgs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
  }),

  /** DEPRECATED - Now defined within @homeaway/svg-defs. (Flag to determine if the SVG uses a fill.)*/
  useFill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** Flag to determine if the SVG is being used inline with text, adds .SVG--inline class */
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** Flag to determine if the SVG is being used inline within a block, adds .SVG--inline-flex class */
  inlineFlex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /** Optional stroke-width attribute to add to svg, will override default 1.5 CSS. Adds .SVG--stroke-width-#.  Currently only classes for 1 and 2 provided. */
  strokeWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
SVGIcon.defaultProps = {
  data: {},
  markup: ''
};
/* harmony default export */ __webpack_exports__["default"] = (SVGIcon);
//# sourceMappingURL=SVGIcon.js.map

/***/ }),

/***/ "MUld":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ListYourProperty = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__("q2Bk");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListYourProperty = exports.ListYourProperty = (_temp = _class = function (_React$Component) {
    _inherits(ListYourProperty, _React$Component);

    function ListYourProperty() {
        _classCallCheck(this, ListYourProperty);

        return _possibleConstructorReturn(this, (ListYourProperty.__proto__ || Object.getPrototypeOf(ListYourProperty)).apply(this, arguments));
    }

    _createClass(ListYourProperty, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'a',
                this.attrs,
                this.props.text
            );
        }
    }, {
        key: 'attrs',
        get: function get() {
            return {
                className: this.className,
                'data-bypass': true,
                href: this.props.link
            };
        }
    }, {
        key: 'className',
        get: function get() {
            return (0, _classnames2.default)('site-header-list-your-property', 'btn', 'btn-default', this.props.isInverse && 'btn-inverse');
        }
    }]);

    return ListYourProperty;
}(_react2.default.Component), _class.propTypes = {
    isInverse: _propTypes2.default.bool,
    text: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
    isInverse: false
}, _temp);
//# sourceMappingURL=ListYourProperty.js.map

/***/ }),

/***/ "N7cN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _react = _interopRequireWildcard(__webpack_require__("GiK3"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

__webpack_require__("Cmpj");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * BaseButton
 *
 */
var ButtonBase =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ButtonBase, _Component);

  function ButtonBase() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ButtonBase.prototype;

  _proto.render = function render() {
    var _classNames;

    var _this$props = this.props,
        size = _this$props.size,
        inverse = _this$props.inverse,
        block = _this$props.block,
        srOnlyLabel = _this$props.srOnlyLabel,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, ["size", "inverse", "block", "srOnlyLabel", "className"]);

    var buttonClasses = (0, _classnames.default)('btn', className, (_classNames = {
      'btn-inverse': inverse,
      'btn-block': block
    }, _classNames["btn-" + size] = size, _classNames));
    var labelClasses = (0, _classnames.default)('btn__label', {
      'sr-only': srOnlyLabel
    });

    if (this.props.href) {
      return _react.default.createElement("a", _extends({
        className: buttonClasses
      }, rest), _react.default.createElement("span", {
        className: labelClasses
      }, this.props.label), this.props.children);
    }

    return _react.default.createElement("button", _extends({
      className: buttonClasses
    }, rest), _react.default.createElement("span", {
      className: labelClasses
    }, this.props.label), this.props.children);
  };

  return ButtonBase;
}(_react.Component);

ButtonBase.propTypes = {
  /** Flags for if the button is .btn-block (span the full width of a parent) */
  block: _propTypes.default.bool,

  /** Flag for if the button is disabled */
  disabled: _propTypes.default.bool,

  /** If href is specified, the component outputs an <a> tag,
   * otherwise, it is a button tag. */
  href: _propTypes.default.string,

  /** Flag for if the button is is inverse-styled and receives className .btn-inverse */
  inverse: _propTypes.default.bool,

  /** The text or html to display on the button, required. */
  label: _propTypes.default.node.isRequired,

  /** Size variation from Baseline. */
  size: _propTypes.default.oneOf(['xs', 'sm', 'lg']),

  /** Flag for applying .sr-only class to the button label for Screen Readers */
  srOnlyLabel: _propTypes.default.bool,

  /** Specify the type of button. One of: 'button'|'submit'|'reset' */
  type: _propTypes.default.oneOf(['button', 'submit', 'reset'])
};
ButtonBase.defaultProps = {
  type: 'button'
};
var _default = ButtonBase;
exports.default = _default;
//# sourceMappingURL=ButtonBase.js.map

/***/ }),

/***/ "NZwV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var isObject = __webpack_require__("bYe6");
var stringify = __webpack_require__("mOwr");

/**
 * @typedef {Object} ErrorLog
 * @private
 * @property {string} userAgent - User agent retrieved from window.navigator
 * @property {string} message - Error message
 * @property {string} url - File in which the error occurred
 * @property {number} columnNumber - Column on which the error occurred
 * @property {number} lineNumber - Line on which the error occurred
 * @property {string} stack - Stack trace, if available
 */

/**
 * @typedef {Object} ClientLog
 * @private
 * @property {string} userAgent - User agent retrieved from window.navigator
 * @property {string} message - Developer authored message
 * @property {string} url - route from which the error was thrown
 * @property {string} type - What kind of log is this? info, error.
 */

/**
 * @name
 * createClientLog
 * @private
 * @description
 * A function for creating client logs.
 * @param {string[]} Array containing one string, the message to post.
 * @param {string} logType - What kind of log is this? ex: info, error.
 * @return {ClientLog}
 */

function createClientLog(_ref, logType) {
    var _ref2 = _slicedToArray(_ref, 1),
        message = _ref2[0];

    return {
        type: logType,
        userAgent: navigator.userAgent,
        message: message,
        url: window.location.href
    };
}

/**
 * @name
 * createErrorLog
 * @private
 * @description
 * Formats data passed to log handlers into a consistently formatted
 * log. Limit stack traces to 10 entries.
 * @param {string|Error} messageOrEvent
 * @param {url=} source
 * @param {number=} lineno
 * @param {number=} colno
 * @param {Error=} errorObj
 * @return {ErrorLog}
 */

function createErrorLog(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 5),
        messageOrEvent = _ref4[0],
        url = _ref4[1],
        lineNumber = _ref4[2],
        columnNumber = _ref4[3],
        errorObj = _ref4[4];

    return {
        userAgent: navigator.userAgent,
        message: isObject(messageOrEvent) ? stringify(messageOrEvent) : messageOrEvent,
        url: url || '',
        lineNumber: lineNumber,
        columnNumber: typeof columnNumber === 'number' ? columnNumber : window.event && window.event.errorCharacter,
        stack: errorObj && errorObj.stack && errorObj.stack.split(/\r\n|\r|\n/).slice(0, 10).join('\r\n')
    };
}

/**
 * @name createLog
 * @private
 * @description
 * Determines if the log information came from window.onerror or was created
 * by the developer and calls either #createErrorLog or #createClientLog.
 * @param {array} logInfo - Log data from window.onerror or the developer.
 * @param {string} logType - What kind of log is this?
 * @returns {ErrorLog|ClientLog}
 */

function createLog(logInfo, logType) {
    if (logType === 'exception') {
        return createErrorLog(logInfo, logType);
    }
    return createClientLog(logInfo, logType);
}

module.exports = createLog;
//# sourceMappingURL=createLog.js.map

/***/ }),

/***/ "NuNx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O1Qq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OPbx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FACEBOOK__24 = void 0;
var FACEBOOK__24 = '<svg data-id="SVG_FACEBOOK__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" transform="scale(1.5, 1.5)" vector-effect="non-scaling-stroke" d="M14.4 1H1.6c-.3 0-.6.3-.6.6v12.8c0 .3.3.6.6.6h6.8V9.7H6.7V7.7h1.7V5.8c0-1.8 1.2-2.7 2.8-2.7l1.6.1v1.9h-1c-1 0-1.2.4-1.2 1v1.5h2.2l-.4 2.2h-1.8V15h3.8c.3 0 .6-.3.6-.6V1.6c0-.3-.3-.6-.6-.6" stroke="none" fill-rule="evenodd"/></svg>';
exports.FACEBOOK__24 = FACEBOOK__24;

/***/ }),

/***/ "OWqW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialize = initialize;
exports.evaluateExperiment = evaluateExperiment;
exports.evaluateAllExperiments = evaluateAllExperiments;
exports.evaluateExperimentAndLog = evaluateExperimentAndLog;
exports.logExperiment = logExperiment;

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

var _EvaluationData = __webpack_require__("qwsy");

var _EvaluationData2 = _interopRequireDefault(_EvaluationData);

var _utils = __webpack_require__("GL8r");

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-use-before-define: ["error", { "functions": false }]*/

/**
 * Keep track of exposed experiments to avoid sending extra unneeded EDAP events
 * @private
 */
var exposedExperiments = {};

/**
 * Initialize a global `__ABACUS__` object with the tests passed into the constructor.
 * The reason a global variable is used is so that shared components, which also
 * use @homeaway/abacus-client-utils (but perhaps different versions), all reference
 * the same dictionary of tests. Cast these test objects as {@link EvaluationData} objects.
 *
 * @param {Object<string, EvaluationData>} tests - a dictionary of test names to evaluation data objects
 */
function initialize(tests) {
    if (typeof window === 'undefined') {
        return;
    }

    // Reset the map of exposed experiments
    exposedExperiments = {};

    // Save any experiments queued for exposure logging
    var exposuresToLog = [];
    if (Array.isArray(window.__ABACUS__)) {
        exposuresToLog = window.__ABACUS__;
        window.__ABACUS__ = null;
    }

    if (tests && !window.__ABACUS__) {
        var experimentCache = Object.keys(tests).reduce(function (obj, testName) {
            obj[testName] = new _EvaluationData2.default(tests[testName]);
            return obj;
        }, {});

        // Proxy calls of `__ABACUS__.push(expName1[, ...[, expNameN]])` to `evaluateExperimentAndLog(expNameN)`
        Object.defineProperty(experimentCache, 'push', {
            value: function value() {
                for (var _len = arguments.length, experimentNames = Array(_len), _key = 0; _key < _len; _key++) {
                    experimentNames[_key] = arguments[_key];
                }

                experimentNames.forEach(function (experimentName) {
                    evaluateExperimentAndLog(experimentName);
                });
            }
        });

        window.__ABACUS__ = experimentCache;
    }

    // Log queued exposures
    exposuresToLog.forEach(function (experimentName) {
        return evaluateExperimentAndLog(experimentName);
    });
}

/**
 * Returns an instance of EvaluationData for the specified experiment name. This method does not log the
 * evaluation. Please ensure you understand how to separate evaluation from logging before using this method. Always
 * prefer to use {@link evaluateExperimentAndLog|evaluateExperimentAndLog()}.
 *
 * @param {string} experimentName - the name of the experiment to evaluate
 * @returns {EvaluationData}
 */
function evaluateExperiment(experimentName) {
    if (typeof window === 'undefined') {
        return;
    }

    var evaluationData = window.__ABACUS__[experimentName];
    if (evaluationData) {
        return evaluationData; // eslint-disable-line consistent-return
    }

    return utils.getEvaluationDataWithException(); // eslint-disable-line consistent-return
}

/**
 * Returns an instance of EvaluationData for all experiments running on the page. This method does not log the
 * evaluation. To evaluate specified experiment name without logging use {@link evaluateExperiment|evaluateExperiment()}.
 *
 * @returns {EvaluationData}
 */
function evaluateAllExperiments() {
    if (typeof window === 'undefined') {
        return;
    }

    var evaluationDatas = window.__ABACUS__ || {};
    if (Object.keys(evaluationDatas).length > 0) {
        return evaluationDatas; // eslint-disable-line consistent-return
    }

    return utils.getEmptyEvaluationData(); // eslint-disable-line consistent-return
}

/**
 * Retrieves an already evaluated experiment, logs the exposure of an experiment, and returns the result as an EvaluationData object. If any
 * errors occur than the resulting EvaluationData will contain details of the error and the Abacus bucket value will
 * refer to the control bucket.
 *
 * @param {string} experimentName - the name of the experiment to evaluate
 * @param {object} [edapTriggerOptions] - The `triggerOptions` object that is applied to the EDAP `test.exposure` event. See {@link https://github.homeawaycorp.com/edap/edap-integrations/blob/master/API.md#triggereventname-data-opts|triggerOptions}.
 * @param {object} [edapData] - Contains any additional properties to include in the edap event
 * @returns {EvaluationData}
 */
function evaluateExperimentAndLog(experimentName, edapTriggerOptions, edapData) {
    if (typeof window === 'undefined') {
        return;
    }

    var evaluationData = evaluateExperiment(experimentName);

    if (evaluationData) {
        logExperiment(evaluationData, edapTriggerOptions, edapData);
    }

    return evaluationData; // eslint-disable-line consistent-return
}

/* eslint-disable complexity */
/**
 * Logs an already evaluated experiment. Keeps track of which experiments have been logged so that the exposure event is
 * triggered at most once per test per pageload.
 *
 * Please ensure you understand how to separate evaluation from logging before using this method. Your experiment will
 * be invalid if the passed in EvaluationData has not come as a result of calling evaluateExperiment().
 *
 * @param {EvaluationData|string} evaluationData - Object that contains information about the evaluated test. Alternatively, supply an experiment name.
 * @param {object} [edapTriggerOptions] - The `triggerOptions` object that is applied to the EDAP `test.exposure` event. See {@link https://github.homeawaycorp.com/edap/edap-integrations/blob/master/API.md#triggereventname-data-opts|triggerOptions}.
 * @param {object} [edapData] - Contains any additional properties to include in the edap event
 */
function logExperiment(evaluationData, edapTriggerOptions, edapData) {
    if (typeof window === 'undefined' || !evaluationData) {
        return;
    }

    if (typeof evaluationData === 'string') {
        evaluateExperimentAndLog(evaluationData, edapTriggerOptions, edapData);
        return;
    }

    if (evaluationData.exception) {
        return;
    }

    var experimentName = evaluationData.experimentKey.experimentName;

    if (exposedExperiments.hasOwnProperty(experimentName)) {
        return;
    }

    evaluationData = new _EvaluationData2.default(evaluationData);

    edapData = edapData || {};
    edapData.testname = evaluationData.experimentKey.experimentName + ':' + evaluationData.experimentInstanceId;
    edapData.variant = '' + evaluationData.value;

    (0, _edapWrapper2.default)().push(function (edap) {
        edap.trigger('test.exposure', edapData, edapTriggerOptions);
    });

    exposedExperiments[experimentName] = true;
}
/* eslint-enable complexity */

exports.default = {
    initialize: initialize,
    evaluateExperiment: evaluateExperiment,
    evaluateAllExperiments: evaluateAllExperiments,
    evaluateExperimentAndLog: evaluateExperimentAndLog,
    logExperiment: logExperiment
};
//# sourceMappingURL=AbacusClientUtils.js.map

/***/ }),

/***/ "P0Ca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Inbox = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSvg = __webpack_require__("CWk1");

var _MAIL__ = __webpack_require__("6Ssj");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Inbox = exports.Inbox = function (_React$Component) {
    _inherits(Inbox, _React$Component);

    function Inbox() {
        _classCallCheck(this, Inbox);

        return _possibleConstructorReturn(this, (Inbox.__proto__ || Object.getPrototypeOf(Inbox)).apply(this, arguments));
    }

    _createClass(Inbox, [{
        key: 'render',
        value: function render() {
            var text = this.props.text;


            return _react2.default.createElement(
                'div',
                { className: this.className },
                _react2.default.createElement(_reactSvg.SVGIcon, { inlineFlex: true, markup: _MAIL__.MAIL__16 }),
                _react2.default.createElement(
                    'span',
                    { className: 'site-header-nav__icon-label' },
                    text
                )
            );
        }
    }, {
        key: 'className',
        get: function get() {
            return (0, _classnames2.default)('site-header-nav__inbox', _defineProperty({}, '' + this.props.cssClass, !!this.props.cssClass));
        }
    }]);

    return Inbox;
}(_react2.default.Component);
//# sourceMappingURL=Inbox.js.map

/***/ }),

/***/ "P8LM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _clientLogger = __webpack_require__("29Zd");

var _clientLogger2 = _interopRequireDefault(_clientLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FACEBOOK_SETTINGS_MAP = new Map().set('localhost', {
    socialHost: 'social.stage.homeaway.com',
    appId: 155404361189801
}).set('localhost.com', {
    socialHost: 'social.stage.homeaway.com',
    appId: 155404361189801
}).set('homeaway.localhost', {
    socialHost: 'social.stage.homeaway.com',
    appId: 176278865785256
}).set('vrbo.localhost', {
    socialHost: 'social.stage.homeaway.com',
    appId: 206287156074616
}).set('local.homelidays.es', {
    socialHost: 'social.homeaway.com',
    appId: 958959140937389
}).set('local.abritel.fr', {
    socialHost: 'social.stage.homeaway.com',
    appId: 216495905037464
}).set('local.vrbo.com', {
    socialHost: 'social.stage.vrbo.com',
    appId: 109213082502054
}).set('local.fewo-direkt.de', {
    socialHost: 'social.stage.homeaway.com',
    appId: 160652240666876
}).set('local.fr.homeaway.ca', {
    socialHost: 'social.stage.homeaway.com',
    appId: 128528480560007
}).set('local.homeaway.co.uk', {
    socialHost: 'social.stage.homeaway.com',
    appId: 150947144978961
}).set('local.homeaway.com.ar', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('local.homeaway.at', {
    socialHost: 'social.stage.homeaway.com',
    appId: 216722541738655
}).set('local.homeaway.jp', {
    socialHost: 'social.stage.homeaway.com',
    appId: 216722541738655
}).set('abritel.fr', {
    socialHost: 'social.homeaway.com',
    appId: 210126639025536
}).set('aluguetemporada.com.br', {
    socialHost: 'social.homeaway.com',
    appId: 209459075759568
}).set('fewo-direkt.de', {
    socialHost: 'social.homeaway.com',
    appId: 128002723946928
}).set('fr.homeaway.ca', {
    socialHost: 'social.homeaway.com',
    appId: 176677122390129
}).set('homeaway.co.uk', {
    socialHost: 'social.homeaway.com',
    appId: 191612647555578
}).set('homeaway.com.ar', {
    socialHost: 'social.homeaway.com',
    appId: 177941532264129
}).set('homeaway.at', {
    socialHost: 'social.homeaway.com',
    appId: 257265161001223
}).set('homeaway.com.au', {
    socialHost: 'social.homeaway.com',
    appId: 176962292361464
}).set('homeaway.ca', {
    socialHost: 'social.homeaway.com',
    appId: 128944923850903
}).set('homeaway.com.co', {
    socialHost: 'social.homeaway.com',
    appId: 168262816569205
}).set('homeaway.com', {
    socialHost: 'social.homeaway.com',
    appId: 174366222619074
}).set('luxury.homeaway.com', {
    socialHost: 'social.homeaway.com',
    appId: 174366222619074
}).set('homeaway.co.in', {
    socialHost: 'social.homeaway.com',
    appId: 223143287703401
}).set('homeaway.co.nz', {
    socialHost: 'social.homeaway.com',
    appId: 455487181161072
}).set('homeaway.dk', {
    socialHost: 'social.homeaway.com',
    appId: 128693037210786
}).set('homeaway.es', {
    socialHost: 'social.homeaway.com',
    appId: 120290661389436
}).set('homeaway.fi', {
    socialHost: 'social.homeaway.com',
    appId: 1295839347151836
}).set('homeaway.it', {
    socialHost: 'social.homeaway.com',
    appId: 230220910326999
}).set('homeaway.com.mx', {
    socialHost: 'social.homeaway.com',
    appId: 1762647237360709
}).set('homeaway.nl', {
    socialHost: 'social.homeaway.com',
    appId: 400009137046079
}).set('homeaway.no', {
    socialHost: 'social.homeaway.com',
    appId: 203285933505567
}).set('homeaway.pt', {
    socialHost: 'social.homeaway.com',
    appId: 1860413537565319
}).set('homeaway.se', {
    socialHost: 'social.homeaway.com',
    appId: 748103608704813
}).set('ownersdirect.co.uk', {
    socialHost: 'social.homeaway.com',
    appId: 132344663970987
}).set('vrbo.com', {
    socialHost: 'social.vrbo.com',
    appId: 232223133460554
}).set('homeaway.gr', {
    socialHost: 'social.homeaway.com',
    appId: 560429950766895
}).set('homeaway.pl', {
    socialHost: 'social.homeaway.com',
    appId: 1710867789211219
}).set('homelidays.com', {
    socialHost: 'social.homeaway.com',
    appId: 278229565951848
}).set('homelidays.it', {
    socialHost: 'social.homeaway.com',
    appId: 963084767161022
}).set('homelidays.es', {
    socialHost: 'social.homeaway.com',
    appId: 692112134295560
}).set('vacationrentals.com', {
    socialHost: 'social.vacationrentals.com',
    appId: 1375264539207158
}).set('homeaway.lk', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.cl', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.co', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.co.in', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.com.ar', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.com.cn', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.com.my', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.com.pe', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.com.sg', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.com.uy', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.ec', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.ph', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.ru', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.co.kr', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.co.th', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.com.vn', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.hk', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.id', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.jp', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('homeaway.tw', {
    socialHost: 'social.homeaway.com',
    appId: 246920655340133
}).set('stage.abritel.fr', {
    socialHost: 'social.stage.homeaway.com',
    appId: 218616934825671
}).set('stage.aluguetemporada.com.br', {
    socialHost: 'social.stage.homeaway.com',
    appId: 217815528240857
}).set('stage.fewo-direkt.de', {
    socialHost: 'social.stage.homeaway.com',
    appId: 228890220454386
}).set('stage.fr.homeaway.ca', {
    socialHost: 'social.homeaway.com',
    appId: 103380066421518
}).set('stage.homeaway.co.uk', {
    socialHost: 'social.stage.homeaway.com',
    appId: 178338138886049
}).set('stage.homeaway.co.nz', {
    socialHost: 'social.stage.homeaway.com',
    appId: 106973762796393
}).set('stage.homeaway.com.ar', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.aluguetemporada.com.br', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.com.ar', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.at', {
    socialHost: 'social.stage.homeaway.com',
    appId: 155443997894330
}).set('stage.homeaway.com.au', {
    socialHost: 'social.stage.homeaway.com',
    appId: 202799066431823
}).set('stage.homeaway.ca', {
    socialHost: 'social.stage.homeaway.com',
    appId: 102098883216214
}).set('stage.homeaway.co', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.com', {
    socialHost: 'social.stage.homeaway.com',
    appId: 223242541035731
}).set('luxury-stage.homeaway.com', {
    socialHost: 'social.stage.homeaway.com',
    appId: 223242541035731
}).set('cas-stage.homeaway.com', {
    socialHost: 'social.stage.homeaway.com',
    appId: 223242541035731
}).set('stage.homeaway.dk', {
    socialHost: 'social.stage.homeaway.com',
    appId: 168573503206240
}).set('stage.homeaway.es', {
    socialHost: 'social.stage.homeaway.com',
    appId: 205880156123789
}).set('stage.homeaway.fi', {
    socialHost: 'social.stage.homeaway.com',
    appId: 124898097591508
}).set('stage.homeaway.co.in', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.it', {
    socialHost: 'social.stage.homeaway.com',
    appId: 230220910326999
}).set('stage.homeaway.nl', {
    socialHost: 'social.stage.homeaway.com',
    appId: 216036205095513
}).set('stage.homeaway.com.mx', {
    socialHost: 'social.stage.homeaway.com',
    appId: 160107347388893
}).set('stage.homeaway.no', {
    socialHost: 'social.stage.homeaway.com',
    appId: 228413807185035
}).set('stage.homeaway.pt', {
    socialHost: 'social.stage.homeaway.com',
    appId: 192760300771148
}).set('stage.homeaway.se', {
    socialHost: 'social.stage.homeaway.com',
    appId: 190923107625925
}).set('stage.ownersdirect.co.uk', {
    socialHost: 'social.stage.homeaway.com',
    appId: 179318072124302
}).set('stage.vrbo.com', {
    socialHost: 'social.stage.vrbo.com',
    appId: 124450337638403
}).set('stage.homeaway.gr', {
    socialHost: 'social.stage.homeaway.com',
    appId: 629705233827091
}).set('stage.homeaway.pl', {
    socialHost: 'social.stage.homeaway.com',
    appId: 402088900169654
}).set('stage.homelidays.com', {
    socialHost: 'social.stage.homeaway.com',
    appId: 923024571167979
}).set('stage.homelidays.it', {
    socialHost: 'social.homeaway.com',
    appId: 1249106871869873
}).set('stage.homelidays.es', {
    socialHost: 'social.homeaway.com',
    appId: 107072019810406
}).set('stage.vacationrentals.com', {
    socialHost: 'social.stage.vacationrentals.com',
    appId: 740054666164700
}).set('stage.homeaway.lk', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.cl', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.com.cn', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.com.my', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.com.pe', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.com.sg', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.com.uy', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.ec', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.de', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.ph', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.ru', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.co.kr', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.co.th', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.com.vn', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.hk', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.id', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.jp', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('stage.homeaway.tw', {
    socialHost: 'social.stage.homeaway.com',
    appId: 159072491337276
}).set('test.abritel.fr', {
    socialHost: 'social.stage.homeaway.com',
    appId: 216495905037464
}).set('test.fewo-direkt.de', {
    socialHost: 'social.stage.homeaway.com',
    appId: 160652240666876
}).set('test.fr.homeaway.ca', {
    socialHost: 'social.stage.homeaway.com',
    appId: 128528480560007
}).set('test.homeaway.co.uk', {
    socialHost: 'social.stage.homeaway.com',
    appId: 150947144978961
}).set('test.homeaway.com.ar', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.at', {
    socialHost: 'social.stage.homeaway.com',
    appId: 216722541738655
}).set('test.homeaway.ca', {
    socialHost: 'social.stage.homeaway.ccom',
    appId: 102098883216214
}).set('test.homeaway.com', {
    socialHost: 'social.stage.homeaway.com',
    appId: 214276818594151
}).set('luxury-test.homeaway.com', {
    socialHost: 'social.stage.homeaway.com',
    appId: 214276818594151
}).set('local.homeaway.com', {
    socialHost: 'social.stage.homeaway.com',
    appId: 214276818594151
}).set('cas-test.homeaway.com', {
    socialHost: 'social.stage.homeaway.com',
    appId: 214276818594151
}).set('test.homeaway.com.au', {
    socialHost: 'social.stage.homeaway.com',
    appId: 232355823447356
}).set('test.homeaway.co.nz', {
    socialHost: 'social.stage.homeaway.com',
    appId: 408693902531641
}).set('test.homeaway.dk', {
    socialHost: 'social.stage.homeaway.com',
    appId: 128562707222964
}).set('test.homeaway.es', {
    socialHost: 'social.stage.homeaway.com',
    appId: 218505198169378
}).set('test.homeaway.co.in', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.it', {
    socialHhost: 'social.stage.homeaway.com',
    appId: 171544982905463
}).set('test.homeaway.com.mx', {
    socialHost: 'social.stage.homeaway.com',
    appId: 190761167642816
}).set('test.homeaway.nl', {
    socialHost: 'social.stage.homeaway.com',
    appId: 216201598414227
}).set('test.homeaway.no', {
    socialHost: 'social.stage.homeaway.com',
    appId: 171012689625753
}).set('test.homeaway.pt', {
    socialHost: 'social.stage.homeaway.com',
    appId: 221229267894962
}).set('test.homeaway.se', {
    socialHost: 'social.stage.homeaway.com',
    appId: 171502289576202
}).set('test.ownersdirect.co.uk', {
    socialHost: 'social.stage.homeaway.com',
    appId: 205904176119591
}).set('test.vrbo.com', {
    socialHost: 'social.stage.vrbo.com',
    appId: 109213082502054
}).set('test.homeaway.gr', {
    socialHost: 'social.stage.homeaway.com',
    appId: 789666784457552
}).set('test.homeaway.pl', {
    socialHost: 'social.stage.homeaway.com',
    appId: 417671541925591
}).set('test.homelidays.com', {
    socialHost: 'social.stage.homeaway.com',
    appId: 656718087846825
}).set('test.homelidays.it', {
    socialHost: 'social.homeaway.com',
    appId: 1714068882219402
}).set('test.homelidays.es', {
    socialHost: 'social.homeaway.com',
    appId: 958959140937389
}).set('test.vacationrentals.com', {
    socialHost: 'social.stage.vacationrentals.com',
    appId: 1774052049590533
}).set('test.homeaway.lk', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.cl', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.co', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.com.cn', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.com.my', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.com.pe', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.com.sg', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.com.uy', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.ec', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.ph', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.ru', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.co.kr', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.co.th', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.com.vn', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.hk', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.id', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.jp', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.tw', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.fi', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.de', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.stayz.com.au', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1931748713753630
}).set('test.homeaway.com.br', {
    socialHost: 'social.stage.homeaway.com',
    appId: 797315507323547
}).set('test.aluguetemporada.com.br', {
    socialHost: 'social.stage.homeaway.com',
    appId: 797315507323547
}).set('identity-auth-ui-dev-ustst1-01.wvrgroup.internal', {
    socialHost: 'social.stage.homeaway.com',
    appId: 185688351887352
}).set('identity-auth-ui-dev-usstg1-01.wvrgroup.internal', {
    socialHost: 'social.stage.homeaway.com',
    appId: 1183308035090139
});

// per https://developers.facebook.com/docs/messenger-platform/messenger-profile/supported-locales
// we want to only pick locales that facebook supports
var localeMap = {
    // custom mappings here
    da: 'da_DK',
    de: 'de_DE',
    en: 'en_US',
    es: 'es_LA',
    en_AU: 'en_GB',
    en_GB: 'en_GB',
    en_IN: 'en_GB',
    en_US: 'en_US',
    es_ES: 'es_ES',
    fi: 'fi_FI',
    fr: 'fr_FR',
    fr_CA: 'fr_CA',
    it: 'it_IT',
    nb: 'nb_NO',
    nl: 'nl_NL',
    no: 'nb_NO',
    // base locales here
    no_NO: 'nb_NO',
    pt_BR: 'pt_BR',
    pt_PT: 'pt_PT',
    ko_KR: 'ko_KR',
    nl_NL: 'nl_NL',
    ru_RU: 'ru_RU',
    zh_CN: 'zh_CN',
    zh_HK: 'zh_HK',
    zh_TW: 'zh_TW',
    ja_KS: 'ja_KS',
    pl_PL: 'pl_PL',
    fi_FI: 'fi_FI',
    vi_VN: 'vi_VN',
    sv_SE: 'sv_SE',
    el_GR: 'el_GR',
    es_LA: 'es_LA',
    ja_JP: 'ja_JP',
    tr_TR: 'tr_TR'
};

function getLocale(locale) {
    if (locale) {
        var localParts = locale.split('_');
        if (localParts.length > 2) {
            locale = localParts[0] + '_' + localParts[1];
        }
        var returnLocale = localeMap[locale] ? localeMap[locale] : localeMap[locale.split('_')[0]];
        return returnLocale || 'en_US';
    }
    return 'en_US';
}

/**
 * Get the corresponding facebook settings as per the given domain and locale
 * @param domain String
 * @param locale String
 * @returns {any | {}} Object
 */
function get(domain, locale) {
    if (domain && domain.startsWith('www.')) {
        domain = domain.substring(4);
    }
    var settings = FACEBOOK_SETTINGS_MAP.get(domain);

    if (!settings) {
        _clientLogger2.default.logError('[ALERT] There are no facebook settings for the specified domain=' + domain);
        settings = FACEBOOK_SETTINGS_MAP.get('homeaway.com');
    }
    settings.trackingHost = settings.socialHost.replace('social.', 'facebook.');
    settings.locale = getLocale(locale);

    return settings;
}

module.exports = {
    get: get
};
//# sourceMappingURL=facebook.settings.js.map

/***/ }),

/***/ "PBUe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PXso":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("O1Qq");

var _TandCComponent = __webpack_require__("/s9T");

var _TandCComponent2 = _interopRequireDefault(_TandCComponent);

var _HeaderSectionComponent = __webpack_require__("F1Vd");

var _HeaderSectionComponent2 = _interopRequireDefault(_HeaderSectionComponent);

var _CalloutCardComponent = __webpack_require__("um2z");

var _CalloutCardComponent2 = _interopRequireDefault(_CalloutCardComponent);

var _SignUpComponent = __webpack_require__("vuNg");

var _SignUpComponent2 = _interopRequireDefault(_SignUpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SignUpPageComponent = function (_Component) {
    _inherits(SignUpPageComponent, _Component);

    function SignUpPageComponent(props) {
        _classCallCheck(this, SignUpPageComponent);

        var _this = _possibleConstructorReturn(this, (SignUpPageComponent.__proto__ || Object.getPrototypeOf(SignUpPageComponent)).call(this, props));

        _this.state = {
            emailAddress: _this.props.emailAddress,
            currentPage: _this.props.currentPage,
            error: '',
            errorTitle: ''
        };
        _this.handleError = _this.handleError.bind(_this);
        return _this;
    }

    _createClass(SignUpPageComponent, [{
        key: 'handleError',
        value: function handleError(error) {
            this.setState({ error: error });
        }
    }, {
        key: 'render',
        value: function render() {
            var cardContent = _react2.default.createElement(_SignUpComponent2.default, {
                actionLocation: this.props.actionLocation,
                lingua: this.props.lingua,
                emailAddress: this.props.emailAddress,
                service: this.props.service,
                handleError: this.handleError,
                site: this.props.site,
                updatePage: this.props.updatePage,
                setFirstName: this.props.setFirstName,
                setEmail: this.props.setEmail,
                passwordType: this.props.passwordType,
                showHidePassword: this.props.showHidePassword,
                isWaiting: this.props.isWaiting,
                enableLoading: this.props.enableLoading,
                disableLoading: this.props.disableLoading,
                setAuthJson: this.props.setAuthJson,
                useNewEndpoints: this.props.useNewEndpoints,
                multiUserEnabled: this.props.multiUserEnabled
            });
            return _react2.default.createElement(
                'div',
                { className: 'border-border-color' },
                _react2.default.createElement(_HeaderSectionComponent2.default, { header: this.props.lingua.read('lex.header.signup') }),
                _react2.default.createElement(_CalloutCardComponent2.default, { content: cardContent, error: this.state.error, errorTitle: this.state.errorTitle }),
                _react2.default.createElement(_TandCComponent2.default, { lingua: this.props.lingua, multiUserEnabled: this.props.multiUserEnabled })
            );
        }
    }]);

    return SignUpPageComponent;
}(_react.Component);

exports.default = SignUpPageComponent;
//# sourceMappingURL=SignUpPageComponent.js.map

/***/ }),

/***/ "QDAn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Flags = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDropdown = __webpack_require__("CVj+");

__webpack_require__("wt6h");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Flags = exports.Flags = function (_React$Component) {
    _inherits(Flags, _React$Component);

    function Flags() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Flags);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Flags.__proto__ || Object.getPrototypeOf(Flags)).call.apply(_ref, [this].concat(args))), _this), _this.onClickFlag = /* istanbul ignore next */function (event) {
            var countryCode = event.currentTarget.dataset.countryCode;

            // @ts-ignore
            if (countryCode && window.edap) {
                // @ts-ignore
                window.edap.push(function (edap) {
                    var payload = {
                        eventaction: 'header-countryflag',
                        eventcategory: 'react-site-header',
                        eventlabel: 'countryCode',
                        eventvalue: countryCode
                    };
                    edap.trigger('generic.event', payload);
                });
            }
        }, _this.renderItem = function (flag) {
            return _react2.default.createElement(
                'a',
                {
                    className: 'site-header__link site-header-flags__flag ' + flag.countryCode,
                    'data-bypass': 'true',
                    'data-country-code': flag.countryCode,
                    href: flag.link,
                    key: flag.countryCode + '-' + flag.link,
                    onClick: _this.onClickFlag,
                    role: 'menuitem'
                },
                _react2.default.createElement('i', { 'aria-hidden': 'true', className: 'site-header-flags__flag-icon flag-' + flag.countryCode }),
                _react2.default.createElement(
                    'span',
                    { className: 'site-header-flags__flag-text' },
                    flag.text
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Flags, [{
        key: 'render',
        value: function render() {
            if (!this.props.items) {
                return null;
            }

            var currentFlag = this.props.items[0];

            var toggle = _react2.default.createElement(
                'button',
                {
                    'aria-haspopup': 'true',
                    className: 'site-header-flags__toggle'
                },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    currentFlag.text
                ),
                _react2.default.createElement('i', { 'aria-hidden': 'true', className: 'flag-' + currentFlag.countryCode })
            );

            return _react2.default.createElement(
                _reactDropdown.Dropdown,
                {
                    className: this.className,
                    customToggle: toggle,
                    dropdownRight: true,
                    id: 'site-header-flags',
                    label: currentFlag.text,
                    tabIndex: -1
                },
                _react2.default.createElement(
                    'div',
                    { 'aria-labelledby': 'site-header-flags', className: 'site-header-flags__dropdown-menu', role: 'menu' },
                    this.props.items.map(this.renderItem)
                )
            );
        }
    }, {
        key: 'className',
        get: function get() {
            return (0, _classnames2.default)('site-header-flags', { 'site-header-flags--columns': this.props.showColumns });
        }
    }]);

    return Flags;
}(_react2.default.Component);
//# sourceMappingURL=Flags.js.map

/***/ }),

/***/ "QgIf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _HeaderSectionComponent = __webpack_require__("F1Vd");

var _HeaderSectionComponent2 = _interopRequireDefault(_HeaderSectionComponent);

var _TandCComponent = __webpack_require__("/s9T");

var _TandCComponent2 = _interopRequireDefault(_TandCComponent);

var _CalloutCardComponent = __webpack_require__("um2z");

var _CalloutCardComponent2 = _interopRequireDefault(_CalloutCardComponent);

var _InitialCredentialsComponent = __webpack_require__("T/4v");

var _InitialCredentialsComponent2 = _interopRequireDefault(_InitialCredentialsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InitialPageComponent = function (_Component) {
    _inherits(InitialPageComponent, _Component);

    function InitialPageComponent(props) {
        _classCallCheck(this, InitialPageComponent);

        var _this = _possibleConstructorReturn(this, (InitialPageComponent.__proto__ || Object.getPrototypeOf(InitialPageComponent)).call(this, props));

        _this.state = {
            error: '',
            errorTitle: ''
        };
        _this.handleError = _this.handleError.bind(_this);
        return _this;
    }

    _createClass(InitialPageComponent, [{
        key: 'handleError',
        value: function handleError(error) {
            this.setState({ error: error });
        }
    }, {
        key: 'render',
        value: function render() {
            var options = { 'siteName': this.props.siteName };
            var cardContent = _react2.default.createElement(_InitialCredentialsComponent2.default, {
                actionLocation: this.props.actionLocation,
                lingua: this.props.lingua,
                firstName: this.props.firstName,
                currentPage: this.props.currentPage,
                performInitialBulkUpdate: this.props.performInitialBulkUpdate,
                setAuthAccountType: this.props.setAuthAccountType,
                handleError: this.handleError,
                locale: this.props.locale,
                onClose: this.props.onClose,
                isWaiting: this.props.isWaiting,
                enableLoading: this.props.enableLoading,
                disableLoading: this.props.disableLoading,
                site: this.props.site,
                handleLoginSuccess: this.props.handleLoginSuccess,
                updatePage: this.props.updatePage,
                performBulkPageUpdate: this.props.performBulkPageUpdate,
                setAuthJson: this.props.setAuthJson,
                useNewEndpoints: this.props.useNewEndpoints,
                multiUserEnabled: this.props.multiUserEnabled,
                expediaIconDisplayed: this.props.expediaIconDisplayed
            });
            return _react2.default.createElement(
                'div',
                { className: 'InitialPageComponent border-border-color' },
                _react2.default.createElement(_HeaderSectionComponent2.default, { header: this.props.lingua.read('lex.header.initial', options) }),
                _react2.default.createElement(_CalloutCardComponent2.default, { content: cardContent, error: this.state.error, errorTitle: this.state.errorTitle }),
                _react2.default.createElement(_TandCComponent2.default, { lingua: this.props.lingua, multiUserEnabled: this.props.multiUserEnabled })
            );
        }
    }]);

    return InitialPageComponent;
}(_react.Component);

exports.default = InitialPageComponent;
//# sourceMappingURL=InitialPageComponent.js.map

/***/ }),

/***/ "QnUD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ACCOUNT__16.js
var ACCOUNT__16 = '<svg data-id="SVG_ACCOUNT__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8zm2 4.8c.3-1.6 1.4-3 2.9-3.6m4.2 0a5 5 0 0 1 1.8 1.4"/><path d="M10.7 7.2C10.7 8.7 9.5 10 8 10a2.7 2.7 0 0 1-2.7-2.7v-.6C5.3 5 6.5 3.9 8 3.9c1.5 0 2.7 1.2 2.7 2.7v.6z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ACCOUNT__24.js
var ACCOUNT__24 = '<svg data-id="SVG_ACCOUNT__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0zm2.62 6.32a6.8 6.8 0 0 1 3.85-4.75m5.57 0a6.74 6.74 0 0 1 2.43 1.86"/><path d="M15.53 10.97a3.52 3.52 0 0 1-7.06 0v-.88a3.52 3.52 0 1 1 7.06 0v.88z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ADD_CIRCLE__16.js
var ADD_CIRCLE__16 = '<svg data-id="SVG_ADD_CIRCLE__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0zM8 10.8V5.2M10.8 8H5.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ADD_CIRCLE__24.js
var ADD_CIRCLE__24 = '<svg data-id="SVG_ADD_CIRCLE__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2.8 12a9.3 9.3 0 0 1 12.7-8.5 9.3 9.3 0 0 1 5 12 9.4 9.4 0 0 1-6.7 5.6 9.3 9.3 0 0 1-11-9.1zm9.2 4V8m4 4H8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/AIR_CONDITIONING__24.js
var AIR_CONDITIONING__24 = '<svg data-id="SVG_AIR_CONDITIONING__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M9.22 14.41V5.57a2.4 2.4 0 1 0-4.8 0v8.84a3.6 3.6 0 1 0 4.8 0zM6.83 11.08v4.8M14.34 6.72l1.74 1.16 1.73-1.16M16.08 14.81V5.56M14.34 13.66l1.74-1.16 1.73 1.16M19.54 8.45L18.4 10.2l1.15 1.73M11.45 10.19h9.25M12.6 8.45l1.16 1.74-1.15 1.73" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.62 17.08a1.22 1.22 0 1 1 2.43 0 1.22 1.22 0 0 1-2.43 0" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ALARM__16.js
var ALARM__16 = '<svg data-id="SVG_ALARM__16" viewBox="0 0 16 16" width="16" height="16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M2.2 3.5l1.2-1.1m9.2 0l1.2 1.1M10 6L8 8.2m-2 0H8m4.5 5.2l-.7-.8m-7.7 0l-.8.8m-.5-5.2a5.2 5.2 0 1 1 10.4 0 5.2 5.2 0 0 1-10.4 0z"/><path fill="currentColor" stroke="none" d="M7 8.2a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ALARM__24.js
var ALARM__24 = '<svg data-id="SVG_ALARM__24" viewBox="0 0 24 24" width="24" height="24"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M4.4 6.3l1.5-1.5m12.2 0l1.5 1.5m-4.8 3.2L12 12.4m-2.8 0H12m6 7l-1-1m-10.2 0l-1 1m-.7-7a7 7 0 1 1 13.8 0 7 7 0 0 1-13.8 0z"/><path fill="currentColor" stroke="none" d="M10.8 12.4a1.3 1.3 0 1 1 2.5 0 1.3 1.3 0 0 1-2.5 0"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ALERT__16.js
var ALERT__16 = '<svg data-id="SVG_ALERT__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M8.9 11A.9.9 0 1 1 7 11 .9.9 0 0 1 9 11"/><path stroke-linecap="round" stroke-linejoin="round" d="M8 4.8v3.9m7-.7A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ALERT__24.js
var ALERT__24 = '<svg data-id="SVG_ALERT__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M12 7.8v5.1m9.3-.9a9.3 9.3 0 1 1-18.6 0 9.3 9.3 0 0 1 18.6 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ALERT_ERROR__32.js
var ALERT_ERROR__32 = '<svg data-id="SVG_ALERT_ERROR__32" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><circle stroke="none" fill="currentColor" cx="16" cy="16" r="16"/><path d="M8 16h16" fill="none" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ALERT_INFO__32.js
var ALERT_INFO__32 = '<svg data-id="SVG_ALERT_INFO__32" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><circle stroke="none" fill="currentColor" cx="16" cy="16" r="16"/><circle stroke="none" fill="#FFF" cx="15.5" cy="8.5" r="1.5"/><path stroke="none" fill="#FFF" fill-rule="nonzero" d="M15.5 15h-2v-2h4v11h-2z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ALERT_SUCCESS__32.js
var ALERT_SUCCESS__32 = '<svg data-id="SVG_ALERT_SUCCESS__32" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><circle stroke="none" fill="currentColor" cx="16" cy="16" r="16"/><path stroke="#FFF" fill="none" stroke-linecap="round" stroke-linejoin="round" d="M10 17l5 4 7-10"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ALERT_TIME__32.js
var ALERT_TIME__32 = '<svg data-id="SVG_ALERT_TIME__32" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><circle stroke="none" fill="currentColor" cx="16" cy="16" r="16"/><circle fill="none" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" cx="16" cy="16" r="9"/><path stroke="#FFF" fill="none" stroke-linecap="round" stroke-linejoin="round" d="M13 17h4v-5"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ALERT_WARNING__16.js
var ALERT_WARNING__16 = '<svg data-id="SVG_ALERT_WARNING__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke="none" fill="currentColor" d="M8.9 12A.9.9 0 1 1 7 12 .9.9 0 0 1 9 12"/><path stroke-linecap="round" stroke-linejoin="round" d="M7 2.4a1.2 1.2 0 0 1 2 0l5.8 10a1.2 1.2 0 0 1-1 1.8H2.2a1.2 1.2 0 0 1-1-1.8l5.7-10zm1 3.3v3.8"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ALERT_WARNING__24.js
var ALERT_WARNING__24 = '<svg data-id="SVG_ALERT_WARNING__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M13 17.1a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M10.6 4.5a1.6 1.6 0 0 1 2.8 0L21 17.7a1.6 1.6 0 0 1-1.4 2.5H4.4A1.6 1.6 0 0 1 3 17.7l7.6-13.2zM12 9V14"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ALERT_WARNING__32.js
var ALERT_WARNING__32 = '<svg data-id="SVG_ALERT_WARNING__32" width="32px" height="32px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><circle stroke="none" fill="currentColor" cx="16" cy="16" r="16"/><path stroke="none" fill="#FFF" d="M17.5 19.5083c0 .8285-.6716 1.5-1.5 1.5s-1.5-.6715-1.5-1.5V6.4903c0-.8283.6716-1.5 1.5-1.5s1.5.6717 1.5 1.5v13.018z" fill-rule="nonzero"/><circle stroke="none" fill="#FFF" cx="16" cy="26" r="2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ANDROID__16.js
var ANDROID__16 = '<svg data-id="SVG_ANDROID__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g stroke="none" fill="currentColor" transform="scale(.667, .667)"><path stroke="none" d="M3.3 7.7A1.5 1.5 0 0 0 2 9.2v6.2a1.5 1.5 0 1 0 3 0V9.2a1.5 1.5 0 0 0-1.6-1.5"/><path data-name="Shape" d="M15.3 2.2l1-2a.2.2 0 0 0-.4-.1l-1 1.9A7.2 7.2 0 0 0 9 2L8.1.1a.2.2 0 0 0-.4.2l1 1.9a6 6 0 0 0-3.4 5.3h13.4a6 6 0 0 0-3.4-5.3M9 5a.6.6 0 1 1 .4-.2.6.6 0 0 1-.4.2m6 0a.6.6 0 1 1 .6-.6.6.6 0 0 1-.5.6M5.4 17.6A1.6 1.6 0 0 0 7 19.2h1v3.3a1.5 1.5 0 1 0 3 0v-3.3h2v3.3a1.5 1.5 0 0 0 3 0v-3.3h1a1.6 1.6 0 0 0 1.6-1.6V8H5.4zm15.3-9.9a1.5 1.5 0 0 0-1.5 1.5v6.2a1.5 1.5 0 1 0 3 0V9.2a1.5 1.5 0 0 0-1.5-1.5"/><path stroke="none" d="M3.3 7.7A1.5 1.5 0 0 0 2 9.2v6.2a1.5 1.5 0 1 0 3 0V9.2a1.5 1.5 0 0 0-1.6-1.5zm12-5.5l1-2a.2.2 0 0 0-.4-.1l-1 1.9A7.2 7.2 0 0 0 9 2L8.1.1a.2.2 0 0 0-.4.2l1 1.9a6 6 0 0 0-3.4 5.3h13.4a6 6 0 0 0-3.4-5.3zM9 5a.6.6 0 1 1 .4-.2.6.6 0 0 1-.4.2zm6 0a.6.6 0 1 1 .6-.6.6.6 0 0 1-.6.6zM5.5 8v9.6A1.6 1.6 0 0 0 7 19.2h1v3.3a1.5 1.5 0 1 0 3 0v-3.3h2v3.3a1.5 1.5 0 1 0 3 0v-3.3h1a1.6 1.6 0 0 0 1.6-1.6V8zm16.8 1.2a1.5 1.5 0 1 0-3 0v6.2a1.5 1.5 0 1 0 3 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ANDROID__24.js
var ANDROID__24 = '<svg data-id="SVG_ANDROID__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g stroke="none" fill="currentColor"><path stroke="none" d="M3.3 7.7A1.5 1.5 0 0 0 2 9.2v6.2a1.5 1.5 0 1 0 3 0V9.2a1.5 1.5 0 0 0-1.6-1.5"/><path data-name="Shape" d="M15.3 2.2l1-2a.2.2 0 0 0-.4-.1l-1 1.9A7.2 7.2 0 0 0 9 2L8.1.1a.2.2 0 0 0-.4.2l1 1.9a6 6 0 0 0-3.4 5.3h13.4a6 6 0 0 0-3.4-5.3M9 5a.6.6 0 1 1 .4-.2.6.6 0 0 1-.4.2m6 0a.6.6 0 1 1 .6-.6.6.6 0 0 1-.5.6M5.4 17.6A1.6 1.6 0 0 0 7 19.2h1v3.3a1.5 1.5 0 1 0 3 0v-3.3h2v3.3a1.5 1.5 0 0 0 3 0v-3.3h1a1.6 1.6 0 0 0 1.6-1.6V8H5.4zm15.3-9.9a1.5 1.5 0 0 0-1.5 1.5v6.2a1.5 1.5 0 1 0 3 0V9.2a1.5 1.5 0 0 0-1.5-1.5"/><path stroke="none" d="M3.3 7.7A1.5 1.5 0 0 0 2 9.2v6.2a1.5 1.5 0 1 0 3 0V9.2a1.5 1.5 0 0 0-1.6-1.5zm12-5.5l1-2a.2.2 0 0 0-.4-.1l-1 1.9A7.2 7.2 0 0 0 9 2L8.1.1a.2.2 0 0 0-.4.2l1 1.9a6 6 0 0 0-3.4 5.3h13.4a6 6 0 0 0-3.4-5.3zM9 5a.6.6 0 1 1 .4-.2.6.6 0 0 1-.4.2zm6 0a.6.6 0 1 1 .6-.6.6.6 0 0 1-.6.6zM5.5 8v9.6A1.6 1.6 0 0 0 7 19.2h1v3.3a1.5 1.5 0 1 0 3 0v-3.3h2v3.3a1.5 1.5 0 1 0 3 0v-3.3h1a1.6 1.6 0 0 0 1.6-1.6V8zm16.8 1.2a1.5 1.5 0 1 0-3 0v6.2a1.5 1.5 0 1 0 3 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ARROW_DOWN__16.js
var ARROW_DOWN__16 = '<svg data-id="SVG_ARROW_DOWN__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M11.3 10.3L8 13.6l-3.4-3.3M8 13.7V2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ARROW_DOWN__24.js
var ARROW_DOWN__24 = '<svg data-id="SVG_ARROW_DOWN__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round" ><path d="M17 15.7l-5 5-5-5M12 20.8V3.2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ARROW_LEFT__16.js
var ARROW_LEFT__16 = '<svg data-id="SVG_ARROW_LEFT__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M10.4 4.5l3.3 3.3-3.3 3.4M13.8 7.9H2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ARROW_LEFT__24.js
var ARROW_LEFT__24 = '<svg data-id="SVG_ARROW_LEFT__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M8.3 17l-5-5 5-5M3.2 12h17.6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ARROW_LEFT__32.js
var ARROW_LEFT__32 = '<svg data-id="SVG_ARROW_LEFT__32" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M12 24l-8-8 8-8m-8 8h24" fill="none"  stroke-linecap="round" stroke-linejoin="round" /></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ARROW_RIGHT__16.js
var ARROW_RIGHT__16 = '<svg data-id="SVG_ARROW_RIGHT__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M10.4 4.5l3.3 3.3-3.3 3.4M13.8 7.9H2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ARROW_RIGHT__24.js
var ARROW_RIGHT__24 = '<svg data-id="SVG_ARROW_RIGHT__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M15.7 7l5 5-5 5M20.8 12H3.2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ARROW_RIGHT__32.js
var ARROW_RIGHT__32 = '<svg data-id="SVG_ARROW_RIGHT__32" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M20 24l8-8-8-8M4 16h24" fill="none"  stroke-linecap="round" stroke-linejoin="round" /></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ARROW_UP__16.js
var ARROW_UP__16 = '<svg data-id="SVG_ARROW_UP__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M4.7 5.5L8 2.2l3.4 3.3M8 2.2v11.6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ARROW_UP__24.js
var ARROW_UP__24 = '<svg data-id="SVG_ARROW_UP__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round""><path d="M7 8.7l5-5 5 5M12 3.7v17.6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ATM__16.js
var ATM__16 = '<svg data-id="SVG_ATM__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M3.8 9.5H1V3.1h12.5c.8 0 1.5.6 1.5 1.5v5h-.6"/><path stroke-linecap="round" stroke-linejoin="round" d="M12.2 6.3V13H5.3c-.8 0-1.5-.6-1.5-1.5v-5m-.7 0h9.8m-3.1 6.5V6.3"/><path fill="currentColor" stroke="none" d="M5.9 11h1.9V9.1H5.9z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ATM__24.js
var ATM__24 = '<svg data-id="SVG_ATM__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M6.5 15H2.8V6.3h17c.8 0 1.5.7 1.5 1.5v7h-.8"/><path stroke-linecap="round" stroke-linejoin="round" d="M17.5 10.7v8.7H8c-.8 0-1.5-.6-1.5-1.5v-7.2m-1 0h13m-4.2 8.7v-8.7"/><path fill="currentColor" stroke="none" d="M9.2 16.8h2.5v-2.5H9.2z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ATTACHMENT__16.js
var ATTACHMENT__16 = '<svg data-id="SVG_ATTACHMENT__16" viewBox="0 0 16 16" width="16" height="16"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M10.6 7.1l-6.3 5.7c-1.2 1-2.2 1.1-3 .3-.5-.6-.9-1.7.4-3l8-7.2a3.2 3.2 0 0 1 4.4 4.8L7.2 14"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/ATTACHMENT__24.js
var ATTACHMENT__24 = '<svg data-id="SVG_ATTACHMENT__24" viewBox="0 0 24 24" width="24" height="24"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M15.5 10.8l-7.9 8c-1.5 1.4-2.8 1.5-3.8.5-.8-.8-1.4-2.3.3-4l10-10a4.3 4.3 0 0 1 6.1 6L11.5 20"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BEACH__16.js
var BEACH__16 = '<svg data-id="SVG_BEACH__16" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M2.02 9.01a6.03 6.03 0 0 1 11.82-2.35M5.96 8.23a16.9 16.9 0 0 1-.3-2.29c-.05-.74-.03-1.42.04-2 .07-.59.2-1.07.38-1.41.18-.35.4-.55.67-.6.26-.05.54.05.84.3.3.25.6.64.9 1.15.29.51.56 1.13.8 1.83.25.7.45 1.46.61 2.23v.01M6.75 1.93l-.18-.91M9.26 14.54L8.06 8.5M1.42 14.54h7.84M14.58 14.54H12.2"/><path d="M2.02 9.01l2.1.27 1.84-1.05 2.1.26L9.9 7.45l2.1.26 1.84-1.05"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BEACH__24.js
var BEACH__24 = '<svg data-id="SVG_BEACH__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M4.1 13.4a7.96 7.96 0 0 1 15.62-3.1M9.3 12.37c-.2-1.03-.34-2.05-.4-3.02-.05-.98-.03-1.88.06-2.65.1-.77.27-1.4.5-1.86.24-.46.54-.73.88-.8.35-.06.73.07 1.12.4.4.33.8.85 1.18 1.52.4.68.75 1.5 1.07 2.42a22.5 22.5 0 0 1 .8 2.96M10.34 4.04l-.23-1.2M13.67 20.71l-1.59-7.99M3.3 20.71h10.37M20.7 20.71h-4.07"/><path d="M4.1 13.4l2.77.36 2.43-1.39 2.78.35 2.43-1.38 2.78.34 2.43-1.38"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BED_LG__16.js
var BED_LG__16 = '<svg data-id="SVG_BED_LG__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M15 9.7v3.57H2.5a1.5 1.5 0 0 1-1.5-1.5V9.7h11.05M2 4.6V1.25h10.5c.83 0 1.5.67 1.5 1.5V4.6h-1.83"/><path d="M11.67 4.6H14l1 4.68v.91M1 10.19v-.91L2 4.6h9.67M1 11.77v2.98M15 13.27v1.48"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BED_LG__24.js
var BED_LG__24 = '<svg data-id="SVG_BED_LG__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M21.25 15.5v3.3h-17a1.5 1.5 0 0 1-1.5-1.5v-1.8h14.6M4.51 9.18V4.75h13.52c.82 0 1.5.67 1.5 1.5v2.93h-1.95"/><path d="M16.84 9.18h2.65l1.76 5.76v1.2M2.75 16.15v-1.21l1.8-5.76h2.6M5.4 18.8v1.95M18.6 18.8v1.95M7.16 10.02h3.52V7.37H7.16z"/><path d="M13.32 10.09h3.53V7.44h-3.53zM13.2 9.18h-2.52"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BED_SM__16.js
var BED_SM__16 = '<svg data-id="SVG_BED_SM__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13.86 9.7v3.57H3.36a1.5 1.5 0 0 1-1.5-1.5V9.7h9.05M2.86 4.6V1.25h8.5c.83 0 1.5.67 1.5 1.5V4.6h-1.83"/><path d="M10.53 4.6h2.33l1 4.68v.91"/><path d="M1.86 10.19v-.91l1-4.68h7.67M1.86 11.77v2.98M13.86 13.27v1.48"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BED_SM__24.js
var BED_SM__24 = '<svg data-id="SVG_BED_SM__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M19.55 15.41v3.56H5.95a1.5 1.5 0 0 1-1.5-1.5v-2.06H16M6.22 9.2V4.74h10.06c.83 0 1.5.67 1.5 1.5v2.94"/><path d="M14.22 9.2h3.52l1.81 5.7V16M4.45 16v-1.1l1.8-5.7h3.53M6.22 18.97v1.78M17.78 18.97v1.78M9.78 10.08h4.44V7.42H9.78z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BIKE__16.js
var BIKE__16 = '<svg data-id="SVG_BIKE__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3.3 12.1a2.3 2.3 0 1 1 0-4.5 2.3 2.3 0 0 1 0 4.5zM15 10a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0zm-7 0l2.8-4.7L8 10zM5.7 5.6L3.3 10"/><path d="M12.7 9.9l-2.4-6H9M5.7 5.6H4.3m1.4 0L8 10"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BIKE__24.js
var BIKE__24 = '<svg data-id="SVG_BIKE__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5.8 18a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm15.5-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/><path d="M8.8 15H12l3.8-6.2M9 9.4L5.8 15"/><path d="M18.3 15L15 7h-1.7M9 9.4H7.2m1.8 0l3 5.6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BIRDHOUSE__40.js
var BIRDHOUSE__40 = '<svg data-id="SVG_BIRDHOUSE__40" width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><g stroke="none" fill="currentColor" fill-rule="evenodd"><path stroke="none" d="M29 21.7v-4.3l2.8-.3v4.2l-2.7.4zm2.8 5.2l-2.7.5v-4.3l2.7-.4v4.2zm-7.4 1.4v-4.6l3.3-.4v4.4l-3.3.6zM7.6 31.7v-2.4l6.5-1.1s1.2 0 1-1.3c0-1.1-1.2-1-1.2-1l-6.3 1V15.2l6.6-7.9 7.4 8.3v18.6l-14-2.5zm16.8-13.9l3.3-.3v4.4l-3.3.4v-4.5zm3-12.7H12.4l-9 10.7 3.2-.2V27l-2.4.3s-1.2.3-.9 1.5c.3 1 1.2 1 1.2 1l2-.4v3l15.2 2.8 11.9-2.7V15.8l3.2-.3-9.2-10.4z"/><path d="M17.3 16a5.9 5.9 0 0 1 1.4 3.8c0 1.3-.4 2.6-1.2 3.5a3.9 3.9 0 0 1-3 1.6 4 4 0 0 1-3-1.5 6 6 0 0 1-1.3-3.8c0-1.4.4-2.6 1-3.5a3.9 3.9 0 0 1 3.1-1.7 4 4 0 0 1 3 1.5zm-.4 6.8a5 5 0 0 0 1-3.3 5 5 0 0 0-1.2-3 3.1 3.1 0 0 0-2.5-1.2 3 3 0 0 0-2.3 1.3 5 5 0 0 0-.9 3.2 5 5 0 0 0 1.2 3 3.1 3.1 0 0 0 2.4 1.2 3 3 0 0 0 2.3-1.2zm-4-3c.1 1.5.7 2.7 1.5 3.1-1.2.1-2.3-1.3-2.4-3-.1-1.8.8-3.3 2-3.4-.7.5-1.1 1.8-1 3.3z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BOAT__16.js
var BOAT__16 = '<svg data-id="SVG_BOAT__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13 15a2.6 2.6 0 0 1-2.5-1.6m0 0A2.7 2.7 0 0 1 8 15m0 0a2.6 2.6 0 0 1-2.5-1.6m0 0A2.7 2.7 0 0 1 3.1 15M12.9 12.1l1-3.8L8 6.8 2.1 8.3l1 3.8M13 7.8v-4c0-.6-.6-1.1-1.2-1.1H4.2c-.6 0-1.1.5-1.1 1.1v1.8M8 2.7V1"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BOAT__24.js
var BOAT__24 = '<svg data-id="SVG_BOAT__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M18.5 20.7a3.5 3.5 0 0 1-3.2-2.2m0 0a3.6 3.6 0 0 1-3.3 2.2m0 0a3.5 3.5 0 0 1-3.2-2.2m0 0a3.6 3.6 0 0 1-3.3 2.2M18.1 17.8l1.6-5-7.7-2-7.8 2 1.7 5M18.5 12.3V7c0-.9-.7-1.5-1.5-1.5H7c-.8 0-1.5.6-1.5 1.5v2.2M12 5.5V3.2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BOOKMARK__16.js
var BOOKMARK__16 = '<svg data-id="SVG_BOOKMARK__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M13 15l-5-4-5 4V2.7C3 1.8 3.8 1 4.8 1h6.5c1 0 1.7.8 1.7 1.8V15z"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BOOKMARK__24.js
var BOOKMARK__24 = '<svg data-id="SVG_BOOKMARK__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M20 22l-8-5.7L4 22V4.5C4 3.1 5.1 2 6.5 2h11C18.9 2 20 3.1 20 4.5V22z"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BUS__16.js
var BUS__16 = '<svg data-id="SVG_BUS__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M2.5 5.2v-3C2.5 1.4 3 1 3.6 1h8.8c.6 0 1 .5 1 1.1v10.6h-5M8.4 12.7H2.5V7.8M5.9 13.9a1.1 1.1 0 0 1-2.3 0v-1.2h2.3V14zm6.5 0a1.1 1.1 0 1 1-2.3 0v-1.2h2.3V14zm-4.8-3.7h.8"/><path stroke="none" fill="currentColor" d="M4.2 10.2a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0m5.8 0a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 7.8H1m1.5-4.3h11"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/BUS__24.js
var BUS__24 = '<svg data-id="SVG_BUS__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M4.7 8.4V4.7c0-.8.7-1.5 1.6-1.5h11.5c.8 0 1.5.7 1.5 1.5v13.5h-6.8M12.5 18.2H4.8l-.1-6.5M9.2 19.7a1.5 1.5 0 1 1-3 0v-1.5h3v1.5z"/><path stroke="none" fill="currentColor" d="M7 15a1.3 1.3 0 1 1 2.4 0A1.3 1.3 0 0 1 7 15"/><path stroke-linecap="round" stroke-linejoin="round" d="M21.3 11.7H2.6m2-5.1h14.6m-1.5 13.1a1.5 1.5 0 0 1-3 0v-1.5h3v1.5zM11.5 15h1"/><path stroke="none" fill="currentColor" d="M14.6 15a1.3 1.3 0 1 1 2.5 0 1.3 1.3 0 0 1-2.5 0"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CABIN__16.js
var CABIN__16 = '<svg data-id="SVG_CABIN__16" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6.33l6.04-4.98a1.5 1.5 0 0 1 1.92 0L15 6.33M3.1 4.6V1.65M9.71 14V7.4h-3.4V14M3.64 7.4h8.74M6.7 4.6h2.61M3.08 10.7h3.23M3.08 14h9.86M9.71 10.7h3.23"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CABIN__24.js
var CABIN__24 = '<svg data-id="SVG_CABIN__24" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 10.18l8.3-6.84a1.5 1.5 0 0 1 1.9 0l8.3 6.84M5.5 7.5V3h1.47M14.26 20v-8h-4.5v8M5.5 12h13.01M5.5 12h4.26M10.92 6.88h1.58M5.5 20h13.03M14.5 14.75h4M5.5 14.75h3.27M14.5 17.42h4M5.5 17.42h3.27M7.98 9.4h7.52"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CALENDAR__16.js
var CALENDAR__16 = '<svg data-id="SVG_CALENDAR__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M1.4 2.7H13c.9 0 1.5.7 1.5 1.5v10.6H3c-.9 0-1.5-.7-1.5-1.5v-8H12"/><path fill="currentColor" stroke="none" d="M7.1 9.2h1.8V7.4H7.1zM7.1 12.8h1.8v-1.9H7.1zM3.7 9.2h1.9V7.4H3.7zM3.7 12.8h1.9v-1.9H3.7zM10.4 9.2h1.9V7.4h-1.9zM10.4 12.8h1.9v-1.9h-1.9z"/><path stroke-linecap="round" stroke-linejoin="round" d="M4.6 1.2v1.5m6.8-1.5v1.5"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CALENDAR__24.js
var CALENDAR__24 = '<svg data-id="SVG_CALENDAR__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M3.3 4.7h16c.8 0 1.5.7 1.5 1.5v14.5h-16c-.9 0-1.5-.7-1.5-1.5V8h14.1"/><path fill="currentColor" stroke="none" d="M10.8 13.3h2.5v-2.5h-2.5zM10.8 18h2.5v-2.5h-2.5zM6.3 13.3h2.5v-2.5H6.3zM6.3 18h2.5v-2.5H6.3zM15.2 13.3h2.5v-2.5h-2.5zM15.2 18h2.5v-2.5h-2.5z"/><path  stroke-linecap="round" stroke-linejoin="round" d="M7.5 2.7v2m9-2v2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CALENDAR_FILL__16.js
var CALENDAR_FILL__16 = '<svg data-id="SVG_CALENDAR_FILL__16" width="16" height="16" viewBox="0 0 16 16"><path stroke="none" fill="currentColor" d="M15 0a1 1 0 0 1 .7.3 1 1 0 0 1 .3.7v14a1 1 0 0 1-.3.7 1 1 0 0 1-.7.3H1a1 1 0 0 1-.7-.3A1 1 0 0 1 0 15V1A1 1 0 0 1 .3.3 1 1 0 0 1 1 0h1.3v2a1 1 0 0 0 1 1 1 1 0 0 0 .7-.3 1 1 0 0 0 .3-.7V0h7.4v2a1 1 0 0 0 .3.7 1 1 0 0 0 .7.3 1 1 0 0 0 .7-.3 1 1 0 0 0 .3-.7V0H15zM5 13.7V11H2.3v2.7zM5 9V6.3H2.3V9zm4.3 4.7V11H6.7v2.7zm0-4.7V6.3H6.7V9zm4.4 4.7V11H11v2.7h2.7zm0-4.7V6.3H11V9h2.7z"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CAMERA__16.js
var CAMERA__16 = '<svg data-id="SVG_CAMERA__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M12 6.9a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M1.7 2.7H3m-2 2h3.3l2.4-2H10l2.3 2h1.2c.8 0 1.5.6 1.5 1.5v7.1H2.5c-.8 0-1.5-.6-1.5-1.5V7"/><path stroke-linecap="round" stroke-linejoin="round" d="M5.8 8.3a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CAMERA__24.js
var CAMERA__24 = '<svg data-id="SVG_CAMERA__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M17.9 10.7a.7.7 0 1 1 1.5 0 .7.7 0 0 1-1.5 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M3.6 5h1.8M2.8 7.5h4.4l3-2.7h4.4l3.1 2.7h2c.9 0 1.6.7 1.6 1.5v10h-17c-.9 0-1.5-.7-1.5-1.6v-7.3"/><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.4a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CAR__16.js
var CAR__16 = '<svg data-id="SVG_CAR__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M14.6 12.4H1.4V8.6c0-.7.5-1.2 1.1-1.2h11c.6 0 1.1.5 1.1 1.2v3.8zm-9.9 1.1a1.1 1.1 0 1 1-2.3 0v-1.1h2.3v1.1zm8.9 0a1.1 1.1 0 0 1-2.3 0v-1.1h2.3v1.1zM6.5 10h3"/><path stroke="none" fill="currentColor" d="M3.1 9.9a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0m8 0a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0"/><path  stroke-linecap="round" stroke-linejoin="round" d="M3 4.6l.3-2.3c.1-.5.6-1 1.1-1h7.1c.6 0 1 .5 1.2 1l.6 5.1m-.2-2.8H15m-14 0h2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CAR__24.js
var CAR__24 = '<svg data-id="SVG_CAR__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M20.7 18H3.2v-5.1c0-.8.7-1.5 1.5-1.5h14.5c.9 0 1.5.7 1.5 1.5v5zm-13 1.5a1.5 1.5 0 0 1-3 0V18h3v1.5zm11.6 0a1.5 1.5 0 1 1-3 0V18h3v1.5zM10 14.7h4"/><path fill="currentColor" stroke="none" d="M5.4 14.7a1.3 1.3 0 1 1 2.5 0 1.3 1.3 0 0 1-2.5 0m10.6 0a1.3 1.3 0 1 1 2.5 0 1.3 1.3 0 0 1-2.5 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M5.4 8.5l.4-3c.1-.7.7-1.3 1.5-1.3h9.4c.7 0 1.4.6 1.5 1.3l.8 5.9m-.3-2.9h2.5m-18.5 0h2.7"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CARET_UP__16.js
var CARET_UP__16 = '<svg data-id="SVG_CARET_UP__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd" transform="rotate(180) translate(-16,-16) scale(.667, .667)"><path fill="currentColor" stroke="none" d="M11.293 15.293L5.707 9.707A1 1 0 0 1 6.414 8h11.172a1 1 0 0 1 .707 1.707l-5.586 5.586a1 1 0 0 1-1.414 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CARET_DOWN__16.js
var CARET_DOWN__16 = '<svg data-id="SVG_CARET_DOWN__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd" transform="scale(.667, .667)"><path fill="currentColor" stroke="none" d="M11.293 15.293L5.707 9.707A1 1 0 0 1 6.414 8h11.172a1 1 0 0 1 .707 1.707l-5.586 5.586a1 1 0 0 1-1.414 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CARET_UP__24.js
var CARET_UP__24 = '<svg data-id="SVG_CARET_UP__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd" transform="rotate(180) translate(-24,-24)"><path fill="currentColor" stroke="none" d="M11.293 15.293L5.707 9.707A1 1 0 0 1 6.414 8h11.172a1 1 0 0 1 .707 1.707l-5.586 5.586a1 1 0 0 1-1.414 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CARET_DOWN__24.js
var CARET_DOWN__24 = '<svg data-id="SVG_CARET_DOWN__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M11.293 15.293L5.707 9.707A1 1 0 0 1 6.414 8h11.172a1 1 0 0 1 .707 1.707l-5.586 5.586a1 1 0 0 1-1.414 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CASTLE__16.js
var CASTLE__16 = '<svg data-id="SVG_CASTLE__16" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M11.39 5.05l1.53 9.18H4.64a1.5 1.5 0 0 1-1.45-1.87l1.36-5.34h1.81M12.92 1.77v1.78c0 .83-.67 1.5-1.5 1.5H4.58a1.5 1.5 0 0 1-1.5-1.5V1.77M5.86 9.64h1.16M6.52 12.26h1.15M9.22 10.3h1.16M8.49 7.67h1.15"/><path d="M8.98 1.77v1.31h1.97V1.77M5.05 1.77v1.31h1.97V1.77"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CASTLE__24.js
var CASTLE__24 = '<svg data-id="SVG_CASTLE__24" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M16.49 8.08l2.02 12.14H7.25a1.73 1.73 0 0 1-1.68-2.17l1.88-7.37h2.4M18.5 3.75v2.6c0 .96-.77 1.73-1.72 1.73H7.24c-.96 0-1.73-.77-1.73-1.73v-2.6M9.19 14.15h1.52M10.05 17.62h1.52M13.63 15.02h1.52M12.65 11.55h1.53"/><path d="M13.3 3.75v1.73h2.61V3.75M8.11 3.75v1.73h2.6V3.75"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHAT__16.js
var CHAT__16 = '<svg data-id="SVG_CHAT__16" viewBox="0 0 16 16" width="16" height="16"><g stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="M6.5.5c-3.314 0-6 2.239-6 5 0 1.021.369 1.97 1 2.762V12l2.573-1.93a6.98 6.98 0 0 0 2.427.43c3.314 0 6-2.239 6-5s-2.686-5-6-5z" data-cap="butt"/><path d="M5.219 12.504C6.308 13.427 7.824 14 9.5 14c.783 0 1.529-.129 2.215-.356L14.5 15.5v-3.738c.631-.792 1-1.74 1-2.762a4.36 4.36 0 0 0-.799-2.495" data-cap="butt" data-color="color-2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHAT__24.js
var CHAT__24 = '<svg data-id="SVG_CHAT__24" viewBox="0 0 24 24" width="24" height="24"><g stroke-linecap="square" stroke="currentColor" fill="none" stroke-miterlimit="10"><path data-cap="butt" data-color="color-2" d="M8.299 17.101C9.592 19.11 12.326 20.5 15.5 20.5c.59 0 1.163-.051 1.716-.142L21.5 22.5v-4.04c1.241-1.057 2-2.44 2-3.96 0-1.552-.792-2.961-2.081-4.027" stroke-linecap="butt"/><path d="M11.5 1.5c-5.523 0-10 3.582-10 8 0 1.797.75 3.45 2 4.785V19.5l4.833-2.416c.996.266 2.059.416 3.167.416 5.523 0 10-3.582 10-8s-4.477-8-10-8z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHECK__12.js
var CHECK__12 = '<svg data-id="SVG_CHECK__12" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M2 7l3 3 6-8"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHECK__16.js
var CHECK__16 = '<svg data-id="SVG_CHECK__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M14.5 3.3l-8.2 9.4L1.5 8"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHECK__24.js
var CHECK__24 = '<svg data-id="SVG_CHECK__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M21.2 5.8L10.4 18.2 4.2 12"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHECK_IN__16.js
var CHECK_IN__16 = '<svg data-id="SVG_CHECK_IN__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M1.7 8.6H5V5.3"/><path stroke-linecap="round" stroke-linejoin="round" d="M.8 4.4L5 8.6m-3.3 2v2.5c0 .8.7 1.5 1.5 1.5h11.2V4c0-.8-.6-1.5-1.5-1.5H1.7"/><path fill="currentColor" stroke="none" d="M10.4 9.1h1.9V7.2h-1.9zM10.4 12.6h1.9v-1.9h-1.9zM7.1 12.6H9v-1.9H7.1zM3.9 12.6h1.9v-1.9H3.9z"/><path fill="currentColor" stroke="none" d="M10.4 9.1h1.9V7.2h-1.9zM7.1 9.1H9V7.2H7.1z"/><path stroke-linecap="round" stroke-linejoin="round" d="M4.4 1v1.5M11.2 1v1.5m3.2 2.8H7.1"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHECK_IN__24.js
var CHECK_IN__24 = '<svg data-id="SVG_CHECK_IN__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M15.6 18.1h2.5v-2.5h-2.5zM11.1 18.1h2.5v-2.5h-2.5zM6.6 18.1h2.5v-2.5H6.6z"/><path stroke-linecap="round" stroke-linejoin="round" d="M3.6 13H8V8.6"/><path stroke-linecap="round" stroke-linejoin="round" d="M3.6 8.6L7.8 13m-4.2 2.5V19c0 .8.7 1.5 1.5 1.5h15.3V6.1c0-.8-.6-1.5-1.5-1.5H3.6"/><path fill="currentColor" stroke="none" d="M15.6 13.1h2.5v-2.5h-2.5z"/><path fill="currentColor" stroke="none" d="M15.6 13.1h2.5v-2.5h-2.5zM11.1 13.1h2.5v-2.5h-2.5z"/><path stroke-linecap="round" stroke-linejoin="round" d="M7.6 2.6v2m9-2v2m3.6 4h-9.6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHECK_OUT__16.js
var CHECK_OUT__16 = '<svg data-id="SVG_CHECK_OUT__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M11.1 5.1h3.3v3.3"/><path stroke-linecap="round" stroke-linejoin="round" d="M10.2 9.3L14.4 5m0 5.4v4H2.6c-.6 0-1-.5-1-1.1v-11h12.6"/><path fill="currentColor" stroke="none" d="M5.7 8.9H3.8V7h1.9zM5.7 12.4H3.8v-1.9h1.9zM8.9 12.4H7v-1.9h1.9zM12.2 12.4h-1.9v-1.9h1.9z"/><path fill="currentColor" stroke="none" d="M5.7 8.9H3.8V7h1.9zM8.9 8.9H7V7h1.9z"/><path stroke-linecap="round" stroke-linejoin="round" d="M11.6.9v1.5M4.8.9v1.5M1.6 5.2H9"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHECK_OUT__24.js
var CHECK_OUT__24 = '<svg data-id="SVG_CHECK_OUT__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M16 8.6h4.4v3.8"/><path stroke-linecap="round" stroke-linejoin="round" d="M16 13l4.4-4.2m0 6.6v5.2H5.1c-.8 0-1.5-.7-1.5-1.5V4.6h16.8"/><path fill="currentColor" stroke="none" d="M6.6 13.1h2.5v-2.5H6.6zM6.6 18.1h2.5v-2.5H6.6zM11 18.1h2.5v-2.5H11zM15.6 18.1h2.5v-2.5h-2.5z"/><path fill="currentColor" stroke="none" d="M6.6 13.1h2.5v-2.5H6.6zM11 13.1h2.5v-2.5H11z"/><path stroke-linecap="round" stroke-linejoin="round" d="M17.6 2.6v2m-9-2v2m-4 4h8.8"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_DOWN__12.js
var CHEVRON_DOWN__12 = '<svg data-id="SVG_CHEVRON_DOWN__12" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M11 4L6 9 1 4"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_UP__12.js
var CHEVRON_UP__12 = '<svg data-id="SVG_CHEVRON_UP__12" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round"  d="M11 8L6 3 1 8"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_LEFT__12.js
var CHEVRON_LEFT__12 = '<svg data-id="SVG_CHEVRON_LEFT__12" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M8 11L3 6l5-5"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_RIGHT__12.js
var CHEVRON_RIGHT__12 = '<svg data-id="SVG_CHEVRON_RIGHT__12" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M4 11l5-5-5-5"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_DOWN__16.js
var CHEVRON_DOWN__16 = '<svg data-id="SVG_CHEVRON_DOWN__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M3 6l5 4.6L13 6"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_UP__16.js
var CHEVRON_UP__16 = '<svg data-id="SVG_CHEVRON_UP__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M3 10l5-4.6 5 4.6"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_LEFT__16.js
var CHEVRON_LEFT__16 = '<svg data-id="SVG_CHEVRON_LEFT__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M10 13L5.4 8 10 3"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_RIGHT__16.js
var CHEVRON_RIGHT__16 = '<svg data-id="SVG_CHEVRON_RIGHT__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M6 13l4.6-5L6 3"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_DOWN__24.js
var CHEVRON_DOWN__24 = '<svg data-id="SVG_CHEVRON_DOWN__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M19 9.3l-7 6.4-7-6.4"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_UP__24.js
var CHEVRON_UP__24 = '<svg data-id="SVG_CHEVRON_UP__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M5 14.7l7-6.4 7 6.4"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_LEFT__24.js
var CHEVRON_LEFT__24 = '<svg data-id="SVG_CHEVRON_LEFT__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M14.7 18.9l-6.4-7 6.4-7"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CHEVRON_RIGHT__24.js
var CHEVRON_RIGHT__24 = '<svg data-id="SVG_CHEVRON_RIGHT__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M9.3 5l6.4 7-6.4 7"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CITY__16.js
var CITY__16 = '<svg data-id="SVG_CITY__16" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3.6 6.05h1.42M8.33 10.17H6.92M8.33 12.27H6.92M11.11 1v2.03M7.62 7.08V3.03h5.12c.83 0 1.5.67 1.5 1.5v10.04H7.62M7.62 14.57H2.5a1.5 1.5 0 0 1-1.5-1.5V5.1L4.31 2l1.56 1.46"/><path d="M4.31 14.57V8.29l6.62-2.24v8.52"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CITY__24.js
var CITY__24 = '<svg data-id="SVG_CITY__24" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M6.57 9.86h1.86M14 14.86h-2.88M14 17.86h-2.88M17.13 2.86v2.67M12.13 11.24V5.9h7.24c.83 0 1.5.68 1.5 1.5v13.75h-8.75M11.88 21.14H4.62a1.5 1.5 0 0 1-1.5-1.5v-11L7.5 4.55l2.06 1.93"/><path d="M8.13 21.1v-8.29l8.74-2.95V21.1"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CLEANING__24.js
var CLEANING__24 = '<svg data-id="SVG_CLEANING__24" width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M9.16 18.55l2.09-3.32c.79-1.25.6-2.88-.44-3.93a3.36 3.36 0 0 0-4.16-.47l-5.36 3.38 6.5 6.5M5.64 11.47l4.9 4.9M20.71 1.29l-9.9 9.9M14.43 15.23h3.45M17.88 12.6a1.31 1.31 0 0 1 0 2.63M12.33 18.09h7.07M19.4 20.71a1.31 1.31 0 0 0 0-2.62"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CLOSE__12.js
var CLOSE__12 = '<svg data-id="SVG_CLOSE__12"  width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M2 10l8-8m0 8L2 2" fill="none" stroke-linecap="round" stroke-linejoin="round" /></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CLOSE__16.js
var CLOSE__16 = '<svg data-id="SVG_CLOSE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 12.5l-9-9m9 0l-9 9" fill="none" stroke-linecap="round" stroke-linejoin="round" /></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CLOSE__24.js
var CLOSE__24 = '<svg data-id="SVG_CLOSE__24"  width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18 18.3L6 6.3m12 0l-12 12" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CLOSE__32.js
var CLOSE__32 = '<svg data-id="SVG_CLOSE__32"  width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path transform="scale(2, 2)" vector-effect="non-scaling-stroke" d="M1 15L15 1m0 14L1 1" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/COFFEE__16.js
var COFFEE__16 = '<svg data-id="SVG_COFFEE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M7.57 4.62V2M9.53 4.62V3.3M5.6 4.62V3.3M2.66 5.93h8.32c.82 0 1.5.67 1.5 1.5v.8c0 2.7-2.2 4.9-4.91 4.9M2.66 8.22c0 2.71 2.2 4.91 4.9 4.91M2 13.13h11.13"/><path d="M11.98 10.38a1.47 1.47 0 0 0 2.36-1.18c0-.81-.66-1.48-1.47-1.48h-.29"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/COFFEE__24.js
var COFFEE__24 = '<svg data-id="SVG_COFFEE__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M11.59 7.2V3.74M14.1 7.2V5.47M9.1 7.2V5.47M5.1 9.75h11.25c.95 0 1.73.77 1.73 1.73v1.3c0 3.58-2.9 6.49-6.5 6.49M5.1 12.75c0 3.58 2.9 6.49 6.49 6.49M4.73 19.75h14.71"/><path d="M17.1 16.96a1.95 1.95 0 1 0 1.48-3.21h-.38"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/COMPASS__16.js
var COMPASS__16 = '<svg data-id="SVG_COMPASS__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle cx="8" cy="8" r="7" stroke-linecap="round" stroke-linejoin="round"/><path fill="currentColor" stroke="none" fill-rule="nonzero" d="M10 5L7.3 6.3l-.8 1L5.1 10c-.3.5.3 1.1.8.8l2.9-1.3c.3-.2.7-.5.8-.8L10.9 6c.3-.6-.3-1.2-.8-1z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/COMPASS__24.js
var COMPASS__24 = '<svg data-id="SVG_COMPASS__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle cx="12" cy="12" r="9" stroke-linecap="round" stroke-linejoin="round" /><path fill="currentColor" sroke="none" fill-rule="nonzero" d="M14.8 8L11 9.8c-.5.4-.9.7-1.1 1.2L8 14.8a.8.8 0 0 0 1.1 1.1l3.8-1.7c.5-.3 1-.7 1.1-1.2l2-3.7c.4-.8-.4-1.5-1.1-1.3z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/COUCH__16.js
var COUCH__16 = '<svg data-id="SVG_COUCH__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M2.33 12.98s.8-1.12.67-1.3M13.67 12.98l-.67-1.3M2.67 3H12a1.33 1.33 0 0 1 1.33 1.33v2.03M3.67 9V6.38"/><path d="M12.33 9H3.67V6.38H1V11c0 .73.6.66 1.33.66H15V6.36h-2.67V9z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/COUCH__24.js
var COUCH__24 = '<svg data-id="SVG_COUCH__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M4.51 19.45s1.05-1.48.88-1.73M19.49 19.45l-.88-1.73M6.27 6.27h9.95a1.5 1.5 0 0 1 1.5 1.5v6.42M6.27 14.2V9.48" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.73 14.19H6.27v-3.47l-3.52-.01v5.51c0 .83.67 1.5 1.5 1.5h17v-7.01h-3.52v3.48z" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.25 10.53a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M8.25 10.53a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M14.25 10.53a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CREDIT_CARD__16.js
var CREDIT_CARD__16 = '<svg data-id="SVG_CREDIT_CARD__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M11.2 11.3h1.9V9.4h-1.9z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 5.3H1v6.6c0 .6.5 1.1 1.1 1.1H15V4.1c0-.6-.5-1.1-1.1-1.1H1m7.1 7.3H3.4M15 7.6H1"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CREDIT_CARD__24.js
var CREDIT_CARD__24 = '<svg data-id="SVG_CREDIT_CARD__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M16.3 16.4h2.5v-2.5h-2.5z"/><path d="M21.2 8.5H2.7v8.7c0 .8.7 1.5 1.5 1.5h17V7c0-.8-.6-1.5-1.5-1.5h-17m9.4 9.7H6m15.3-3.6H2.7" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CRIB__16.js
var CRIB__16 = '<svg data-id="SVG_CRIB__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3v6.37M12 3v6.37M4 3v6.37M13 13l.74 1.47M2.74 13L2 14.47M1 10h14M1 2v9.55c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V2M1 3h11"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CRIB__24.js
var CRIB__24 = '<svg data-id="SVG_CRIB__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M10.03 6.62v8.82M14.03 6.62v8.82M17.53 6.62v8.82M6.53 6.62v8.82M17.76 18.09l.88 1.76M6.3 18.09l-.9 1.76M3.64 15.44h16.77M3.64 4.85V16.6c0 .82.68 1.5 1.5 1.5h13.77c.83 0 1.5-.68 1.5-1.5V4.85M3.64 6.62h13.89"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CURRENCY_USD__16.js
var CURRENCY_USD__16 = '<svg data-id="SVG_CURRENCY_USD__16" viewBox="0 0 16 16" width="16" height="16"><g stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M11.853 3.28c-1.694-.932-7.029-1.626-7.029 1.581 0 3.838 6.775 2.484 6.775 5.871s-4.4 3.133-7.452 2.032"/><path data-color="color-2" d="M8.5.5v15"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CURRENCY_GBP__16.js
var CURRENCY_GBP__16 = '<svg data-id="SVG_CURRENCY_GBP__16" viewBox="0 0 16 16" width="16" height="16"><g stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12.5 3.5a3.553 3.553 0 0 0-3.417-2 3.941 3.941 0 0 0-3.583 4v9M3.5 14.5h9"/><path data-color="color-2" d="M3.5 8.5h6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CURRENCY_EURO__16.js
var CURRENCY_EURO__16 = '<svg data-id="SVG_CURRENCY_EURO__16" viewBox="0 0 16 16" width="16" height="16"><g stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13.2 13.85a5.536 5.536 0 0 1-2.6.65c-3.59 0-5.85-2.91-5.85-6.5s2.26-6.5 5.85-6.5a4.957 4.957 0 0 1 2.6.65"/><path data-color="color-2" d="M2.5 6.5h7M2.5 9.5h7"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CURRENCY_USD__24.js
var CURRENCY_USD__24 = '<svg data-id="SVG_CURRENCY_USD__24" viewBox="0 0 24 24" width="24" height="24"><g stroke-linecap="square" stroke="currentColor" fill="none" stroke-miterlimit="10"><path d="M12.5 1.5v22M17.875 5.5C15.375 4.125 7.5 3.1 7.5 7.833c0 5.667 10 3.667 10 8.667s-6.5 4.625-11 3"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CURRENCY_GBP__24.js
var CURRENCY_GBP__24 = '<svg data-id="SVG_CURRENCY_GBP__24" viewBox="0 0 24 24" width="24" height="24"><g stroke-linecap="square" stroke="currentColor" fill="none" stroke-miterlimit="10"><path data-cap="butt" d="M19.5 6.5c-1.312-1.969-2.406-3-5-3a5 5 0 0 0-5 5v13" stroke-linecap="butt"/><path d="M6.5 21.5h13M6.5 13.5h8"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/CURRENCY_EURO__24.js
var CURRENCY_EURO__24 = '<svg data-id="SVG_CURRENCY_EURO__24" viewBox="0 0 24 24" width="24" height="24"><g stroke-linecap="square" stroke="currentColor" fill="none" stroke-miterlimit="10"><path d="M19.5 21.5a8.511 8.511 0 0 1-4 1c-5.523 0-9-4.477-9-10s3.477-10 9-10c1.344 0 2.781.25 4 1M3.5 10.5h11M3.5 14.5h11"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DASHBOARD__16.js
var DASHBOARD__16 = '<svg data-id="SVG_DASHBOARD__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="currentcolor" stroke="none" d="M7 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M1 10a7 7 0 0 1 14 0M3.5 10a4.5 4.5 0 0 1 6.7-4m2 2.4c.2.5.3 1 .3 1.6m-2.3-4L8 10M15 10v1.2c0 .6-.5 1.2-1.1 1.2H2c-.6 0-1.1-.6-1.1-1.2V10"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DASHBOARD__24.js
var DASHBOARD__24 = '<svg data-id="SVG_DASHBOARD__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M10.8 15a1.3 1.3 0 1 1 2.5 0 1.3 1.3 0 0 1-2.5 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M2.8 15a9.2 9.2 0 1 1 18.5 0M6 15a6 6 0 0 1 9-5.1m2.6 3l.3 2.1M15 10L12 15M21.3 15v1.7c0 .8-.7 1.5-1.5 1.5H4.3c-.9 0-1.5-.7-1.5-1.5V15"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DISLIKE__16.js
var DISLIKE__16 = '<svg data-id="SVG_DISLIKE__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M3 13A7 7 0 0 1 4.2 2.1a7 7 0 0 1 7.8 0 7.1 7.1 0 0 1 3 4.4A7 7 0 0 1 9.4 15a7 7 0 0 1-4-.4M3 12.9l9.8-9.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DISLIKE__24.js
var DISLIKE__24 = '<svg data-id="SVG_DISLIKE__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.5 18.5a9.2 9.2 0 0 1 0-13A9.2 9.2 0 0 1 17 4.3a9.2 9.2 0 0 1 2.6 12.8 9.2 9.2 0 0 1-11.2 3.4m-3-2l13-13" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DOCUMENT__16.js
var DOCUMENT__16 = '<svg data-id="SVG_DOCUMENT__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M10.8 15H2.96a.87.87 0 0 1-.87-.87V4.76"/><path d="M13.91 5.94v2.34a713.94 713.94 0 0 0 0 2.83c.01.58-.44 1.05-1.02 1.07H5.78a1.04 1.04 0 0 1-1.02-1.07V2.07A1.04 1.04 0 0 1 5.78 1h5.82c.3 0 .6.14.8.37l1.29 1.52M7.6 8.44h2.1M7.6 5.26h3.48"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DOCUMENT__24.js
var DOCUMENT__24 = '<svg data-id="SVG_DOCUMENT__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M16.62 21.25H5.52c-.68 0-1.23-.55-1.23-1.23V6.76"/><path d="M19.7 7.77V13.07a1431.96 1431.96 0 0 0 0 3.66c.03.81-.62 1.5-1.43 1.51H8.74a1.48 1.48 0 0 1-1.44-1.51V4.26c-.02-.81.62-1.49 1.44-1.51h7.7c.43 0 .84.2 1.12.52L19.03 5M10.3 14.94h3.87M10.3 11.35h6.41M10.3 7.77h6.41"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DOOR__16.js
var DOOR__16 = '<svg data-id="SVG_DOOR__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M3 1l6.15 1.42a1.5 1.5 0 0 1 1.16 1.46V15l-6.15-1.42A1.5 1.5 0 0 1 3 12.12V1h3.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.6 1h4.9c.83 0 1.5.67 1.5 1.5v10.7" stroke="#5E6D77" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.53 8a.88.88 0 1 1-1.75 0 .88.88 0 0 1 1.75 0" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DOOR__24.js
var DOOR__24 = '<svg data-id="SVG_DOOR__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12.4 11.55v.88M5.5 2.74l8.34 1.97A1.5 1.5 0 0 1 15 6.17v15.07l-8.34-1.96a1.5 1.5 0 0 1-1.16-1.46V2.74h4.69"/><path d="M10.19 2.74H17c.83 0 1.5.68 1.5 1.5v14.62"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DOWNLOAD__16.js
var DOWNLOAD__16 = '<svg data-id="SVG_DOWNLOAD__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M14.6 10.5v3c0 .6-.5 1.1-1.1 1.1h-11c-.6 0-1.1-.5-1.1-1.1v-3"/><path d="M12.2 7.5L8 11.1 3.8 7.5M8 11V1.4"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DOWNLOAD__24.js
var DOWNLOAD__24 = '<svg data-id="SVG_DOWNLOAD__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 15.2v4c0 .7-.7 1.4-1.5 1.4H4.8c-.9 0-1.5-.7-1.5-1.5v-3.9"/><path d="M17.6 11.2L12 16l-5.6-4.7M12 15.8V3.1"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DRINK__16.js
var DRINK__16 = '<svg data-id="SVG_DRINK__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3.75 3.05h7.36c.83 0 1.5.67 1.5 1.5v1.03a4.43 4.43 0 0 1-4.43 4.43M5.8 14.64h4.77M8.18 14.64v-4.48"/><path d="M8.18 10.01a4.43 4.43 0 0 1-4.43-4.43v-.49H8.5M2.3 4.37a2 2 0 1 1 2.82-2.82"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DRINK__24.js
var DRINK__24 = '<svg data-id="SVG_DRINK__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M6.52 6h9.9c1 0 1.8.8 1.8 1.8v1.55a5.85 5.85 0 0 1-5.85 5.85M9.22 21h6.3M12.52 20.92v-5.44"/><path d="M12.37 15.2a5.85 5.85 0 0 1-5.85-5.86V8.7h6.27M4.29 7.5a2.63 2.63 0 1 1 3.73-3.73"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DRYER__16.js
var DRYER__16 = '<svg data-id="SVG_DRYER__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M15 2.2c0-.65-.54-1.2-1.2-1.2H2.2C1.54 1 1 1.56 1 2.2v11.6c0 .65.54 1.2 1.2 1.2h11.6c.66 0 1.2-.55 1.2-1.2V2.2z" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.4 8a3.6 3.6 0 1 0 7.2 0 3.6 3.6 0 0 0-7.2 0z" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.55 3.4a1.05 1.05 0 1 0 2.1 0 1.05 1.05 0 0 0-2.1 0" fill="currentColor" stroke="none"/><path d="M7.07 7.7l.63-.63" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DRYER__24.js
var DRYER__24 = '<svg data-id="SVG_DRYER__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M20.75 4.76c0-.83-.67-1.5-1.5-1.5H4.75c-.83 0-1.5.67-1.5 1.5v14.48c0 .83.67 1.5 1.5 1.5h14.5c.83 0 1.5-.67 1.5-1.5V4.76z"/><path d="M17.62 5.44a.31.31 0 1 0 0 .63.31.31 0 0 0 0-.63M15.12 5.44a.31.31 0 1 0 0 .63.31.31 0 0 0 0-.63M17.8 8.25H3.87M10.75 5.76H6.38M16.04 14.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM10.84 14.5c0-.67.54-1.2 1.2-1.2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DVD__16.js
var DVD__16 = '<svg data-id="SVG_DVD__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8z"/><path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM3.85 6.28a4.49 4.49 0 0 1 2.43-2.43M12.15 9.72a4.5 4.5 0 0 1-2.43 2.43"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/DVD__24.js
var DVD__24 = '<svg data-id="SVG_DVD__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0" fill="currentColor" stroke="none"/><path d="M2.7 12a9.3 9.3 0 1 1 18.6 0 9.3 9.3 0 0 1-18.6 0z" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.31 9.64a6.18 6.18 0 0 1 3.33-3.33M17.69 14.36a6.17 6.17 0 0 1-3.33 3.33" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/EDIT__16.js
var EDIT__16 = '<svg data-id="SVG_EDIT__16"  width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M11.9.7l2.4 2.4L11 6.5l-5.2 5.1-3 .6.6-3zM10 2.5L12.6 5m-6.6 9.3h8.8m-13.4 0h2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/EDIT__24.js
var EDIT__24 = '<svg data-id="SVG_EDIT__24"  width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M17.2 3l3.2 3.2-4.4 4.4-6.8 6.8-4 .8.8-4zM15.2 6l2.5 2.6M9.2 21h11.6M3.2 21h2.6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/EXPAND__16.js
var EXPAND__16 = '<svg data-id="SVG_EXPAND__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M8.2 13.3H2.7V7.8M7.8 2.7h5.5v5.5"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/EXPAND__24.js
var EXPAND__24 = '<svg data-id="SVG_EXPAND__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12.1 18.6H4.9v-7.2M11.9 5.4h7.2v7.2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/EXPEDIA_COLOR__24.js
var EXPEDIA_COLOR__24 = '<svg data-id="SVG_EXPEDIA_COLOR__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="none" fill-rule="evenodd"><path fill="#EDB32A" stroke="none" d="M14.2 19.4l7.2-12.1-.4-1L8.3.9.2 12.6v.5l14 6.3"/><path fill="#212D4C" stroke="none" d="M12.8 8.5l-.4-1.3-3.7-5 .6-.2 6.5 5.6 3.8-1c.5-.2 1-.2 1.3-.2A11 11 0 0 0 14.7.6c-5.7-2-12 1-14 6.7a11 11 0 0 0-.6 5.4l9.1-3.2 3.6-1m8.6-1A6 6 0 0 1 20 8l-3.9 1-2.5 8.2-.7.2.6-6.2-.3-1.3-3.6 1-9.5 2.3a11 11 0 0 0 7.1 8c5.7 2 12-.9 14-6.6 1-2.4.9-5 0-7.2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/FACEBOOK__16.js
var FACEBOOK__16 = '<svg data-id="SVG_FACEBOOK__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M14.4 1H1.6c-.3 0-.6.3-.6.6v12.8c0 .3.3.6.6.6h6.8V9.7H6.7V7.7h1.7V5.8c0-1.8 1.2-2.7 2.8-2.7l1.6.1v1.9h-1c-1 0-1.2.4-1.2 1v1.5h2.2l-.4 2.2h-1.8V15h3.8c.3 0 .6-.3.6-.6V1.6c0-.3-.3-.6-.6-.6" stroke="none" fill-rule="evenodd"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/FACEBOOK__24.js
var FACEBOOK__24 = '<svg data-id="SVG_FACEBOOK__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" transform="scale(1.5, 1.5)" vector-effect="non-scaling-stroke" d="M14.4 1H1.6c-.3 0-.6.3-.6.6v12.8c0 .3.3.6.6.6h6.8V9.7H6.7V7.7h1.7V5.8c0-1.8 1.2-2.7 2.8-2.7l1.6.1v1.9h-1c-1 0-1.2.4-1.2 1v1.5h2.2l-.4 2.2h-1.8V15h3.8c.3 0 .6-.3.6-.6V1.6c0-.3-.3-.6-.6-.6" stroke="none" fill-rule="evenodd"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/FACEBOOK_COLOR__24.js
var FACEBOOK_COLOR__24 = '<svg data-id="SVG_FACEBOOK_COLOR__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 22v-9.2H7V9.5h2.5v-3c0-2.3 1.5-4.5 5-4.5 1.4 0 2.5.2 2.5.2l-.1 3.1h-2.2c-1.3 0-1.4.7-1.4 1.7v2.5H17l-.3 3.3h-3.4V22H9.5z" stroke="none" fill="#3B5998" fill-rule="evenodd"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/FAMILY__16.js
var FAMILY__16 = '<svg data-id="SVG_FAMILY__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M6.7 7.8A3.7 3.7 0 0 0 .9 11M15 11a3.8 3.8 0 0 0-1-2.6 3.7 3.7 0 0 0-4.8-.5"/><path d="M6.2 5.6c0 .9-.7 1.6-1.6 1.6-.9 0-1.5-.7-1.5-1.6v-.3c0-.9.6-1.6 1.5-1.6s1.6.7 1.6 1.6v.3z"/><path stroke-linecap="round" stroke-linejoin="round" d="M6.2 5.6c0 .9-.7 1.6-1.6 1.6-.9 0-1.5-.7-1.5-1.6v-.3c0-.9.6-1.6 1.5-1.6s1.6.7 1.6 1.6v.3z"/><path d="M13 5.6c0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6v-.3c0-.9.7-1.6 1.6-1.6.9 0 1.5.7 1.5 1.6v.3z"/><path stroke-linecap="round" stroke-linejoin="round" d="M13 5.6c0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6v-.3c0-.9.7-1.6 1.6-1.6.9 0 1.5.7 1.5 1.6v.3zm-2.3 6.7a2.8 2.8 0 0 0-.7-1.4 2.8 2.8 0 0 0-2-.8 2.8 2.8 0 0 0-2.3 1.2 2.8 2.8 0 0 0-.4 1"/><path d="M9.3 8.7c0 .8-.6 1.4-1.3 1.4-.7 0-1.3-.6-1.3-1.4v-.3c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3v.3z"/><path stroke-linecap="round" stroke-linejoin="round" d="M9.3 8.7c0 .8-.6 1.4-1.3 1.4-.7 0-1.3-.6-1.3-1.4v-.3c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3v.3z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/FAMILY__24.js
var FAMILY__24 = '<svg data-id="SVG_FAMILY__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M10.2 11.5a4.9 4.9 0 0 0-7.6 4m18.8 0a4.8 4.8 0 0 0-1.4-3.4 5 5 0 0 0-6.2-.6"/><path d="M9.6 8.6c0 1.1-1 2-2 2a2 2 0 0 1-2.1-2V8c0-1.2.9-2 2-2s2 .8 2 2v.5z"/><path stroke-linecap="round" stroke-linejoin="round" d="M9.6 8.6c0 1.1-1 2-2 2a2 2 0 0 1-2.1-2V8c0-1.2.9-2 2-2s2 .8 2 2v.5z"/><path d="M18.5 8.6c0 1.1-.9 2-2 2a2 2 0 0 1-2-2V8c0-1.2.9-2 2-2s2 .8 2 2v.5z"/><path stroke-linecap="round" stroke-linejoin="round" d="M18.5 8.6c0 1.1-.9 2-2 2a2 2 0 0 1-2-2V8c0-1.2.9-2 2-2s2 .8 2 2v.5zm-3 8.8a3.6 3.6 0 0 0-7 0"/><path d="M13.8 12.7c0 1-.8 1.7-1.8 1.7s-1.8-.8-1.8-1.7v-.5c0-1 .8-1.7 1.8-1.7s1.8.8 1.8 1.7v.5z"/><path stroke-linecap="round" stroke-linejoin="round" d="M13.8 12.7c0 1-.8 1.7-1.8 1.7s-1.8-.8-1.8-1.7v-.5c0-1 .8-1.7 1.8-1.7s1.8.8 1.8 1.7v.5z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/FILTER__16.js
var FILTER__16 = '<svg data-id="SVG_FILTER__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M2.9 8.4h2m0 0a1.5 1.5 0 1 1 3.1 0 1.5 1.5 0 0 1-3 0zM8 3.9H1.4m9.6 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-.3 4.5h2.4m-2-4.5h3.5m-8.7 9h4.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/FILTER__24.js
var FILTER__24 = '<svg data-id="SVG_FILTER__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5.3 12.8h2.8m0 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm4-6H3.3m12.8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-1 6h3.7m-2.7-6h4.7m-11.5 12h5.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/FLAG__16.js
var FLAG__16 = '<svg data-id="SVG_FLAG__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M2.5 14.8V2.2m0 7.1V1.6c3.7-1.5 7.3 1.6 11 0v6.6c0 .7-.5 1.4-1.3 1.5-2.3.4-4.7-.7-7-.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/FLAG__24.js
var FLAG__24 = '<svg data-id="SVG_FLAG__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M4.8 21.3V4.6m0 9.4V3.8c4.8-2 9.6 2 14.5 0v9c0 .8-.6 1.4-1.4 1.6-3.2.7-6.5-.9-9.7-1" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GAME__16.js
var GAME__16 = '<svg data-id="SVG_GAME__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M10.27 3.54l2.55-.46A1.52 1.52 0 0 1 14.6 4.4l.85 8.36a1.51 1.51 0 0 1-2.65 1.14l-2.15-2.51h-5.3L3.2 13.9a1.51 1.51 0 0 1-2.65-1.14l.85-8.36a1.51 1.51 0 0 1 1.78-1.33l2.55.46H8V1.56M4.6 5.54v2.64M3.28 6.86H5.9M7.19 9.13h1.63" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.97 5.54a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M11.97 8.17a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9.87 6.1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M12.56 6.1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GAME__24.js
var GAME__24 = '<svg data-id="SVG_GAME__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M15.04 6.1l3.36-.6a2 2 0 0 1 2.35 1.76l1.13 11.05a2 2 0 0 1-3.51 1.5l-2.84-3.32h-7l-2.84 3.32a2 2 0 0 1-3.5-1.5L3.3 7.26a2 2 0 0 1 2.35-1.77l3.38.62h3l-.01-2.62M7.53 8.75v3.48M5.79 10.5h3.48M10.96 13.5h2.15" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.16 8.75a.88.88 0 1 1-1.76 0 .88.88 0 0 1 1.76 0M17.16 12.23a.88.88 0 1 1-1.76 0 .88.88 0 0 1 1.76 0M14.54 9.62a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75M18.02 9.62a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GEAR__16.js
var GEAR__16 = '<svg data-id="SVG_GEAR__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M9.3 14.2l-.1.8H6.8l-.1-.8a1.3 1.3 0 0 0-2.1-.9l-.7.5-1.7-1.7.5-.7a1.3 1.3 0 0 0-.9-2L1 9.1V6.8l.8-.1a1.3 1.3 0 0 0 .9-2.1l-.5-.7 1.7-1.7.7.5a1.3 1.3 0 0 0 2-.9l.2-.8h2.4l.1.8a1.3 1.3 0 0 0 2.1.9l.7-.5 1.7 1.7-.5.7a1.3 1.3 0 0 0 .9 2l.8.2v2.4l-.8.1a1.3 1.3 0 0 0-.9 2.1l.5.7-1.7 1.7-.7-.5"/><path d="M5.5 8a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GEAR__24.js
var GEAR__24 = '<svg data-id="SVG_GEAR__24" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13.8 20.2l-.2 1h-3.2l-.2-1A1.8 1.8 0 0 0 7.5 19l-1 .7-2.2-2.3.7-.9a1.8 1.8 0 0 0-1.2-2.7l-1-.2v-3.2l1-.2A1.8 1.8 0 0 0 5 7.5l-.7-1 2.3-2.2.9.7a1.8 1.8 0 0 0 2.7-1.2l.2-1h3.2l.2 1A1.8 1.8 0 0 0 16.5 5l1-.7 2.2 2.3-.7.9a1.8 1.8 0 0 0 1.2 2.7l1 .2v3.2l-1 .2a1.8 1.8 0 0 0-1.2 2.7l.7 1-2.3 2.2-.9-.7"/><path d="M8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GLOBE__16.js
var GLOBE__16 = '<svg data-id="SVG_GLOBE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke-width="1" transform="translate(1.3 1.3)"><path d="M1.8 11a6.5 6.5 0 0 1 9.8 0M1.8 2.4a6.5 6.5 0 0 0 9.8 0"/><path d="M6.7 13.2c2.3-1 3.6-3.6 3.6-6.5 0-3-1.3-5.5-3.6-6.6m0 13.1c-2.3-1-3.6-3.6-3.6-6.5 0-3 1.3-5.5 3.6-6.6m0 13.1V.1M.1 6.7h13.1"/><circle cx="6.7" cy="6.7" r="6.5" stroke-linecap="square"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GLOBE__24.js
var GLOBE__24 = '<svg data-id="SVG_GLOBE__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" transform="translate(2 2)"><path d="M2.6 16.4a9.8 9.8 0 0 1 14.7 0M2.6 3.6a9.8 9.8 0 0 0 14.7 0"/><path d="M10 19.8c3.5-1.7 5.3-5.4 5.3-9.8S13.5 1.9 10 .2m0 19.6C6.5 18 4.7 14.4 4.7 10S6.5 1.9 10 .2m0 19.6V.2M.2 10h19.6"/><circle cx="10" cy="10" r="9.8" stroke-linecap="square"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GOOGLE_COLOR__24.js
var GOOGLE_COLOR__24 = '<svg data-id="SVG_GOOGLE_COLOR__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M21.86 12.23c0-.71-.07-1.4-.19-2.05h-9.54v3.87h5.45a4.6 4.6 0 0 1-2.02 3.02v2.5h3.28a9.69 9.69 0 0 0 3.02-7.34z" stroke="none" fill="#4688F1"/><path d="M12.13 22c2.74 0 5.03-.9 6.7-2.42l-3.27-2.51c-.9.6-2.07.95-3.43.95a6.03 6.03 0 0 1-5.67-4.12H3.08v2.6c1.66 3.26 5.1 5.5 9.05 5.5z" stroke="none" fill="#3AA757"/><path d="M6.46 13.9a5.94 5.94 0 0 1 0-3.8V7.5H3.08a9.89 9.89 0 0 0 0 9l3.38-2.6z" stroke="none" fill="#F9BB2D"/><path d="M12.13 5.98c1.49 0 2.82.5 3.87 1.5l2.91-2.88A9.8 9.8 0 0 0 12.13 2C8.17 2 4.74 4.24 3.08 7.5l3.38 2.6a6.03 6.03 0 0 1 5.67-4.12z" stroke="none" fill="#E7453C"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GOOGLE_PLUS__16.js
var GOOGLE_PLUS__16 = '<svg data-id="SVG_GOOGLE_PLUS__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero" fill="currentColor"><path d="M1 8.5c0 1.9 1.2 3.6 2.9 4.2 1.6.6 3.6.2 4.6-1.3.8-1 1-2.3.9-3.5H5.3v1.5h2.4c-.2.7-.6 1.4-1.4 1.7-1.3.6-3-.2-3.5-1.7S3 6.2 4.5 5.8c.9-.4 1.8 0 2.6.5L8 5c-.8-.7-2-1.2-3-1C2.9 4 .9 6 1 8.4zM12.4 6.8v1.3H11v1.3h1.3v1.3h1.3V9.4H15V8.1h-1.3V6.8h-1.3z" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GOOGLE_PLUS__24.js
var GOOGLE_PLUS__24 = '<svg data-id="SVG_GOOGLE_PLUS__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero" fill="currentColor"><path transform="scale(1.5, 1.5)" vector-effect="non-scaling-stroke" d="M1 8.49a4.47 4.47 0 0 0 2.9 4.23c1.59.56 3.55.14 4.61-1.29.78-1 .95-2.33.87-3.58h-4.1v1.52l2.46.03c-.2.74-.68 1.43-1.4 1.7-1.37.63-3.13-.2-3.56-1.71-.53-1.45.33-3.2 1.74-3.62.88-.32 1.79.04 2.54.52.38-.37.74-.77 1.08-1.17a4.17 4.17 0 0 0-3.07-1.1C2.85 4.03.92 6.17 1 8.48zM12.4 6.8l-.02 1.3-1.3.01v1.3h1.3l.01 1.31h1.3v-1.3L15 9.4V8.1h-1.3l-.01-1.31h-1.3z" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GRID_LG__16.js
var GRID_LG__16 = '<svg data-id="SVG_GRID_LG__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M1.9 6.6h4.7V1.9H1.9zM9.4 6.6h4.7V1.9H9.4zM1.9 14.1h4.7V9.4H1.9zM9.4 14.1h4.7V9.4H9.4z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GRID_LG__24.js
var GRID_LG__24 = '<svg data-id="SVG_GRID_LG__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3.9 10.1h6.2V3.9H3.9zM13.9 10.1h6.2V3.9h-6.2zM3.9 20.1h6.2v-6.2H3.9zM13.9 20.1h6.2v-6.2h-6.2z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GRID_SM__16.js
var GRID_SM__16 = '<svg data-id="SVG_GRID_SM__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M1.9 4.3h2.4V1.9H1.9zM6.8 4.3h2.4V1.9H6.8zM11.7 4.3h2.4V1.9h-2.4zM1.9 9.2h2.4V6.8H1.9zM6.8 9.2h2.4V6.8H6.8zM11.7 9.2h2.4V6.8h-2.4zM1.9 14.1h2.4v-2.4H1.9zM6.8 14.1h2.4v-2.4H6.8zM11.7 14.1h2.4v-2.4h-2.4z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GRID_SM__24.js
var GRID_SM__24 = '<svg data-id="SVG_GRID_SM__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 7.5h3v-3h-3zM4.5 13.5h3v-3h-3zM4.5 19.5h3v-3h-3zM10.5 7.5h3v-3h-3zM10.5 13.5h3v-3h-3zM10.5 19.5h3v-3h-3zM16.5 7.5h3v-3h-3zM16.5 13.5h3v-3h-3zM16.5 19.5h3v-3h-3z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GRIP__16.js
var GRIP__16 = '<svg data-id="SVG_GRIP__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" stroke="none"><circle cx="5" cy="2" r="2"/><circle cx="11" cy="2" r="2"/><circle cx="5" cy="8" r="2"/><circle cx="11" cy="8" r="2"/><circle cx="5" cy="14" r="2"/><circle cx="11" cy="14" r="2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GRIP__24.js
var GRIP__24 = '<svg data-id="SVG_GRIP__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" stroke="none" transform="scale(1.5, 1.5)"><circle cx="5" cy="2" r="2"/><circle cx="11" cy="2" r="2"/><circle cx="5" cy="8" r="2"/><circle cx="11" cy="8" r="2"/><circle cx="5" cy="14" r="2"/><circle cx="11" cy="14" r="2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GRILL__16.js
var GRILL__16 = '<svg data-id="SVG_GRILL__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2.8V1M7 6.3h2M10 2.8V1.7M6 2.8V1.7M3.7 4.3h8.6v1.5a4.3 4.3 0 0 1-8.6.5M5 13h6M11.7 15L9.9 9.7M4.3 15l1.8-5.3"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GRILL__24.js
var GRILL__24 = '<svg data-id="SVG_GRILL__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5V2.8M10.7 9.8h2.6M14.7 5V3.7M9.4 5V3.7M6.3 7.2h11.4V9a5.7 5.7 0 0 1-11.4.7M8 18.6h8M16.9 21.2l-2.4-7M7.2 21.2l2.4-7"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GROUP__16.js
var GROUP__16 = '<svg data-id="SVG_GROUP__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.9A4 4 0 0 0 6.7 9a4 4 0 0 0-3.8.4A4 4 0 0 0 1 13"/><path d="M6.9 7c0 1-.8 1.8-1.9 1.8C4 8.8 3.2 8 3.2 7v-.5c0-1 .8-1.9 1.8-1.9S7 5.5 7 6.5V7z"/><path stroke-linecap="round" stroke-linejoin="round" d="M6.9 7c0 1-.8 1.8-1.9 1.8C4 8.8 3.2 8 3.2 7v-.5c0-1 .8-1.9 1.8-1.9S7 5.5 7 6.5V7zm2.3.7a4 4 0 0 1 5.8 3.4"/><path d="M9.3 5.4c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-.5c0-1-.8-1.8-1.8-1.8S9.3 4 9.3 5v.5z"/><path stroke-linecap="round" stroke-linejoin="round" d="M9.3 5.4c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-.5c0-1-.8-1.8-1.8-1.8S9.3 4 9.3 5v.5z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/GROUP__24.js
var GROUP__24 = '<svg data-id="SVG_GROUP__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path  stroke-linecap="round" stroke-linejoin="round" d="M13.4 18.2a5.3 5.3 0 0 0-2.4-4.4 5.5 5.5 0 0 0-3-.9 5.3 5.3 0 0 0-3.7 1.6 5.3 5.3 0 0 0-1.6 3.7"/><path d="M10.5 10.4c0 1.4-1 2.5-2.4 2.5a2.5 2.5 0 0 1-2.5-2.5v-.6c0-1.4 1-2.5 2.4-2.5s2.5 1.1 2.5 2.5v.6z"/><path  stroke-linecap="round" stroke-linejoin="round" d="M10.5 10.4c0 1.4-1 2.5-2.4 2.5a2.5 2.5 0 0 1-2.5-2.5v-.6c0-1.4 1-2.5 2.4-2.5s2.5 1.1 2.5 2.5v.6zm2.5 1.4a5.2 5.2 0 0 1 8.3 4.1"/><path d="M13.7 8.4c0 1.3 1 2.4 2.4 2.4 1.3 0 2.4-1.1 2.4-2.4v-.6c0-1.4-1.1-2.4-2.4-2.4-1.4 0-2.4 1-2.4 2.4v.6z"/><path  stroke-linecap="round" stroke-linejoin="round" d="M13.7 8.4c0 1.3 1 2.4 2.4 2.4 1.3 0 2.4-1.1 2.4-2.4v-.6c0-1.4-1.1-2.4-2.4-2.4-1.4 0-2.4 1-2.4 2.4v.6z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/HANGER__16.js
var HANGER__16 = '<svg data-id="SVG_HANGER__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M8 6.7l6 4a1.5 1.5 0 0 1-.9 2.7H3a1.5 1.5 0 0 1-.9-2.8L6.2 8M8 6a1.7 1.7 0 1 0-1.7-1.7M8 6v.7"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/HANGER__24.js
var HANGER__24 = '<svg data-id="SVG_HANGER__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12 10l8.5 5.5a1.8 1.8 0 0 1-1 3.2h-15a1.8 1.8 0 0 1-1-3.2l6.2-4M12 9a2.2 2.2 0 1 0-2.2-2.2M12 9v1"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/HEART__16.js
var HEART__16 = '<svg data-id="SVG_HEART__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M8 3.98S9.13 2 11.5 2C13.57 2 15 3.7 15 5.73c0 2.86-2.98 4.6-7 8.27-4.02-3.67-7-5.41-7-8.27C1 3.7 2.43 2 4.5 2 6.88 2 8 3.98 8 3.98z"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/HEART__24.js
var HEART__24 = '<svg data-id="SVG_HEART__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M12 6.7s1.49-2.6 4.63-2.6c2.73 0 4.62 2.24 4.62 4.9 0 3.77-3.94 6.07-9.25 10.9C6.69 15.07 2.75 12.77 2.75 9c0-2.66 1.89-4.9 4.63-4.9C10.5 4.1 12 6.7 12 6.7z"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/HEART_SELECTED__16.js
var HEART_SELECTED__16 = '<svg data-id="SVG_HEART_SELECTED__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" d="M8 3.98S9.13 2 11.5 2C13.57 2 15 3.7 15 5.73c0 2.86-2.98 4.6-7 8.27-4.02-3.67-7-5.41-7-8.27C1 3.7 2.43 2 4.5 2 6.88 2 8 3.98 8 3.98z"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/HEART_SELECTED__24.js
var HEART_SELECTED__24 = '<svg data-id="SVG_HEART_SELECTED__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" d="M12 6.7s1.49-2.6 4.63-2.6c2.73 0 4.62 2.24 4.62 4.9 0 3.77-3.94 6.07-9.25 10.9C6.69 15.07 2.75 12.77 2.75 9c0-2.66 1.89-4.9 4.63-4.9C10.5 4.1 12 6.7 12 6.7z"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/HEATER__24.js
var HEATER__24 = '<svg data-id="SVG_HEATER__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M9.2 14.4V5.6a2.4 2.4 0 1 0-4.8 0v8.8a3.6 3.6 0 1 0 4.8 0zM6.8 6.7V16"  stroke-linecap="round" stroke-linejoin="round"/><path d="M5.6 17A1.2 1.2 0 1 1 8 17a1.2 1.2 0 0 1-2.4 0" fill="currentColor" stroke="none"/><path d="M16 5a4.1 4.1 0 0 1 .4 4.7c-.7 0-1.4-.5-1.5-1.2a3.3 3.3 0 0 0-1.7 3 3.7 3.7 0 0 0 3.7 3.8c2 0 3.7-1.7 3.8-3.7 0-3.7-2-5.7-4.7-6.6z" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/HOT_TUB__16.js
var HOT_TUB__16 = '<svg data-id="SVG_HOT_TUB__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M6.7 5a1.4 1.4 0 0 1 0 2M6.7 5a1.4 1.4 0 0 1 0-2M9.3 3.3a1.4 1.4 0 0 1 0 2M9.3 3.3a1.4 1.4 0 0 1 0-2M4.4 13.4l-.6 1.3M11.6 13.4l.7 1.3M14.5 9.5a4 4 0 0 1-4 3.9h-5a4 4 0 0 1-4-4v-.7h13v.8z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/HOT_TUB__24.js
var HOT_TUB__24 = '<svg data-id="SVG_HOT_TUB__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 8.2a2 2 0 0 1 0 2.7M10.3 8.2a2 2 0 0 1 0-2.8M13.7 6a2 2 0 0 1 0 2.7M13.7 6a2 2 0 0 1 0-2.7M7.2 19.5l-1 1.8M16.8 19.5l1 1.8M20.8 14.3c0 2.9-2.4 5.2-5.3 5.2h-7c-2.9 0-5.2-2.3-5.2-5.2v-1h17.5v1z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/HOUSE__16.js
var HOUSE__16 = '<svg data-id="SVG_HOUSE__16" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12.93 5.33v7.65c0 .83-.68 1.5-1.5 1.5H4.59a1.5 1.5 0 0 1-1.5-1.5V8.3"/><path d="M1 6.83l6.05-4.98a1.5 1.5 0 0 1 1.9 0L15 6.83M3.1 5.1V2.16M9.71 11.93V8.29h-3.4v6.2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/HOUSE__24.js
var HOUSE__24 = '<svg data-id="SVG_HOUSE__24" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M18.51 8.33v10.6c0 .83-.67 1.5-1.5 1.5h-10a1.5 1.5 0 0 1-1.5-1.5v-6.68"/><path d="M2.75 10.32l8.3-6.84a1.5 1.5 0 0 1 1.9 0l8.3 6.84M5.51 8.04V4.13H7M14.26 17.05v-4.8h-4.5v8.2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/INFO__16.js
var INFO__16 = '<svg data-id="SVG_INFO__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke="none" fill="currentColor" d="M7.1 5A.9.9 0 1 1 9 5 .9.9 0 0 1 7 5"/><path stroke-linecap="round" stroke-linejoin="round" d="M8 11.2V7.3M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/INFO__24.js
var INFO__24 = '<svg data-id="SVG_INFO__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M11 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M12 16.2v-5.1m-9.3.9a9.3 9.3 0 1 1 18.6 0 9.3 9.3 0 0 1-18.6 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/INSTAGRAM__16.js
var INSTAGRAM__16 = '<svg data-id="SVG_INSTAGRAM__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" transform="translate(1 1)" fill-rule="evenodd"><path d="M1.3 4V10c0 1.5 1.2 2.7 2.7 2.7h6c1.5 0 2.7-1.2 2.7-2.7V4c0-1.5-1.2-2.7-2.7-2.7H4A2.7 2.7 0 0 0 1.3 4zM0 4a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4V10a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z" stroke="none" fill-rule="nonzero"/><path d="M7 10.7a3.7 3.7 0 1 1 0-7.4 3.7 3.7 0 0 1 0 7.4zm0-1.3a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8z" stroke="none" fill-rule="nonzero"/><circle cx="10.7" cy="3.3" r="1" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/INSTAGRAM__24.js
var INSTAGRAM__24 = '<svg data-id="SVG_INSTAGRAM__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" transform="translate(2 2)" fill-rule="evenodd"><path d="M1.87 5.75v8.4a3.88 3.88 0 0 0 3.88 3.88h8.5a3.88 3.88 0 0 0 3.88-3.88v-8.4a3.88 3.88 0 0 0-3.88-3.88h-8.5a3.88 3.88 0 0 0-3.88 3.88zm-1.84 0A5.73 5.73 0 0 1 5.75.03h8.5a5.73 5.73 0 0 1 5.73 5.72v8.4a5.73 5.73 0 0 1-5.73 5.72h-8.5a5.73 5.73 0 0 1-5.72-5.72v-8.4z" stroke="none" fill-rule="nonzero"/><path d="M10.03 15.28a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5zm0-1.85a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z" stroke="none" fill-rule="nonzero"/><circle cx="15.33" cy="4.65" r="1.27" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/INSTANT_BOOK__16.js
var INSTANT_BOOK__16 = '<svg data-id="SVG_INSTANT_BOOK__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M10.2 12l2.4-3.7a1.5 1.5 0 0 0-1.3-2.4H8.2V1L3.4 7.8A1.4 1.4 0 0 0 4.6 10h3.2v5"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/INSTANT_BOOK__24.js
var INSTANT_BOOK__24 = '<svg data-id="SVG_INSTANT_BOOK__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M14.8 17.3l3.7-5.7a1.5 1.5 0 0 0-1.2-2.3h-5.1V2.7l-6.3 9-.4.6a1.5 1.5 0 0 0 1.2 2.4h5v6.5"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/IOS__16.js
var IOS__16 = '<svg data-id="SVG_IOS__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" transform="scale(.667, .667)"><path stroke="none" d="M18.6 12.6a5.5 5.5 0 0 1 2.6-4.5 5.6 5.6 0 0 0-4.4-2.4c-1.9-.2-3.7 1-4.7 1s-2.4-1-4-1a5.9 5.9 0 0 0-4.9 3c-2.1 3.7-.5 9.1 1.5 12.1 1 1.5 2.2 3.1 3.8 3s2.1-1 4-1 2.4 1 4 1 2.7-1.5 3.7-3a12 12 0 0 0 1.7-3.4 5.3 5.3 0 0 1-3.3-4.8z"/><path stroke="none" d="M15.4 3.7a5.3 5.3 0 0 0 1.3-3.8 5.4 5.4 0 0 0-3.5 1.8 5 5 0 0 0-1.3 3.6 4.5 4.5 0 0 0 3.5-1.6z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/IOS__24.js
var IOS__24 = '<svg data-id="SVG_IOS__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path stroke="none" d="M18.6 12.6a5.5 5.5 0 0 1 2.6-4.5 5.6 5.6 0 0 0-4.4-2.4c-1.9-.2-3.7 1-4.7 1s-2.4-1-4-1a5.9 5.9 0 0 0-4.9 3c-2.1 3.7-.5 9.1 1.5 12.1 1 1.5 2.2 3.1 3.8 3s2.1-1 4-1 2.4 1 4 1 2.7-1.5 3.7-3a12 12 0 0 0 1.7-3.4 5.3 5.3 0 0 1-3.3-4.8z"/><path stroke="none" d="M15.4 3.7a5.3 5.3 0 0 0 1.3-3.8 5.4 5.4 0 0 0-3.5 1.8 5 5 0 0 0-1.3 3.6 4.5 4.5 0 0 0 3.5-1.6z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/INVITE__16.js
var INVITE__16 = '<svg data-id="SVG_INVITE__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M5.7 9.8A6 6 0 0 0 2 14.2m11.7 0a6 6 0 0 0-3.5-4.4"/><path d="M11.1 7.6c0 1.8-1.4 3.2-3.1 3.2a3.1 3.1 0 0 1-3.2-3.2v-.8c0-1.7 1.4-3 3.2-3 1.7 0 3.1 1.3 3.1 3v.8zM13 1.4V4m-1.4-1.3h2.7"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/INVITE__24.js
var INVITE__24 = '<svg data-id="SVG_INVITE__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.7 14.6a6.8 6.8 0 0 0-4 5m13.2 0a6.7 6.7 0 0 0-4-5"/><path d="M14.8 12.1c0 2-1.5 3.6-3.5 3.6S7.8 14 7.8 12v-.8c0-2 1.6-3.6 3.5-3.6 2 0 3.5 1.6 3.5 3.6v.8z"/><path stroke-linecap="round" stroke-linejoin="round" d="M14.8 12.1c0 2-1.5 3.6-3.5 3.6S7.8 14 7.8 12v-.8c0-2 1.6-3.6 3.5-3.6 2 0 3.5 1.6 3.5 3.6v.8zm3.1-8v3.4m-1.7-1.7h3.5"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/KEY__16.js
var KEY__16 = '<svg data-id="SVG_KEY__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M7.7 9.7v1.4H5.9v1.8H4.2v1.8H1.4v-2.8l4.4-4.5M10.08 10.42a4.51 4.51 0 1 0-4.28-3"/><path d="M9 5.53a1.4 1.4 0 1 0 1.39-1.4A1.4 1.4 0 0 0 9 5.53" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/KEY__24.js
var KEY__24 = '<svg data-id="SVG_KEY__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M11.6 14.4v1.9H9.3v2.3H7v2.3H3.3v-3.7l5.8-5.8M14.8 15.3a6 6 0 1 0-5.7-4"/><path d="M13.4 8.9a1.8 1.8 0 1 0 3.7 0 1.8 1.8 0 0 0-3.7 0"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LANDSCAPE__16.js
var LANDSCAPE__16 = '<svg data-id="SVG_LANDSCAPE__16" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12.09 13.97H2.57a1.57 1.57 0 0 1-1.32-2.43l4.42-6.88 4.07 6.9H4.32"/><path d="M7.78 11.56h5.65a1.57 1.57 0 0 0 1.32-2.42l-4.42-6.88L7.3 7.41M1.87 7.39a4.03 4.03 0 0 1 7.35-3.25"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LANDSCAPE__24.js
var LANDSCAPE__24 = '<svg data-id="SVG_LANDSCAPE__24" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M17.15 19.54H4.22a1.47 1.47 0 0 1-1.24-2.26l6.08-9.46 5.14 8.7H7.37"/><path d="M11.73 16.51h8.05a1.47 1.47 0 0 0 1.24-2.26L14.94 4.8l-3.83 6.5M4.28 11.25a5.07 5.07 0 0 1 9.26-4.1"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LINK__16.js
var LINK__16 = '<svg data-id="SVG_LINK__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M6 10l4-4m.4 2.5l.6.5 3.3-3.2c.4-.5.4-1.2 0-1.6l-2.5-2.5c-.4-.4-1.1-.4-1.6 0L7 5l.5.6m-2 2L5 7l-3.3 3.2c-.4.5-.4 1.2 0 1.6l2.5 2.5c.4.4 1.1.4 1.6 0L9 11l-.5-.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LINK__24.js
var LINK__24 = '<svg data-id="SVG_LINK__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9.3 14.7l5.4-5.4m.5 3.3l.8.7L20.3 9c.6-.5.6-1.5 0-2l-3.2-3.3c-.6-.6-1.6-.6-2.2 0L10.6 8l.8.7m-2.6 2.7l-.8-.8L3.7 15c-.6.6-.6 1.6 0 2.1l3.2 3.3c.6.6 1.6.6 2.2 0l4.3-4.3-.8-.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LINKEDIN__16.js
var LINKEDIN__16 = '<svg data-id="SVG_LINKEDIN__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M12.93 12.93h-2.08V9.68c0-.77 0-1.77-1.08-1.77s-1.24.84-1.24 1.71v3.3H6.46V6.26h1.99v.91h.02c.28-.52.96-1.08 1.97-1.08 2.1 0 2.49 1.39 2.49 3.19v3.66zm-8.82-7.6a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4zm1.04 7.6H3.07V6.25h2.08v6.68zM14.42 1H1.58a.58.58 0 0 0-.58.58v12.84c0 .32.26.58.58.58h12.84c.32 0 .58-.26.58-.58V1.58a.58.58 0 0 0-.58-.58z" stroke="none" fill-rule="evenodd"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LINKEDIN__24.js
var LINKEDIN__24 = '<svg data-id="SVG_LINKEDIN__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor"  transform="scale(1.5, 1.5)" vector-effect="non-scaling-stroke" d="M12.93 12.93h-2.08V9.68c0-.77 0-1.77-1.08-1.77s-1.24.84-1.24 1.71v3.3H6.46V6.26h1.99v.91h.02c.28-.52.96-1.08 1.97-1.08 2.1 0 2.49 1.39 2.49 3.19v3.66zm-8.82-7.6a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4zm1.04 7.6H3.07V6.25h2.08v6.68zM14.42 1H1.58a.58.58 0 0 0-.58.58v12.84c0 .32.26.58.58.58h12.84c.32 0 .58-.26.58-.58V1.58a.58.58 0 0 0-.58-.58z" stroke="none" fill-rule="evenodd"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LIST__16.js
var LIST__16 = '<svg data-id="SVG_LIST__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M1.9 9.2h12.2V6.8H1.9zM1.9 4.3h12.2V1.9H1.9zM1.9 14.1h12.2v-2.4H1.9z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LIST__24.js
var LIST__24 = '<svg data-id="SVG_LIST__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M4 13.5h16v-3H4zM4 7.5h16v-3H4zM4 19.5h16v-3H4z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LOCATION__16.js
var LOCATION__16 = '<svg data-id="SVG_LOCATION__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3.95 9.11a5.1 5.1 0 0 1 .55-6.58l.03-.03c2-2 5.23-2 7.23 0l.04.03a5.1 5.1 0 0 1 .55 6.58L8.15 15l-4.2-5.89z"/><path d="M9.84 6.15a1.7 1.7 0 1 1-3.38 0 1.7 1.7 0 0 1 3.38 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LOCATION__24.js
var LOCATION__24 = '<svg data-id="SVG_LOCATION__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M6.45 13.47a6.75 6.75 0 0 1 .73-8.7l.05-.04a6.75 6.75 0 0 1 9.54 0l.05.05a6.75 6.75 0 0 1 .73 8.7L12 21.24l-5.55-7.78z"/><path d="M14.24 9.55a2.24 2.24 0 1 1-4.48 0 2.24 2.24 0 0 1 4.48 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LOCK__16.js
var LOCK__16 = '<svg data-id="SVG_LOCK__16"  width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4.6a3 3 0 1 0-6 0v1.8M3 6.5h8.4c.8 0 1.5.6 1.5 1.5v6.3H4.6c-.8 0-1.5-.6-1.5-1.5V9"/><path d="M6.9 9.6a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0zm1.1 3v-1.9"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LOCK__24.js
var LOCK__24 = '<svg data-id="SVG_LOCK__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M16 7.7a3.9 3.9 0 1 0-7.9 0V10M5.5 10.1h11.3c1 0 1.7.8 1.7 1.7v8.7H7.2c-1 0-1.7-.8-1.7-1.7v-6"/><path d="M10.5 14.2a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm1.5 4v-2.5"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LOCK_FILLED__16.js
var LOCK_FILLED__16 = '<svg data-id="SVG_LOCK_FILLED__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path stroke="none" fill-rule="evenodd" fill="currentColor" d="M12.6 7.1c.5 0 .9.4.9.9v6.1c0 .5-.4.9-1 .9h-9c-.6 0-1-.4-1-.9V8c0-.5.4-.9 1-.9h.8V4.5C4.3 2.5 6 1 8 1s3.7 1.6 3.7 3.5v2.6h.9zM6.2 4.5v2.6h3.6V4.5c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8z"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LOG_IN__16.js
var LOG_IN__16 = '<svg data-id="SVG_LOG_IN__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 8H15m-3.2 3.2l3-3.2-3.2-3.2M9.8 1h-8v14h8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LOG_IN__24.js
var LOG_IN__24 = '<svg data-id="SVG_LOG_IN__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M8 12h15M18 17l5-5-5-5M15 1H3v22h12"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LOG_OUT__16.js
var LOG_OUT__16 = '<svg data-id="SVG_LOG_OUT__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 8H1m3.3 3.2L1 8l3.3-3.2M6.2 1h8v14h-8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/LOG_OUT__24.js
var LOG_OUT__24 = '<svg data-id="SVG_LOG_OUT__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M16 12H1M6 17l-5-5 5-5M9 1h12v22H9"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MAIL__16.js
var MAIL__16 = '<svg data-id="SVG_MAIL__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M12.5 6L8.7 9c-.4.4-1 .4-1.4.1L2.8 5.6a1.1 1.1 0 0 0-1.8 1v5.2c0 .6.5 1.1 1.1 1.1H15V4.2c0-.6-.5-1.1-1.1-1.1H1"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MAIL__24.js
var MAIL__24 = '<svg data-id="SVG_MAIL__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M18 9l-5 4c-.6.5-1.4.5-2 0L5.3 8.5a1.5 1.5 0 0 0-2.4 1.1V17c0 .8.6 1.5 1.5 1.5h17V7c0-.8-.7-1.5-1.5-1.5h-17"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MAP__16.js
var MAP__16 = '<svg data-id="SVG_MAP__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M12.58 9.72l2.04 4.07-3.56-1.02-6.12 2.04-3.56-1.02 2.04-4.07"/><path d="M5.25 6.5a3.35 3.35 0 0 1 .36-4.3l.02-.03a3.34 3.34 0 0 1 4.74 0l.02.02a3.35 3.35 0 0 1 .36 4.31L8 10.36 5.25 6.5z" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.88 4.56a.88.88 0 1 1-1.76 0 .88.88 0 0 1 1.76 0" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MAP__24.js
var MAP__24 = '<svg data-id="SVG_MAP__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M18.06 14.52l2.69 5.38-4.71-1.34-8.08 2.69-4.71-1.35 2.7-5.38"/><path d="M8.37 10.27a4.42 4.42 0 0 1 .47-5.7l.03-.03a4.42 4.42 0 0 1 6.26 0l.03.04a4.42 4.42 0 0 1 .47 5.7L12 15.36l-3.63-5.1z" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.25 7.7a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MENU__16.js
var MENU__16 = '<svg data-id="SVG_MENU__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M13.7 8H2.3m11.4 5H2.3M13.7 3H2.3" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MENU__24.js
var MENU__24 = '<svg data-id="SVG_MENU__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.5 12h-15m15 6.5h-15m15-13h-15" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MESSAGE__16.js
var MESSAGE__16 = '<svg data-id="SVG_MESSAGE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M10 8H4.2m7.6-3H4.2M1 5v8a1.1 1.1 0 0 0 2.1.6l1.5-2.5H15V3.3c0-.8-.7-1.5-1.5-1.5H1" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MESSAGE__24.js
var MESSAGE__24 = '<svg data-id="SVG_MESSAGE__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14.6 13.1H7m10-4H7m-4.2 0V20a1.5 1.5 0 0 0 2.7.7l2-3.3h13.8V6.5c0-.9-.7-1.5-1.5-1.5h-17" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MINIMIZE__16.js
var MINIMIZE__16 = '<svg data-id="SVG_MINIMIZE__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M1.4 8.9h5.5v5.5M14.6 7.1H9.1V1.6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MINIMIZE__24.js
var MINIMIZE__24 = '<svg data-id="SVG_MINIMIZE__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M2.8 13.3h7.4v7.3M21.2 10.7h-7.4V3.3"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MINUS__12.js
var MINUS__12 = '<svg data-id="SVG_MINUS__12" width="12" height="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path d="M11 6H1" fill="none" stroke-linecap="round" /></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MINUS__16.js
var MINUS__16 = '<svg data-id="SVG_MINUS__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M12.5 8h-9"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MINUS__24.js
var MINUS__24 = '<svg data-id="SVG_MINUS__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M18 12H6"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MOBILE__16.js
var MOBILE__16 = '<svg data-id="SVG_MOBILE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M3.46 1h7.58c.83 0 1.5.67 1.5 1.5V15H4.96a1.5 1.5 0 0 1-1.5-1.5V3.21M7.08 3.32h1.89" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.88 12.59a.88.88 0 1 1-1.76 0 .88.88 0 0 1 1.76 0" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MOBILE__24.js
var MOBILE__24 = '<svg data-id="SVG_MOBILE__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M6 2.75h10.5c.83 0 1.5.67 1.5 1.5v17H7.5a1.5 1.5 0 0 1-1.5-1.5V5.67M10.78 5.81h2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.25 18.06a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MONEY__16.js
var MONEY__16 = '<svg data-id="SVG_MONEY__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M6.49 8A1.51 1.51 0 1 1 9.5 8 1.51 1.51 0 0 1 6.5 8z" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.65 7.61a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M12.86 8.39a.76.76 0 1 1-1.52 0 .76.76 0 0 1 1.52 0" fill="currentColor" stroke="none"/><path d="M1.01 6.57v5.58c4.16-1.48 8.32 1.01 12.48.38.83-.12 1.5-1.05 1.5-1.88v-6.8C10.33 5.5 5.67 2.17 1 3.84" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MONEY__24.js
var MONEY__24 = '<svg data-id="SVG_MONEY__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M10 11.88a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.57 11.37a1 1 0 1 1-2 0 1 1 0 0 1 2 0M18.43 12.4a1 1 0 1 1-2 0 1 1 0 0 1 2 0" fill="currentColor" stroke="none"/><path d="M2.75 10v7.39c5.67-2.03 11.33 1.53 17 .4.83-.15 1.5-1.08 1.5-1.9v-9.5c-6.17 2.2-12.33-2.2-18.5 0" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MOON__16.js
var MOON__16 = '<svg data-id="SVG_MOON__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15.16 9.8a7.28 7.28 0 0 1-8.95-2.29 7.33 7.33 0 0 1-1.12-6.5 7.33 7.33 0 1 0 10.07 8.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MOON__24.js
var MOON__24 = '<svg data-id="SVG_MOON__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.2 15.14A9.27 9.27 0 0 1 8.31 3.16a9.27 9.27 0 1 0 12.75 11.12 9.23 9.23 0 0 1-3.88.86z" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MORE__16.js
var MORE__16 = '<svg data-id="SVG_MORE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M12 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M1 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" fill="currentColor" stroke="none" fill-rule="evenodd"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MORE__24.js
var MORE__24 = '<svg data-id="SVG_MORE__24" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2.8 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7.2 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7.3 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0" fill="currentColor" stroke="none" fill-rule="evenodd"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/MORE_VERTICAL__24.js
var MORE_VERTICAL__24 = '<svg data-id="SVG_MORE_VERTICAL__24" width="24px" height="24px" viewBox="0 0 24 24"xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M12,5 L12,5" data-id="Line"></path><path d="M12,12 L12,12" data-id="Line"></path><path d="M12,19 L12,19" data-id="Line"></path></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/NEWS__16.js
var NEWS__16 = '<svg data-id="SVG_NEWS__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path d="M6.35 14.19h7.48c.65 0 1.17-.52 1.17-1.17V2.98c0-.65-.52-1.17-1.17-1.17H3.67v11.21M1 4.44v8.58M3.67 13.02c0 .65-.52 1.17-1.17 1.17h-.33c-.65 0-1.17-.52-1.17-1.17M6.35 9.2h5.93M6.35 11.5h5.93" stroke-linecap="round" stroke-linejoin="round"/><path stroke-linecap="round" stroke-linejoin="round" d="M6.38 6.9h5.9V4.5h-5.9z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/NEWS__24.js
var NEWS__24 = '<svg data-id="SVG_NEWS__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path d="M8.96 19.96H19.5c.83 0 1.5-.67 1.5-1.5V5.54c0-.83-.67-1.5-1.5-1.5H6v14.42M3 7.42v11.04M6 18.46a1.5 1.5 0 1 1-3 0M8.96 13.54h2.62M8.96 16.49h2.62" stroke-linecap="round" stroke-linejoin="round"/><path stroke-linecap="round" stroke-linejoin="round" d="M9 10.59h9V7.5H9zM14.92 16.49H18v-2.95h-3.08z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/NO_SMOKING__16.js
var NO_SMOKING__16 = '<svg data-id="SVG_NO_SMOKING__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12.2 2.2l-9 12.2M9 10.4h5.4V7.7H8.2M8.2 7.7H3a1.4 1.4 0 0 0 0 2.7h3.4M11 7.7v2.7M3.7 7.7v2.7M2.4 3.5c-.6.5-.6 1.4 0 2M2.4 3.5c.5-.5.5-1.4 0-2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/NO_SMOKING__24.js
var NO_SMOKING__24 = '<svg data-id="SVG_NO_SMOKING__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M17.6 4L5.8 20M13.3 14.7h7.2V11h-8.2M12.3 11.1h-7a1.8 1.8 0 1 0 0 3.6h4.4M16 11.1v3.6M6.3 11.1v3.6M4 5.3C3.3 6 3.3 7 4 7.8M4 5.3c.7-.7.7-1.9 0-2.6M6 9c.7-.6.7-1.8 0-2.5"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/NOTIFICATION__16.js
var NOTIFICATION__16 = '<svg data-id="SVG_NOTIFICATION__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round""><path d="M3 12.2V7.6a5 5 0 0 1 5-4.9M13 9.5V7.6a5 5 0 0 0-5-4.9m6 9.5H2m8.6 0a2.6 2.6 0 1 1-5.2 0h5.2zM8 1.2v1.5"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/NOTIFICATION__24.js
var NOTIFICATION__24 = '<svg data-id="SVG_NOTIFICATION__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.5 17.5v-6C5.5 7.9 8.5 5 12 5m6.5 9.5v-3c0-3.6-3-6.5-6.5-6.5m8 12.5H4m11.5 0a3.5 3.5 0 1 1-7 0h7zM12 3v2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/OVEN__24.js
var OVEN__24 = '<svg data-id="SVG_OVEN__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3.3 4.7c0-.8.6-1.5 1.5-1.5h14.5c.8 0 1.5.7 1.5 1.5v14.5c0 .9-.7 1.5-1.5 1.5H4.8c-.9 0-1.5-.6-1.5-1.5V4.7z"/><path d="M6.4 11.5c0-.4.3-.8.8-.8h9.6c.5 0 .8.4.8.8v6c0 .4-.3.7-.8.7H7.2a.8.8 0 0 1-.8-.8v-5.9zM9.5 13.2h5M6.4 5.4a.3.3 0 0 1 0 .7.3.3 0 1 1 0-.7M17.6 5.4a.3.3 0 0 0 0 .7.3.3 0 1 0 0-.7M9.8 5.7h4.4M17.8 8.2h-14"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PERSON__16.js
var PERSON__16 = '<svg data-id="SVG_PERSON__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M5.8 8.3a5.7 5.7 0 0 0-3.6 5.3m11.6 0a5.8 5.8 0 0 0-3.6-5.3"/><path d="M11 6.2a3 3 0 1 1-6 0v-.8a3 3 0 1 1 6 0v.8z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PERSON__24.js
var PERSON__24 = '<svg data-id="SVG_PERSON__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M8.46 12.47a9.33 9.33 0 0 0-5 5 9.23 9.23 0 0 0-.71 3.54M21.25 21.01a9.28 9.28 0 0 0-5.71-8.54"/><path d="M16.85 9.04A4.84 4.84 0 0 1 12 13.88h-.02a4.84 4.84 0 0 1-4.84-4.84V7.83A4.84 4.84 0 0 1 12 2.99h.02a4.84 4.84 0 0 1 4.84 4.84v1.2z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PET_PAW__24.js
var PET_PAW__24 = '<svg data-id="SVG_PET_PAW__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 14.3a3 3 0 0 0-6 0 2.4 2.4 0 1 0 0 4.9c.5 0 1-.2 1.5-.4.9-.5 2-.5 3 0 .4.2 1 .4 1.5.4a2.4 2.4 0 0 0 0-4.9zM5 13.1a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6zM8.6 8.3a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6zM14.7 8.3a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6zM18.9 13.1a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PHONE__16.js
var PHONE__16 = '<svg data-id="SVG_PHONE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 15A13.47 13.47 0 0 1 1 1.53M14.92 12.37l.06-.34a1.5 1.5 0 0 0-.75-1.56L11.95 9.2a1.5 1.5 0 0 0-1.92.4l-.8 1.04-.02-.01a10.52 10.52 0 0 1-3.85-3.86l1.05-.8c.59-.46.76-1.27.4-1.92L5.52 1.77a1.5 1.5 0 0 0-1.56-.75L1 1.52c0 .64.04 1.26.13 1.87M11.22 4.78l1.73-1.73M12.52 6.62l1.85-.42M9.37 3.48l.42-1.85"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PHONE__24.js
var PHONE__24 = '<svg data-id="SVG_PHONE__24" viewBox="0 0 24 24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M20.1 20.54c-9.3 0-16.85-7.55-16.85-16.85M20.5 18.2l.22-1.34a1.94 1.94 0 0 0-.96-2.02l-2.77-1.54a1.94 1.94 0 0 0-2.48.52l-.97 1.26-.02-.01c-2-1.16-3.67-2.82-4.82-4.83l1.27-.97c.76-.58.98-1.64.51-2.48L8.94 4.03c-.4-.72-1.2-1.1-2.02-.97l-3.67.63c0 .79.05 1.56.16 2.32M15.17 8.83l2.48-2.48M16.88 10.54l2.27-.51M13.46 7.12l.51-2.27"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PICTURE__16.js
var PICTURE__16 = '<svg data-id="SVG_PICTURE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M1.38 1.38h11.74c.83 0 1.5.67 1.5 1.5v11.74H2.88a1.5 1.5 0 0 1-1.5-1.5v-9.4"/><path d="M1.38 12.81l3.79-3.79 5.6 5.6M8.5 9.66l3.37-3.36 2.75 2.76M5.27 5.27a1.56 1.56 0 1 1 3.12 0 1.56 1.56 0 0 1-3.12 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PICTURE__24.js
var PICTURE__24 = '<svg data-id="SVG_PICTURE__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3.25 3.3h16c.83 0 1.5.66 1.5 1.5v16h-16a1.5 1.5 0 0 1-1.5-1.5V6.37"/><path d="M3.25 18.4l5-5 7.4 7.4M12.67 14.23l4.44-4.43 3.64 3.64M8.4 8.44a2.06 2.06 0 1 1 4.12 0 2.06 2.06 0 0 1-4.12 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PINTEREST__16.js
var PINTEREST__16 = '<svg data-id="SVG_PINTEREST__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M8 1a7 7 0 0 0-2.55 13.52 6.7 6.7 0 0 1 .02-2.01l.82-3.48S6.1 8.61 6.1 8c0-.97.56-1.7 1.26-1.7.6 0 .89.45.89.99 0 .6-.39 1.5-.58 2.33-.17.7.35 1.26 1.03 1.26 1.25 0 2.2-1.3 2.2-3.2 0-1.68-1.2-2.85-2.92-2.85-2 0-3.16 1.5-3.16 3.04 0 .6.23 1.24.52 1.6a.2.2 0 0 1 .05.2l-.2.79c-.03.13-.1.16-.23.1-.87-.41-1.42-1.7-1.42-2.72 0-2.2 1.6-4.23 4.62-4.23 2.43 0 4.32 1.73 4.32 4.04 0 2.41-1.52 4.35-3.63 4.35-.71 0-1.38-.37-1.6-.8l-.44 1.66c-.16.61-.59 1.37-.87 1.84A7 7 0 1 0 8 1" stroke="none" fill-rule="evenodd"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PINTEREST__24.js
var PINTEREST__24 = '<svg data-id="SVG_PINTEREST__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" transform="scale(1.5, 1.5)" vector-effect="non-scaling-stroke" d="M8 1a7 7 0 0 0-2.55 13.52 6.7 6.7 0 0 1 .02-2.01l.82-3.48S6.1 8.61 6.1 8c0-.97.56-1.7 1.26-1.7.6 0 .89.45.89.99 0 .6-.39 1.5-.58 2.33-.17.7.35 1.26 1.03 1.26 1.25 0 2.2-1.3 2.2-3.2 0-1.68-1.2-2.85-2.92-2.85-2 0-3.16 1.5-3.16 3.04 0 .6.23 1.24.52 1.6a.2.2 0 0 1 .05.2l-.2.79c-.03.13-.1.16-.23.1-.87-.41-1.42-1.7-1.42-2.72 0-2.2 1.6-4.23 4.62-4.23 2.43 0 4.32 1.73 4.32 4.04 0 2.41-1.52 4.35-3.63 4.35-.71 0-1.38-.37-1.6-.8l-.44 1.66c-.16.61-.59 1.37-.87 1.84A7 7 0 1 0 8 1" stroke="none" fill-rule="evenodd"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PLANE__16.js
var PLANE__16 = '<svg data-id="SVG_PLANE__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M11.9 6.3l1.3 6.2c.1.5 0 1-.4 1.4l-.4.3-2.2-2.7m-.5-7.4L3.5 2.8c-.5-.1-1 0-1.4.4l-.3.4 2.7 2.2"/><path d="M6.1 11.5l.3 1.4c0 .5-.1 1-.5 1.3l-.3.4-1.7-2.5-2.5-1.7.4-.3c.3-.4.8-.5 1.3-.5l1.4.3 7.3-8a1.6 1.6 0 0 1 2.3 2.3l-8 7.3zm7.5-2.2l-.9 1m-6-8l-1 1"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PLANE__24.js
var PLANE__24 = '<svg data-id="SVG_PLANE__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M17.1 9.7l1.8 8.5c.1.5 0 1-.4 1.4l-.6.6-3-4.3m-.6-9L5.8 5c-.5-.1-1 0-1.4.4l-.6.6 4.3 3"/><path d="M9.5 16.6l.4 2.2c0 .4-.1 1-.4 1.3l-.7.7-2.2-3.4-3.3-2.2.6-.6c.4-.4.9-.5 1.3-.5l2.2.4L17 4a2.2 2.2 0 0 1 3.1 3L9.5 16.7zm10-2.8L18.2 15m-8-10.4L9 5.8"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PLAY__16.js
var PLAY__16 = '<svg data-id="SVG_PLAY__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M2 1l11.8 6.1a1.2 1.2 0 0 1 0 2.2L3.8 15A1.2 1.2 0 0 1 2 14V4.3"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PLAY__24.js
var PLAY__24 = '<svg data-id="SVG_PLAY__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M5.1 3l15.4 7.5a1.6 1.6 0 0 1 0 2.9l-13 7.5a1.6 1.6 0 0 1-2.4-1.4V7.2"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PLUS__16.js
var PLUS__16 = '<svg data-id="SVG_PLUS__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 12.5v-9M12.5 8h-9" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PLUS__24.js
var PLUS__24 = '<svg data-id="SVG_PLUS__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 18.5v-12m6 6H6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/POOL__16.js
var POOL__16 = '<svg data-id="SVG_POOL__16" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12.16 7.36H3.83M12.16 10.3H3.83M1 4.43h14M3.83 11.56V2.13A1.14 1.14 0 0 1 4.96 1M12.16 11.56V2.13A1.14 1.14 0 0 0 11.03 1M12.03 15a2.2 2.2 0 0 1-2.02-1.35M10 13.64A2.19 2.19 0 0 1 7.99 15M14.05 13.64A2.19 2.19 0 0 1 12.03 15M7.98 15a2.2 2.2 0 0 1-2.02-1.35M3.93 15a2.2 2.2 0 0 1-2.02-1.35M5.96 13.64A2.19 2.19 0 0 1 3.93 15"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/POOL__24.js
var POOL__24 = '<svg data-id="SVG_POOL__24" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M17.5 11.68H6.48M17.5 15.1H6.48M2.75 8.26h18.5M6.49 17.12V5.22a1.5 1.5 0 0 1 1.5-1.5M17.5 17.12V5.22a1.5 1.5 0 0 0-1.5-1.5M17.33 20.25a2.9 2.9 0 0 1-2.68-1.8M14.65 18.46a2.89 2.89 0 0 1-2.67 1.79M20 18.46a2.89 2.89 0 0 1-2.67 1.79M11.98 20.25a2.9 2.9 0 0 1-2.68-1.8M6.63 20.25a2.9 2.9 0 0 1-2.68-1.8M9.3 18.46a2.86 2.86 0 0 1-1.56 1.57c-.36.14-.73.22-1.11.22"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PREMIER_PARTNER__24.js
var PREMIER_PARTNER__24 = '<svg data-id="SVG_PREMIER_PARTNER__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="currentColor" stroke="none" cx="12" cy="12" r="12"/><path d="M12 11.7c-.8 0-1.4-.6-1.4-1.3v-.5c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4v.5c0 .7-.6 1.3-1.4 1.3zm5.4-5c-.3-.5-.9-.8-1.5-.8H8.1c-.7 0-1.2.3-1.5.9l-2 3.9 6.1 7.1a1.7 1.7 0 0 0 2.6 0l3.2-3.8-.1-.2a5 5 0 0 0-2.4-2.4c.2-.3.3-.7.3-1v-.5c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3v.5c0 .3 0 .7.3 1a5 5 0 0 0-1.2.8l.6.7c.3-.3.7-.6 1.2-.7a2.3 2.3 0 0 0 2.8 0 4.2 4.2 0 0 1 2 1.7l-2.9 3.3c-.2.4-.8.4-1 0l-5.8-6.7 1.7-3.3c.1-.3.4-.4.7-.4h7.8c.3 0 .5.1.7.4l1.7 3.3L17 12l.7.6 1.7-2-2-3.8z" fill="#fff" stroke="#FFF" stroke-width=".5"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PRINT__16.js
var PRINT__16 = '<svg data-id="SVG_PRINT__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M4.1 6.4h1.5m-1.8 4.7H1.4V4H13c.8 0 1.5.7 1.5 1.5v5.7h-.5M4.5 3.9V1h7v2.9"/><path stroke-linecap="round" stroke-linejoin="round" d="M11.5 9.1V15h-7V9.1M3.8 9h8.4"/><path fill="currentColor" stroke="none" d="M12.4 6.4a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/PRINT__24.js
var PRINT__24 = '<svg data-id="SVG_PRINT__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M5.5 9.6h2m3.2 6.5h3m-4 2.5h5M6.5 16.1H3.3V6.6h16c.8 0 1.5.7 1.5 1.5v8H20"/><path stroke-linecap="round" stroke-linejoin="round" d="M6.5 6.6V2.8H16c.8 0 1.5.7 1.5 1.5v2.3m0 7v7.7H8c-.8 0-1.5-.7-1.5-1.5v-6.3m-1 0h13"/><path fill="currentColor" stroke="none" d="M19.2 9.6a.8.8 0 1 1-1.5 0 .8.8 0 0 1 1.5 0m-3 0a.8.8 0 1 1-1.5 0 .8.8 0 0 1 1.5 0"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/QUESTION__16.js
var QUESTION__16 = '<svg data-id="SVG_QUESTION__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke="none" fill="currentColor" d="M8.8 11.6a.8.8 0 1 1-1.5 0 .8.8 0 0 1 1.5 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8z"/><path stroke-linecap="round" stroke-linejoin="round" d="M6 6a2 2 0 1 1 2.7 2c-.4 0-.7.5-.7 1v.2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/QUESTION__24.js
var QUESTION__24 = '<svg data-id="SVG_QUESTION__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" stroke="none" d="M13 16.7a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M2.7 12a9.3 9.3 0 1 1 18.6 0 9.3 9.3 0 0 1-18.6 0z"/><path stroke-linecap="round" stroke-linejoin="round" d="M9.4 9.5a2.6 2.6 0 1 1 3.6 2.4c-.6.2-1 .8-1 1.4v.3"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/REFRESH__16.js
var REFRESH__16 = '<svg data-id="SVG_REFRESH__16" viewBox="0 0 16 16" width="16" height="16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3.1 13.4V9.9h3.5M12.9 2.6v3.5H9.4"/><path d="M3.2 7A4.9 4.9 0 0 1 7 3.2a5 5 0 0 1 5.4 2.7m.4 3a5 5 0 0 1-3 3.6 4.8 4.8 0 0 1-3.7 0 5 5 0 0 1-2.6-2.4"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/REFRESH__24.js
var REFRESH__24 = '<svg data-id="SVG_REFRESH__24" viewBox="0 0 24 24" width="24" height="24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5.5 19.4v-4.6h4.6M18.5 5.1v4.6h-4.6"/><path d="M5.6 11a6.5 6.5 0 0 1 12.2-1.6m.6 4.1A6.5 6.5 0 0 1 6 15"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/REMOVE_CIRCLE__16.js
var REMOVE_CIRCLE__16 = '<svg data-id="SVG_REMOVE_CIRCLE__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M1 8a7 7 0 0 1 12-5A7 7 0 0 1 9.3 15 7 7 0 0 1 1 8zm10 0H5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/REMOVE_CIRCLE__24.js
var REMOVE_CIRCLE__24 = '<svg data-id="SVG_REMOVE_CIRCLE__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2.8 12a9.3 9.3 0 0 1 12.7-8.5 9.3 9.3 0 0 1 5.6 10.3A9.3 9.3 0 0 1 2.7 12zM16 12H8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/REPLY__16.js
var REPLY__16 = '<svg data-id="SVG_REPLY__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M15 14s.2-3.5-4.2-4.7M7.4 5.2S15.5 5 15 14M7.4 8.5v3.6L1 7l6.4-5v3.2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/REPLY__24.js
var REPLY__24 = '<svg data-id="SVG_REPLY__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M20.7 19.5s.3-5-6.5-6.2m-3-4.8s10.2-.2 9.5 11M11.2 12.6v4.6l-7.9-6.4 7.9-6.3v4"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SATELLITE__24.js
var SATELLITE__24 = '<svg data-id="SVG_SATELLITE__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M18.8 13.9A6.9 6.9 0 1 1 9 4.2l9.7 9.7zM19.2 6.4a1.9 1.9 0 1 1-2.6-2.7 1.9 1.9 0 0 1 2.6 2.7zM16.6 6.4L13.9 9M4.1 20.7L7.7 17c.5-.4 1.3-.4 1.7 0l3.6 3.6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SEARCH__16.js
var SEARCH__16 = '<svg data-id="SVG_SEARCH__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.8 8a5 5 0 0 0-.7-3.7A4.9 4.9 0 0 0 7 2a5 5 0 0 0-2.7 9 5 5 0 0 0 6.2-.6m0 0l3.4 3.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SEARCH__24.js
var SEARCH__24 = '<svg data-id="SVG_SEARCH__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M16.7 13.2a6.5 6.5 0 1 0-1.4 2m0 0l4.6 4.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SEND__16.js
var SEND__16 = '<svg data-id="SVG_SEND__16" viewBox="0 0 16 16" width="16" height="16"><g stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path data-cap="butt" d="M4.504 9.503L12.5 15.5l3-15-15 6 2.002 1.501"/><path data-cap="butt" d="M7.63 11.848L4.5 15.5l.004-5.997L9 6.5"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SEND__24.js
var SEND__24 = '<svg data-id="SVG_SEND__24" viewBox="0 0 24 24" width="24" height="24"><g stroke-linecap="square" stroke="currentColor" fill="none" stroke-miterlimit="10"><path data-cap="butt" stroke-linecap="butt" d="M22.5 2.5l-15 12v7l3.6-4.3"/><path d="M2.5 10.5l20-8-4 20z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SHARE__16.js
var SHARE__16 = '<svg data-id="SVG_SHARE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13.7 9.9v3c0 .6-.5 1-1.2 1h-9c-.7 0-1.2-.4-1.2-1v-3M3.9 5.5L8 2l4.1 3.5M8 2.6v7.6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SHARE__24.js
var SHARE__24 = '<svg data-id="SVG_SHARE__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M19.5 14V18c0 .8-.7 1.5-1.5 1.5H6c-.8 0-1.5-.7-1.5-1.5V14M6.6 8.2L12 3.6l5.4 4.6M12 4.4v10"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SHARE_ANDROID__16.js
var SHARE_ANDROID__16 = '<svg data-id="SVG_SHARE_ANDROID__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M5.2 9l3.5 2M7.3 5.7l3.5-2M3.5 6.2a1.9 1.9 0 1 1 0 3.8 1.9 1.9 0 0 1 0-3.8zm9-5a1.9 1.9 0 1 1 0 3.7 1.9 1.9 0 0 1 0-3.8zm0 10.1a1.9 1.9 0 1 1 0 3.8 1.9 1.9 0 0 1 0-3.8z" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SHARE_ANDROID__24.js
var SHARE_ANDROID__24 = '<svg data-id="SVG_SHARE_ANDROID__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.4 13.2l4.6 2.6m-1.7-6.7l4.5-2.6m-9.5 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM17 2.7a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm0 13.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5z" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SHOWER__16.js
var SHOWER__16 = '<svg data-id="SVG_SHOWER__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M4.1 13.6L3.4 15M11.9 13.6l.7 1.4M11.5 4.4H9M15 9.4c0 2.3-1.9 4.2-4.2 4.2H5.2A4.2 4.2 0 0 1 1 9.4v-.8h10.5M10.2 4.4v-1a2.4 2.4 0 1 1 4.8 0v6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SHOWER__24.js
var SHOWER__24 = '<svg data-id="SVG_SHOWER__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M7.2 19l-1 1.7M16.8 19l1 1.7M16 6.3h-2.6M14.8 10.1V8.9M17.7 9.4l-.4-1.1M11.8 9.4l.5-1.1M20.8 13.7c0 3-2.4 5.3-5.3 5.3h-7c-2.9 0-5.2-2.4-5.2-5.3v-1h14.2M14.8 6.3a3 3 0 1 1 6 0v7.4"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SNOWFLAKE__16.js
var SNOWFLAKE__16 = '<svg data-id="SVG_SNOWFLAKE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none"><g stroke-linecap="round" stroke-linejoin="round"><path d="M1 8h5M1.6 9.8L3.5 8M1.6 6l1.9 2M15 8H9.7M14.3 6l-2 2M14.3 9.8l-2-1.9M4.4 14L7 9.6M6.4 14.4l-.7-2.6M3 12.5l2.7-.7M11.4 1.9L9 6.3M9.5 1.5l.7 2.6M12.8 3.4l-2.6.7M11.4 14L9 9.6M12.8 12.5l-2.6-.7M9.5 14.4l.7-2.6M4.4 1.9L7 6.3M3 3.4l2.7.7M6.4 1.5L5.7 4M8 6a1.9 1.9 0 1 1 0 3.8A1.9 1.9 0 0 1 8 6z"/></g></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SNOWFLAKE__24.js
var SNOWFLAKE__24 = '<svg data-id="SVG_SNOWFLAKE__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M2.7 12h6.8M3.6 14.5L6 12M3.6 9.5L6 12M2.7 12h6.8M3.6 14.5L6 12M3.6 9.5L6 12M21.3 12h-6.8M20.4 9.5L18 12M20.4 14.5L18 12M21.3 12h-6.8M20.4 9.5L18 12M20.4 14.5L18 12M7.4 20l3.4-5.8M10 20.6L9 17M5.6 18l3.5-.9M7.4 20l3.4-5.8M10 20.6L9 17M5.6 18l3.5-.9M16.6 4l-3.3 5.8M14 3.4L15 7M18.4 6l-3.5.9M16.6 4l-3.4 5.8M14 3.4L15 7M18.4 6l-3.5.9M16.6 20l-3.4-5.8M18.4 18l-3.5-.9M14 20.6l1-3.5M16.6 20l-3.4-5.8M18.4 18l-3.5-.9M14 20.6l1-3.5M7.4 4l3.3 5.8M5.6 6l3.5.9M10 3.4L9 7M7.4 4l3.4 5.8M5.6 6l3.5.9M10 3.4L9 7M12 9.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SORT__16.js
var SORT__16 = '<svg data-id="SVG_SORT__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M9.6 10.3l2.6 2.6 2.7-2.6M12.2 5.5v7.4M1.6 3.1h12.2M1.6 8H8m-6.4 4.8H6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SORT__24.js
var SORT__24 = '<svg data-id="SVG_SORT__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M14.2 15.4l3.5 3.5 3.5-3.5M17.7 9.1V19M3.7 5.4h16.1M3.8 12H12m-8.4 6.5h5.6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/STAR__16.js
var STAR__16 = '<svg data-id="SVG_STAR__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M6 5.6L8 1l1.8 4.2c.1.3.4.4.7.5L15 6l-3.4 3.5c-.2.2-.3.5-.2.7l1.3 4.7-4.3-3a.7.7 0 0 0-.8 0l-4.3 3 1.3-4.7c0-.2 0-.5-.2-.8L1 6.2l2.3-.2"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/STAR__24.js
var STAR__24 = '<svg data-id="SVG_STAR__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M9.4 8.6L12 2.5 14.4 8c.1.3.5.6.9.6l6 .6-4.6 4.5a1 1 0 0 0-.2 1l1.7 6.2-5.7-4a.9.9 0 0 0-1 0l-5.7 4 1.7-6.2a1 1 0 0 0-.2-1L2.8 9.2l3-.3"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/STOPWATCH__16.js
var STOPWATCH__16 = '<svg data-id="SVG_STOPWATCH__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M6.87 1.73h2.27M10.13 6.87L7.95 9.04M3.38 4.42l.76.76M11.87 5.27l.76-.76M2.77 9.04a5.23 5.23 0 1 1 10.46 0 5.23 5.23 0 0 1-10.46 0z" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 9.04a1 1 0 1 1 2 0 1 1 0 0 1-2 0" fill="currentColor" stroke="none"/><path d="M8 3.3V2.23" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/STOPWATCH__24.js
var STOPWATCH__24 = '<svg data-id="SVG_STOPWATCH__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M10.49 3.25h3.02M14.8 10.05l-2.87 2.87M5.9 6.82l1 1M17.12 7.94l1-1M5.09 12.92a6.91 6.91 0 1 1 13.83 0 6.91 6.91 0 0 1-13.83 0z" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.75 12.92a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" fill="currentColor" stroke="none"/><path d="M12 5.33V3.92" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/STROLLER__24.js
var STROLLER__24 = '<svg data-id="SVG_STROLLER__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M6 20.7a1.7 1.7 0 1 0 0-3.5 1.7 1.7 0 0 0 0 3.5zM14.1 20.7a1.7 1.7 0 1 0 0-3.5 1.7 1.7 0 0 0 0 3.5zM15.3 14.8h-9c-.6 0-1-.3-1.2-.8l-.9-3.8H17"/><path d="M14.4 17.2L18.2 7c.4-.9 1.2-1.5 2.2-1.5h1.3M7.6 18.3h4.9M4.2 10.2a7 7 0 0 1 7-7v7M11.2 10.2l-6-3.6M11.2 10.2l-3.5-6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SUCCESS__16.js
var SUCCESS__16 = '<svg data-id="SVG_SUCCESS__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M1 8a7 7 0 0 1 12-5A7 7 0 0 1 9.3 15 7 7 0 0 1 1 8z"/><path d="M8.9 8.3l-2.2 2.2-2.1-2.2M11.4 5.8L9 8.3"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SUCCESS__24.js
var SUCCESS__24 = '<svg data-id="SVG_SUCCESS__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M2.8 12a9.3 9.3 0 0 1 12.7-8.5 9.3 9.3 0 0 1 5 12 9.3 9.3 0 0 1-12 5A9.3 9.3 0 0 1 2.8 12z"/><path d="M13.2 12.5l-2.9 2.8-2.8-2.8M16.5 9.1l-3.3 3.4"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SUITCASE__16.js
var SUITCASE__16 = '<svg data-id="SVG_SUITCASE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4.28h12.5c.83 0 1.5.67 1.5 1.5v8.33H2.5a1.5 1.5 0 0 1-1.5-1.5V6.97M4.06 14.11V4.27M11.94 14.11V4.27M4.91 4.28l1.42-2.62h3.34l1.42 2.62"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/SUITCASE__24.js
var SUITCASE__24 = '<svg data-id="SVG_SUITCASE__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M2.75 6.44h17c.83 0 1.5.67 1.5 1.5v11.5h-17a1.5 1.5 0 0 1-1.5-1.5V10M6.75 19.44v-13M17.75 19.44v-13M7.75 6.2l1.88-2.76h4.4l1.89 2.76"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TAG__16.js
var TAG__16 = '<svg data-id="SVG_TAG__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M5 14.6L1.4 11c-.5-.4-.5-1.2 0-1.7L8.6 2a2 2 0 0 1 1.4-.5h3.8c.7 0 1.2.5 1.2 1.2v3.8a2 2 0 0 1-.6 1.3l-6.8 7"/><path fill="currentColor" stroke="none" d="M11.6 3.6a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TAG__24.js
var TAG__24 = '<svg data-id="SVG_TAG__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M8.3 20.3l-4.6-4.6C3 15 3 14 3.7 13.6l9-9.1c.5-.5 1.2-.8 1.8-.8h4.7c.9 0 1.5.7 1.5 1.6V10a2.4 2.4 0 0 1-.7 1.7l-8.5 8.6"/><path d="M16 10a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TOILET__16.js
var TOILET__16 = '<svg data-id="SVG_TOILET__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M4.3 4.4V2.2c0-.7.5-1.2 1.1-1.2h5c.6 0 1 .5 1 1.2v5.6M10.2 13l.3 2H8M8 7.8h5v.8a5 5 0 0 1-2.8 4.4M5.8 13l-.3 2H8M8 7.8H3v.8A5 5 0 0 0 5.9 13M4.3 4.4h2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TOILET__24.js
var TOILET__24 = '<svg data-id="SVG_TOILET__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M7.3 8.4V4.3c0-.9.7-1.5 1.5-1.5h6.5c.9 0 1.5.6 1.5 1.5v7.5M15.2 18.6l.3 2.7h-3.2M12.3 11.8h6.5v1c0 2.5-1.5 4.7-3.6 5.8M9.3 18.6L9 21.3h3.3M12.3 11.8H5.8v1c0 2.5 1.4 4.7 3.5 5.8M7.3 5.8H10"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TOOLTIP__16.js
var TOOLTIP__16 = '<svg data-id="SVG_TOOLTIP__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g stroke="none" fill="currentColor" fill-rule="evenodd"><path stroke="none" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0z"/><path fill="#FFF" stroke="none" d="M7.2 10c0-.4 0-.8.2-1.1l.7-1L9 7l.2-.8c0-.4-.1-.6-.3-.8-.2-.2-.4-.3-.8-.3-.3 0-.6 0-.8.3a1 1 0 0 0-.3.7H5.5c0-.7.2-1.2.7-1.6.5-.4 1-.6 1.8-.6s1.4.2 1.8.6c.5.4.7 1 .7 1.7 0 .6-.3 1.2-.9 1.8l-.7.7c-.3.3-.4.7-.4 1.3H7.2zM7 12c0-.2 0-.4.2-.6l.6-.2.6.3.2.5c0 .2 0 .4-.2.5l-.6.3c-.3 0-.5-.1-.6-.3A.7.7 0 0 1 7 12z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TOOLTIP_INFO__16.js
var TOOLTIP_INFO__16 = '<svg data-id="SVG_TOOLTIP_INFO__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g stroke="none" fill="currentColor" fill-rule="evenodd"><path stroke="none" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z"/><path strok="none" d="M9 13V7.3H7V13zM8 5.7c.7 0 1.3-.6 1.3-1.4C9.3 3.6 8.7 3 8 3c-.7 0-1.3.6-1.3 1.3 0 .8.6 1.4 1.3 1.4z" fill="#FFF"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TOUR_360__16.js
var TOUR_360__16 = '<svg data-id="SVG_TOUR_360__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M4.4 11.4V8.1H1.1M7.5 14.2a16.9 16.9 0 0 0 3.8-1l2-1.2c.7-.4 1.1-.8 1.4-1.3.3-.4.4-.8.3-1.2-.1-.4-.4-.8-.8-1-.4-.3-1-.6-1.7-.7l-1-.1"/><path stroke-linecap="round" stroke-linejoin="round" d="M9.8 13.7a17 17 0 0 1-3.9.6c-.9 0-1.7 0-2.4-.2-.7-.1-1.3-.3-1.7-.6-.4-.3-.7-.7-.8-1 0-.5 0-.9.3-1.3.3-.5.7-1 1.3-1.3l1.1-.7M11.6 4.3v6.4H7"/><path stroke-linecap="round" stroke-linejoin="round" d="M2.7 5.7L7.3 2c.4-.4 1-.4 1.5 0l4.5 3.7"/><path fill="currentColor" stroke="none" d="M7 8.4h2.1V6.3H7z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TOUR_360__24.js
var TOUR_360__24 = '<svg data-id="SVG_TOUR_360__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M7.5 16.9v-4.7H2.8M11.3 19.8a22 22 0 0 0 5-1.3c1.1-.4 2-1 2.8-1.5.8-.6 1.4-1.1 1.8-1.7.3-.6.5-1.2.4-1.7-.2-.5-.5-1-1-1.4-.6-.4-1.4-.7-2.4-.8l-1.1-.2"/><path stroke-linecap="round" stroke-linejoin="round" d="M14.3 19.2a21.4 21.4 0 0 1-8.2.6c-1-.2-1.8-.5-2.3-1-.6-.3-1-.8-1-1.3-.2-.5 0-1 .3-1.7a9.9 9.9 0 0 1 3.2-2.6m1.1-5.8V4.6M16.8 7.8v7.8h-6.6"/><path stroke-linecap="round" stroke-linejoin="round" d="M5 9.3l6-5c.6-.4 1.5-.4 2 0l6 5"/><path fill="currentColor" stroke="none" d="M10.6 12.2h2.9V9.3h-2.9z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TOWEL__16.js
var TOWEL__16 = '<svg data-id="SVG_TOWEL__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13 13.7V15M5 13.7V15M3 13.7V15M7 13.7V15M9 13.7V15M11 13.7V15M3 7l2 .7L7 7l2 .7 2-.7 2 .7"/><path d="M13 5l-2-.7L9 5l-2-.7L5 5l-2-.7v9.4h10V2.5c0-.8-.7-1.5-1.5-1.5H3M13 3h2M1 3h2v1.3"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TOWEL__24.js
var TOWEL__24 = '<svg data-id="SVG_TOWEL__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M18.6 19.5v1.8M8 19.5v1.8M5.4 19.5v1.8M10.7 19.5v1.8M13.3 19.5v1.8M16 19.5v1.8M5.4 10.7l2.6.9 2.7-1 2.6 1 2.7-1 2.6 1"/><g><path d="M18.6 8L16 7.2l-2.7.8-2.6-.8L8 8l-2.6-.8v12.3h13.2V4.3c0-.9-.7-1.5-1.5-1.5H5.4M18.6 5.4h2.7M2.8 5.4h2.6v1.8"/></g></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TRAIN__16.js
var TRAIN__16 = '<svg data-id="SVG_TRAIN__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M11 11.2H3v-9C3 1.5 3.7 1 4.3 1h7.6c.6 0 1.1.6 1.1 1.2v9"/><path stroke-linecap="round" stroke-linejoin="round" d="M5.4 3.3h5.2l-.3 3.4H5.7zM4.4 13.4h7.2M5 11.2L3.7 15m8.6 0L11 11.2"/><path stroke="none" fill="currentColor" d="M4.5 9a.9.9 0 1 1 1.7 0 .9.9 0 0 1-1.7 0m5.1 0a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TRAIN__24.js
var TRAIN__24 = '<svg data-id="SVG_TRAIN__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M16 16.2H5.4V4.3c0-.8.7-1.5 1.5-1.5h10c.9 0 1.5.7 1.5 1.5v11.9"/><path stroke-linecap="round" stroke-linejoin="round" d="M8.5 5.7h7l-.5 4.6H9zM7.3 19h9.5m-8.7-2.8l-1.7 5m11.3 0l-1.8-5"/><path stroke="none" fill="currentColor" d="M7.3 13.2a1.3 1.3 0 1 1 2.5 0 1.3 1.3 0 0 1-2.5 0m6.8 0a1.3 1.3 0 1 1 2.5 0 1.3 1.3 0 0 1-2.5 0"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TRASHCAN__16.js
var TRASHCAN__16 = '<svg data-id="SVG_TRASHCAN__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M2.3 4.7h11.6m-3.7-1.4c0-.6-.5-1-1-1H7a1 1 0 0 0-1 1v1.4h4.2V3.3zM6.8 11V7.3M9.3 11V7.3m3.4-2.6l-.8 8.3c0 .5-.5 1-1 1H5.2a1 1 0 0 1-1-1l-.5-5.8" fill="none" stroke-linecap="round" stroke-linejoin="round" /></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TRASHCAN__24.js
var TRASHCAN__24 = '<svg data-id="SVG_TRASHCAN__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3.2 5.8h17.5m-5.6-1c0-.9-.6-1.5-1.5-1.5h-3.2c-.9 0-1.5.6-1.5 1.5v1H15v-1zm-5 11.6V10m3.8 6.3V10m5-4.3l-1.2 13.6c0 .8-.7 1.4-1.5 1.4H7.8c-.8 0-1.5-.6-1.5-1.4l-1-10.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TREND_ARROW_UP__16.js
var TREND_ARROW_UP__16 = '<svg data-id="SVG_TREND_ARROW_UP__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M15 4.5l-6.5 7-3.7-4-3.7 4"/><path d="M9.4 4.5H15v6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TREND_ARROW_DOWN__16.js
var TREND_ARROW_DOWN__16 = '<svg data-id="SVG_TREND_ARROW_DOWN__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M15 11.5l-6.5-7-3.7 4-3.8-4"/><path d="M9.4 11.5H15v-6"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TREND_ARROW_UP__24.js
var TREND_ARROW_UP__24 = '<svg data-id="SVG_TREND_ARROW_UP__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" transform="scale(1.5, 1.5)"><path d="M15 4.5l-6.5 7-3.7-4-3.7 4" vector-effect="non-scaling-stroke"/><path d="M9.4 4.5H15v6" vector-effect="non-scaling-stroke"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TREND_ARROW_DOWN__24.js
var TREND_ARROW_DOWN__24 = '<svg data-id="SVG_TREND_ARROW_DOWN__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" transform="scale(1.5, 1.5)"><path d="M15 11.5l-6.5-7-3.7 4-3.8-4" vector-effect="non-scaling-stroke"/><path d="M9.4 11.5H15v-6" vector-effect="non-scaling-stroke"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TUMBLR__16.js
var TUMBLR__16 = '<svg data-id="SVG_TUMBLR__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.4 12.2l-1.2.2c-1 0-1.3-.8-1.3-1.4V6.7h2.8V4.6H9V1H7l-.1.1C6.6 2.2 6 4.1 4 4.9v1.8h1.4v4.6c0 1.5 1.2 3.8 4.2 3.7 1 0 2.2-.4 2.4-.8l-.6-2z" stroke="none" fill-rule="evenodd" fill="currentColor"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TUMBLR__24.js
var TUMBLR__24 = '<svg data-id="SVG_TUMBLR__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path transform="scale(1.5, 1.5)" vector-effect="non-scaling-stroke" d="M11.4 12.2l-1.2.2c-1 0-1.3-.8-1.3-1.4V6.7h2.8V4.6H9V1H7l-.1.1C6.6 2.2 6 4.1 4 4.9v1.8h1.4v4.6c0 1.5 1.2 3.8 4.2 3.7 1 0 2.2-.4 2.4-.8l-.6-2z" stroke="none" fill-rule="evenodd" fill="currentColor"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TV__16.js
var TV__16 = '<svg data-id="SVG_TV__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M1 3.6h12.9c.6 0 1.1.5 1.1 1.2v8.8H2.1c-.6 0-1.1-.5-1.1-1.1V3.6" stroke-linecap="round" stroke-linejoin="round"/><path stroke-linecap="round" stroke-linejoin="round" d="M3.5 6.3h7v5h-7V8.7M10 1.6l-2 2-2-2"/><path d="M13.5 6.3a.8.8 0 1 1-1.5 0 .8.8 0 0 1 1.5 0M13.5 8.8a.8.8 0 1 1-1.5 0 .8.8 0 0 1 1.5 0M13.5 11.2a.8.8 0 1 1-1.5 0 .8.8 0 0 1 1.5 0" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TV__24.js
var TV__24 = '<svg data-id="SVG_TV__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M2.8 6.6h17c.8 0 1.5.7 1.5 1.5v11.7h-17c-.9 0-1.5-.6-1.5-1.5v-9" stroke-linecap="round" stroke-linejoin="round"/><path stroke-linecap="round" stroke-linejoin="round" d="M2.8 9.3H16v7.9H5.4v-5.3M14.6 4L12 6.6 9.4 4"/><path d="M19.4 10.6a.8.8 0 1 1-1.5 0 .8.8 0 0 1 1.5 0M19.4 13.2a.8.8 0 1 1-1.5 0 .8.8 0 0 1 1.5 0M19.4 15.9a.8.8 0 1 1-1.5 0 .8.8 0 0 1 1.5 0" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TWITTER__16.js
var TWITTER__16 = '<svg data-id="SVG_TWITTER__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15 3.3c-.5.3-1 .4-1.6.5.5-.4 1-1 1.2-1.6-.5.3-1.2.6-1.8.7a2.9 2.9 0 0 0-4.9 2.6 8.2 8.2 0 0 1-6-3 2.9 2.9 0 0 0 1 3.9c-.5 0-1-.2-1.3-.4 0 1.4 1 2.6 2.3 2.9a2.9 2.9 0 0 1-1.3 0c.3 1.1 1.4 2 2.7 2A5.8 5.8 0 0 1 1 12.1a8.1 8.1 0 0 0 12.6-7.3c.5-.4 1-.9 1.4-1.5" stroke="none" fill-rule="evenodd" fill="currentColor"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/TWITTER__24.js
var TWITTER__24 = '<svg data-id="SVG_TWITTER__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path transform="scale(1.5, 1.5)" vector-effect="non-scaling-stroke" d="M15 3.3c-.5.3-1 .4-1.6.5.5-.4 1-1 1.2-1.6-.5.3-1.2.6-1.8.7a2.9 2.9 0 0 0-4.9 2.6 8.2 8.2 0 0 1-6-3 2.9 2.9 0 0 0 1 3.9c-.5 0-1-.2-1.3-.4 0 1.4 1 2.6 2.3 2.9a2.9 2.9 0 0 1-1.3 0c.3 1.1 1.4 2 2.7 2A5.8 5.8 0 0 1 1 12.1a8.1 8.1 0 0 0 12.6-7.3c.5-.4 1-.9 1.4-1.5" stroke="none" fill-rule="evenodd" fill="currentColor"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/VIEW__16.js
var VIEW__16 = '<svg data-id="SVG_VIEW__16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" stroke-linecap="round" stroke-linejoin="round""><path d="M10.3 8a2.3 2.3 0 1 1-4.6 0 2.3 2.3 0 0 1 4.6 0z"/><path d="M1 8l2.3-2.7a6 6 0 0 1 9.4 0L15 8l-2.3 2.7a6 6 0 0 1-9.4 0L1 8z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/VIEW__24.js
var VIEW__24 = '<svg data-id="SVG_VIEW__24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M15 11.8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/><path d="M2.7 11.8l3-3.6c3.5-4 9-4 12.5 0l3 3.6-3 3.5a8 8 0 0 1-12.4 0l-3-3.6z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/WALLET__16.js
var WALLET__16 = '<svg data-id="SVG_WALLET__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M4.17 5.34h8.95c.83 0 1.5.67 1.5 1.5v7.58H2.88a1.5 1.5 0 0 1-1.5-1.5V4.75c0-.72.5-1.34 1.2-1.47l10.34-2.04v1.9"/><path d="M10.9 9.88c0-.63.51-1.14 1.15-1.14h2.57v2.3h-2.57c-.64 0-1.15-.52-1.15-1.16z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/WALLET__24.js
var WALLET__24 = '<svg data-id="SVG_WALLET__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M6.94 8.04h12.31c.83 0 1.5.67 1.5 1.5v10.5h-16a1.5 1.5 0 0 1-1.5-1.5V6.86c0-.72.5-1.34 1.21-1.48L18.5 2.62v2.5"/><path d="M15.83 14.02c0-.83.68-1.5 1.5-1.5h3.42v3.03h-3.42a1.5 1.5 0 0 1-1.5-1.5v-.03z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/WASHER__16.js
var WASHER__16 = '<svg data-id="SVG_WASHER__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M1 2.2C1 1.56 1.54 1 2.2 1h11.6c.66 0 1.2.55 1.2 1.2v11.6c0 .65-.54 1.2-1.2 1.2H2.2A1.2 1.2 0 0 1 1 13.8V2.2z" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.6 8a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0z" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.47 8a2.45 2.45 0 0 0-1.73-.72c-1.76 0-1.72 1.44-3.48 1.44-.67 0-1.29-.27-1.73-.72" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.45 3.4a1.05 1.05 0 1 1-2.1 0 1.05 1.05 0 0 1 2.1 0" fill="currentColor" stroke="none"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/WASHER__24.js
var WASHER__24 = '<svg data-id="SVG_WASHER__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3.2 4.76c0-.83.67-1.5 1.5-1.5h14.5c.83 0 1.5.67 1.5 1.5v14.48c0 .83-.67 1.5-1.5 1.5H4.7a1.5 1.5 0 0 1-1.5-1.5V4.76z"/><path d="M6.33 5.44a.31.31 0 1 1 0 .63.31.31 0 0 1 0-.63M8.83 5.44a.31.31 0 1 1 0 .63.31.31 0 0 1 0-.63M13.37 5.76h4.37M15.95 14.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"/><path d="M15.81 14.5c-.5-.5-1.17-.8-1.93-.8-1.95 0-1.9 1.6-3.86 1.6-.75 0-1.44-.3-1.93-.8M17.74 8.25H3.84"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/WHEELCHAIR__16.js
var WHEELCHAIR__16 = '<svg data-id="SVG_WHEELCHAIR__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M8.49 2.59a1.52 1.52 0 1 1-3.05 0 1.52 1.52 0 0 1 3.05 0zM7 6.17v3.18h3.78l1.9 2.54h1.9M9.8 6.17H7M10.38 13.05A4.65 4.65 0 1 1 4.52 6.2"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/WHEELCHAIR__24.js
var WHEELCHAIR__24 = '<svg data-id="SVG_WHEELCHAIR__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12.48 4.76a2.01 2.01 0 1 1-4.03 0 2.01 2.01 0 0 1 4.03 0zM10.52 9.5v4.2h4.99l2.52 3.35h2.51M14.22 9.5h-3.7M14.98 18.58a6.15 6.15 0 1 1-7.74-9.04"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/WIFI__16.js
var WIFI__16 = '<svg data-id="SVG_WIFI__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3.31 9.07a5.58 5.58 0 0 1 9.37 0M1 5.55a9.3 9.3 0 0 1 14 0M9.66 12.35a1.66 1.66 0 1 1-3.32 0 1.66 1.66 0 0 1 3.32 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/WIFI__24.js
var WIFI__24 = '<svg data-id="SVG_WIFI__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M7.3 15.08a5.6 5.6 0 0 1 9.4 0M4.99 11.55a9.33 9.33 0 0 1 14.02 0"/><path d="M2.75 8.05a13.03 13.03 0 0 1 9.22-3.8c3.63 0 6.92 1.48 9.28 3.87M13.66 18.37a1.66 1.66 0 1 1-3.32 0 1.66 1.66 0 0 1 3.32 0z"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/YARD__24.js
var YARD__24 = '<svg data-id="SVG_YARD__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M15.65 17.28h5.05l-3.68-4.9h2.45L15.8 7.47h1.84l-3.06-4.3-3.06 4.3h1.83l-1.92 2.57M15.65 17.29v3.38M4.9 12.33v8.34M8.28 12.33v8.34M11.67 12.33v8.34M3.2 14.03h10.16M3.2 18.98h10.16"/></g></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/YOUTUBE__16.js
var YOUTUBE__16 = '<svg data-id="SVG_YOUTUBE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M6.556 9.741V5.807L10.34 7.78 6.556 9.74zm8.308-4.616s-.136-.965-.556-1.39c-.533-.558-1.13-.56-1.403-.593C10.945 3 8.005 3 8.005 3H8s-2.94 0-4.9.142c-.273.032-.87.035-1.403.593-.42.425-.556 1.39-.556 1.39S1 6.258 1 7.39v1.063c0 1.133.14 2.266.14 2.266s.137.965.556 1.39c.533.558 1.233.54 1.545.6 1.12.107 4.761.14 4.761.14s2.943-.004 4.903-.146c.273-.033.87-.036 1.403-.594.42-.425.556-1.39.556-1.39s.14-1.133.14-2.266V7.39c0-1.133-.14-2.266-.14-2.266z" stroke="none" fill-rule="evenodd" fill="currentColor"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/defs/YOUTUBE__24.js
var YOUTUBE__24 = '<svg data-id="SVG_YOUTUBE__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path transform="scale(1.5, 1.5)" vector-effect="non-scaling-stroke" d="M6.556 9.741V5.807L10.34 7.78 6.556 9.74zm8.308-4.616s-.136-.965-.556-1.39c-.533-.558-1.13-.56-1.403-.593C10.945 3 8.005 3 8.005 3H8s-2.94 0-4.9.142c-.273.032-.87.035-1.403.593-.42.425-.556 1.39-.556 1.39S1 6.258 1 7.39v1.063c0 1.133.14 2.266.14 2.266s.137.965.556 1.39c.533.558 1.233.54 1.545.6 1.12.107 4.761.14 4.761.14s2.943-.004 4.903-.146c.273-.033.87-.036 1.403-.594.42-.425.556-1.39.556-1.39s.14-1.133.14-2.266V7.39c0-1.133-.14-2.266-.14-2.266z" stroke="none" fill-rule="evenodd" fill="currentColor"/></svg>';
// CONCATENATED MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ACCOUNT__16", function() { return ACCOUNT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ACCOUNT__24", function() { return ACCOUNT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ADD_CIRCLE__16", function() { return ADD_CIRCLE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ADD_CIRCLE__24", function() { return ADD_CIRCLE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AIR_CONDITIONING__24", function() { return AIR_CONDITIONING__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ALARM__16", function() { return ALARM__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ALARM__24", function() { return ALARM__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ALERT__16", function() { return ALERT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ALERT__24", function() { return ALERT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ALERT_INFO__32", function() { return ALERT_INFO__32; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ALERT_ERROR__32", function() { return ALERT_ERROR__32; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ALERT_TIME__32", function() { return ALERT_TIME__32; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ALERT_SUCCESS__32", function() { return ALERT_SUCCESS__32; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ALERT_WARNING__16", function() { return ALERT_WARNING__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ALERT_WARNING__24", function() { return ALERT_WARNING__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ALERT_WARNING__32", function() { return ALERT_WARNING__32; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ANDROID__16", function() { return ANDROID__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ANDROID__24", function() { return ANDROID__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ARROW_DOWN__16", function() { return ARROW_DOWN__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ARROW_DOWN__24", function() { return ARROW_DOWN__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ARROW_LEFT__16", function() { return ARROW_LEFT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ARROW_LEFT__24", function() { return ARROW_LEFT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ARROW_LEFT__32", function() { return ARROW_LEFT__32; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ARROW_RIGHT__16", function() { return ARROW_RIGHT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ARROW_RIGHT__24", function() { return ARROW_RIGHT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ARROW_RIGHT__32", function() { return ARROW_RIGHT__32; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ARROW_UP__16", function() { return ARROW_UP__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ARROW_UP__24", function() { return ARROW_UP__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ATM__16", function() { return ATM__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ATM__24", function() { return ATM__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ATTACHMENT__16", function() { return ATTACHMENT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ATTACHMENT__24", function() { return ATTACHMENT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BEACH__16", function() { return BEACH__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BEACH__24", function() { return BEACH__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BED_LG__16", function() { return BED_LG__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BED_LG__24", function() { return BED_LG__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BED_SM__16", function() { return BED_SM__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BED_SM__24", function() { return BED_SM__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BIKE__16", function() { return BIKE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BIKE__24", function() { return BIKE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BIRDHOUSE__40", function() { return BIRDHOUSE__40; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BOAT__16", function() { return BOAT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BOAT__24", function() { return BOAT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BOOKMARK__16", function() { return BOOKMARK__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BOOKMARK__24", function() { return BOOKMARK__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BUS__16", function() { return BUS__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BUS__24", function() { return BUS__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CABIN__16", function() { return CABIN__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CABIN__24", function() { return CABIN__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CALENDAR__16", function() { return CALENDAR__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CALENDAR__24", function() { return CALENDAR__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CALENDAR_FILL__16", function() { return CALENDAR_FILL__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CAMERA__16", function() { return CAMERA__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CAMERA__24", function() { return CAMERA__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CAR__16", function() { return CAR__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CAR__24", function() { return CAR__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CARET_UP__16", function() { return CARET_UP__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CARET_DOWN__16", function() { return CARET_DOWN__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CARET_UP__24", function() { return CARET_UP__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CARET_DOWN__24", function() { return CARET_DOWN__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CASTLE__16", function() { return CASTLE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CASTLE__24", function() { return CASTLE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHAT__16", function() { return CHAT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHAT__24", function() { return CHAT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHECK__12", function() { return CHECK__12; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHECK__16", function() { return CHECK__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHECK__24", function() { return CHECK__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHECK_IN__16", function() { return CHECK_IN__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHECK_IN__24", function() { return CHECK_IN__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHECK_OUT__16", function() { return CHECK_OUT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHECK_OUT__24", function() { return CHECK_OUT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_DOWN__12", function() { return CHEVRON_DOWN__12; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_LEFT__12", function() { return CHEVRON_LEFT__12; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_RIGHT__12", function() { return CHEVRON_RIGHT__12; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_UP__12", function() { return CHEVRON_UP__12; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_DOWN__16", function() { return CHEVRON_DOWN__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_LEFT__16", function() { return CHEVRON_LEFT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_RIGHT__16", function() { return CHEVRON_RIGHT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_UP__16", function() { return CHEVRON_UP__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_DOWN__24", function() { return CHEVRON_DOWN__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_LEFT__24", function() { return CHEVRON_LEFT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_RIGHT__24", function() { return CHEVRON_RIGHT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CHEVRON_UP__24", function() { return CHEVRON_UP__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CITY__16", function() { return CITY__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CITY__24", function() { return CITY__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CLEANING__24", function() { return CLEANING__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CLOSE__12", function() { return CLOSE__12; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CLOSE__16", function() { return CLOSE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CLOSE__24", function() { return CLOSE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CLOSE__32", function() { return CLOSE__32; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "COFFEE__16", function() { return COFFEE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "COFFEE__24", function() { return COFFEE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "COMPASS__16", function() { return COMPASS__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "COMPASS__24", function() { return COMPASS__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "COUCH__16", function() { return COUCH__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "COUCH__24", function() { return COUCH__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CREDIT_CARD__16", function() { return CREDIT_CARD__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CREDIT_CARD__24", function() { return CREDIT_CARD__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CRIB__16", function() { return CRIB__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CRIB__24", function() { return CRIB__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CURRENCY_USD__16", function() { return CURRENCY_USD__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CURRENCY_USD__24", function() { return CURRENCY_USD__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CURRENCY_GBP__16", function() { return CURRENCY_GBP__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CURRENCY_GBP__24", function() { return CURRENCY_GBP__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CURRENCY_EURO__16", function() { return CURRENCY_EURO__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CURRENCY_EURO__24", function() { return CURRENCY_EURO__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DASHBOARD__16", function() { return DASHBOARD__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DASHBOARD__24", function() { return DASHBOARD__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DISLIKE__16", function() { return DISLIKE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DISLIKE__24", function() { return DISLIKE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DOCUMENT__16", function() { return DOCUMENT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DOCUMENT__24", function() { return DOCUMENT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DOOR__16", function() { return DOOR__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DOOR__24", function() { return DOOR__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DOWNLOAD__16", function() { return DOWNLOAD__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DOWNLOAD__24", function() { return DOWNLOAD__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DRINK__16", function() { return DRINK__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DRINK__24", function() { return DRINK__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DRYER__16", function() { return DRYER__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DRYER__24", function() { return DRYER__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DVD__16", function() { return DVD__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DVD__24", function() { return DVD__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "EDIT__16", function() { return EDIT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "EDIT__24", function() { return EDIT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "EXPAND__16", function() { return EXPAND__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "EXPAND__24", function() { return EXPAND__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "EXPEDIA_COLOR__24", function() { return EXPEDIA_COLOR__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FACEBOOK__16", function() { return FACEBOOK__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FACEBOOK__24", function() { return FACEBOOK__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FACEBOOK_COLOR__24", function() { return FACEBOOK_COLOR__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FAMILY__16", function() { return FAMILY__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FAMILY__24", function() { return FAMILY__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FILTER__16", function() { return FILTER__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FILTER__24", function() { return FILTER__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FLAG__16", function() { return FLAG__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FLAG__24", function() { return FLAG__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GAME__16", function() { return GAME__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GAME__24", function() { return GAME__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GEAR__16", function() { return GEAR__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GEAR__24", function() { return GEAR__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GLOBE__16", function() { return GLOBE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GLOBE__24", function() { return GLOBE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GOOGLE_COLOR__24", function() { return GOOGLE_COLOR__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GOOGLE_PLUS__16", function() { return GOOGLE_PLUS__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GOOGLE_PLUS__24", function() { return GOOGLE_PLUS__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GRID_LG__16", function() { return GRID_LG__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GRID_LG__24", function() { return GRID_LG__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GRID_SM__16", function() { return GRID_SM__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GRID_SM__24", function() { return GRID_SM__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GRILL__16", function() { return GRILL__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GRILL__24", function() { return GRILL__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GRIP__16", function() { return GRIP__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GRIP__24", function() { return GRIP__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GROUP__16", function() { return GROUP__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GROUP__24", function() { return GROUP__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HANGER__16", function() { return HANGER__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HANGER__24", function() { return HANGER__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HEART__16", function() { return HEART__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HEART__24", function() { return HEART__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HEART_SELECTED__16", function() { return HEART_SELECTED__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HEART_SELECTED__24", function() { return HEART_SELECTED__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HEATER__24", function() { return HEATER__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HOT_TUB__16", function() { return HOT_TUB__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HOT_TUB__24", function() { return HOT_TUB__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HOUSE__16", function() { return HOUSE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HOUSE__24", function() { return HOUSE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "INSTAGRAM__16", function() { return INSTAGRAM__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "INSTAGRAM__24", function() { return INSTAGRAM__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "INSTANT_BOOK__16", function() { return INSTANT_BOOK__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "INSTANT_BOOK__24", function() { return INSTANT_BOOK__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "INFO__16", function() { return INFO__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "INFO__24", function() { return INFO__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "IOS__16", function() { return IOS__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "IOS__24", function() { return IOS__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "INVITE__16", function() { return INVITE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "INVITE__24", function() { return INVITE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "KEY__16", function() { return KEY__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "KEY__24", function() { return KEY__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LANDSCAPE__16", function() { return LANDSCAPE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LANDSCAPE__24", function() { return LANDSCAPE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LIST__16", function() { return LIST__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LIST__24", function() { return LIST__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LINK__16", function() { return LINK__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LINK__24", function() { return LINK__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LINKEDIN__24", function() { return LINKEDIN__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LINKEDIN__16", function() { return LINKEDIN__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOCATION__16", function() { return LOCATION__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOCATION__24", function() { return LOCATION__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOCK__16", function() { return LOCK__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOCK__24", function() { return LOCK__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOCK_FILLED__16", function() { return LOCK_FILLED__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOG_IN__16", function() { return LOG_IN__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOG_IN__24", function() { return LOG_IN__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOG_OUT__16", function() { return LOG_OUT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOG_OUT__24", function() { return LOG_OUT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MAIL__16", function() { return MAIL__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MAIL__24", function() { return MAIL__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MAP__16", function() { return MAP__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MAP__24", function() { return MAP__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MINIMIZE__16", function() { return MINIMIZE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MINIMIZE__24", function() { return MINIMIZE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MINUS__12", function() { return MINUS__12; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MINUS__16", function() { return MINUS__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MINUS__24", function() { return MINUS__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MENU__16", function() { return MENU__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MENU__24", function() { return MENU__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MESSAGE__16", function() { return MESSAGE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MESSAGE__24", function() { return MESSAGE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MOBILE__16", function() { return MOBILE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MOBILE__24", function() { return MOBILE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MONEY__16", function() { return MONEY__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MONEY__24", function() { return MONEY__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MOON__16", function() { return MOON__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MOON__24", function() { return MOON__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MORE__16", function() { return MORE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MORE__24", function() { return MORE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MORE_VERTICAL__24", function() { return MORE_VERTICAL__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NEWS__16", function() { return NEWS__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NEWS__24", function() { return NEWS__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NO_SMOKING__16", function() { return NO_SMOKING__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NO_SMOKING__24", function() { return NO_SMOKING__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NOTIFICATION__16", function() { return NOTIFICATION__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NOTIFICATION__24", function() { return NOTIFICATION__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "OVEN__24", function() { return OVEN__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PERSON__16", function() { return PERSON__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PERSON__24", function() { return PERSON__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PET_PAW__24", function() { return PET_PAW__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PHONE__16", function() { return PHONE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PHONE__24", function() { return PHONE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PICTURE__16", function() { return PICTURE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PICTURE__24", function() { return PICTURE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PINTEREST__16", function() { return PINTEREST__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PINTEREST__24", function() { return PINTEREST__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PLANE__16", function() { return PLANE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PLANE__24", function() { return PLANE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PLAY__16", function() { return PLAY__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PLAY__24", function() { return PLAY__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PLUS__16", function() { return PLUS__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PLUS__24", function() { return PLUS__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "POOL__16", function() { return POOL__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "POOL__24", function() { return POOL__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PREMIER_PARTNER__24", function() { return PREMIER_PARTNER__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PRINT__16", function() { return PRINT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PRINT__24", function() { return PRINT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "QUESTION__16", function() { return QUESTION__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "QUESTION__24", function() { return QUESTION__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "REMOVE_CIRCLE__16", function() { return REMOVE_CIRCLE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "REMOVE_CIRCLE__24", function() { return REMOVE_CIRCLE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "REFRESH__16", function() { return REFRESH__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "REFRESH__24", function() { return REFRESH__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "REPLY__16", function() { return REPLY__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "REPLY__24", function() { return REPLY__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SATELLITE__24", function() { return SATELLITE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SEARCH__16", function() { return SEARCH__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SEARCH__24", function() { return SEARCH__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SEND__16", function() { return SEND__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SEND__24", function() { return SEND__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SHARE__16", function() { return SHARE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SHARE__24", function() { return SHARE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SHARE_ANDROID__16", function() { return SHARE_ANDROID__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SHARE_ANDROID__24", function() { return SHARE_ANDROID__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SHOWER__16", function() { return SHOWER__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SHOWER__24", function() { return SHOWER__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SNOWFLAKE__16", function() { return SNOWFLAKE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SNOWFLAKE__24", function() { return SNOWFLAKE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SORT__16", function() { return SORT__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SORT__24", function() { return SORT__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "STAR__16", function() { return STAR__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "STAR__24", function() { return STAR__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "STOPWATCH__16", function() { return STOPWATCH__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "STOPWATCH__24", function() { return STOPWATCH__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "STROLLER__24", function() { return STROLLER__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SUCCESS__16", function() { return SUCCESS__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SUCCESS__24", function() { return SUCCESS__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SUITCASE__16", function() { return SUITCASE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SUITCASE__24", function() { return SUITCASE__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TAG__16", function() { return TAG__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TAG__24", function() { return TAG__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TOILET__16", function() { return TOILET__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TOILET__24", function() { return TOILET__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TOOLTIP__16", function() { return TOOLTIP__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TOOLTIP_INFO__16", function() { return TOOLTIP_INFO__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TOUR_360__16", function() { return TOUR_360__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TOUR_360__24", function() { return TOUR_360__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TOWEL__16", function() { return TOWEL__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TOWEL__24", function() { return TOWEL__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TRAIN__16", function() { return TRAIN__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TRAIN__24", function() { return TRAIN__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TRASHCAN__16", function() { return TRASHCAN__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TRASHCAN__24", function() { return TRASHCAN__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TREND_ARROW_UP__16", function() { return TREND_ARROW_UP__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TREND_ARROW_DOWN__16", function() { return TREND_ARROW_DOWN__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TREND_ARROW_UP__24", function() { return TREND_ARROW_UP__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TREND_ARROW_DOWN__24", function() { return TREND_ARROW_DOWN__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TUMBLR__16", function() { return TUMBLR__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TUMBLR__24", function() { return TUMBLR__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TV__16", function() { return TV__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TV__24", function() { return TV__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TWITTER__16", function() { return TWITTER__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TWITTER__24", function() { return TWITTER__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "VIEW__16", function() { return VIEW__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "VIEW__24", function() { return VIEW__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "WALLET__16", function() { return WALLET__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "WALLET__24", function() { return WALLET__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "WASHER__16", function() { return WASHER__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "WASHER__24", function() { return WASHER__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "WHEELCHAIR__16", function() { return WHEELCHAIR__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "WHEELCHAIR__24", function() { return WHEELCHAIR__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "WIFI__16", function() { return WIFI__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "WIFI__24", function() { return WIFI__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "YARD__24", function() { return YARD__24; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "YOUTUBE__16", function() { return YOUTUBE__16; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "YOUTUBE__24", function() { return YOUTUBE__24; });



























































































































































































































































































































/***/ }),

/***/ "QzNM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),

/***/ "R6lU":
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),

/***/ "R8mX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ "ROVI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEART__16 = void 0;
var HEART__16 = '<svg data-id="SVG_HEART__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M8 3.98S9.13 2 11.5 2C13.57 2 15 3.7 15 5.73c0 2.86-2.98 4.6-7 8.27-4.02-3.67-7-5.41-7-8.27C1 3.7 2.43 2 4.5 2 6.88 2 8 3.98 8 3.98z"/></svg>';
exports.HEART__16 = HEART__16;

/***/ }),

/***/ "RcS0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rhre":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HelpMenu = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactSvg = __webpack_require__("CWk1");

var _CHEVRON_LEFT__ = __webpack_require__("pAW9");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HelpMenu = exports.HelpMenu = function (_React$Component) {
    _inherits(HelpMenu, _React$Component);

    function HelpMenu() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, HelpMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HelpMenu.__proto__ || Object.getPrototypeOf(HelpMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickBack = function () {
            _this.props.setActiveMenu('tray');
        }, _this.renderItem = function (item, index) {
            if (item.cssClass === 'divider') {
                return _react2.default.createElement('div', { className: 'site-header-divider', key: 'divider-' + index });
            }

            if (item.cssClass === 'nav-header') {
                return _react2.default.createElement(
                    'div',
                    { className: 'site-header-tray__menu-item-header', key: 'header-' + index },
                    item.text
                );
            }

            return _react2.default.createElement(
                'a',
                { className: 'site-header-tray__menu-item-link site-header-tray__menu-item-link--help', 'data-bypass': 'true', href: item.link, key: 'link-' + index },
                item.text
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(HelpMenu, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'site-header-tray__menu' },
                _react2.default.createElement(
                    'div',
                    {
                        className: 'site-header-tray__menu-header',
                        onClick: this.handleClickBack,
                        onKeyPress: this.handleClickBack,
                        role: 'button',
                        tabIndex: 0
                    },
                    _react2.default.createElement(
                        'span',
                        { className: 'site-header-tray__menu-back' },
                        _react2.default.createElement(_reactSvg.SVGIcon, { inlineFlex: true, markup: _CHEVRON_LEFT__.CHEVRON_LEFT__16 }),
                        _react2.default.createElement(
                            'span',
                            { className: 'site-header-tray__menu-item-text' },
                            this.props.help.back
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'site-header-tray__items' },
                    this.props.help.items.map(this.renderItem)
                )
            );
        }
    }]);

    return HelpMenu;
}(_react2.default.Component);
//# sourceMappingURL=HelpMenu.js.map

/***/ }),

/***/ "Rn6f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S7o0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SHWX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T/3Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = __webpack_require__("HfJ9");

__webpack_require__("Ta60");

var _AuthAccountTypes = __webpack_require__("ku0b");

var _AuthAccountTypes2 = _interopRequireDefault(_AuthAccountTypes);

var _ums = __webpack_require__("t0XK");

var _ums2 = _interopRequireDefault(_ums);

var _api = __webpack_require__("cGdw");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mpaasEnv = process.env.MPAAS_ENVIRONMENT;

var ExpediaAuthComponent = function (_Component) {
    _inherits(ExpediaAuthComponent, _Component);

    _createClass(ExpediaAuthComponent, null, [{
        key: 'getExpediaUrl',
        value: function getExpediaUrl() {
            var url = '';
            switch (mpaasEnv) {
                case 'production':
                    url = 'https://www.expedia.com';
                    break;
                case 'test':
                case 'stage':
                default:
                    url = 'https://wwwexpediacom.trunk.sb.karmalab.net';
                    break;
            }
            return url;
        }
    }, {
        key: 'getClientId',
        value: function getClientId() {
            var clientId = '';
            switch (mpaasEnv) {
                case 'production':
                    clientId = '4F4EBDFEF9E04DDCD429EABC47FA4918';
                    break;
                case 'test':
                case 'stage':
                default:
                    clientId = '67DE0287BF47F004473658373E250308';
                    break;
            }
            return clientId;
        }
    }, {
        key: 'getScreenWidth',
        value: function getScreenWidth() {
            var screenWidth = screen.width;
            if (window.innerWidth) {
                screenWidth = window.innerWidth;
            } else if (document.documentElement.clientWidth) {
                screenWidth = document.documentElement.clientWidth;
            }
            return screenWidth;
        }
    }, {
        key: 'getScreenHeight',
        value: function getScreenHeight() {
            var screenHeight = screen.height;
            if (window.innerHeight) {
                screenHeight = window.innerHeight;
            } else if (document.documentElement.clientHeight) {
                screenHeight = document.documentElement.clientHeight;
            }
            return screenHeight;
        }
    }, {
        key: 'propTypes',
        get: function get() {
            return {
                actionLocation: _propTypes2.default.string,
                enableLoading: _propTypes2.default.func,
                disableLoading: _propTypes2.default.func
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                enableLoading: function enableLoading() {},
                disableLoading: function disableLoading() {}
            };
        }
    }]);

    function ExpediaAuthComponent(props) {
        _classCallCheck(this, ExpediaAuthComponent);

        // Window doesn't exist server side so this is needed, we need to pass a valid host name or component will not load in catalyst app!
        var _this = _possibleConstructorReturn(this, (ExpediaAuthComponent.__proto__ || Object.getPrototypeOf(ExpediaAuthComponent)).call(this, props));

        var hostPath = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:8080';
        var redirectUri = hostPath + '/auth/ui/expediaLogin';
        _this.state = {
            expediaWindow: null,
            hostPath: hostPath,
            redirectUri: redirectUri
        };
        _this.onClickExpedia = _this.onClickExpedia.bind(_this);
        _this.displayAppropriateButton = _this.displayAppropriateButton.bind(_this);
        _this.loginAttempt = _this.loginAttempt.bind(_this);
        _this.loginFailure = _this.loginFailure.bind(_this);
        _this.loginSuccess = _this.loginSuccess.bind(_this);
        _this.expediaSignInSignUp = _this.expediaSignInSignUp.bind(_this);
        _this.handleResponse = _this.handleResponse.bind(_this);
        _this.register = _this.register.bind(_this);
        _this.authenticate = _this.authenticate.bind(_this);
        _this.expediaAccessToken = _this.expediaAccessToken.bind(_this);
        if (_this.props.token) {
            _this.register(_this.props.token);
        }
        return _this;
    }

    _createClass(ExpediaAuthComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('successfulRedirect', this.handleResponse);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('successfulRedirect', this.handleResponse);
        }
    }, {
        key: 'loginAttempt',
        value: function loginAttempt() {
            (0, _edapWrapper2.default)().push({
                name: 'login.attempt',
                data: { logintype: 'expedia', loginsource: 'lex', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
        }
    }, {
        key: 'loginSuccess',
        value: function loginSuccess(json) {
            this.setState({ loggedIn: true });
            (0, _edapWrapper2.default)().push({
                name: 'login.success',
                data: { logintype: 'expedia', loginsource: 'lex', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.props.setAuthJson(json);
            this.props.onClose();
        }
    }, {
        key: 'loginFailure',
        value: function loginFailure() {
            this.setState({ loggedIn: false });
            (0, _edapWrapper2.default)().push({
                name: 'login.failure',
                data: { logintype: 'expedia', loginsource: 'lex', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.props.handleError(this.props.lingua.read('error.generic'));
        }
    }, {
        key: 'handleJson',
        value: function handleJson(json, accessToken) {
            if (json) {
                if (_AuthAccountTypes2.default.isNotUndefined(json.authType)) {
                    var SIGNUP = this.checkAuthType(json.authType, _AuthAccountTypes2.default.SIGNUP);
                    if (SIGNUP && _ums2.default.isTCRequired(this.props.site)) {
                        // this is the SignUp scenario, so we need to update the pageName to TermsAndConditions only for the required EU brands
                        var pageName = 'TermsAndConditions';
                        this.props.performBulkPageUpdate(pageName, '', _AuthAccountTypes2.default.EXPEDIA, accessToken);
                        this.props.disableLoading();
                    } else {
                        var umsOnly = this.checkAuthType(json.authType, _AuthAccountTypes2.default.UMS);
                        if (SIGNUP || umsOnly) {
                            this.register(accessToken);
                        } else {
                            this.authenticate(accessToken);
                        }
                    }
                }
            }
        }
    }, {
        key: 'checkAuthType',
        value: function checkAuthType(accountType, loginType) {
            return accountType.some(function (t) {
                return t === loginType;
            });
        }
    }, {
        key: 'expediaAuthStatus',
        value: function expediaAuthStatus(accessToken) {
            var _this2 = this;

            var payload = {
                accessToken: accessToken,
                authType: 'EXPEDIA'
            };

            return new Promise(function (resolve, reject) {
                (0, _api.apiPost)('/auth/aam/v3/token/status', payload).then(function (response) {
                    if (response.status >= 200 && response.status < 400) {
                        response.json().then(function (json) {
                            _this2.handleJson(json, accessToken);
                            return resolve();
                        });
                    }
                }).catch(function (e) {
                    // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                    if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                        _this2.loginFailure();
                    }
                    return reject(e);
                });
            });
        }
    }, {
        key: 'expediaAccessToken',
        value: function expediaAccessToken(code) {
            var _this3 = this;

            var payload = {
                authCode: this.state.redirectUri + ';' + code
            };

            return new Promise(function (resolve, reject) {
                (0, _api.apiPost)('/auth/aam/v3/expedia/token', payload).then(function (response) {
                    if (response.status >= 200 && response.status < 400) {
                        response.json().then(function (json) {
                            _this3.expediaAuthStatus(json.accessToken);
                            return resolve('expedia access token resolved');
                        });
                    }
                }).catch(function (e) {
                    // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                    if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                        _this3.loginFailure();
                    }
                    return reject(e);
                });
            });
        }
    }, {
        key: 'register',
        value: function register(token) {
            var _this4 = this;

            var payload = {
                userName: '',
                secret: token,
                authType: 'EXPEDIA',
                rememberMe: true
            };
            return new Promise(function (resolve, reject) {
                (0, _api.apiPost)('/auth/aam/v3/register', payload).then(function (response) {
                    _this4.checkStatus(response, resolve, reject);
                }).catch(function (e) {
                    return _this4.failLogin(e, reject);
                });
            });
        }
    }, {
        key: 'authenticate',
        value: function authenticate(token) {
            var _this5 = this;

            var payload = {
                'userName': '',
                'authType': 'EXPEDIA',
                'secret': token,
                'rememberMe': true
            };

            return new Promise(function (resolve, reject) {
                (0, _api.apiPost)('/auth/aam/v3/authenticate', payload).then(function (response) {
                    _this5.checkStatus(response, resolve, reject);
                }).catch(function (e) {
                    _this5.failLogin(e, reject);
                });
            });
        }
    }, {
        key: 'failLogin',
        value: function failLogin(e, reject) {
            this.props.disableLoading();
            this.loginFailure();
            return reject(e);
        }
    }, {
        key: 'checkStatus',
        value: function checkStatus(response, resolve, reject) {
            var _this6 = this;

            if (response.status >= 200 && response.status < 400) {
                response.json().then(function (json) {
                    _this6.loginSuccess(json);
                });
                return resolve();
            }
            this.props.disableLoading();
            this.loginFailure();
            return reject();
        }
    }, {
        key: 'onClickExpedia',
        value: function onClickExpedia() {
            this.loginAttempt();
            this.expediaSignInSignUp();
        }
    }, {
        key: 'expediaSignInSignUp',
        value: function expediaSignInSignUp() {
            var expediaAuthWindow = this.openNewSocialAuthWindow(425, 450);
            this.setState({ expediaWindow: expediaAuthWindow });
        }
    }, {
        key: 'handleResponse',
        value: function handleResponse() {
            var code = this.getExpediaCode();
            if (code !== '') {
                this.expediaAccessToken(code);
            } else {
                this.loginFailure();
            }
        }
    }, {
        key: 'getExpediaCode',
        value: function getExpediaCode() {
            var regex = new RegExp('code=([^&#]*)', 'i');
            var params = regex.exec(this.state.expediaWindow.location.search.substring(1));
            return params ? params[1] : '';
        }
    }, {
        key: 'openNewSocialAuthWindow',
        value: function openNewSocialAuthWindow(width, height) {
            var dualScreenLeft = window.screenLeft !== 'undefined' ? window.screenLeft : screen.left;
            var dualScreenTop = window.screenTop !== 'undefined' ? window.screenTop : screen.top;
            var screenWidth = ExpediaAuthComponent.getScreenWidth();
            var screenHeight = ExpediaAuthComponent.getScreenHeight();
            var left = screenWidth / 2 - width / 2 + dualScreenLeft;
            var top = screenHeight / 2 - height / 2 + dualScreenTop;

            return window.open(ExpediaAuthComponent.getExpediaUrl() + '/oauth/authorize?client_id=' + ExpediaAuthComponent.getClientId() + '&response_type=code&redirect_uri=' + this.state.redirectUri, '', 'channelmode=yes,width=' + width + ',height=' + height + ',top=' + top + ', left=' + left, 'resizable=no,toolbar=no,menubar=no,location=no,status=no');
        }
    }, {
        key: 'displayAppropriateButton',
        value: function displayAppropriateButton() {
            if (typeof this.props.authStatus !== 'undefined') {
                return _react2.default.createElement(
                    'div',
                    { className: 'SocialButtons__icon' },
                    _react2.default.createElement(
                        _index.ButtonPrimary,
                        { label: '', block: true, className: 'btn--expedia btn-block', onClick: this.onClickExpedia },
                        _react2.default.createElement(
                            'span',
                            { className: 'Expedia_icon SVGIcon--24px SVGIcon--inline-flex btn--spacing' },
                            _react2.default.createElement(
                                'svg',
                                { xmlns: 'http://www.w3.org/2000/svg', width: '22', height: '34', viewBox: '0 0 22 34', preserveAspectRatio: 'xMaxYMax meet' },
                                _react2.default.createElement(
                                    'g',
                                    { fill: 'none', fillRule: 'evenodd' },
                                    _react2.default.createElement('path', { fill: '#EDB32A', d: 'M14.217 19.438l7.18-12.175c-.118-.336-.25-.666-.4-.99L8.285.905.151 12.55c.03.188.062.377.1.564l13.966 6.324' }),
                                    _react2.default.createElement('path', { fill: '#212D4C',
                                        d: 'M12.847 8.452L12.405 7.2 8.653 2.175l.674-.168 6.47 5.602 3.806-1.091c.447-.115.954-.14 1.342-.137A10.962 10.962 0 0 0 14.67.64C8.954-1.4 2.67 1.592.638 7.32a10.994 10.994 0 0 0-.514 5.338l9.12-3.174 3.603-1.032M21.378 7.459c-.336.213-.826.5-1.315.654l-3.82 1.082-2.55 8.127-.661.215.539-6.208-.302-1.288-3.58 1.015-9.463 2.212a10.947 10.947 0 0 0 7.086 8.096c5.724 2.025 12.012-.946 14.05-6.628.876-2.448.82-5.002.016-7.277'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'Expedia_button_label' },
                            this.props.lingua.read('lex.social.login.with.card.message.expedia')
                        )
                    )
                );
            }
            if (this.props.expediaIconDisplayed === true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'SocialButtons_icon' },
                    _react2.default.createElement(
                        'div',
                        { className: 'small' },
                        _react2.default.createElement(
                            _index.Button,
                            { type: 'button', className: 'btn btn-icon btn-default btn-icon-circle', onClick: this.onClickExpedia, label: '' },
                            _react2.default.createElement(
                                'svg',
                                { xmlns: 'http://www.w3.org/2000/svg', width: '22', height: '34', viewBox: '0 0 22 34', preserveAspectRatio: 'xMaxYMax meet' },
                                _react2.default.createElement(
                                    'g',
                                    { fill: 'none', fillRule: 'evenodd' },
                                    _react2.default.createElement('path', { fill: '#EDB32A',
                                        d: 'M14.217 19.438l7.18-12.175c-.118-.336-.25-.666-.4-.99L8.285.905.151 12.55c.03.188.062.377.1.564l13.966 6.324'
                                    }),
                                    _react2.default.createElement('path', { fill: '#212D4C',
                                        d: 'M12.847 8.452L12.405 7.2 8.653 2.175l.674-.168 6.47 5.602 3.806-1.091c.447-.115.954-.14 1.342-.137A10.962 10.962 0 0 0 14.67.64C8.954-1.4 2.67 1.592.638 7.32a10.994 10.994 0 0 0-.514 5.338l9.12-3.174 3.603-1.032M21.378 7.459c-.336.213-.826.5-1.315.654l-3.82 1.082-2.55 8.127-.661.215.539-6.208-.302-1.288-3.58 1.015-9.463 2.212a10.947 10.947 0 0 0 7.086 8.096c5.724 2.025 12.012-.946 14.05-6.628.876-2.448.82-5.002.016-7.277'
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                'Expedia'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'Expedia_label' },
                            _react2.default.createElement(
                                'label',
                                null,
                                this.props.lingua.read('lex.expedia.icon.label')
                            )
                        )
                    )
                );
            }
            return _react2.default.createElement('div', null);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                this.displayAppropriateButton()
            );
        }
    }]);

    return ExpediaAuthComponent;
}(_react.Component);

exports.default = ExpediaAuthComponent;
//# sourceMappingURL=ExpediaAuthComponent.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lNQ5")))

/***/ }),

/***/ "T/4v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("o6oS");

var _reactFormComponents = __webpack_require__("hyOf");

var _reactButtons = __webpack_require__("WAAH");

var _reactLoadingOverlay = __webpack_require__("/vpO");

var _api = __webpack_require__("cGdw");

var _SocialLoginComponent = __webpack_require__("+/ZX");

var _SocialLoginComponent2 = _interopRequireDefault(_SocialLoginComponent);

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

var _AuthAccountTypes = __webpack_require__("ku0b");

var _AuthAccountTypes2 = _interopRequireDefault(_AuthAccountTypes);

var _ums = __webpack_require__("t0XK");

var _ums2 = _interopRequireDefault(_ums);

var _clientLogger = __webpack_require__("29Zd");

var _clientLogger2 = _interopRequireDefault(_clientLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-undefined */


var validate = __webpack_require__("ZZjE");

var InitialCredentialsComponent = function (_Component) {
    _inherits(InitialCredentialsComponent, _Component);

    function InitialCredentialsComponent(props) {
        _classCallCheck(this, InitialCredentialsComponent);

        var _this = _possibleConstructorReturn(this, (InitialCredentialsComponent.__proto__ || Object.getPrototypeOf(InitialCredentialsComponent)).call(this, props));

        _this.state = {
            emailAddress: '',
            firstName: _this.props.firstName,
            currentPage: _this.props.currentPage,
            errorMsg: '',
            authAccountType: _this.props.authAccountType,
            site: _this.props.site,
            disabled: true
        };

        _this.submitForm = _this.submitForm.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.checkStatus = _this.checkStatus.bind(_this);
        _this.handleJson = _this.handleJson.bind(_this);
        _this.validateEmail = _this.validateEmail.bind(_this);
        _this.checkAuthType = _this.checkAuthType.bind(_this);
        _this.triggerSubmit = _this.triggerSubmit.bind(_this);
        return _this;
    }

    _createClass(InitialCredentialsComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({ disabled: false });
        }
    }, {
        key: 'triggerSubmit',
        value: function triggerSubmit(e) {
            var _this2 = this;

            e.preventDefault();
            this.props.enableLoading();
            setTimeout(function () {
                _this2.submitForm();
            }, 800);
        }
    }, {
        key: 'handleChange',
        value: function handleChange(event) {
            this.setState(_defineProperty({}, event.target.name, event.target.value));
        }
    }, {
        key: 'checkStatus',
        value: function checkStatus(response) {
            switch (response.status) {
                case 200:
                    return response.json();
                default:
                    this.props.disableLoading();
                    this.props.handleError(this.props.lingua.read('error.generic'));
                    _clientLogger2.default.logError('An error has occurred : ' + response.status + ' - ' + response.statusText);
                    break;
            }
            return null;
        }
    }, {
        key: 'checkAuthType',
        value: function checkAuthType(accountType, loginType) {
            return accountType.some(function (t) {
                return t === loginType;
            });
        }
    }, {
        key: 'handleJson',
        value: function handleJson(json) {
            if (json) {
                if (_AuthAccountTypes2.default.isNotUndefined(json.authType)) {
                    var pageName = _AuthAccountTypes2.default.SIGNUP;
                    var status = [];
                    var hasFacebook = this.checkAuthType(json.authType, _AuthAccountTypes2.default.FACEBOOK);
                    var hasGoogle = this.checkAuthType(json.authType, _AuthAccountTypes2.default.GOOGLE);
                    var hasUMS = this.checkAuthType(json.authType, _AuthAccountTypes2.default.UMS);
                    var hasExpedia = this.checkAuthType(json.authType, _AuthAccountTypes2.default.EXPEDIA);

                    if (hasUMS) {
                        pageName = _AuthAccountTypes2.default.UMS;
                        status = [_AuthAccountTypes2.default.UMS];
                    } else {
                        if (hasFacebook) {
                            pageName = _AuthAccountTypes2.default.FACEBOOK;
                            status.push(_AuthAccountTypes2.default.FACEBOOK);
                        }
                        if (hasGoogle) {
                            pageName = _AuthAccountTypes2.default.GOOGLE;
                            status.push(_AuthAccountTypes2.default.GOOGLE);
                        }
                        if (hasExpedia) {
                            pageName = _AuthAccountTypes2.default.EXPEDIA;
                            status.push(_AuthAccountTypes2.default.EXPEDIA);
                        }
                    }
                    if (status.length === 0) {
                        if (_ums2.default.isTCRequired(this.state.site)) {
                            // this is the SignUp scenario, so we need to update the pageName to TermsAndConditions only for the required EU brands
                            pageName = 'TermsAndConditions';
                        }
                        status = [_AuthAccountTypes2.default.SIGNUP];
                    }

                    this.props.performInitialBulkUpdate(pageName, this.state.emailAddress, status);
                }
            }
        }
    }, {
        key: 'submitForm',
        value: function submitForm() {
            if (!this.validateEmail()) {
                return;
            }
            (0, _edapWrapper2.default)().push({
                name: 'generic.click',
                data: { eventcategory: 'lex.auth', eventaction: 'email.submit', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            var statusRequest = {
                'emailAddress': this.state.emailAddress
            };
            // update this so we don't have to worry about rolling back the edge rule in test and stage
            var url = '/auth/aam/v3/status';
            (0, _api.apiPost)(url, statusRequest).then(this.checkStatus).then(this.handleJson);
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail() {
            var constraints = {
                from: {
                    email: true
                }
            };
            var emailAddress = this.state.emailAddress.trim();
            var emailValid = !validate({ from: emailAddress }, constraints);
            if (!emailValid) {
                this.props.disableLoading();
                this.setState({ errorMsg: this.props.lingua.read('lex.email.invalid') });
            }
            return emailValid;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'text-center' },
                _react2.default.createElement(
                    'form',
                    { className: 'EmailField', onSubmit: this.triggerSubmit, noValidate: true },
                    _react2.default.createElement(_reactFormComponents.FormInput, {
                        id: 'lex-emailAddress',
                        name: 'emailAddress',
                        label: this.props.lingua.read('form.placeholder.emailAddress'),
                        value: this.state.emailAddress,
                        onChange: this.handleChange,
                        type: 'email',
                        autoComplete: 'email',
                        errorMsg: this.state.errorMsg,
                        disabled: this.state.disabled,
                        autoFocus: true
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'InitialCredentials' },
                        _react2.default.createElement(
                            _reactButtons.ButtonPrimary,
                            { type: 'submit', id: 'lex-initial-button', label: this.props.lingua.read('lex.initial.button'), disabled: !this.state.emailAddress, className: 'btn-lg' },
                            _react2.default.createElement(_reactLoadingOverlay.LoadingOverlay, { loading: this.props.isWaiting })
                        )
                    )
                ),
                !this.props.multiUserEnabled && _react2.default.createElement(_SocialLoginComponent2.default, {
                    enableLoading: this.props.enableLoading,
                    disableLoading: this.props.disableLoading,
                    lingua: this.props.lingua,
                    handleError: this.props.handleError,
                    locale: this.props.locale,
                    onClose: this.props.onClose,
                    handleLoginSuccess: this.props.handleLoginSuccess,
                    updatePage: this.props.updatePage,
                    performBulkPageUpdate: this.props.performBulkPageUpdate,
                    setAuthJson: this.props.setAuthJson,
                    site: this.props.site,
                    useNewEndpoints: this.props.useNewEndpoints,
                    expediaIconDisplayed: this.props.expediaIconDisplayed
                })
            );
        }
    }]);

    return InitialCredentialsComponent;
}(_react.Component);

exports.default = InitialCredentialsComponent;
//# sourceMappingURL=InitialCredentialsComponent.js.map

/***/ }),

/***/ "TAxY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__("KSGD"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _reactDom = _interopRequireDefault(__webpack_require__("O27J"));

var _reactLifecyclesCompat = __webpack_require__("R8mX");

var _PropTypes = __webpack_require__("QzNM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),

/***/ "TFtr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ta60":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TrFK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TrayMenu = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactSvg = __webpack_require__("CWk1");

var _CHEVRON_RIGHT__ = __webpack_require__("Jq3D");

var _travelerSvgs = __webpack_require__("dlC0");

var _travelerSvgs2 = _interopRequireDefault(_travelerSvgs);

var _Scratchpad = __webpack_require__("g3iV");

var _login = __webpack_require__("yoR0");

var _reactGlobalizationSelector = __webpack_require__("f6Le");

var _reactGlobalizationSelector2 = _interopRequireDefault(_reactGlobalizationSelector);

var _urlSearchParams = __webpack_require__("5mUy");

var _urlSearchParams2 = _interopRequireDefault(_urlSearchParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TrayMenu = exports.TrayMenu = function (_React$PureComponent) {
    _inherits(TrayMenu, _React$PureComponent);

    function TrayMenu() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TrayMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TrayMenu.__proto__ || Object.getPrototypeOf(TrayMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handleChangeGlobalSelector = function (locale, siteUrl, currency) {
            var countryCode = locale.split('_')[1].toLowerCase();
            var origin = void 0;
            var params = void 0;

            if (window && window.location) {
                if (countryCode === _this.props.countryCode) {
                    origin = window.location.protocol + '//' + window.location.host + window.location.pathname;
                    params = new _urlSearchParams2.default(window.location.search);
                } else {
                    origin = siteUrl.replace(/\/$/, '');
                    params = new _urlSearchParams2.default();
                }

                params.set('gx-locale', locale);
                params.set('gx-currency', currency);

                window.location.assign(origin + '?' + params.toString());
            }
        }, _this.handleClickHeaderFlag = function () {
            _this.props.setActiveMenu('flag');
        }, _this.handleClickHelp = function () {
            _this.props.setActiveMenu('help');
        }, _this.handleClickLogin = function (item) {
            return function (event) {
                if (_this.props.login.travelerLoginClickHandler && (0, _login.clickedOnTravelerLogin)(item.cssClass)) {
                    event.stopPropagation();
                    event.preventDefault();
                    _this.props.handleTravelerLogin();
                    _this.props.login.travelerLoginClickHandler();
                }
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TrayMenu, [{
        key: 'render',


        // eslint-disable-next-line complexity
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'site-header-tray__menu' },
                !this.props.traveler && this.props.login && _react2.default.createElement(
                    'div',
                    { className: 'site-header-tray__menu-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'site-header-tray__menu-header-greeting' },
                        this.props.login.greeting
                    ),
                    this.props.flags && _react2.default.createElement(
                        'span',
                        {
                            'aria-label': this.props.flags.items[0].text,
                            className: 'site-header-tray__menu-header-flag',
                            onClick: this.handleClickHeaderFlag,
                            onKeyPress: this.handleClickHeaderFlag,
                            role: 'button',
                            tabIndex: 0
                        },
                        _react2.default.createElement('i', { 'aria-hidden': 'true', className: 'flag-' + this.props.flags.items[0].countryCode })
                    )
                ),
                this.props.feedbackComponent,
                this.props.traveler && _react2.default.createElement(
                    'div',
                    { className: 'site-header-tray__menu-header site-header-tray__menu-header--traveler' },
                    _react2.default.createElement('img', {
                        alt: 'avatar',
                        'aria-hidden': 'true',
                        className: 'site-header-tray__menu-header-avatar img-circle',
                        role: 'presentation',
                        src: this.props.traveler.avatar.image
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'site-header-tray__menu-header-greeting' },
                        this.props.traveler.label
                    ),
                    this.props.flags && _react2.default.createElement(
                        'span',
                        {
                            'aria-label': this.props.flags.items[0].text,
                            className: 'site-header-tray__menu-header-flag',
                            onClick: this.handleClickHeaderFlag,
                            onKeyPress: this.handleClickHeaderFlag,
                            role: 'button',
                            tabIndex: 0
                        },
                        _react2.default.createElement('i', { 'aria-hidden': 'true', className: 'flag-' + this.props.flags.items[0].countryCode })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'site-header-tray__menu-items' },
                    this.props.scratchpad && _react2.default.createElement(
                        'a',
                        { className: 'site-header-tray__menu-item-link', 'data-bypass': 'true', href: this.props.scratchpad.link },
                        _react2.default.createElement(_Scratchpad.Scratchpad, {
                            label: this.props.scratchpad.label,
                            link: this.props.scratchpad.link
                        })
                    ),
                    this.props.traveler && this.props.traveler.items.map(function (item, index) {
                        if (item.cssClass === 'divider') {
                            return _react2.default.createElement('div', { className: 'site-header-divider', key: 'divider-' + index });
                        }

                        // FIXME: This is a hack to identify the inbox item
                        // TODO: Sort out a maintainable way to indentify and handle inbox and inbox data
                        if (item.cssClass === 'se-traveler-inbox') {
                            return _react2.default.createElement(
                                'a',
                                { className: 'site-header-tray__menu-item-link', 'data-bypass': 'true', href: item.link, key: item.link || index },
                                _react2.default.createElement(_reactSvg.SVGIcon, { inlineFlex: true, markup: _travelerSvgs2.default[item.icon] }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'site-header-tray__menu-item-text' },
                                    item.text
                                )
                            );
                        }

                        return _react2.default.createElement(
                            'a',
                            { className: 'site-header-tray__menu-item-link', 'data-bypass': 'true', href: item.link, key: item.link || index },
                            _react2.default.createElement(_reactSvg.SVGIcon, { inlineFlex: true, markup: _travelerSvgs2.default[item.icon] }),
                            _react2.default.createElement(
                                'span',
                                { className: 'site-header-tray__menu-item-text' },
                                item.text
                            )
                        );
                    }),
                    this.props.login && this.props.login.items && this.props.login.items.map(function (item, index) {
                        return _react2.default.createElement(
                            'a',
                            { className: 'site-header-tray__menu-item-link', 'data-bypass': 'true', href: item.link, key: item.link || index, onClick: _this2.handleClickLogin(item) },
                            item.text
                        );
                    }),
                    this.props.help && _react2.default.createElement(
                        'a',
                        {
                            className: 'site-header-tray__menu-item-link site-header-tray__menu-item-link--icon-right',
                            'data-bypass': 'true',
                            onClick: this.handleClickHelp,
                            onKeyPress: this.handleClickHelp,
                            role: 'button',
                            tabIndex: 0
                        },
                        _react2.default.createElement(
                            'span',
                            null,
                            this.props.help.label
                        ),
                        _react2.default.createElement(_reactSvg.SVGIcon, { inline: true, markup: _CHEVRON_RIGHT__.CHEVRON_RIGHT__16 })
                    ),
                    this.props.extraNav && this.props.extraNav.items && this.props.extraNav.items.map(function (item, index) {
                        return _react2.default.createElement(
                            'a',
                            { className: 'site-header-tray__menu-item-link', 'data-bypass': 'true', href: item.link, key: index },
                            item.text
                        );
                    }),
                    this.props.lyp && _react2.default.createElement(
                        'a',
                        { className: 'site-header-tray__menu-item-link', 'data-bypass': 'true', href: this.props.lyp.link },
                        this.props.lyp.text
                    ),
                    (this.props.renderCountryLanguageSelector || this.props.renderCurrencySelector) && _react2.default.createElement(
                        'div',
                        { className: 'site-header-tray__menu-item-globalization-selector' },
                        _react2.default.createElement(_reactGlobalizationSelector2.default, _extends({}, this.props.globalizationSelector, {
                            countryCode: this.props.countryCode,
                            currencyCode: this.props.currencyCode,
                            languageCode: this.props.languageCode,
                            onGlobalSelectorChange: this.handleChangeGlobalSelector,
                            renderCountryLanguageSelector: this.props.renderCountryLanguageSelector,
                            renderCurrencySelector: this.props.renderCurrencySelector
                        }))
                    )
                )
            );
        }
    }]);

    return TrayMenu;
}(_react2.default.PureComponent);
//# sourceMappingURL=TrayMenu.js.map

/***/ }),

/***/ "Trj0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "U8at":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _reactDom = __webpack_require__("O27J");

var _TransitionGroup = _interopRequireDefault(__webpack_require__("tW2u"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "ULDB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InternalTools = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDropdown = __webpack_require__("CVj+");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InternalTools = exports.InternalTools = (_temp = _class = function (_React$Component) {
    _inherits(InternalTools, _React$Component);

    function InternalTools() {
        _classCallCheck(this, InternalTools);

        return _possibleConstructorReturn(this, (InternalTools.__proto__ || Object.getPrototypeOf(InternalTools)).apply(this, arguments));
    }

    _createClass(InternalTools, [{
        key: 'render',
        value: function render() {
            if (!this.props.children) {
                return null;
            }

            var _props = this.props,
                children = _props.children,
                className = _props.className,
                customToggle = _props.customToggle,
                id = _props.id,
                label = _props.label,
                dropdownProps = _objectWithoutProperties(_props, ['children', 'className', 'customToggle', 'id', 'label']);

            className = (0, _classnames2.default)('site-header-nav__dropdown', className);

            /* istanbul ignore else */
            if (!customToggle) {
                customToggle = _react2.default.createElement(
                    'span',
                    {
                        'aria-expanded': 'false',
                        'aria-haspopup': 'true',
                        className: 'site-header-nav__toggle Dropdown__toggle',
                        id: id,
                        role: 'button'
                    },
                    label,
                    ' ',
                    _react2.default.createElement('span', { 'aria-hidden': 'true', className: 'caret' })
                );
            }

            return _react2.default.createElement(
                _reactDropdown.Dropdown,
                _extends({ className: className, customToggle: customToggle, id: id, label: label }, dropdownProps),
                children
            );
        }
    }]);

    return InternalTools;
}(_react2.default.Component), _class.propTypes = {
    className: _propTypes2.default.string,
    customToggle: _propTypes2.default.element,
    dropdownRight: _propTypes2.default.bool,
    id: _propTypes2.default.string,
    label: _propTypes2.default.string
}, _class.defaultProps = {
    dropdownRight: true,
    id: 'site-header__internal-tools',
    label: 'Internal Tools'
}, _temp);
//# sourceMappingURL=InternalTools.js.map

/***/ }),

/***/ "UNM8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * See README.md for full description
 *
 * @module redux-middleware-adapter
 */

var _registeredMiddleware;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var stage = {
    before: 'before',
    after: 'after'
};

var registeredMiddleware = (_registeredMiddleware = {}, _defineProperty(_registeredMiddleware, stage.before, {}), _defineProperty(_registeredMiddleware, stage.after, {}), _registeredMiddleware);

/**
 * middlewareAdapter is applied to the redux store. It is a standard redux middleware.
 * It is invoked after each dispatched action, prior to any reducer being called.
 * middlewareAdapter maintains a map of action types and callbacks. In response
 * to an action, it will invoke each of the callback functions that are
 * associated with that action's type.
 */
var middlewareAdapter = function middlewareAdapter(store) {
    return function (next) {
        return function (action) {
            if (registeredMiddleware[stage.before][action.type]) {
                registeredMiddleware[stage.before][action.type].forEach(function (middleware) {
                    return middleware(store, action);
                });
            }

            var result = next(action);

            if (registeredMiddleware[stage.after][action.type]) {
                registeredMiddleware[stage.after][action.type].reduce(function (_result, middleware) {
                    return middleware(store, action);
                }, result);
            }

            // return the state to follow Redux convention
            return result;
        };
    };
};

/**
 * registerMiddleware takes an actionType and a callback function.
 * When an action of the provided type is dispatched, the callback function will
 * be invoked by the middlewareAdapter.
 * The provided callback function takes 3 parameters, the store and the action.
 * These parameters may be omitted if they are not needed.
 * @param {String} actionType action type string of the action that is dispatched that the function is concerned with
 * @param {func} func middleware function that is listening to the action provided
 * @param {String} callTiming This can be either "before" or "after" and tells middleware adapter to call the middleware function
 * before or after the redux state is updated by the reducers handling the same action type. Default: "before"
 */
var registerMiddleware = function registerMiddleware(actionType, func) {
    var callTiming = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stage.before;

    /* istanbul ignore else */
    if (!registeredMiddleware[callTiming][actionType]) {
        registeredMiddleware[callTiming][actionType] = [];
    }

    // Only push the function on if it doesn't already exist. This protects against having multiple
    // copies of the same function which would happen during server-side initialization.
    if (registeredMiddleware[callTiming][actionType].indexOf(func) === -1) {
        registeredMiddleware[callTiming][actionType].push(func);
    }
};

module.exports = { registerMiddleware: registerMiddleware, middlewareAdapter: middlewareAdapter, registeredMiddleware: registeredMiddleware };
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "UVcR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UVdu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UVf0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__("4JXe"));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__("U8at"));

var _TransitionGroup = _interopRequireDefault(__webpack_require__("tW2u"));

var _Transition = _interopRequireDefault(__webpack_require__("TAxY"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),

/***/ "Vj64":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _HeaderSectionComponent = __webpack_require__("F1Vd");

var _HeaderSectionComponent2 = _interopRequireDefault(_HeaderSectionComponent);

var _TandCComponent = __webpack_require__("/s9T");

var _TandCComponent2 = _interopRequireDefault(_TandCComponent);

var _CalloutCardComponent = __webpack_require__("um2z");

var _CalloutCardComponent2 = _interopRequireDefault(_CalloutCardComponent);

var _ChangePasswordComponent = __webpack_require__("9Orx");

var _ChangePasswordComponent2 = _interopRequireDefault(_ChangePasswordComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangePasswordPageComponent = function (_Component) {
    _inherits(ChangePasswordPageComponent, _Component);

    function ChangePasswordPageComponent(props) {
        _classCallCheck(this, ChangePasswordPageComponent);

        var _this = _possibleConstructorReturn(this, (ChangePasswordPageComponent.__proto__ || Object.getPrototypeOf(ChangePasswordPageComponent)).call(this, props));

        _this.state = {
            error: '',
            errorTitle: ''
        };
        _this.handleError = _this.handleError.bind(_this);
        return _this;
    }

    _createClass(ChangePasswordPageComponent, [{
        key: 'handleError',
        value: function handleError(error) {
            this.setState({ error: error });
        }
    }, {
        key: 'render',
        value: function render() {
            var options = { 'siteName': this.props.siteName };
            var cardContent = _react2.default.createElement(_ChangePasswordComponent2.default, {
                actionLocation: this.props.actionLocation,
                lingua: this.props.lingua,
                service: this.props.service,
                handleError: this.handleError,
                site: this.props.site,
                updatePage: this.props.updatePage,
                ticketId: this.props.ticketId,
                isWaiting: this.props.isWaiting,
                enableLoading: this.props.enableLoading,
                disableLoading: this.props.disableLoading
            });
            return _react2.default.createElement(
                'div',
                { className: 'ChangePasswordPageComponent border-border-color' },
                _react2.default.createElement(_HeaderSectionComponent2.default, { header: this.props.lingua.read('lex.header.password', options) }),
                _react2.default.createElement(_CalloutCardComponent2.default, { content: cardContent, error: this.state.error, errorTitle: this.state.errorTitle }),
                _react2.default.createElement(_TandCComponent2.default, { lingua: this.props.lingua, multiUserEnabled: this.props.multiUserEnabled })
            );
        }
    }]);

    return ChangePasswordPageComponent;
}(_react.Component);

exports.default = ChangePasswordPageComponent;
//# sourceMappingURL=ChangePasswordPageComponent.js.map

/***/ }),

/***/ "Vrhc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vswj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOG_OUT__16 = void 0;
var LOG_OUT__16 = '<svg data-id="SVG_LOG_OUT__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 8H1m3.3 3.2L1 8l3.3-3.2M6.2 1h8v14h-8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
exports.LOG_OUT__16 = LOG_OUT__16;

/***/ }),

/***/ "WAAH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("GiK3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/ButtonBase.css
var esm_ButtonBase = __webpack_require__("y+XB");
var ButtonBase_default = /*#__PURE__*/__webpack_require__.n(esm_ButtonBase);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/ButtonBase.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





/**
 * BaseButton
 *
 */

var ButtonBase_ButtonBase =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ButtonBase, _Component);

  function ButtonBase() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ButtonBase.prototype;

  _proto.render = function render() {
    var _classNames;

    var _this$props = this.props,
        size = _this$props.size,
        inverse = _this$props.inverse,
        block = _this$props.block,
        srOnlyLabel = _this$props.srOnlyLabel,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, ["size", "inverse", "block", "srOnlyLabel", "className"]);

    var buttonClasses = classnames_default()('btn', className, (_classNames = {
      'btn-inverse': inverse,
      'btn-block': block
    }, _classNames["btn-" + size] = size, _classNames));
    var labelClasses = classnames_default()('btn__label', {
      'sr-only': srOnlyLabel
    });

    if (this.props.href) {
      return react_default.a.createElement("a", _extends({
        className: buttonClasses
      }, rest), react_default.a.createElement("span", {
        className: labelClasses
      }, this.props.label), this.props.children);
    }

    return react_default.a.createElement("button", _extends({
      className: buttonClasses
    }, rest), react_default.a.createElement("span", {
      className: labelClasses
    }, this.props.label), this.props.children);
  };

  return ButtonBase;
}(react["Component"]);

ButtonBase_ButtonBase.propTypes = {
  /** Flags for if the button is .btn-block (span the full width of a parent) */
  block: prop_types_default.a.bool,

  /** Flag for if the button is disabled */
  disabled: prop_types_default.a.bool,

  /** If href is specified, the component outputs an <a> tag,
   * otherwise, it is a button tag. */
  href: prop_types_default.a.string,

  /** Flag for if the button is is inverse-styled and receives className .btn-inverse */
  inverse: prop_types_default.a.bool,

  /** The text or html to display on the button, required. */
  label: prop_types_default.a.node.isRequired,

  /** Size variation from Baseline. */
  size: prop_types_default.a.oneOf(['xs', 'sm', 'lg']),

  /** Flag for applying .sr-only class to the button label for Screen Readers */
  srOnlyLabel: prop_types_default.a.bool,

  /** Specify the type of button. One of: 'button'|'submit'|'reset' */
  type: prop_types_default.a.oneOf(['button', 'submit', 'reset'])
};
ButtonBase_ButtonBase.defaultProps = {
  type: 'button'
};
/* harmony default export */ var lib_esm_ButtonBase = (ButtonBase_ButtonBase);
//# sourceMappingURL=ButtonBase.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/Button.css
var Button = __webpack_require__("/roH");
var Button_default = /*#__PURE__*/__webpack_require__.n(Button);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/Button.js
function Button__extends() { Button__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Button__extends.apply(this, arguments); }






function Button_Button(props) {
  var buttonClasses = classnames_default()('btn-default', props.className);
  return react_default.a.createElement(lib_esm_ButtonBase, Button__extends({}, props, {
    className: buttonClasses
  }));
}

Button_Button.propTypes = Button__extends({}, lib_esm_ButtonBase.propTypes);
Button_Button.defaultProps = Button__extends({}, lib_esm_ButtonBase.defaultProps);
/* harmony default export */ var esm_Button = (Button_Button);
//# sourceMappingURL=Button.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/ButtonPrimary.js
function ButtonPrimary__extends() { ButtonPrimary__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ButtonPrimary__extends.apply(this, arguments); }





function ButtonPrimary(props) {
  var buttonClasses = classnames_default()('btn-primary', props.className);
  return react_default.a.createElement(lib_esm_ButtonBase, ButtonPrimary__extends({}, props, {
    className: buttonClasses
  }));
}

ButtonPrimary.propTypes = ButtonPrimary__extends({}, lib_esm_ButtonBase.propTypes);
ButtonPrimary.defaultProps = ButtonPrimary__extends({}, lib_esm_ButtonBase.defaultProps);
/* harmony default export */ var esm_ButtonPrimary = (ButtonPrimary);
//# sourceMappingURL=ButtonPrimary.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/ButtonOverlay.js
function ButtonOverlay__extends() { ButtonOverlay__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ButtonOverlay__extends.apply(this, arguments); }





function ButtonOverlay(props) {
  var buttonClasses = classnames_default()('btn-overlay', props.className);
  return react_default.a.createElement(lib_esm_ButtonBase, ButtonOverlay__extends({}, props, {
    className: buttonClasses
  }));
}

ButtonOverlay.propTypes = ButtonOverlay__extends({}, lib_esm_ButtonBase.propTypes);
ButtonOverlay.defaultProps = ButtonOverlay__extends({}, lib_esm_ButtonBase.defaultProps);
/* harmony default export */ var esm_ButtonOverlay = (ButtonOverlay);
//# sourceMappingURL=ButtonOverlay.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/ButtonLink.js
function ButtonLink__extends() { ButtonLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ButtonLink__extends.apply(this, arguments); }





function ButtonLink(props) {
  var buttonClasses = classnames_default()('btn-link', props.className);
  return react_default.a.createElement(lib_esm_ButtonBase, ButtonLink__extends({}, props, {
    className: buttonClasses
  }));
}

ButtonLink.propTypes = ButtonLink__extends({}, lib_esm_ButtonBase.propTypes);
ButtonLink.defaultProps = ButtonLink__extends({}, lib_esm_ButtonBase.defaultProps);
/* harmony default export */ var esm_ButtonLink = (ButtonLink);
//# sourceMappingURL=ButtonLink.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-svg/lib/esm/index.js
var esm = __webpack_require__("CWk1");
var esm_default = /*#__PURE__*/__webpack_require__.n(esm);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/ButtonIconBase.css
var ButtonIconBase = __webpack_require__("NuNx");
var ButtonIconBase_default = /*#__PURE__*/__webpack_require__.n(ButtonIconBase);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/ButtonIconBase.js
function ButtonIconBase__extends() { ButtonIconBase__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ButtonIconBase__extends.apply(this, arguments); }

function ButtonIconBase__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = ButtonIconBase__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function ButtonIconBase__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ButtonIconBase__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }








var ButtonIconBase_ButtonIcon =
/*#__PURE__*/
function (_Component) {
  ButtonIconBase__inheritsLoose(ButtonIcon, _Component);

  function ButtonIcon() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ButtonIcon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        svgMarkup = _this$props.svgMarkup,
        svgId = _this$props.svgId,
        circle = _this$props.circle,
        className = _this$props.className,
        rest = ButtonIconBase__objectWithoutProperties(_this$props, ["svgMarkup", "svgId", "circle", "className"]);

    var buttonIconClassName = classnames_default()('btn-icon', 'ButtonIcon', className, {
      'btn-icon-circle': circle
    });
    var finalIconMarkup;

    if (svgMarkup) {
      finalIconMarkup = react_default.a.createElement(esm["SVGIcon"], {
        useFill: true,
        className: "flex-center",
        markup: svgMarkup
      });
    } else if (svgId) {
      finalIconMarkup = react_default.a.createElement("span", {
        className: "flex-center"
      }, react_default.a.createElement(esm["SVGIcon"], {
        useFill: true,
        id: svgId
      }));
    }

    return react_default.a.createElement(lib_esm_ButtonBase, ButtonIconBase__extends({
      srOnlyLabel: true,
      className: buttonIconClassName
    }, rest), finalIconMarkup, this.props.children);
  };

  return ButtonIcon;
}(react["Component"]);

ButtonIconBase_ButtonIcon.propTypes = ButtonIconBase__extends({}, lib_esm_ButtonBase.propTypes, {
  /** SVG markup from @homeaway/svg-defs module. Please reference directly from lib/defs/ */
  svgMarkup: prop_types_default.a.string,

  /** ID name of SVG from an SVG Definition block, the xlink:href of the SVG you want. Used in the 'use' tag to grab it's definition from the SVG Definitions */
  svgId: prop_types_default.a.string,

  /** Flag to determine if this component should also have className .btn-icon-circle */
  circle: prop_types_default.a.bool
});
/* harmony default export */ var esm_ButtonIconBase = (ButtonIconBase_ButtonIcon);
//# sourceMappingURL=ButtonIconBase.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/ButtonIcon.js
function ButtonIcon__extends() { ButtonIcon__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ButtonIcon__extends.apply(this, arguments); }





function ButtonIcon_ButtonIcon(props) {
  var buttonClasses = classnames_default()('btn-default', props.className);
  return react_default.a.createElement(esm_ButtonIconBase, ButtonIcon__extends({}, props, {
    className: buttonClasses
  }));
}

ButtonIcon_ButtonIcon.propTypes = ButtonIcon__extends({}, esm_ButtonIconBase.propTypes);
ButtonIcon_ButtonIcon.defaultProps = ButtonIcon__extends({}, esm_ButtonIconBase.defaultProps);
/* harmony default export */ var esm_ButtonIcon = (ButtonIcon_ButtonIcon);
//# sourceMappingURL=ButtonIcon.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/ButtonIconPrimary.js
function ButtonIconPrimary__extends() { ButtonIconPrimary__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ButtonIconPrimary__extends.apply(this, arguments); }





function ButtonIconPrimary(props) {
  var buttonClasses = classnames_default()('btn-primary', props.className);
  return react_default.a.createElement(esm_ButtonIconBase, ButtonIconPrimary__extends({}, props, {
    className: buttonClasses
  }));
}

ButtonIconPrimary.propTypes = ButtonIconPrimary__extends({}, esm_ButtonIconBase.propTypes);
ButtonIconPrimary.defaultProps = ButtonIconPrimary__extends({}, esm_ButtonIconBase.defaultProps);
/* harmony default export */ var esm_ButtonIconPrimary = (ButtonIconPrimary);
//# sourceMappingURL=ButtonIconPrimary.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/ButtonIconOverlay.js
function ButtonIconOverlay__extends() { ButtonIconOverlay__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ButtonIconOverlay__extends.apply(this, arguments); }





function ButtonIconOverlay(props) {
  var buttonClasses = classnames_default()('btn-overlay', props.className);
  return react_default.a.createElement(esm_ButtonIconBase, ButtonIconOverlay__extends({}, props, {
    className: buttonClasses
  }));
}

ButtonIconOverlay.propTypes = ButtonIconOverlay__extends({}, esm_ButtonIconBase.propTypes);
ButtonIconOverlay.defaultProps = ButtonIconOverlay__extends({}, esm_ButtonIconBase.defaultProps);
/* harmony default export */ var esm_ButtonIconOverlay = (ButtonIconOverlay);
//# sourceMappingURL=ButtonIconOverlay.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-buttons/lib/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Button", function() { return esm_Button; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonPrimary", function() { return esm_ButtonPrimary; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonOverlay", function() { return esm_ButtonOverlay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonLink", function() { return esm_ButtonLink; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonIcon", function() { return esm_ButtonIcon; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonIconPrimary", function() { return esm_ButtonIconPrimary; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonIconOverlay", function() { return esm_ButtonIconOverlay; });








//# sourceMappingURL=index.js.map

/***/ }),

/***/ "Wf0s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wgkp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var validate = __webpack_require__("ZZjE");

var PASSWORD_MAX_LENGTH = 32;
var PASSWORD_MIN_LENGTH = 7;

var pwdLengthOptions = {
    min: PASSWORD_MIN_LENGTH,
    max: PASSWORD_MAX_LENGTH
};

var pwdLengthValidationOptions = {
    minimum: PASSWORD_MIN_LENGTH,
    maximum: PASSWORD_MAX_LENGTH,
    message: 'ums.validation.password.length'
};

var validatePasswordConstraint = {
    p: {
        presence: true,
        regex: {
            // ?= is the look ahead char in regex
            // so this is a search ahead to find either
            // a letter character AND a number or
            // a single character in the unicode range
            pattern: '(?=.*?[0-9])(?=.*?[a-zA-Z])|(?=.*?[\u0128-\uFFFF])',
            message: 'ums.validation.password.regex'
        },
        length: pwdLengthValidationOptions
    }
};

// Following is a fix to get regex to work, apparently it's a known issue
validate.validators.regex = function (value, options) {
    var regExp = new RegExp(options.pattern);

    if (!regExp.test(value)) {
        return options.message;
    }
    return null;
};

module.exports = {
    validatePasswordConstraint: validatePasswordConstraint,
    pwdLengthOptions: pwdLengthOptions,
    validate: validate
};
//# sourceMappingURL=password.settings.js.map

/***/ }),

/***/ "XSjK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("GiK3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-transition-group/CSSTransition.js
var CSSTransition = __webpack_require__("4JXe");
var CSSTransition_default = /*#__PURE__*/__webpack_require__.n(CSSTransition);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-loading-overlay/lib/esm/index.js + 2 modules
var esm = __webpack_require__("/vpO");

// EXTERNAL MODULE: ./node_modules/@homeaway/react-svg/lib/esm/index.js
var lib_esm = __webpack_require__("CWk1");
var esm_default = /*#__PURE__*/__webpack_require__.n(lib_esm);

// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/index.js + 313 modules
var svg_defs_lib_esm = __webpack_require__("QnUD");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-modal/lib/esm/ModalStructure.js
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }








/* eslint-disable no-multi-spaces */

var ModalStructure_ModalStructure =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ModalStructure, _Component);

  function ModalStructure(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.handleModalClick = _this.handleModalClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.renderBackdrop = _this.renderBackdrop.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }
  /** The .modal-overlay is class is contained WITHIN the Modal markup itself,
   *  thus we need to manually handle determining if the user is clicking outside
   *  the modal dialog.
   */


  var _proto = ModalStructure.prototype;

  _proto.handleModalClick = function handleModalClick(e) {
    // Do not do anything is we are specifying false for closeOnOutsideClick
    if (this.props.closeOnOutsideClick) {
      // currentTarget here is the `modal` div, which covers the entire screen
      // any clicks on the backdrop will have a target of modal
      // any clicks on the modal itself will have a target of modal-body, model-header, etc
      if (e.target !== e.currentTarget) {
        return;
      }

      e.stopPropagation();
      this.props.onClose();
    }
  } // Helps with iOS specific bug: swiping on header or footer steals some sort of
  // focus that should be on modal-body, thus causing natural scrolling to freeze
  // until modal-body is tapped again
  ;

  _proto.preventTouchMove = function preventTouchMove(e) {
    e.preventDefault();
  };

  _proto.renderBackdrop = function renderBackdrop() {
    return react_default.a.createElement("div", {
      tabIndex: "-1",
      className: "Modal__backdrop"
    });
  };

  _proto.renderModalContent = function renderModalContent() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        closeButton = _this$props.closeButton,
        closeText = _this$props.closeText,
        header = _this$props.header,
        footer = _this$props.footer,
        id = _this$props.id,
        isInstructional = _this$props.isInstructional,
        isLoading = _this$props.isLoading,
        isWorkflow = _this$props.isWorkflow,
        onClose = _this$props.onClose,
        modalBodyRef = _this$props.modalBodyRef,
        title = _this$props.title,
        closeOnEsc = _this$props.closeOnEsc,
        closeOnOutsideClick = _this$props.closeOnOutsideClick,
        isOpen = _this$props.isOpen,
        modalAnimation = _this$props.modalAnimation,
        timeouts = _this$props.timeouts;
    var modalStyles = {
      display: 'block'
    };
    var modalClassName = classnames_default()(className, 'Modal');
    var modalContentClassName = classnames_default()('Modal__content', isInstructional ? 'Modal__content--instructional' : '', isWorkflow ? 'Modal__content--workflow' : '');
    return react_default.a.createElement("div", {
      ref: function ref(c) {
        _this2.dialog = c;
      },
      className: modalClassName,
      id: id,
      style: modalStyles,
      onClick: this.handleModalClick,
      tabIndex: "-1",
      role: "dialog",
      "aria-labelledby": id + "-label",
      "aria-modal": "true"
    }, react_default.a.createElement("div", {
      className: "Modal__dialog"
    }, react_default.a.createElement("div", {
      className: modalContentClassName,
      role: "document"
    }, isLoading && react_default.a.createElement(esm["LoadingOverlay"], null), header && react_default.a.createElement("div", {
      onTouchMove: this.preventTouchMove,
      className: "Modal__header"
    }, closeButton && react_default.a.createElement("button", {
      type: "button",
      onClick: onClose,
      className: "Modal__close-btn",
      "aria-label": closeText
    }, react_default.a.createElement("span", {
      className: "Modal__close-flex",
      "aria-hidden": "true"
    }, react_default.a.createElement(lib_esm["SVGIcon"], {
      markup: svg_defs_lib_esm["CLOSE__16"]
    }))), title && react_default.a.createElement("h4", {
      id: id + "-label",
      className: "Modal__title"
    }, title)), react_default.a.createElement("div", {
      ref: modalBodyRef,
      className: "Modal__body"
    }, children), footer && react_default.a.createElement("div", {
      onTouchMove: this.preventTouchMove,
      className: "Modal__footer"
    }, footer))));
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        closeOnEsc = _this$props2.closeOnEsc,
        closeOnOutsideClick = _this$props2.closeOnOutsideClick,
        isOpen = _this$props2.isOpen,
        modalAnimation = _this$props2.modalAnimation,
        renderBackdrop = _this$props2.renderBackdrop,
        timeouts = _this$props2.timeouts;
    var useModalAnimation = modalAnimation !== 'none';
    return react_default.a.createElement("div", null, renderBackdrop && useModalAnimation && react_default.a.createElement(CSSTransition_default.a, {
      in: isOpen,
      classNames: "Modal__backdrop",
      timeout: {
        enter: timeouts.backdrop.transitionEnterTimeout,
        exit: timeouts.backdrop.transitionExitTimeout
      },
      mountOnEnter: true,
      unmountOnExit: true
    }, this.renderBackdrop()), renderBackdrop && !useModalAnimation && isOpen && this.renderBackdrop(), useModalAnimation && react_default.a.createElement(CSSTransition_default.a, {
      in: isOpen,
      classNames: modalAnimation,
      timeout: {
        enter: timeouts.modal.transitionEnterTimeout,
        exit: timeouts.modal.transitionExitTimeout
      },
      mountOnEnter: true,
      unmountOnExit: true
    }, this.renderModalContent()), !useModalAnimation && isOpen && this.renderModalContent());
  };

  return ModalStructure;
}(react["Component"]);

ModalStructure_ModalStructure.propTypes = {
  /** id attribute for the modal. Used to generate aria-labeledby attributes as well */
  id: prop_types_default.a.string.isRequired,

  /** Flag to determine if the Modal has a close "x" button in the header */
  closeButton: prop_types_default.a.bool,

  /** Screen Reader only text for close button in Modal Header */
  closeText: prop_types_default.a.string.isRequired,

  /** Flag for if the Modal Header is shown */
  header: prop_types_default.a.bool,

  /** The Modal Heading in .modal-title. Used as the label for the modal if provided. */
  title: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.element]),

  /** React Component for Modal footer */
  footer: prop_types_default.a.oneOfType([prop_types_default.a.element, prop_types_default.a.arrayOf(prop_types_default.a.element)]),

  /** Flag to determine if the Modal should display a loading overlay */
  isLoading: prop_types_default.a.bool,

  /** Flag to determine if the Modal should be styled as "instructional" */
  isInstructional: prop_types_default.a.bool,

  /** Flag to determine if the Modal should be styled as "modal-content--workflow" (more compact mobile styling) */
  isWorkflow: prop_types_default.a.bool,

  /** ReactCSSTransitionGroup transitionName for modal animation */
  modalAnimation: prop_types_default.a.oneOf(['modal-from-center', 'modal-from-bottom', 'modal-from-left', 'modal-from-right', 'none']),

  /** Flag to determine if the dark backdrop should be rendered. **/
  renderBackdrop: prop_types_default.a.bool,

  /** Timeout object for transitions */
  timeouts: prop_types_default.a.shape({
    backdrop: prop_types_default.a.shape({
      transitionEnterTimeout: prop_types_default.a.number,
      transitionExitTimeout: prop_types_default.a.number
    }),
    modal: prop_types_default.a.shape({
      transitionEnterTimeout: prop_types_default.a.number,
      transitionExitTimeout: prop_types_default.a.number
    })
  })
};
ModalStructure_ModalStructure.defaultProps = {
  closeButton: null,
  header: null,
  footer: null,
  modalAnimation: 'modal-from-center',
  renderBackdrop: true,
  title: null,
  timeouts: {
    backdrop: {
      transitionEnterTimeout: 250,
      transitionExitTimeout: 250
    },
    modal: {
      transitionEnterTimeout: 350,
      transitionExitTimeout: 350
    }
  }
};
/* harmony default export */ var esm_ModalStructure = (ModalStructure_ModalStructure);
//# sourceMappingURL=ModalStructure.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/a11y-tools/lib/esm/trap-focus.js
var TrapFocus =
/*#__PURE__*/
function () {
  function TrapFocus() {
    this.focusableElements = [];
  }
  /** a11y: create list of focusable items. This could change during component life cycle, so this method should be called again in componentDidUpdate. */


  var _proto = TrapFocus.prototype;

  _proto.determineFocusable = function determineFocusable(container) {
    this.focusableElements = container.querySelectorAll('a[href], area[href], input, select, textarea, button:not([disabled]), [tabindex="0"]');
  };

  _proto.resetFocus = function resetFocus() {
    var firstFocusable = this.focusableElements[0];

    if (this.focusableElements.length >= 1) {
      firstFocusable.focus();
    }
  }
  /** a11y: limit tabbing of elements to those within the container */
  ;

  _proto.handleTabbing = function handleTabbing(e) {
    if (this.focusableElements.length < 1) {
      return false;
    }

    var firstFocusable = this.focusableElements[0];

    if (this.focusableElements.length === 1) {
      e.preventDefault();
      firstFocusable.focus();
      return true;
    }

    var lastFocusable = this.focusableElements[this.focusableElements.length - 1];

    if (e.shiftKey) {
      if (window.document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      }
    } else if (window.document.activeElement === lastFocusable) {
      e.preventDefault();
      firstFocusable.focus();
    }

    return true;
  };

  return TrapFocus;
}();

/* harmony default export */ var trap_focus = (TrapFocus);
//# sourceMappingURL=trap-focus.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/a11y-tools/lib/esm/track-focus.css
var track_focus = __webpack_require__("vF2h");
var track_focus_default = /*#__PURE__*/__webpack_require__.n(track_focus);

// CONCATENATED MODULE: ./node_modules/@homeaway/a11y-tools/lib/esm/track-focus.js


var TrackFocus =
/*#__PURE__*/
function () {
  function TrackFocus() {
    var _this = this;

    var usingKeyboard = false;

    this.preFocus = function (e) {
      usingKeyboard = e.type === 'keydown';
    };

    this.addFocus = function (e) {
      if (usingKeyboard && typeof e.target.classList !== 'undefined') {
        _this.addFocusRelative(e.target);

        e.target.classList.add('focus--keyboard');
      }
    };

    this.addFocusRelative = function (target) {
      if (typeof window !== 'undefined') {
        var position = window.getComputedStyle(target).position;
        var positionRegex = /(absolute|relative|fixed)/;

        if (!positionRegex.test(position)) {
          target.classList.add('focus--relative');
        }
      }
    };

    this.removeFocus = function (e) {
      /* istanbul ignore else */
      if (typeof e.target.classList !== 'undefined') {
        e.target.classList.remove('focus--relative');
        e.target.classList.remove('focus--keyboard');
      }
    };
  }

  var _proto = TrackFocus.prototype;

  _proto.bindEvents = function bindEvents() {
    /* istanbul ignore next */
    if (typeof document !== 'undefined') {
      document.body.addEventListener('keydown', this.preFocus);
      document.body.addEventListener('mousedown', this.preFocus);
      document.body.addEventListener('focusin', this.addFocus);
      document.body.addEventListener('focusout', this.removeFocus);
    }
  };

  _proto.unbindEvents = function unbindEvents() {
    /* istanbul ignore next */
    if (typeof document !== 'undefined') {
      document.body.removeEventListener('keydown', this.preFocus);
      document.body.removeEventListener('mousedown', this.preFocus);
      document.body.removeEventListener('focusin', this.addFocus);
      document.body.removeEventListener('focusout', this.removeFocus);
    }
  };

  return TrackFocus;
}();

/* harmony default export */ var esm_track_focus = (TrackFocus);
//# sourceMappingURL=track-focus.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/a11y-tools/lib/esm/index.js



//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-modal/lib/esm/Modal.css
var esm_Modal = __webpack_require__("q6wk");
var Modal_default = /*#__PURE__*/__webpack_require__.n(esm_Modal);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-modal/lib/esm/Modal-variations.css
var Modal_variations = __webpack_require__("6ihM");
var Modal_variations_default = /*#__PURE__*/__webpack_require__.n(Modal_variations);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-modal/lib/esm/Modal-animations.css
var Modal_animations = __webpack_require__("fjAN");
var Modal_animations_default = /*#__PURE__*/__webpack_require__.n(Modal_animations);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-modal/lib/esm/Modal.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Modal__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }








var KEYCODES = {
  ESCAPE: 27,
  TAB: 9
};
var TIMEOUTS = {
  backdrop: {
    transitionEnterTimeout: 250,
    transitionExitTimeout: 250
  },
  modal: {
    transitionEnterTimeout: 350,
    transitionExitTimeout: 350
  }
};
var STATE_ENUM = {
  OPEN: 1,
  CLOSING: 2
};

var Modal_Modal =
/*#__PURE__*/
function (_Component) {
  Modal__inheritsLoose(Modal, _Component);

  function Modal(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleOpen = function () {
      _this.addBodyClasses();

      if (typeof window !== 'undefined') {
        _this.focusedElementBeforeOpen = window.document.activeElement;

        _this.addListeners();

        _this.trapFocus.determineFocusable(_this.modalStructure.dialog);

        _this.handleFirstFocus();
      }

      if (_this.props.onModalOpen) {
        _this.props.onModalOpen(_this.modalStructure, _this.modalBodyElement);
      }
    };

    _this.handleClose = function () {
      _this.removeBodyClasses();

      if (typeof window !== 'undefined') {
        // ensure that that focusedElementBefore is an element with focus()
        // a11y: return focus to item that was focused before opening modal
        if (_this.focusedElementBeforeOpen && typeof _this.focusedElementBeforeOpen.focus === 'function') {
          _this.focusedElementBeforeOpen.focus();
        }

        _this.removeListeners();
      }

      if (_this.props.onModalClose) {
        _this.props.onModalClose();
      }
    };

    _this.handleFirstFocus = function () {
      _this.modalStructure.dialog.focus();
    };

    _this.resetFocus = function () {
      _this.trapFocus.determineFocusable(_this.modalStructure.dialog);

      _this.trapFocus.resetFocus();
    };

    _this.handleKeydown = function (e) {
      if (e.keyCode === KEYCODES.ESCAPE && _this.props.isOpen) {
        _this.props.onClose();
      } else if (e.keyCode === KEYCODES.TAB) {
        _this.trapFocus.handleTabbing(e);
      }
    };

    _this.addListeners = function () {
      if (typeof window !== 'undefined' && _this.props.closeOnEsc) {
        window.document.addEventListener('keydown', _this.handleKeydown);
      }
    };

    _this.removeListeners = function () {
      if (_this.props.closeOnEsc) {
        window.document.removeEventListener('keydown', _this.handleKeydown);
      }
    };

    _this.setLastPageYOffset = function () {
      window.reactModalLastPageYOffset = window.pageYOffset;
    };

    _this.getLastPageYOffset = function () {
      return window.reactModalLastPageYOffset;
    };

    _this.getBodyDataset = function () {
      var dataSet = window.document.body.dataset.reactModals || '{}';
      var reactModals = JSON.parse(dataSet);
      return reactModals;
    };

    _this.setBodyDataset = function (reactModals) {
      window.document.body.dataset.reactModals = JSON.stringify(reactModals);
    };

    _this.addBodyDataset = function () {
      // Get global modal data
      var reactModals = _this.getBodyDataset(); // Update instance to `OPEN` state


      reactModals[_this.stackId] = STATE_ENUM.OPEN; // Set global modal data

      _this.setBodyDataset(reactModals);
    };

    _this.removeBodyDataset = function () {
      // Get global modal data
      var reactModals = _this.getBodyDataset(); // Update instance to `CLOSING` state.


      reactModals[_this.stackId] = STATE_ENUM.CLOSING; // Set global modal data

      _this.setBodyDataset(reactModals); // While modal is transitioning out, set a timeout to allow for a brief `CLOSING` state.


      setTimeout(function () {
        // Get global modal data
        reactModals = _this.getBodyDataset(); // Remove instance from global modal data if it hasn't been re-opened again

        if (reactModals[_this.stackId] === STATE_ENUM.CLOSING) {
          // Commit delete
          delete reactModals[_this.stackId];

          _this.setBodyDataset(reactModals);
        }
      }, TIMEOUTS.modal.transitionExitTimeout + 10);
    };

    _this.hasModalsOpen = function () {
      if (typeof window !== 'undefined') {
        // Get global modal data
        var reactModals = _this.getBodyDataset(); // Filter global modal data by `OPEN` state


        var reactModalsOpen = Object.keys(reactModals).filter(function (v) {
          return reactModals[v] === STATE_ENUM.OPEN;
        }); // Return true if any modal instance data with `OPEN` state detected.

        return reactModalsOpen.length > 0;
      }

      return false;
    };

    _this.hasModalsClosing = function () {
      if (typeof window !== 'undefined') {
        // Get global modal data
        var reactModals = _this.getBodyDataset(); // Filter global modal data by `CLOSING` state


        var reactModalsOpen = Object.keys(reactModals).filter(function (v) {
          return reactModals[v] === STATE_ENUM.CLOSING;
        }); // Return true if any modal instance data with `CLOSING` state is detected

        return reactModalsOpen.length > 0;
      }

      return false;
    };

    _this.addBodyClasses = function () {
      if (typeof window !== 'undefined') {
        window.document.body.classList.add('body--modal-open'); // If modals aren't already open add necessary CSS classes to document.body element

        if (_this.props.fixedBody && !_this.hasModalsOpen()) {
          // Only store pageYOffset while we don't have fixed-position modal classes
          // attached to body to avoid obscure paint error in mobile Safari when
          // immediately opening another modal (just use previously store value)
          if (!_this.hasModalsClosing()) {
            _this.setLastPageYOffset(); // Set a delay for adding fixed-position CSS classes to body to hide background
            // page jumping from the user.


            setTimeout(_this.addMobileBodyClass, TIMEOUTS.modal.transitionEnterTimeout);
          } else {
            _this.addMobileBodyClass();
          }
        } // Add modal data to global shared state


        _this.addBodyDataset(); // Add modal CSS class to modal element


        _this.addModalBodyParentClasses();
      }
    };

    _this.addMobileBodyClass = function () {
      // UITK-307 - Prevent race condition if addMobileBodyClass called after a close event
      if (_this.hasModalsOpen()) {
        window.document.body.classList.add('body--ios-modal-open');
      }
    };

    _this.removeBodyClasses = function () {
      if (typeof window !== 'undefined') {
        // Remove modal instance from global data
        // (will update state to CLOSING, wait a short delay, then finally remove data)
        _this.removeBodyDataset(); // Remove modal CSS classes from element


        _this.removeModalBodyParentClasses(); // If modals aren't open, remove body CSS classes


        if (!_this.hasModalsOpen()) {
          // return to original opening position, if scrolled on iOS (iOS defect)
          window.document.body.classList.remove('body--modal-open');

          if (_this.props.fixedBody) {
            window.document.body.classList.remove('body--ios-modal-open'); // Scroll to previous pageYOffset when modal first opened

            window.scrollTo(0, _this.getLastPageYOffset());
          }
        }
      }
    };

    _this.openAnimation = false;
    _this.stackId = _this.props.id + "-modal-open";
    _this.focusedElementBeforeOpen = {};
    _this.trapFocus = new trap_focus(); // Initialize global vars

    if (typeof window !== 'undefined') {
      window.reactModalLastPageYOffset = window.reactModalLastPageYOffset || 0;
    }

    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.isOpen) {
      this.handleOpen();
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen !== this.props.isOpen) {
      if (nextProps.isOpen) {
        this.shouldOpen = true;
      } else {
        this.shouldClose = true;
      }
    }
  } // Only update open modals.
  // Child content (footer and children) were causing all modals to update is state is shared
  ;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (nextProps.isOpen === true || this.props.isOpen !== nextProps.isOpen) {
      return true;
    }

    return false;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var callDetermineFocusable = true;

    if (this.shouldOpen) {
      callDetermineFocusable = false;
      this.shouldOpen = false;
      this.handleOpen();
    } else if (this.shouldClose) {
      callDetermineFocusable = false;
      this.shouldClose = false;
      this.handleClose();
    } else if (this.props.scrollTop) {
      this.props.scrollToTop(this.modalBodyElement);
    } // a11y: regenerate list of focusable elements.  Not called for shouldOpen
    // as it is already called in handleOpen().  Not called in shouldClose
    // because -- it should close!


    if (this.modalStructure && this.modalStructure.dialog && callDetermineFocusable) {
      this.trapFocus.determineFocusable(this.modalStructure.dialog);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.isOpen) {
      this.handleClose();
    }
  };

  /**
   * addModalBodyParentClasses()
   * Add CSS classes to modal elements.
   */
  _proto.addModalBodyParentClasses = function addModalBodyParentClasses() {
    var openModalBodies = window.document.querySelectorAll('.Modal__body'); // for loop to handle IE 11

    for (var i = 0; i < openModalBodies.length; i++) {
      if (i !== openModalBodies.length - 1) {
        openModalBodies[i].classList.add('Modal__body--is-modal-parent');
      }
    }
  }
  /**
   * removeModalBodyParentClasses()
   * Removes CSS classes from modal elements.
   */
  ;

  _proto.removeModalBodyParentClasses = function removeModalBodyParentClasses() {
    var openModalBodies = window.document.querySelectorAll('.Modal__body'); // for loop to handle IE 11

    for (var i = 0; i < openModalBodies.length; i++) {
      if (i !== openModalBodies.length - 1) {
        openModalBodies[i].classList.remove('Modal__body--is-modal-parent');
      }
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onModalOpen = _this$props.onModalOpen,
        onModalClose = _this$props.onModalClose,
        scrollTop = _this$props.scrollTop,
        scrollToTop = _this$props.scrollToTop,
        rest = _objectWithoutProperties(_this$props, ["onModalOpen", "onModalClose", "scrollTop", "scrollToTop"]);

    return react_default.a.createElement(esm_ModalStructure, _extends({
      ref: function ref(c) {
        return _this2.modalStructure = c;
      },
      modalBodyRef: function modalBodyRef(el) {
        return _this2.modalBodyElement = el;
      } // eslint-disable-line react/jsx-no-bind
      ,
      timeouts: TIMEOUTS
    }, rest));
  };

  return Modal;
}(react["Component"]);

Modal_Modal.propTypes = _extends({}, esm_ModalStructure.propTypes, {
  /** Flag to determine if the Modal should close on pressing the Esc key. */
  closeOnEsc: prop_types_default.a.bool,

  /** Flag to determine if the Modal should close if you click outside of it. */
  closeOnOutsideClick: prop_types_default.a.bool,

  /** Flag to determine if body should be given a fixed position to stop scroll-behind. */
  fixedBody: prop_types_default.a.bool,

  /** Should the modal display or not. */
  isOpen: prop_types_default.a.bool.isRequired,

  /** Event listener to fire when the Modal has opened. */
  onModalOpen: prop_types_default.a.func,

  /** Event listener to fire when the Modal has closed. */
  onModalClose: prop_types_default.a.func,

  /** Event handler or action that manages changing isOpen to false within your app. */
  onClose: prop_types_default.a.func.isRequired,

  /** A flag for determining if the modal should call scrollToTop function on property update. */
  scrollTop: prop_types_default.a.bool,

  /** Function to be called when scrollTop is true and modal properties update. */
  scrollToTop: prop_types_default.a.func
});
Modal_Modal.defaultProps = _extends({}, esm_ModalStructure.defaultProps, {
  closeButton: true,
  closeOnEsc: true,
  closeOnOutsideClick: true,
  closeText: 'Close',
  fixedBody: true,
  header: true,
  isInstructional: false,
  isLoading: false,
  isOpen: false,
  modalAnimation: 'modal-from-center',
  scrollTop: false,
  scrollToTop: function scrollToTop() {}
});
/* harmony default export */ var lib_esm_Modal = (Modal_Modal);
//# sourceMappingURL=Modal.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-modal/lib/esm/ScrollableModal.js
function ScrollableModal__extends() { ScrollableModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ScrollableModal__extends.apply(this, arguments); }

function ScrollableModal__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = ScrollableModal__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function ScrollableModal__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ScrollableModal__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var ScrollableModal_ScrollableModal =
/*#__PURE__*/
function (_Component) {
  ScrollableModal__inheritsLoose(ScrollableModal, _Component);

  function ScrollableModal() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.scrollToCssSelector = function (selector, modalBodyElement) {
      var _this$props = _this.props,
          pauseBeforeScroll = _this$props.pauseBeforeScroll,
          scrollDuration = _this$props.scrollDuration,
          scrollTo = _this$props.scrollTo;
      setTimeout(function () {
        var modalRect = modalBodyElement.getClientRects();
        var element = window.document.querySelector(".Modal__body " + selector);

        if (element) {
          var elementRect = element.getClientRects();
          var newTop = elementRect['0'].top - modalRect['0'].top;
          scrollTo(modalBodyElement, newTop, scrollDuration);
        }
      }, pauseBeforeScroll);
    };

    _this.scrollOnOpen = function (modalStructure, modalBodyElement) {
      var _this$props2 = _this.props,
          scrollSelector = _this$props2.scrollSelector,
          onModalOpen = _this$props2.onModalOpen;

      if (onModalOpen) {
        onModalOpen();
      }

      if (scrollSelector) {
        _this.scrollToCssSelector(scrollSelector, modalBodyElement);
      }
    };

    _this.scrollToTopOfModal = function (modalBodyElement) {
      var _this$props3 = _this.props,
          scrollToTop = _this$props3.scrollToTop,
          scrollDuration = _this$props3.scrollDuration;
      scrollToTop(modalBodyElement, 0, scrollDuration);
    };

    return _this;
  }

  var _proto = ScrollableModal.prototype;

  _proto.render = function render() {
    var _this$props4 = this.props,
        renderModalContent = _this$props4.renderModalContent,
        scrollTo = _this$props4.scrollTo,
        scrollToTop = _this$props4.scrollToTop,
        scrollDuration = _this$props4.scrollDuration,
        scrollSelector = _this$props4.scrollSelector,
        onModalOpen = _this$props4.onModalOpen,
        pauseBeforeScroll = _this$props4.pauseBeforeScroll,
        rest = ScrollableModal__objectWithoutProperties(_this$props4, ["renderModalContent", "scrollTo", "scrollToTop", "scrollDuration", "scrollSelector", "onModalOpen", "pauseBeforeScroll"]);

    return react_default.a.createElement(lib_esm_Modal, ScrollableModal__extends({
      onModalOpen: this.scrollOnOpen,
      scrollToTop: this.scrollToTopOfModal,
      isWorkflow: true
    }, rest), renderModalContent());
  };

  return ScrollableModal;
}(react["Component"]);

ScrollableModal_ScrollableModal.propTypes = ScrollableModal__extends({}, lib_esm_Modal.propTypes, {
  /** The time in ms that the modal will pause after open before initiating scroll. */
  pauseBeforeScroll: prop_types_default.a.number,

  /** Duration of scroll in ms. */
  scrollDuration: prop_types_default.a.number,

  /** A CSS selector that finds the body element to scroll to. */
  scrollSelector: prop_types_default.a.string,

  /** Function that renders passed in modal jsx content. */
  renderModalContent: prop_types_default.a.func,

  /** Function to be called when the modal opens. */
  onModalOpen: prop_types_default.a.func,

  /** Function that initiates a scroll to the scrollSelector element. */
  scrollTo: prop_types_default.a.func
});
ScrollableModal_ScrollableModal.defaultProps = ScrollableModal__extends({}, lib_esm_Modal.defaultProps, {
  pauseBeforeScroll: 500,
  scrollDuration: 1000,
  scrollSelector: '',
  renderModalContent: function renderModalContent() {},
  onModalOpen: function onModalOpen() {},
  scrollTo: function scrollTo() {}
});
/* harmony default export */ var esm_ScrollableModal = (ScrollableModal_ScrollableModal);
//# sourceMappingURL=ScrollableModal.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-modal/lib/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Modal", function() { return lib_esm_Modal; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ScrollableModal", function() { return esm_ScrollableModal; });


/* harmony default export */ var react_modal_lib_esm = __webpack_exports__["default"] = (lib_esm_Modal);

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "Xjo9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ygqm":
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__("xXc5")

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),

/***/ "ZGnZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactButtons = __webpack_require__("WAAH");

var _GOOGLE_COLOR__ = __webpack_require__("C+pt");

var _reactSvg = __webpack_require__("CWk1");

var _api = __webpack_require__("cGdw");

var _reactLoadScript = __webpack_require__("gkR1");

var _reactLoadScript2 = _interopRequireDefault(_reactLoadScript);

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clientLogger = __webpack_require__("29Zd");

var _clientLogger2 = _interopRequireDefault(_clientLogger);

var _AuthAccountTypes = __webpack_require__("ku0b");

var _AuthAccountTypes2 = _interopRequireDefault(_AuthAccountTypes);

var _ums = __webpack_require__("t0XK");

var _ums2 = _interopRequireDefault(_ums);

__webpack_require__("6pa0");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleAuthComponent = function (_Component) {
    _inherits(GoogleAuthComponent, _Component);

    _createClass(GoogleAuthComponent, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                actionLocation: _propTypes2.default.string,
                enableLoading: _propTypes2.default.func,
                disableLoading: _propTypes2.default.func
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                enableLoading: function enableLoading() {},
                disableLoading: function disableLoading() {}
            };
        }
    }]);

    function GoogleAuthComponent(props) {
        _classCallCheck(this, GoogleAuthComponent);

        var _this = _possibleConstructorReturn(this, (GoogleAuthComponent.__proto__ || Object.getPrototypeOf(GoogleAuthComponent)).call(this, props));

        _this.onClickGoogle = _this.onClickGoogle.bind(_this);
        _this.authenticate = _this.authenticate.bind(_this);
        _this.register = _this.register.bind(_this);
        _this.loginAttempt = _this.loginAttempt.bind(_this);
        _this.loginFailure = _this.loginFailure.bind(_this);
        _this.loginSuccess = _this.loginSuccess.bind(_this);
        _this.handleScriptError = _this.handleScriptError.bind(_this);
        _this.handleScriptLoad = _this.handleScriptLoad.bind(_this);
        _this.displayAppropriateButton = _this.displayAppropriateButton.bind(_this);
        _this.googleAuthStatus = _this.googleAuthStatus.bind(_this);
        _this.checkStatus = _this.checkStatus.bind(_this);
        _this.displayGoogleLabel = _this.displayGoogleLabel.bind(_this);
        if (_this.props.token) {
            _this.register(_this.props.token);
        }
        return _this;
    }

    _createClass(GoogleAuthComponent, [{
        key: 'loginSuccess',
        value: function loginSuccess(json) {
            this.setState({ loggedIn: true });
            (0, _edapWrapper2.default)().push({
                name: 'login.success',
                data: { logintype: 'google', loginsource: 'lex', publicuuid: json.publicUuid, actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.props.setAuthJson(json);
            this.props.onClose();
        }
    }, {
        key: 'loginFailure',
        value: function loginFailure() {
            this.setState({ loggedIn: false });
            (0, _edapWrapper2.default)().push({
                name: 'login.failure',
                data: { logintype: 'google', loginsource: 'lex', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.props.handleError(this.props.lingua.read('error.generic'));
        }
    }, {
        key: 'loginAttempt',
        value: function loginAttempt() {
            (0, _edapWrapper2.default)().push({
                name: 'login.attempt',
                data: { logintype: 'google', loginsource: 'lex', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
        }
    }, {
        key: 'handleJson',
        value: function handleJson(json, user) {
            if (json) {
                if (_AuthAccountTypes2.default.isNotUndefined(json.authType)) {
                    var SIGNUP = this.checkAuthType(json.authType, _AuthAccountTypes2.default.SIGNUP);
                    if (SIGNUP && _ums2.default.isTCRequired(this.props.site)) {
                        var emailAddress = user.getBasicProfile().getEmail();
                        // this is the SignUp scenario, so we need to update the pageName to TermsAndConditions only for the required EU brands
                        var pageName = 'TermsAndConditions';
                        this.props.performBulkPageUpdate(pageName, emailAddress, _AuthAccountTypes2.default.GOOGLE, user);
                        this.props.disableLoading();
                    } else {
                        var umsOnly = this.checkAuthType(json.authType, _AuthAccountTypes2.default.UMS);
                        if (SIGNUP || umsOnly) {
                            this.register(user);
                        } else {
                            this.authenticate(user);
                        }
                    }
                }
            }
        }
    }, {
        key: 'checkAuthType',
        value: function checkAuthType(accountType, loginType) {
            return accountType.some(function (t) {
                return t === loginType;
            });
        }
    }, {
        key: 'googleAuthStatus',
        value: function googleAuthStatus(user) {
            var _this2 = this;

            var payload = {
                accessToken: user.getAuthResponse().id_token,
                authType: 'GOOGLE'
            };

            return new Promise(function (resolve, reject) {
                (0, _api.apiPost)('/auth/aam/v3/token/status', payload).then(function (response) {
                    if (response.status >= 200 && response.status < 400) {
                        response.json().then(function (json) {
                            _this2.handleJson(json, user);
                            return resolve();
                        });
                    }
                }).catch(function (e) {
                    // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                    if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                        _this2.loginFailure();
                    }
                    return reject(e);
                });
            });
        }
    }, {
        key: 'authenticate',
        value: function authenticate(user) {
            var _this3 = this;

            if (this.props.useNewEndpoints) {
                var emailAddress = user.getBasicProfile().getEmail();
                var payload = {
                    'userName': emailAddress,
                    'authType': 'GOOGLE',
                    'secret': user.getAuthResponse().id_token,
                    'rememberMe': true
                };

                return new Promise(function (resolve, reject) {
                    (0, _api.apiPost)('/auth/aam/v3/authenticate', payload).then(function (response) {
                        _this3.checkStatus(response, resolve, reject);
                        return resolve();
                    }).catch(function (e) {
                        return _this3.failLogin(e, reject);
                    });
                });
            }
            return this.register(user);
        }
    }, {
        key: 'register',
        value: function register(user) {
            var _this4 = this;

            var emailAddress = user.getBasicProfile().getEmail();
            var token = user.getAuthResponse().id_token;
            if (this.props.useNewEndpoints) {
                var _payload = {
                    userName: emailAddress,
                    secret: token,
                    authType: 'GOOGLE',
                    rememberMe: true
                };
                return new Promise(function (resolve, reject) {
                    (0, _api.apiPost)('/auth/aam/v3/register', _payload).then(function (response) {
                        _this4.checkStatus(response, resolve, reject);
                        return resolve();
                    }).catch(function (e) {
                        return _this4.failLogin(e, reject);
                    });
                });
            }
            var payload = {
                emailAddress: emailAddress,
                createTicketGrantingTicket: true,
                service: window.location.href,
                oAuthToken: token,
                oAuthType: 'GOOGLE',
                tmDeviceIdKey: '00000000-0000-0000-0000-000000000000'
            };
            return new Promise(function (resolve, reject) {
                (0, _api.apiPost)('/auth/v2/authenticate', payload).then(function (response) {
                    _this4.checkStatus(response, resolve, reject);
                }).catch(function (e) {
                    return _this4.failLogin(e, reject);
                });
            });
        }
    }, {
        key: 'checkStatus',
        value: function checkStatus(response, resolve, reject) {
            var _this5 = this;

            if (response.status >= 200 && response.status < 400) {
                response.json().then(function (json) {
                    _this5.loginSuccess(json);
                });
                return resolve();
            }
            this.props.disableLoading();
            this.loginFailure();
            return reject();
        }
    }, {
        key: 'failLogin',
        value: function failLogin(e, reject) {
            this.props.disableLoading();
            this.loginFailure();
            return reject(e);
        }
    }, {
        key: 'displayGoogleLabel',
        value: function displayGoogleLabel() {
            if (this.props.expediaIconDisplayed === true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'Google_Label' },
                    _react2.default.createElement(
                        'label',
                        null,
                        this.props.lingua.read('lex.google.icon.label')
                    )
                );
            }
            return _react2.default.createElement('div', null);
        }
    }, {
        key: 'displayAppropriateButton',
        value: function displayAppropriateButton() {
            if (typeof this.props.authStatus !== 'undefined') {
                return _react2.default.createElement(
                    'div',
                    { className: 'SocialButtons__icon' },
                    _react2.default.createElement(
                        _reactButtons.ButtonPrimary,
                        { label: '', className: 'btn--google btn-block', onClick: this.onClickGoogle },
                        _react2.default.createElement(_reactSvg.SVGIcon, { className: 'btn--spacing', inlineFlex: true, markup: _GOOGLE_COLOR__.GOOGLE_COLOR__24 }),
                        _react2.default.createElement(
                            'span',
                            null,
                            this.props.lingua.read('lex.social.login.with.card.message.google')
                        )
                    )
                );
            }
            return _react2.default.createElement(
                'div',
                { className: 'small' },
                _react2.default.createElement(_reactButtons.ButtonIcon, { circle: true, svgMarkup: _GOOGLE_COLOR__.GOOGLE_COLOR__24, onClick: this.onClickGoogle, label: 'Google' }),
                this.displayGoogleLabel()
            );
        }
    }, {
        key: 'onClickGoogle',
        value: function onClickGoogle() {
            var _this6 = this;

            this.loginAttempt();
            var auth = void 0;
            if (window.gapi) {
                try {
                    auth = window.gapi.auth2.getAuthInstance();
                } catch (error) {
                    _clientLogger2.default.logError('An error has occurred while getting auth instance: ' + error);
                }
                if (!auth) {
                    return new Promise(function (resolve, reject) {
                        reject('no auth');
                    });
                }
                /* If the user is signed in, attempt to
                 register them, otherwise sign in */
                if (auth.isSignedIn.get()) {
                    return auth.signIn().then(function (user) {
                        _this6.props.enableLoading();
                        return _this6.googleAuthStatus(user);
                    }).catch(function (e) {
                        // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                        if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                            _this6.loginFailure();
                        }
                    });
                }
                return auth.signIn({
                    scope: 'https://www.googleapis.com/auth/plus.login'
                }).then(function (user) {
                    _this6.props.enableLoading();
                    return _this6.googleAuthStatus(user);
                }).catch(function (e) {
                    // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                    if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                        _this6.loginFailure();
                    }
                });
            }
            this.props.disableLoading();
            return new Promise(function (resolve, reject) {
                _this6.loginFailure();
                reject('no gapi');
            });
        }
    }, {
        key: 'handleScriptError',
        value: function handleScriptError() {
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: {
                    eventaction: 'lexGoogleAuth.googleScriptError',
                    eventcategory: 'lexGoogleAuth',
                    actionlocation: this.props.actionLocation
                }
            });
        }
    }, {
        key: 'handleScriptLoad',
        value: function handleScriptLoad() {
            var _this7 = this;

            /* istanbul ignore next */
            window.gapi.load('auth2', function () {
                window.gapi.auth2.init({
                    client_id: '42464624060-9dvu968n052patjorlqk96iq0ucbmrjs.apps.googleusercontent.com'
                }).then(function () {
                    (0, _edapWrapper2.default)().push({
                        name: 'generic.event',
                        data: {
                            eventaction: 'lexGoogleAuth.googleScriptLoad',
                            eventcategory: 'lexGoogleAuth',
                            actionlocation: _this7.props.actionLocation
                        }
                    });
                }, function (error) {
                    _clientLogger2.default.logError('An error has occurred while initializing google script: ' + error.details);
                });
            }, function (error) {
                _clientLogger2.default.logError('An error has occurred while loading google script: ' + error);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactLoadScript2.default, {
                    url: 'https://apis.google.com/js/platform.js',
                    onError: this.handleScriptError,
                    onLoad: this.handleScriptLoad
                }),
                this.displayAppropriateButton()
            );
        }
    }]);

    return GoogleAuthComponent;
}(_react.Component);

exports.default = GoogleAuthComponent;
//# sourceMappingURL=GoogleAuthComponent.js.map

/***/ }),

/***/ "ZULV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHEVRON_LEFT__12 = void 0;
var CHEVRON_LEFT__12 = '<svg data-id="SVG_CHEVRON_LEFT__12" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M8 11L3 6l5-5"/></svg>';
exports.CHEVRON_LEFT__12 = CHEVRON_LEFT__12;

/***/ }),

/***/ "ZZjE":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/*!
 * validate.js 0.12.0
 *
 * (c) 2013-2017 Nicklas Ansman, 2013 Wrapp
 * Validate.js may be freely distributed under the MIT license.
 * For all details and documentation:
 * http://validatejs.org/
 */

(function(exports, module, define) {
  "use strict";

  // The main function that calls the validators specified by the constraints.
  // The options are the following:
  //   - format (string) - An option that controls how the returned value is formatted
  //     * flat - Returns a flat array of just the error messages
  //     * grouped - Returns the messages grouped by attribute (default)
  //     * detailed - Returns an array of the raw validation data
  //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
  //
  // Please note that the options are also passed to each validator.
  var validate = function(attributes, constraints, options) {
    options = v.extend({}, v.options, options);

    var results = v.runValidations(attributes, constraints, options)
      , attr
      , validator;

    if (results.some(function(r) { return v.isPromise(r.error); })) {
      throw new Error("Use validate.async if you want support for promises");
    }
    return validate.processValidationResults(results, options);
  };

  var v = validate;

  // Copies over attributes from one or more sources to a single destination.
  // Very much similar to underscore's extend.
  // The first argument is the target object and the remaining arguments will be
  // used as sources.
  v.extend = function(obj) {
    [].slice.call(arguments, 1).forEach(function(source) {
      for (var attr in source) {
        obj[attr] = source[attr];
      }
    });
    return obj;
  };

  v.extend(validate, {
    // This is the version of the library as a semver.
    // The toString function will allow it to be coerced into a string
    version: {
      major: 0,
      minor: 12,
      patch: 0,
      metadata: null,
      toString: function() {
        var version = v.format("%{major}.%{minor}.%{patch}", v.version);
        if (!v.isEmpty(v.version.metadata)) {
          version += "+" + v.version.metadata;
        }
        return version;
      }
    },

    // Below is the dependencies that are used in validate.js

    // The constructor of the Promise implementation.
    // If you are using Q.js, RSVP or any other A+ compatible implementation
    // override this attribute to be the constructor of that promise.
    // Since jQuery promises aren't A+ compatible they won't work.
    Promise: typeof Promise !== "undefined" ? Promise : /* istanbul ignore next */ null,

    EMPTY_STRING_REGEXP: /^\s*$/,

    // Runs the validators specified by the constraints object.
    // Will return an array of the format:
    //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
    runValidations: function(attributes, constraints, options) {
      var results = []
        , attr
        , validatorName
        , value
        , validators
        , validator
        , validatorOptions
        , error;

      if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) {
        attributes = v.collectFormValues(attributes);
      }

      // Loops through each constraints, finds the correct validator and run it.
      for (attr in constraints) {
        value = v.getDeepObjectValue(attributes, attr);
        // This allows the constraints for an attribute to be a function.
        // The function will be called with the value, attribute name, the complete dict of
        // attributes as well as the options and constraints passed in.
        // This is useful when you want to have different
        // validations depending on the attribute value.
        validators = v.result(constraints[attr], value, attributes, attr, options, constraints);

        for (validatorName in validators) {
          validator = v.validators[validatorName];

          if (!validator) {
            error = v.format("Unknown validator %{name}", {name: validatorName});
            throw new Error(error);
          }

          validatorOptions = validators[validatorName];
          // This allows the options to be a function. The function will be
          // called with the value, attribute name, the complete dict of
          // attributes as well as the options and constraints passed in.
          // This is useful when you want to have different
          // validations depending on the attribute value.
          validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);
          if (!validatorOptions) {
            continue;
          }
          results.push({
            attribute: attr,
            value: value,
            validator: validatorName,
            globalOptions: options,
            attributes: attributes,
            options: validatorOptions,
            error: validator.call(validator,
                value,
                validatorOptions,
                attr,
                attributes,
                options)
          });
        }
      }

      return results;
    },

    // Takes the output from runValidations and converts it to the correct
    // output format.
    processValidationResults: function(errors, options) {
      errors = v.pruneEmptyErrors(errors, options);
      errors = v.expandMultipleErrors(errors, options);
      errors = v.convertErrorMessages(errors, options);

      var format = options.format || "grouped";

      if (typeof v.formatters[format] === 'function') {
        errors = v.formatters[format](errors);
      } else {
        throw new Error(v.format("Unknown format %{format}", options));
      }

      return v.isEmpty(errors) ? undefined : errors;
    },

    // Runs the validations with support for promises.
    // This function will return a promise that is settled when all the
    // validation promises have been completed.
    // It can be called even if no validations returned a promise.
    async: function(attributes, constraints, options) {
      options = v.extend({}, v.async.options, options);

      var WrapErrors = options.wrapErrors || function(errors) {
        return errors;
      };

      // Removes unknown attributes
      if (options.cleanAttributes !== false) {
        attributes = v.cleanAttributes(attributes, constraints);
      }

      var results = v.runValidations(attributes, constraints, options);

      return new v.Promise(function(resolve, reject) {
        v.waitForResults(results).then(function() {
          var errors = v.processValidationResults(results, options);
          if (errors) {
            reject(new WrapErrors(errors, options, attributes, constraints));
          } else {
            resolve(attributes);
          }
        }, function(err) {
          reject(err);
        });
      });
    },

    single: function(value, constraints, options) {
      options = v.extend({}, v.single.options, options, {
        format: "flat",
        fullMessages: false
      });
      return v({single: value}, {single: constraints}, options);
    },

    // Returns a promise that is resolved when all promises in the results array
    // are settled. The promise returned from this function is always resolved,
    // never rejected.
    // This function modifies the input argument, it replaces the promises
    // with the value returned from the promise.
    waitForResults: function(results) {
      // Create a sequence of all the results starting with a resolved promise.
      return results.reduce(function(memo, result) {
        // If this result isn't a promise skip it in the sequence.
        if (!v.isPromise(result.error)) {
          return memo;
        }

        return memo.then(function() {
          return result.error.then(function(error) {
            result.error = error || null;
          });
        });
      }, new v.Promise(function(r) { r(); })); // A resolved promise
    },

    // If the given argument is a call: function the and: function return the value
    // otherwise just return the value. Additional arguments will be passed as
    // arguments to the function.
    // Example:
    // ```
    // result('foo') // 'foo'
    // result(Math.max, 1, 2) // 2
    // ```
    result: function(value) {
      var args = [].slice.call(arguments, 1);
      if (typeof value === 'function') {
        value = value.apply(null, args);
      }
      return value;
    },

    // Checks if the value is a number. This function does not consider NaN a
    // number like many other `isNumber` functions do.
    isNumber: function(value) {
      return typeof value === 'number' && !isNaN(value);
    },

    // Returns false if the object is not a function
    isFunction: function(value) {
      return typeof value === 'function';
    },

    // A simple check to verify that the value is an integer. Uses `isNumber`
    // and a simple modulo check.
    isInteger: function(value) {
      return v.isNumber(value) && value % 1 === 0;
    },

    // Checks if the value is a boolean
    isBoolean: function(value) {
      return typeof value === 'boolean';
    },

    // Uses the `Object` function to check if the given argument is an object.
    isObject: function(obj) {
      return obj === Object(obj);
    },

    // Simply checks if the object is an instance of a date
    isDate: function(obj) {
      return obj instanceof Date;
    },

    // Returns false if the object is `null` of `undefined`
    isDefined: function(obj) {
      return obj !== null && obj !== undefined;
    },

    // Checks if the given argument is a promise. Anything with a `then`
    // function is considered a promise.
    isPromise: function(p) {
      return !!p && v.isFunction(p.then);
    },

    isJqueryElement: function(o) {
      return o && v.isString(o.jquery);
    },

    isDomElement: function(o) {
      if (!o) {
        return false;
      }

      if (!o.querySelectorAll || !o.querySelector) {
        return false;
      }

      if (v.isObject(document) && o === document) {
        return true;
      }

      // http://stackoverflow.com/a/384380/699304
      /* istanbul ignore else */
      if (typeof HTMLElement === "object") {
        return o instanceof HTMLElement;
      } else {
        return o &&
          typeof o === "object" &&
          o !== null &&
          o.nodeType === 1 &&
          typeof o.nodeName === "string";
      }
    },

    isEmpty: function(value) {
      var attr;

      // Null and undefined are empty
      if (!v.isDefined(value)) {
        return true;
      }

      // functions are non empty
      if (v.isFunction(value)) {
        return false;
      }

      // Whitespace only strings are empty
      if (v.isString(value)) {
        return v.EMPTY_STRING_REGEXP.test(value);
      }

      // For arrays we use the length property
      if (v.isArray(value)) {
        return value.length === 0;
      }

      // Dates have no attributes but aren't empty
      if (v.isDate(value)) {
        return false;
      }

      // If we find at least one property we consider it non empty
      if (v.isObject(value)) {
        for (attr in value) {
          return false;
        }
        return true;
      }

      return false;
    },

    // Formats the specified strings with the given values like so:
    // ```
    // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
    // ```
    // If you want to write %{...} without having it replaced simply
    // prefix it with % like this `Foo: %%{foo}` and it will be returned
    // as `"Foo: %{foo}"`
    format: v.extend(function(str, vals) {
      if (!v.isString(str)) {
        return str;
      }
      return str.replace(v.format.FORMAT_REGEXP, function(m0, m1, m2) {
        if (m1 === '%') {
          return "%{" + m2 + "}";
        } else {
          return String(vals[m2]);
        }
      });
    }, {
      // Finds %{key} style patterns in the given string
      FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
    }),

    // "Prettifies" the given string.
    // Prettifying means replacing [.\_-] with spaces as well as splitting
    // camel case words.
    prettify: function(str) {
      if (v.isNumber(str)) {
        // If there are more than 2 decimals round it to two
        if ((str * 100) % 1 === 0) {
          return "" + str;
        } else {
          return parseFloat(Math.round(str * 100) / 100).toFixed(2);
        }
      }

      if (v.isArray(str)) {
        return str.map(function(s) { return v.prettify(s); }).join(", ");
      }

      if (v.isObject(str)) {
        return str.toString();
      }

      // Ensure the string is actually a string
      str = "" + str;

      return str
        // Splits keys separated by periods
        .replace(/([^\s])\.([^\s])/g, '$1 $2')
        // Removes backslashes
        .replace(/\\+/g, '')
        // Replaces - and - with space
        .replace(/[_-]/g, ' ')
        // Splits camel cased words
        .replace(/([a-z])([A-Z])/g, function(m0, m1, m2) {
          return "" + m1 + " " + m2.toLowerCase();
        })
        .toLowerCase();
    },

    stringifyValue: function(value, options) {
      var prettify = options && options.prettify || v.prettify;
      return prettify(value);
    },

    isString: function(value) {
      return typeof value === 'string';
    },

    isArray: function(value) {
      return {}.toString.call(value) === '[object Array]';
    },

    // Checks if the object is a hash, which is equivalent to an object that
    // is neither an array nor a function.
    isHash: function(value) {
      return v.isObject(value) && !v.isArray(value) && !v.isFunction(value);
    },

    contains: function(obj, value) {
      if (!v.isDefined(obj)) {
        return false;
      }
      if (v.isArray(obj)) {
        return obj.indexOf(value) !== -1;
      }
      return value in obj;
    },

    unique: function(array) {
      if (!v.isArray(array)) {
        return array;
      }
      return array.filter(function(el, index, array) {
        return array.indexOf(el) == index;
      });
    },

    forEachKeyInKeypath: function(object, keypath, callback) {
      if (!v.isString(keypath)) {
        return undefined;
      }

      var key = ""
        , i
        , escape = false;

      for (i = 0; i < keypath.length; ++i) {
        switch (keypath[i]) {
          case '.':
            if (escape) {
              escape = false;
              key += '.';
            } else {
              object = callback(object, key, false);
              key = "";
            }
            break;

          case '\\':
            if (escape) {
              escape = false;
              key += '\\';
            } else {
              escape = true;
            }
            break;

          default:
            escape = false;
            key += keypath[i];
            break;
        }
      }

      return callback(object, key, true);
    },

    getDeepObjectValue: function(obj, keypath) {
      if (!v.isObject(obj)) {
        return undefined;
      }

      return v.forEachKeyInKeypath(obj, keypath, function(obj, key) {
        if (v.isObject(obj)) {
          return obj[key];
        }
      });
    },

    // This returns an object with all the values of the form.
    // It uses the input name as key and the value as value
    // So for example this:
    // <input type="text" name="email" value="foo@bar.com" />
    // would return:
    // {email: "foo@bar.com"}
    collectFormValues: function(form, options) {
      var values = {}
        , i
        , j
        , input
        , inputs
        , option
        , value;

      if (v.isJqueryElement(form)) {
        form = form[0];
      }

      if (!form) {
        return values;
      }

      options = options || {};

      inputs = form.querySelectorAll("input[name], textarea[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);

        if (v.isDefined(input.getAttribute("data-ignored"))) {
          continue;
        }

        name = input.name.replace(/\./g, "\\\\.");
        value = v.sanitizeFormValue(input.value, options);
        if (input.type === "number") {
          value = value ? +value : null;
        } else if (input.type === "checkbox") {
          if (input.attributes.value) {
            if (!input.checked) {
              value = values[name] || null;
            }
          } else {
            value = input.checked;
          }
        } else if (input.type === "radio") {
          if (!input.checked) {
            value = values[name] || null;
          }
        }
        values[name] = value;
      }

      inputs = form.querySelectorAll("select[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);
        if (v.isDefined(input.getAttribute("data-ignored"))) {
          continue;
        }

        if (input.multiple) {
          value = [];
          for (j in input.options) {
            option = input.options[j];
             if (option && option.selected) {
              value.push(v.sanitizeFormValue(option.value, options));
            }
          }
        } else {
          var _val = typeof input.options[input.selectedIndex] !== 'undefined' ? input.options[input.selectedIndex].value : '';
          value = v.sanitizeFormValue(_val, options);
        }
        values[input.name] = value;
      }

      return values;
    },

    sanitizeFormValue: function(value, options) {
      if (options.trim && v.isString(value)) {
        value = value.trim();
      }

      if (options.nullify !== false && value === "") {
        return null;
      }
      return value;
    },

    capitalize: function(str) {
      if (!v.isString(str)) {
        return str;
      }
      return str[0].toUpperCase() + str.slice(1);
    },

    // Remove all errors who's error attribute is empty (null or undefined)
    pruneEmptyErrors: function(errors) {
      return errors.filter(function(error) {
        return !v.isEmpty(error.error);
      });
    },

    // In
    // [{error: ["err1", "err2"], ...}]
    // Out
    // [{error: "err1", ...}, {error: "err2", ...}]
    //
    // All attributes in an error with multiple messages are duplicated
    // when expanding the errors.
    expandMultipleErrors: function(errors) {
      var ret = [];
      errors.forEach(function(error) {
        // Removes errors without a message
        if (v.isArray(error.error)) {
          error.error.forEach(function(msg) {
            ret.push(v.extend({}, error, {error: msg}));
          });
        } else {
          ret.push(error);
        }
      });
      return ret;
    },

    // Converts the error mesages by prepending the attribute name unless the
    // message is prefixed by ^
    convertErrorMessages: function(errors, options) {
      options = options || {};

      var ret = []
        , prettify = options.prettify || v.prettify;
      errors.forEach(function(errorInfo) {
        var error = v.result(errorInfo.error,
            errorInfo.value,
            errorInfo.attribute,
            errorInfo.options,
            errorInfo.attributes,
            errorInfo.globalOptions);

        if (!v.isString(error)) {
          ret.push(errorInfo);
          return;
        }

        if (error[0] === '^') {
          error = error.slice(1);
        } else if (options.fullMessages !== false) {
          error = v.capitalize(prettify(errorInfo.attribute)) + " " + error;
        }
        error = error.replace(/\\\^/g, "^");
        error = v.format(error, {
          value: v.stringifyValue(errorInfo.value, options)
        });
        ret.push(v.extend({}, errorInfo, {error: error}));
      });
      return ret;
    },

    // In:
    // [{attribute: "<attributeName>", ...}]
    // Out:
    // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
    groupErrorsByAttribute: function(errors) {
      var ret = {};
      errors.forEach(function(error) {
        var list = ret[error.attribute];
        if (list) {
          list.push(error);
        } else {
          ret[error.attribute] = [error];
        }
      });
      return ret;
    },

    // In:
    // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
    // Out:
    // ["<message 1>", "<message 2>"]
    flattenErrorsToArray: function(errors) {
      return errors
        .map(function(error) { return error.error; })
        .filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
    },

    cleanAttributes: function(attributes, whitelist) {
      function whitelistCreator(obj, key, last) {
        if (v.isObject(obj[key])) {
          return obj[key];
        }
        return (obj[key] = last ? true : {});
      }

      function buildObjectWhitelist(whitelist) {
        var ow = {}
          , lastObject
          , attr;
        for (attr in whitelist) {
          if (!whitelist[attr]) {
            continue;
          }
          v.forEachKeyInKeypath(ow, attr, whitelistCreator);
        }
        return ow;
      }

      function cleanRecursive(attributes, whitelist) {
        if (!v.isObject(attributes)) {
          return attributes;
        }

        var ret = v.extend({}, attributes)
          , w
          , attribute;

        for (attribute in attributes) {
          w = whitelist[attribute];

          if (v.isObject(w)) {
            ret[attribute] = cleanRecursive(ret[attribute], w);
          } else if (!w) {
            delete ret[attribute];
          }
        }
        return ret;
      }

      if (!v.isObject(whitelist) || !v.isObject(attributes)) {
        return {};
      }

      whitelist = buildObjectWhitelist(whitelist);
      return cleanRecursive(attributes, whitelist);
    },

    exposeModule: function(validate, root, exports, module, define) {
      if (exports) {
        if (module && module.exports) {
          exports = module.exports = validate;
        }
        exports.validate = validate;
      } else {
        root.validate = validate;
        if (validate.isFunction(define) && define.amd) {
          define([], function () { return validate; });
        }
      }
    },

    warn: function(msg) {
      if (typeof console !== "undefined" && console.warn) {
        console.warn("[validate.js] " + msg);
      }
    },

    error: function(msg) {
      if (typeof console !== "undefined" && console.error) {
        console.error("[validate.js] " + msg);
      }
    }
  });

  validate.validators = {
    // Presence validates that the value isn't empty
    presence: function(value, options) {
      options = v.extend({}, this.options, options);
      if (options.allowEmpty !== false ? !v.isDefined(value) : v.isEmpty(value)) {
        return options.message || this.message || "can't be blank";
      }
    },
    length: function(value, options, attribute) {
      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var is = options.is
        , maximum = options.maximum
        , minimum = options.minimum
        , tokenizer = options.tokenizer || function(val) { return val; }
        , err
        , errors = [];

      value = tokenizer(value);
      var length = value.length;
      if(!v.isNumber(length)) {
        v.error(v.format("Attribute %{attr} has a non numeric value for `length`", {attr: attribute}));
        return options.message || this.notValid || "has an incorrect length";
      }

      // Is checks
      if (v.isNumber(is) && length !== is) {
        err = options.wrongLength ||
          this.wrongLength ||
          "is the wrong length (should be %{count} characters)";
        errors.push(v.format(err, {count: is}));
      }

      if (v.isNumber(minimum) && length < minimum) {
        err = options.tooShort ||
          this.tooShort ||
          "is too short (minimum is %{count} characters)";
        errors.push(v.format(err, {count: minimum}));
      }

      if (v.isNumber(maximum) && length > maximum) {
        err = options.tooLong ||
          this.tooLong ||
          "is too long (maximum is %{count} characters)";
        errors.push(v.format(err, {count: maximum}));
      }

      if (errors.length > 0) {
        return options.message || errors;
      }
    },
    numericality: function(value, options, attribute, attributes, globalOptions) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var errors = []
        , name
        , count
        , checks = {
            greaterThan:          function(v, c) { return v > c; },
            greaterThanOrEqualTo: function(v, c) { return v >= c; },
            equalTo:              function(v, c) { return v === c; },
            lessThan:             function(v, c) { return v < c; },
            lessThanOrEqualTo:    function(v, c) { return v <= c; },
            divisibleBy:          function(v, c) { return v % c === 0; }
          }
        , prettify = options.prettify ||
          (globalOptions && globalOptions.prettify) ||
          v.prettify;

      // Strict will check that it is a valid looking number
      if (v.isString(value) && options.strict) {
        var pattern = "^-?(0|[1-9]\\d*)";
        if (!options.onlyInteger) {
          pattern += "(\\.\\d+)?";
        }
        pattern += "$";

        if (!(new RegExp(pattern).test(value))) {
          return options.message ||
            options.notValid ||
            this.notValid ||
            this.message ||
            "must be a valid number";
        }
      }

      // Coerce the value to a number unless we're being strict.
      if (options.noStrings !== true && v.isString(value) && !v.isEmpty(value)) {
        value = +value;
      }

      // If it's not a number we shouldn't continue since it will compare it.
      if (!v.isNumber(value)) {
        return options.message ||
          options.notValid ||
          this.notValid ||
          this.message ||
          "is not a number";
      }

      // Same logic as above, sort of. Don't bother with comparisons if this
      // doesn't pass.
      if (options.onlyInteger && !v.isInteger(value)) {
        return options.message ||
          options.notInteger ||
          this.notInteger ||
          this.message ||
          "must be an integer";
      }

      for (name in checks) {
        count = options[name];
        if (v.isNumber(count) && !checks[name](value, count)) {
          // This picks the default message if specified
          // For example the greaterThan check uses the message from
          // this.notGreaterThan so we capitalize the name and prepend "not"
          var key = "not" + v.capitalize(name);
          var msg = options[key] ||
            this[key] ||
            this.message ||
            "must be %{type} %{count}";

          errors.push(v.format(msg, {
            count: count,
            type: prettify(name)
          }));
        }
      }

      if (options.odd && value % 2 !== 1) {
        errors.push(options.notOdd ||
            this.notOdd ||
            this.message ||
            "must be odd");
      }
      if (options.even && value % 2 !== 0) {
        errors.push(options.notEven ||
            this.notEven ||
            this.message ||
            "must be even");
      }

      if (errors.length) {
        return options.message || errors;
      }
    },
    datetime: v.extend(function(value, options) {
      if (!v.isFunction(this.parse) || !v.isFunction(this.format)) {
        throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
      }

      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var err
        , errors = []
        , earliest = options.earliest ? this.parse(options.earliest, options) : NaN
        , latest = options.latest ? this.parse(options.latest, options) : NaN;

      value = this.parse(value, options);

      // 86400000 is the number of milliseconds in a day, this is used to remove
      // the time from the date
      if (isNaN(value) || options.dateOnly && value % 86400000 !== 0) {
        err = options.notValid ||
          options.message ||
          this.notValid ||
          "must be a valid date";
        return v.format(err, {value: arguments[0]});
      }

      if (!isNaN(earliest) && value < earliest) {
        err = options.tooEarly ||
          options.message ||
          this.tooEarly ||
          "must be no earlier than %{date}";
        err = v.format(err, {
          value: this.format(value, options),
          date: this.format(earliest, options)
        });
        errors.push(err);
      }

      if (!isNaN(latest) && value > latest) {
        err = options.tooLate ||
          options.message ||
          this.tooLate ||
          "must be no later than %{date}";
        err = v.format(err, {
          date: this.format(latest, options),
          value: this.format(value, options)
        });
        errors.push(err);
      }

      if (errors.length) {
        return v.unique(errors);
      }
    }, {
      parse: null,
      format: null
    }),
    date: function(value, options) {
      options = v.extend({}, options, {dateOnly: true});
      return v.validators.datetime.call(v.validators.datetime, value, options);
    },
    format: function(value, options) {
      if (v.isString(options) || (options instanceof RegExp)) {
        options = {pattern: options};
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is invalid"
        , pattern = options.pattern
        , match;

      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }

      if (v.isString(pattern)) {
        pattern = new RegExp(options.pattern, options.flags);
      }
      match = pattern.exec(value);
      if (!match || match[0].length != value.length) {
        return message;
      }
    },
    inclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (v.contains(options.within, value)) {
        return;
      }
      var message = options.message ||
        this.message ||
        "^%{value} is not included in the list";
      return v.format(message, {value: value});
    },
    exclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (!v.contains(options.within, value)) {
        return;
      }
      var message = options.message || this.message || "^%{value} is restricted";
      return v.format(message, {value: value});
    },
    email: v.extend(function(value, options) {
      options = v.extend({}, this.options, options);
      var message = options.message || this.message || "is not a valid email";
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }
      if (!this.PATTERN.exec(value)) {
        return message;
      }
    }, {
      PATTERN: /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i
    }),
    equality: function(value, options, attribute, attributes, globalOptions) {
      if (!v.isDefined(value)) {
        return;
      }

      if (v.isString(options)) {
        options = {attribute: options};
      }
      options = v.extend({}, this.options, options);
      var message = options.message ||
        this.message ||
        "is not equal to %{attribute}";

      if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) {
        throw new Error("The attribute must be a non empty string");
      }

      var otherValue = v.getDeepObjectValue(attributes, options.attribute)
        , comparator = options.comparator || function(v1, v2) {
          return v1 === v2;
        }
        , prettify = options.prettify ||
          (globalOptions && globalOptions.prettify) ||
          v.prettify;

      if (!comparator(value, otherValue, options, attribute, attributes)) {
        return v.format(message, {attribute: prettify(options.attribute)});
      }
    },

    // A URL validator that is used to validate URLs with the ability to
    // restrict schemes and some domains.
    url: function(value, options) {
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is not a valid url"
        , schemes = options.schemes || this.schemes || ['http', 'https']
        , allowLocal = options.allowLocal || this.allowLocal || false;

      if (!v.isString(value)) {
        return message;
      }

      // https://gist.github.com/dperini/729294
      var regex =
        "^" +
        // protocol identifier
        "(?:(?:" + schemes.join("|") + ")://)" +
        // user:pass authentication
        "(?:\\S+(?::\\S*)?@)?" +
        "(?:";

      var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";

      if (allowLocal) {
        tld += "?";
      } else {
        regex +=
          // IP address exclusion
          // private & local networks
          "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
          "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
          "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})";
      }

      regex +=
          // IP address dotted notation octets
          // excludes loopback network 0.0.0.0
          // excludes reserved space >= 224.0.0.0
          // excludes network & broacast addresses
          // (first & last IP address of each class)
          "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
          "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
          "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
        "|" +
          // host name
          "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
          // domain name
          "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
          tld +
        ")" +
        // port number
        "(?::\\d{2,5})?" +
        // resource path
        "(?:[/?#]\\S*)?" +
      "$";

      var PATTERN = new RegExp(regex, 'i');
      if (!PATTERN.exec(value)) {
        return message;
      }
    }
  };

  validate.formatters = {
    detailed: function(errors) {return errors;},
    flat: v.flattenErrorsToArray,
    grouped: function(errors) {
      var attr;

      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = v.flattenErrorsToArray(errors[attr]);
      }
      return errors;
    },
    constraint: function(errors) {
      var attr;
      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = errors[attr].map(function(result) {
          return result.validator;
        }).sort();
      }
      return errors;
    }
  };

  validate.exposeModule(validate, this, exports, module, __webpack_require__("LGuY"));
}).call(this,
         true ? /* istanbul ignore next */ exports : null,
         true ? /* istanbul ignore next */ module : null,
        __webpack_require__("LGuY"));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "ZhlV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorBoundary = __webpack_require__("J1tJ");

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

var _InitialPageComponent = __webpack_require__("QgIf");

var _InitialPageComponent2 = _interopRequireDefault(_InitialPageComponent);

var _LoginPageComponent = __webpack_require__("xRp3");

var _LoginPageComponent2 = _interopRequireDefault(_LoginPageComponent);

var _SignUpPageComponent = __webpack_require__("PXso");

var _SignUpPageComponent2 = _interopRequireDefault(_SignUpPageComponent);

var _SuccessPageComponent = __webpack_require__("CThN");

var _SuccessPageComponent2 = _interopRequireDefault(_SuccessPageComponent);

var _ResetPasswordPageComponent = __webpack_require__("+ac8");

var _ResetPasswordPageComponent2 = _interopRequireDefault(_ResetPasswordPageComponent);

var _SocialLoginPageComponent = __webpack_require__("AYO3");

var _SocialLoginPageComponent2 = _interopRequireDefault(_SocialLoginPageComponent);

var _TermsAndConditionsPageComponent = __webpack_require__("bCL1");

var _TermsAndConditionsPageComponent2 = _interopRequireDefault(_TermsAndConditionsPageComponent);

var _ChangePasswordPageComponent = __webpack_require__("Vj64");

var _ChangePasswordPageComponent2 = _interopRequireDefault(_ChangePasswordPageComponent);

var _AuthAccountTypes = __webpack_require__("ku0b");

var _AuthAccountTypes2 = _interopRequireDefault(_AuthAccountTypes);

__webpack_require__("PBUe");

var _reactModal = __webpack_require__("XSjK");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _clientLogger = __webpack_require__("29Zd");

var _clientLogger2 = _interopRequireDefault(_clientLogger);

var _api = __webpack_require__("cGdw");

var _dynamic = __webpack_require__("Ib56");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_clientLogger2.default.initialize({
    errorRoute: '/auth/ui/logs/errors',
    clientLogRoute: '/auth/ui/logs/cl'
});

var lingua = __webpack_require__("DwxB");
var MessageReader = __webpack_require__("odsh");

var MainComponent = function (_Component) {
    _inherits(MainComponent, _Component);

    _createClass(MainComponent, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                actionLocation: _propTypes2.default.string,
                locale: _propTypes2.default.string.isRequired,
                site: _propTypes2.default.string.isRequired,
                siteName: _propTypes2.default.string.isRequired,
                service: _propTypes2.default.string.isRequired,
                handleCloseModal: _propTypes2.default.func,
                handleLoginSuccess: _propTypes2.default.func,
                useNewEndpoints: _propTypes2.default.bool,
                // The flag to disable the social login when used in the multi-user-traveler app
                multiUserEnabled: _propTypes2.default.bool,
                expediaIconDisplayed: _propTypes2.default.bool,
                serverConfigRendering: _propTypes2.default.bool,
                ticketId: _propTypes2.default.string,
                landingPage: _propTypes2.default.string
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                actionLocation: '-1',
                locale: 'en_US_HA',
                site: 'homeaway_us',
                siteName: 'HomeAway',
                service: 'misconfigured',
                modalMode: false,
                handleCloseModal: function handleCloseModal() {},
                handleLoginSuccess: function handleLoginSuccess() {},
                useNewEndpoints: false,
                multiUserEnabled: false,
                expediaIconDisplayed: false,
                context: 'base',
                serverConfigRendering: false,
                ticketId: '',
                landingPage: 'initial'
            };
        }
    }]);

    function MainComponent(props) {
        _classCallCheck(this, MainComponent);

        var _this = _possibleConstructorReturn(this, (MainComponent.__proto__ || Object.getPrototypeOf(MainComponent)).call(this, props));

        _this.state = {
            service: _this.props.service,
            modalOpened: true,
            currentPage: _this.props.ticketId !== '' ? 'passwordchange' : _this.props.landingPage,
            lingua: lingua,
            firstName: '',
            emailAddress: '',
            authAccountType: [],
            closeButton: true,
            passwordType: '',
            isWaiting: false,
            authJson: {},
            oauth: null,
            token: null,
            authStatus: null,
            expediaConfigRequired: props.expediaIconDisplayed !== true,
            expediaIconDisplayed: props.expediaIconDisplayed,
            ticketId: _this.props.ticketId,
            successContext: _this.props.ticketId !== '' ? 'passwordchange' : _this.props.landingPage
        };

        // Bind to the correct context
        _this.onClose = _this.onClose.bind(_this);
        _this.onModalClose = _this.onModalClose.bind(_this);
        _this.updatePage = _this.updatePage.bind(_this);
        _this.setEmail = _this.setEmail.bind(_this);
        _this.setFirstName = _this.setFirstName.bind(_this);
        _this.performInitialBulkUpdate = _this.performInitialBulkUpdate.bind(_this);
        _this.setAuthAccountType = _this.setAuthAccountType.bind(_this);
        _this.clickBack = _this.clickBack.bind(_this);
        _this.showHidePassword = _this.showHidePassword.bind(_this);
        _this.getMainContent = _this.getMainContent.bind(_this);
        _this.getClassName = _this.getClassName.bind(_this);
        _this.enableLoading = _this.enableLoading.bind(_this);
        _this.disableLoading = _this.disableLoading.bind(_this);
        _this.performBulkPageUpdate = _this.performBulkPageUpdate.bind(_this);
        _this.setAuthJson = _this.setAuthJson.bind(_this);
        _this.loginSuccess = _this.loginSuccess.bind(_this);
        _this.checkStatus = _this.checkStatus.bind(_this);
        _this.loadExpediaConfig = _this.loadExpediaConfig.bind(_this);
        return _this;
    }

    _createClass(MainComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            MessageReader.setLocale(this.props.locale);
            (0, _dynamic.loadLingua)(this.props.locale).then(function () {
                _this2.setState({ linguaLoaded: true });
            }).catch(function (e) {
                _clientLogger2.default.logError('Unable to load lingua keys for locale ' + _this2.props.locale + '. Error=' + e);
                throw new Error('Unable to load lingua keys for locale ' + _this2.props.locale + '. Error=' + e);
            });

            if (this.state.currentPage === 'initial') {
                (0, _api.apiPost)('/auth/aam/v3/refreshlogin', {
                    'tmDeviceIdKey': '00000000-0000-0000-0000-000000000000'
                }).then(this.checkStatus);
            }

            if (this.state.expediaConfigRequired && !this.props.serverConfigRendering) {
                this.loadExpediaConfig();
            }

            if (this.props.modalMode) {
                (0, _edapWrapper2.default)().push({
                    name: 'generic.modal',
                    data: { modalaction: 'open', modalname: 'lex.auth', actionlocation: this.props.actionLocation }
                });
            }
        }
    }, {
        key: 'loadExpediaConfig',
        value: function loadExpediaConfig() {
            var _this3 = this;

            (0, _dynamic.loadConfig)(this.props.locale, this.props.context).then(function (config) {
                var expediaIconDisplayed = config.expediaIconDisplayed === true;
                _this3.setState({ expediaIconDisplayed: expediaIconDisplayed, expediaConfigRequired: false });
            });
        }
    }, {
        key: 'onModalClose',
        value: function onModalClose() {
            (0, _edapWrapper2.default)().push({
                name: 'generic.modal',
                data: { modalaction: 'close', modalname: 'lex.auth', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.props.handleCloseModal();
        }
    }, {
        key: 'loginSuccess',
        value: function loginSuccess(json) {
            this.setAuthJson(json);
            (0, _edapWrapper2.default)().push({
                name: 'login.success',
                data: { loginsource: 'lex', logintype: 'ums', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.onClose();
        }
    }, {
        key: 'checkStatus',
        value: function checkStatus(response) {
            var _this4 = this;

            if (response.status === 200) {
                response.json().then(function (json) {
                    _this4.loginSuccess(json);
                }, function (err) {
                    _clientLogger2.default.logError('error occured on recreate session error=' + err);
                });
            }
        }
    }, {
        key: 'enableLoading',
        value: function enableLoading() {
            this.setState({ isWaiting: true });
        }
    }, {
        key: 'disableLoading',
        value: function disableLoading() {
            this.setState({ isWaiting: false });
        }
    }, {
        key: 'setAuthJson',
        value: function setAuthJson(json) {
            this.setState({ authJson: json });
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            // User is authenticated if authJson is not an empty object
            // so, let the consuming  application know that there was a
            // successful login and send them the json response.
            if (Object.keys(this.state.authJson).length > 0) {
                this.props.handleLoginSuccess(this.state.authJson);
            } else if (this.state.ticketId !== '' || this.props.landingPage !== 'initial') {
                // this is for redirecting password rest & confirm page!
                this.props.handleLoginSuccess(null);
            }

            if (this.props.modalMode) {
                this.setState({ modalOpened: false });
            }
        }
    }, {
        key: 'performInitialBulkUpdate',
        value: function performInitialBulkUpdate(pageName, emailAddress, status) {
            var currentList = this.state.authAccountType.slice();
            var newStatuses = status.slice();
            if (currentList.length > 0) {
                currentList.concat(newStatuses);
            } else {
                currentList = newStatuses;
            }
            if (this.state.service === 'misconfigured') {
                // cannot set href as default prop or tests fail so handling here, mostly for local testing
                this.setState({ service: window.location.href });
            }
            this.setState({
                currentPage: pageName,
                closeButton: true,
                passwordType: 'password',
                emailAddress: emailAddress,
                authAccountType: currentList,
                isWaiting: false
            });
        }
    }, {
        key: 'updatePage',
        value: function updatePage(pageName) {
            this.setState({
                currentPage: pageName,
                closeButton: true,
                passwordType: 'password'
            });
        }
    }, {
        key: 'performBulkPageUpdate',
        value: function performBulkPageUpdate(pageName) {
            var emailAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var oauth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var token = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            this.setState({
                currentPage: pageName,
                emailAddress: emailAddress,
                closeButton: true,
                oauth: [oauth],
                token: token,
                passwordType: 'password'
            });
        }
    }, {
        key: 'setAuthAccountType',
        value: function setAuthAccountType(status) {
            var currentList = this.state.authAccountType.slice();
            currentList.push(status);
            this.setState({
                authAccountType: currentList
            });
        }
    }, {
        key: 'setEmail',
        value: function setEmail(emailaddress) {
            this.setState({ emailAddress: emailaddress });
        }
    }, {
        key: 'setFirstName',
        value: function setFirstName(firstname) {
            this.setState({ firstName: firstname });
        }
    }, {
        key: 'clickBack',
        value: function clickBack() {
            (0, _edapWrapper2.default)().push({
                name: 'generic.click',
                data: { eventcategory: 'lex.auth', eventaction: 'backButton.click', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.setState({
                currentPage: 'initial',
                closeButton: true
            });
        }
    }, {
        key: 'showHidePassword',
        value: function showHidePassword(e) {
            e.preventDefault();
            e.stopPropagation();
            var shouldHide = this.state.passwordType === 'input';
            var eventaction = shouldHide ? 'hide' : 'show';
            (0, _edapWrapper2.default)().push({
                name: 'generic.click',
                data: { eventcategory: 'lex.auth', eventaction: eventaction + 'Pwd.click', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.setState({
                passwordType: shouldHide ? 'password' : 'input'
            });
        }
    }, {
        key: 'getContent',
        value: function getContent(displayPage) {
            var content = '';
            switch (displayPage) {
                case _AuthAccountTypes2.default.UMS:
                    content = _react2.default.createElement(_LoginPageComponent2.default, {
                        actionLocation: this.props.actionLocation,
                        lingua: this.state.lingua,
                        siteName: this.props.siteName,
                        emailAddress: this.state.emailAddress,
                        service: this.state.service,
                        updatePage: this.updatePage,
                        authAccountType: this.state.authAccountType,
                        onClose: this.onClose,
                        passwordType: this.state.passwordType,
                        showHidePassword: this.showHidePassword,
                        isWaiting: this.state.isWaiting,
                        enableLoading: this.enableLoading,
                        disableLoading: this.disableLoading,
                        setAuthJson: this.setAuthJson,
                        site: this.props.site,
                        useNewEndpoints: this.props.useNewEndpoints,
                        multiUserEnabled: this.props.multiUserEnabled,
                        expediaIconDisplayed: this.state.expediaIconDisplayed

                    });
                    break;
                case _AuthAccountTypes2.default.GOOGLE:
                    content = _react2.default.createElement(_SocialLoginPageComponent2.default, {
                        actionLocation: this.props.actionLocation,
                        lingua: this.state.lingua,
                        firstName: this.state.firstName,
                        emailAddress: this.state.emailAddress,
                        service: this.state.service,
                        authAccountType: this.state.authAccountType,
                        onClose: this.onClose,
                        performBulkPageUpdate: this.performBulkPageUpdate,
                        setAuthJson: this.setAuthJson,
                        site: this.props.site,
                        useNewEndpoints: this.props.useNewEndpoints,
                        multiUserEnabled: this.props.multiUserEnabled,
                        updatePage: this.updatePage,
                        expediaIconDisplayed: this.state.expediaIconDisplayed
                    });
                    break;
                case _AuthAccountTypes2.default.FACEBOOK:
                    content = _react2.default.createElement(_SocialLoginPageComponent2.default, {
                        actionLocation: this.props.actionLocation,
                        lingua: this.state.lingua,
                        firstName: this.state.firstName,
                        emailAddress: this.state.emailAddress,
                        service: this.state.service,
                        authAccountType: this.state.authAccountType,
                        onClose: this.onClose,
                        setAuthJson: this.setAuthJson,
                        performBulkPageUpdate: this.performBulkPageUpdate,
                        site: this.props.site,
                        useNewEndpoints: this.props.useNewEndpoints,
                        multiUserEnabled: this.props.multiUserEnabled,
                        updatePage: this.updatePage,
                        expediaIconDisplayed: this.state.expediaIconDisplayed
                    });
                    break;
                case _AuthAccountTypes2.default.EXPEDIA:
                    content = _react2.default.createElement(_SocialLoginPageComponent2.default, {
                        lingua: this.state.lingua,
                        firstName: this.state.firstName,
                        emailAddress: this.state.emailAddress,
                        service: this.state.service,
                        authAccountType: this.state.authAccountType,
                        onClose: this.onClose,
                        setAuthJson: this.setAuthJson,
                        performBulkPageUpdate: this.performBulkPageUpdate,
                        site: this.props.site,
                        useNewEndpoints: this.props.useNewEndpoints,
                        multiUserEnabled: this.props.multiUserEnabled,
                        updatePage: this.updatePage,
                        expediaIconDisplayed: this.state.expediaIconDisplayed
                    });
                    break;
                case 'TermsAndConditions':
                    content = _react2.default.createElement(_TermsAndConditionsPageComponent2.default, {
                        emailAddress: this.state.emailAddress,
                        lingua: this.state.lingua,
                        site: this.props.site,
                        siteName: this.props.siteName,
                        isWaiting: this.state.isWaiting,
                        updatePage: this.updatePage,
                        performBulkPageUpdate: this.performBulkPageUpdate
                    });
                    break;

                case _AuthAccountTypes2.default.SIGNUP:
                    content = this.getSignUpContent();
                    break;
                case 'success':
                    content = _react2.default.createElement(_SuccessPageComponent2.default, {
                        lingua: this.state.lingua,
                        emailAddress: this.state.emailAddress,
                        firstName: this.state.firstName,
                        onClose: this.onClose,
                        successContext: this.state.successContext
                    });
                    break;
                case 'passwordreset':
                    content = _react2.default.createElement(_ResetPasswordPageComponent2.default, {
                        lingua: this.state.lingua,
                        service: this.state.service,
                        updatePage: this.updatePage
                    });
                    break;
                case 'postTandC':
                    if (this.state.oauth) {
                        content = _react2.default.createElement(_SocialLoginPageComponent2.default, {
                            lingua: this.state.lingua,
                            firstName: this.state.firstName,
                            emailAddress: this.state.emailAddress,
                            service: this.state.service,
                            authAccountType: this.state.oauth,
                            onClose: this.onClose,
                            setAuthJson: this.setAuthJson,
                            performBulkPageUpdate: this.performBulkPageUpdate,
                            token: this.state.token,
                            site: this.props.site,
                            useNewEndpoints: this.props.useNewEndpoints,
                            multiUserEnabled: this.props.multiUserEnabled,
                            updatePage: this.updatePage,
                            expediaIconDisplayed: this.state.expediaIconDisplayed
                        });
                    } else {
                        content = this.getSignUpContent();
                    }
                    break;
                case 'passwordchange':
                    content = _react2.default.createElement(_ChangePasswordPageComponent2.default, {
                        actionLocation: this.props.actionLocation,
                        lingua: this.state.lingua,
                        site: this.props.site,
                        service: this.state.service,
                        updatePage: this.updatePage,
                        isWaiting: this.state.isWaiting,
                        enableLoading: this.enableLoading,
                        disableLoading: this.disableLoading,
                        ticketId: this.state.ticketId
                    });
                    break;
                default:
                    // this would be 'initial' screen
                    content = _react2.default.createElement(_InitialPageComponent2.default, {
                        actionLocation: this.props.actionLocation,
                        lingua: this.state.lingua,
                        siteName: this.props.siteName,
                        firstName: this.state.firstName,
                        currentPage: this.state.currentPage,
                        performInitialBulkUpdate: this.performInitialBulkUpdate,
                        setAuthAccountType: this.setAuthAccountType,
                        authStatus: this.state.authStatus,
                        locale: this.props.locale,
                        onClose: this.onClose,
                        isWaiting: this.state.isWaiting,
                        enableLoading: this.enableLoading,
                        disableLoading: this.disableLoading,
                        updatePage: this.updatePage,
                        site: this.props.site,
                        setAuthJson: this.setAuthJson,
                        performBulkPageUpdate: this.performBulkPageUpdate,
                        useNewEndpoints: this.props.useNewEndpoints,
                        multiUserEnabled: this.props.multiUserEnabled,
                        expediaIconDisplayed: this.state.expediaIconDisplayed
                    });
                    break;
            }
            return content;
        }
    }, {
        key: 'getSignUpContent',
        value: function getSignUpContent() {
            return _react2.default.createElement(_SignUpPageComponent2.default, {
                actionLocation: this.props.actionLocation,
                lingua: this.state.lingua,
                site: this.props.site,
                emailAddress: this.state.emailAddress,
                service: this.state.service,
                updatePage: this.updatePage,
                setEmail: this.setEmail,
                setFirstName: this.setFirstName,
                authStatus: 'SIGNUP',
                passwordType: this.state.passwordType,
                showHidePassword: this.showHidePassword,
                isWaiting: this.state.isWaiting,
                enableLoading: this.enableLoading,
                disableLoading: this.disableLoading,
                performBulkPageUpdate: this.performBulkPageUpdate,
                setAuthJson: this.setAuthJson,
                useNewEndpoints: this.props.useNewEndpoints,
                multiUserEnabled: this.props.multiUserEnabled
            });
        }
    }, {
        key: 'getMainContent',
        value: function getMainContent() {
            var content = this.getContent(this.state.currentPage);
            if (this.props.modalMode) {
                return _react2.default.createElement(
                    _reactModal2.default,
                    {
                        id: 'lex-modal',
                        isOpen: this.state.modalOpened,
                        onClose: this.onClose,
                        onModalClose: this.onModalClose,
                        isInstructional: true,
                        closeButton: this.state.closeButton,
                        header: true
                    },
                    content
                );
            }
            return content;
        }
    }, {
        key: 'getClassName',
        value: function getClassName() {
            var displayPage = this.state.currentPage;
            var modeClassName = void 0;
            // CSS will be white content only in these 2 cases, otherwise handle modal & regular page component css separately
            if (displayPage === 'success' || displayPage === 'passwordreset') {
                modeClassName = 'WhiteContent';
                modeClassName = this.props.modalMode ? '' + modeClassName : modeClassName + ' ' + modeClassName + '--desktop';
            } else {
                modeClassName = this.props.modalMode ? 'AuthModal' : 'RegularContent';
                // now we add brand
                modeClassName = this.props.site === 'vrbo' ? modeClassName + ' ' + modeClassName + '--vrbo' : modeClassName + ' ' + modeClassName + '--gradient';
            }

            return (0, _classnames2.default)('' + modeClassName);
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.linguaLoaded) {
                return null;
            }
            if (this.state.expediaConfigRequired && this.props.serverConfigRendering) {
                this.loadExpediaConfig();
            }
            var modeClassName = this.getClassName();
            return _react2.default.createElement(
                'div',
                { className: modeClassName },
                _react2.default.createElement(
                    _ErrorBoundary2.default,
                    { clientLogger: _clientLogger2.default },
                    this.getMainContent()
                )
            );
        }
    }]);

    return MainComponent;
}(_react.Component);

exports.default = MainComponent;
//# sourceMappingURL=MainComponent.js.map

/***/ }),

/***/ "anT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("GiK3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-alerts/lib/esm/Alert/AlertCloseButton.css
var AlertCloseButton = __webpack_require__("iOK6");
var AlertCloseButton_default = /*#__PURE__*/__webpack_require__.n(AlertCloseButton);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-svg/lib/esm/index.js
var esm = __webpack_require__("CWk1");
var esm_default = /*#__PURE__*/__webpack_require__.n(esm);

// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/index.js + 313 modules
var lib_esm = __webpack_require__("QnUD");

// CONCATENATED MODULE: ./node_modules/@homeaway/react-alerts/lib/esm/Alert/AlertCloseButton.js






function AlertCloseButton_AlertCloseButton(props) {
  return react_default.a.createElement("button", {
    type: "button",
    className: "Alert__close",
    onClick: props.onClick
  }, react_default.a.createElement("span", {
    className: "Alert__close-flex"
  }, react_default.a.createElement(esm["SVGIcon"], {
    inlineFlex: true,
    markup: lib_esm["CLOSE__16"]
  }), react_default.a.createElement("span", {
    className: "sr-only"
  }, props.closeText)));
}

AlertCloseButton_AlertCloseButton.propTypes = {
  closeText: prop_types_default.a.string,
  onClick: prop_types_default.a.func
};
/* harmony default export */ var Alert_AlertCloseButton = (AlertCloseButton_AlertCloseButton);
//# sourceMappingURL=AlertCloseButton.js.map
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-alerts/lib/esm/Alert/Alert.css
var Alert_Alert = __webpack_require__("gGW8");
var Alert_default = /*#__PURE__*/__webpack_require__.n(Alert_Alert);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-alerts/lib/esm/Alert/Alert.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }








/**
 * Alert
 *
 */

var Alert_Alert_Alert =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Alert, _Component);

  function Alert(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.removeAlert = function () {
      _this.setState({
        visible: false
      });

      if (_this.props.onAlertClosed) {
        _this.props.onAlertClosed();
      }
    };

    _this.dismissAlert = function () {
      _this.setState({
        dismissed: true
      });

      setTimeout(function () {
        _this.removeAlert();
      }, 500);
    };

    _this.alert = null;
    _this.state = {
      dismissed: false,
      visible: true
    };
    return _this;
  }

  var _proto = Alert.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        ariaLive = _this$props.ariaLive,
        title = _this$props.title,
        msg = _this$props.msg,
        svgClassName = _this$props.svgClassName,
        svgMarkup = _this$props.svgMarkup,
        svgId = _this$props.svgId,
        dismissible = _this$props.dismissible,
        closeText = _this$props.closeText,
        className = _this$props.className,
        onAlertClosed = _this$props.onAlertClosed,
        flairClassName = _this$props.flairClassName,
        rest = _objectWithoutProperties(_this$props, ["ariaLive", "title", "msg", "svgClassName", "svgMarkup", "svgId", "dismissible", "closeText", "className", "onAlertClosed", "flairClassName"]); // eslint-disable-line no-unused-vars


    var _this$state = this.state,
        dismissed = _this$state.dismissed,
        visible = _this$state.visible;
    var alertClass = classnames_default()('Alert', 'border--default', {
      'Alert--dismissible': dismissible,
      'fade': dismissible,
      'in': !dismissed
    }, className);
    var flairClass = classnames_default()('Alert__flair', flairClassName);
    var svgClass = classnames_default()('Alert__svg', 'inline-svg', svgClassName);
    var finalIconMarkup;

    if (svgId) {
      finalIconMarkup = react_default.a.createElement(esm["SVGIcon"], {
        className: svgClass,
        id: svgId
      });
    } else if (svgMarkup) {
      finalIconMarkup = react_default.a.createElement(esm["SVGIcon"], {
        className: svgClass,
        markup: svgMarkup
      });
    }

    if (visible) {
      return react_default.a.createElement("div", _extends({
        ref:
        /* istanbul ignore next */
        function ref(e) {
          _this2.alert = e;
        },
        "aria-live": ariaLive,
        role: "alert",
        className: alertClass
      }, rest), react_default.a.createElement("div", {
        className: flairClass
      }), finalIconMarkup, dismissible && react_default.a.createElement(Alert_AlertCloseButton, {
        closeText: closeText,
        onClick: this.dismissAlert
      }), title && react_default.a.createElement("p", null, react_default.a.createElement("strong", null, title)), msg && react_default.a.createElement("p", null, msg), this.props.children);
    }

    return false;
  };

  return Alert;
}(react["Component"]);

Alert_Alert_Alert.propTypes = {
  /** The aria-live value for the alert.
   * 'polite' - indicates that the screen reader should wait until the user is idle before presenting updates to the user
   * 'assertive' may interupt user's flow
   */
  ariaLive: prop_types_default.a.oneOf(['assertive', 'polite']),

  /** Alert heading, wrapped in an <h4> if you want it.  */
  title: prop_types_default.a.string,

  /** Alert message to be formatted in a <p> tag.  You can also provide your own children markup/components */
  msg: prop_types_default.a.node,

  /* CSS classes to apply to the svg. This is commented out since its meant as an internal property. */
  // svgClassName: PropTypes.string,

  /** SVG markup to display for Alert imported from @homeaway/svg-defs module. Please reference individual file in /lib/defs/ */
  svgMarkup: prop_types_default.a.string,

  /** ID name of SVG from an SVG Definition block, the xlink:href of the SVG you want. Explicitly for use with SVG Definitions coming from the icon system in @homeaway/svg-defs */
  svgId: prop_types_default.a.string,

  /** Flag to determine if the Alert has a close button and can be dismissed */
  dismissible: prop_types_default.a.bool,

  /** Screen Reader .sr-only text for close button. Defaults to english: "Close" */
  closeText: prop_types_default.a.string,

  /** Optional event handler to fire after an Alert has closed */
  onAlertClosed: prop_types_default.a.func
  /** Background CSS helper for flair on left side of Alert. Internal use only. */
  // flairClassName: PropTypes.string

};
Alert_Alert_Alert.defaultProps = {
  ariaLive: 'polite',
  dismissible: false,
  closeText: 'Close',
  svgMarkup: lib_esm["ALERT_WARNING__24"],
  flairClassName: 'bg--color-bg-active',
  svgClassName: 'text-muted'
};
/* harmony default export */ var esm_Alert_Alert = (Alert_Alert_Alert);
//# sourceMappingURL=Alert.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-alerts/lib/esm/Alert/AlertDanger.js
function AlertDanger__extends() { AlertDanger__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AlertDanger__extends.apply(this, arguments); }






function AlertDanger(props) {
  var buttonClasses = classnames_default()('Alert--danger', props.className);
  return react_default.a.createElement(esm_Alert_Alert, AlertDanger__extends({}, props, {
    className: buttonClasses,
    flairClassName: "bg--color-negative",
    svgClassName: "text-danger"
  }));
}

AlertDanger.propTypes = AlertDanger__extends({}, esm_Alert_Alert.propTypes);
AlertDanger.defaultProps = AlertDanger__extends({}, esm_Alert_Alert.defaultProps, {
  ariaLive: 'assertive',
  svgMarkup: lib_esm["ALERT__24"]
});
/* harmony default export */ var Alert_AlertDanger = (AlertDanger);
//# sourceMappingURL=AlertDanger.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-alerts/lib/esm/Alert/AlertInfo.js
function AlertInfo__extends() { AlertInfo__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AlertInfo__extends.apply(this, arguments); }






function AlertInfo(props) {
  var buttonClasses = classnames_default()('Alert--info', props.className);
  return react_default.a.createElement(esm_Alert_Alert, AlertInfo__extends({}, props, {
    className: buttonClasses,
    flairClassName: "bg--color-action",
    svgClassName: "text-info"
  }));
}

AlertInfo.propTypes = AlertInfo__extends({}, esm_Alert_Alert.propTypes);
AlertInfo.defaultProps = AlertInfo__extends({}, esm_Alert_Alert.defaultProps, {
  svgMarkup: lib_esm["INFO__24"]
});
/* harmony default export */ var Alert_AlertInfo = (AlertInfo);
//# sourceMappingURL=AlertInfo.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-alerts/lib/esm/Alert/AlertSuccess.js
function AlertSuccess__extends() { AlertSuccess__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AlertSuccess__extends.apply(this, arguments); }






function AlertSuccess(props) {
  var buttonClasses = classnames_default()('Alert--success', props.className);
  return react_default.a.createElement(esm_Alert_Alert, AlertSuccess__extends({}, props, {
    className: buttonClasses,
    flairClassName: "bg--color-positive",
    svgClassName: "text-success"
  }));
}

AlertSuccess.propTypes = AlertSuccess__extends({}, esm_Alert_Alert.propTypes);
AlertSuccess.defaultProps = AlertSuccess__extends({}, esm_Alert_Alert.defaultProps, {
  svgMarkup: lib_esm["SUCCESS__24"]
});
/* harmony default export */ var Alert_AlertSuccess = (AlertSuccess);
//# sourceMappingURL=AlertSuccess.js.map
// EXTERNAL MODULE: ./node_modules/react-transition-group/index.js
var react_transition_group = __webpack_require__("UVf0");
var react_transition_group_default = /*#__PURE__*/__webpack_require__.n(react_transition_group);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-alerts/lib/esm/InlineMessage/utils/inlineMessageUtil.js

var MESSAGE_TYPE = {
  NONE: 'none',
  HELP: 'help',
  ERROR: 'danger',
  WARN: 'warn',
  INFO: 'info',
  SUCCESS: 'success'
};
var ANIMATION_TYPE = {
  TRANSITION: 'TRANSITION',
  SHAKE: 'SHAKE'
};
var TRANSITION_STATE = {
  ENTER: 'ENTER',
  ENTERING: 'ENTERING',
  ENTERED: 'ENTERED',
  EXIT: 'EXIT',
  EXITING: 'EXITING',
  EXITED: 'EXITED'
};
var duration = 500;
var durationMultiplier = 0.45;
var SETTINGS = {
  SHAKE_DURATION: 600,
  TRANSITION_DURATION: duration,
  TRANSITION_DELAY: duration * durationMultiplier,
  TRANSITION_DURATION_WITH_DELAY: duration - duration * durationMultiplier,
  LINE_HEIGHT: 18,
  NO_MAX_COUNT_MAX_HEIGHT: 200
};
var inlineMessageUtil = {
  isIcon: function isIcon(type) {
    return type !== MESSAGE_TYPE.NONE && type !== MESSAGE_TYPE.HELP;
  },
  getIconTypeToUse: function getIconTypeToUse(_ref) {
    var type = _ref.type,
        prevType = _ref.prevType,
        animating = _ref.animating;
    return animating && (type === MESSAGE_TYPE.HELP || type === MESSAGE_TYPE.NONE) ? prevType : type;
  },
  getIconMarkup: function getIconMarkup(_ref2) {
    var _MESSAGE_TYPE$INFO$ME;

    var type = _ref2.type,
        prevType = _ref2.prevType,
        animating = _ref2.animating;
    var typeToUse = inlineMessageUtil.getIconTypeToUse({
      type: type,
      prevType: prevType,
      animating: animating
    });
    return (_MESSAGE_TYPE$INFO$ME = {}, _MESSAGE_TYPE$INFO$ME[MESSAGE_TYPE.INFO] = lib_esm["INFO__16"], _MESSAGE_TYPE$INFO$ME[MESSAGE_TYPE.WARN] = lib_esm["ALERT_WARNING__16"], _MESSAGE_TYPE$INFO$ME[MESSAGE_TYPE.ERROR] = lib_esm["ALERT__16"], _MESSAGE_TYPE$INFO$ME[MESSAGE_TYPE.SUCCESS] = lib_esm["SUCCESS__16"], _MESSAGE_TYPE$INFO$ME)[typeToUse] || '';
  },
  getAdjustedType: function getAdjustedType(message, type) {
    if (type === void 0) {
      type = MESSAGE_TYPE.ERROR;
    }

    return message === '' || !message ? MESSAGE_TYPE.NONE : type;
  },
  computeAnimationType: function computeAnimationType(_ref3) {
    var type = _ref3.type,
        prevType = _ref3.prevType;
    return {
      iconToIcon: inlineMessageUtil.isIcon(prevType) && inlineMessageUtil.isIcon(type),
      iconToHelp: inlineMessageUtil.isIcon(prevType) && type === MESSAGE_TYPE.HELP,
      helpToIcon: prevType === MESSAGE_TYPE.HELP && inlineMessageUtil.isIcon(type),
      iconToNone: inlineMessageUtil.isIcon(prevType) && type === MESSAGE_TYPE.NONE,
      noneToIcon: prevType === MESSAGE_TYPE.NONE && inlineMessageUtil.isIcon(type),
      anyToNone: prevType !== MESSAGE_TYPE.NONE && type === MESSAGE_TYPE.NONE,
      noneToAny: prevType === MESSAGE_TYPE.NONE && type !== MESSAGE_TYPE.NONE,
      type: type !== prevType ? prevType + "-to-" + type : ''
    };
  },
  generateEnterExitStyles: function generateEnterExitStyles(_ref4) {
    var _ref5;

    var mTop = _ref4.mTop,
        mBottom = _ref4.mBottom,
        maxLineCount = _ref4.maxLineCount,
        _ref4$noAnimation = _ref4.noAnimation,
        noAnimation = _ref4$noAnimation === void 0 ? false : _ref4$noAnimation;
    var hasMaxCount = maxLineCount > 0;
    var marginTop = mTop + "px";
    var marginBottom = mBottom + "px";
    var maxHeight = maxLineCount * SETTINGS.LINE_HEIGHT + "px";
    var transitionAndEase = SETTINGS.TRANSITION_DURATION_WITH_DELAY + "ms ease";
    var transitionAndEaseWithDelay = SETTINGS.TRANSITION_DURATION_WITH_DELAY + "ms ease " + SETTINGS.TRANSITION_DELAY + "ms";

    if (!hasMaxCount) {
      maxHeight = '';
      transitionAndEase = '0ms ease';
      transitionAndEaseWithDelay = "0ms ease " + SETTINGS.TRANSITION_DURATION_WITH_DELAY + "ms";
    }

    return _ref5 = {}, _ref5[TRANSITION_STATE.ENTER] = {
      maxHeight: '0',
      marginTop: '0',
      marginBottom: '0',
      transition: 'none'
    }, _ref5[TRANSITION_STATE.ENTERING] = {
      maxHeight: maxHeight,
      marginTop: marginTop,
      marginBottom: marginBottom,
      transition: noAnimation ? 'none' : "max-height " + transitionAndEase + ", margin-top " + transitionAndEase + ", margin-bottom " + transitionAndEase
    }, _ref5[TRANSITION_STATE.ENTERED] = {
      maxHeight: '',
      marginTop: marginTop,
      marginBottom: marginBottom,
      transition: 'none'
    }, _ref5[TRANSITION_STATE.EXIT] = {
      maxHeight: hasMaxCount ? maxHeight : SETTINGS.NO_MAX_COUNT_MAX_HEIGHT + "px",
      marginTop: marginTop,
      marginBottom: marginBottom,
      transition: 'none'
    }, _ref5[TRANSITION_STATE.EXITING] = {
      maxHeight: '0',
      marginTop: '0',
      marginBottom: '0',
      transition: noAnimation ? 'none' : "max-height " + transitionAndEaseWithDelay + ", margin-top " + transitionAndEaseWithDelay + ", margin-bottom " + transitionAndEaseWithDelay
    }, _ref5[TRANSITION_STATE.EXITED] = {
      maxHeight: '0',
      marginTop: '0',
      marginBottom: '0',
      transition: 'none'
    }, _ref5;
  }
};

/* harmony default export */ var utils_inlineMessageUtil = (inlineMessageUtil);
//# sourceMappingURL=inlineMessageUtil.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-alerts/lib/esm/InlineMessage/InlineMessage.css
var InlineMessage_InlineMessage = __webpack_require__("ACPw");
var InlineMessage_default = /*#__PURE__*/__webpack_require__.n(InlineMessage_InlineMessage);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-alerts/lib/esm/InlineMessage/InlineMessage.js
function InlineMessage__extends() { InlineMessage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return InlineMessage__extends.apply(this, arguments); }

function InlineMessage__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// Third Party Imports



 // Artifactory Imports

 // Primary Imports

 // styles



var InlineMessage_InlineMessage_InlineMessage =
/*#__PURE__*/
function (_Component) {
  InlineMessage__inheritsLoose(InlineMessage, _Component);

  function InlineMessage(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.addAnimationTimeout = function () {
      var noAnimation = _this.props.noAnimation;

      _this.clearAndDeleteTimeouts(ANIMATION_TYPE.TRANSITION);

      _this.timeouts[ANIMATION_TYPE.TRANSITION] = setTimeout(function () {
        delete _this.timeouts[ANIMATION_TYPE.TRANSITION];

        _this.setState({
          animating: false,
          animationReset: false
        });
      }, noAnimation ? 0 : SETTINGS.TRANSITION_DURATION);
    };

    _this.addShakeTimeout = function () {
      var shakeTimeoutCallback = _this.props.shakeTimeoutCallback;

      _this.clearAndDeleteTimeouts(ANIMATION_TYPE.SHAKE);

      _this.timeouts[ANIMATION_TYPE.SHAKE] = setTimeout(function () {
        delete _this.timeouts[ANIMATION_TYPE.SHAKE];

        _this.setState({
          shake: false,
          shakeReset: false
        }, function () {
          if (shakeTimeoutCallback) {
            shakeTimeoutCallback();
          }
        });
      }, SETTINGS.SHAKE_DURATION);
    };

    var _this$props = _this.props,
        type = _this$props.type,
        message = _this$props.message,
        shake = _this$props.shake,
        marginTop = _this$props.marginTop,
        marginBottom = _this$props.marginBottom,
        maxLineCount = _this$props.maxLineCount,
        _noAnimation = _this$props.noAnimation;
    var adjType = inlineMessageUtil.getAdjustedType(message, type);
    var transitionState = adjType === MESSAGE_TYPE.NONE ? TRANSITION_STATE.EXITED : TRANSITION_STATE.ENTERED;
    _this.state = {
      type: adjType,
      prevType: adjType,
      message: message,
      prevMessage: message,
      transitionState: transitionState,
      animating: false,
      animationReset: false,
      shakeReset: false,
      shake: shake
    }; // hash of timeouts if needed for cancelling

    _this.timeouts = {}; // since this is based on props, it can be computed now

    _this.animationType = inlineMessageUtil.computeAnimationType({
      type: adjType,
      prevType: adjType
    }); // since this is based on props, it can be computed now

    _this.enterExitStyles = inlineMessageUtil.generateEnterExitStyles({
      mTop: marginTop,
      mBottom: marginBottom,
      maxLineCount: maxLineCount,
      noAnimation: _noAnimation
    }); // CSSTransition state change callbacks

    _this.onEnter = _this.onTransitionStateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), TRANSITION_STATE.ENTER);
    _this.onEntering = _this.onTransitionStateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), TRANSITION_STATE.ENTERING);
    _this.onEntered = _this.onTransitionStateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), TRANSITION_STATE.ENTERED);
    _this.onExit = _this.onTransitionStateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), TRANSITION_STATE.EXIT);
    _this.onExiting = _this.onTransitionStateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), TRANSITION_STATE.EXITING);
    _this.onExited = _this.onTransitionStateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), TRANSITION_STATE.EXITED);
    return _this;
  }

  var _proto = InlineMessage.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var _this$state = this.state,
        type = _this$state.type,
        message = _this$state.message,
        shake = _this$state.shake,
        shakeCurrentlyReset = _this$state.shakeReset;
    var nextType = nextProps.type,
        newMessage = nextProps.message,
        newShake = nextProps.shake,
        maxLineCount = nextProps.maxLineCount,
        marginTop = nextProps.marginTop,
        marginBottom = nextProps.marginBottom,
        animateIfJustMessageChanges = nextProps.animateIfJustMessageChanges,
        canRetriggerShakeWhileShaking = nextProps.canRetriggerShakeWhileShaking,
        noAnimation = nextProps.noAnimation; // variables to determine if we need to update state based on a change of:
    // message, type, animation, shake, animation reset, or shake reset
    // (resets are a render frame in which the shake or animate classes are removed so
    // they can be re-added on the next render frame to re-trigger a shake or animation)
    // if an animation timeout exist, we are in the process of animating

    var alreadyAnimating = !!this.timeouts[ANIMATION_TYPE.TRANSITION]; // if an shake timeout exist, we are in the process of animating

    var alreadyShaking = !!this.timeouts[ANIMATION_TYPE.SHAKE]; // checks to get type NONE if the newMessage falsey

    var newType = inlineMessageUtil.getAdjustedType(newMessage, nextType);
    var messageChanged = newMessage !== message; // we should animate if the type has changed, or if the message
    // has changed and that is set to trigger and animation

    var animating = newType !== type || messageChanged && animateIfJustMessageChanges; // if we should animate and we are already animating, we need to perform an animation reset

    var animationReset = alreadyAnimating && animating; // if we should shake and we are already shaking, we need to perform a shake reset

    var shakeReset = alreadyShaking && !!newShake; // some additional conditions that determine if we should shake (TODO: explain better)

    var shouldShake = newShake && !shake || newShake && shakeCurrentlyReset; // some additional conditions that determine if we should animate (TODO: explain better)

    var shouldAnimate = !shouldShake && (animating || alreadyAnimating && !shakeReset); // object with properties indicating the type of animation (noneToIcon, iconToHelp, etc)
    // since this is based on props, it can be computed now

    this.animationType = inlineMessageUtil.computeAnimationType({
      type: newType,
      prevType: type
    }); // object with properties containing the transition styles for the CSS Transition for the root element
    // since this is based on props, it can be computed now

    this.enterExitStyles = inlineMessageUtil.generateEnterExitStyles({
      mTop: marginTop,
      mBottom: marginBottom,
      maxLineCount: maxLineCount,
      noAnimation: noAnimation
    }); // are the appropriate conditions meet that require and update of state

    var updatedState = [messageChanged, animating, shouldShake, shakeReset && canRetriggerShakeWhileShaking].some(function (condition) {
      return !!condition;
    });

    if (updatedState) {
      this.setState({
        prevType: type,
        type: newType,
        prevMessage: message,
        message: newMessage,
        animating: shouldAnimate,
        shake: !!newShake && !shouldAnimate,
        animationReset: animationReset,
        shakeReset: shakeReset
      }, function () {
        if (shouldAnimate) {
          // if we should animating (i.e. animate icon and possibly message) add the
          // animation timeout (that will clear and delete any existing animation timeout)
          _this2.addAnimationTimeout();

          if (alreadyShaking && _this2.props.shakeTimeoutCallback) {
            // if we are shaking, our state update will stop that, but we still need to clear
            // and delete any existing shake timeouts and call the shake timout callback
            _this2.clearAndDeleteTimeouts(ANIMATION_TYPE.SHAKE);

            _this2.props.shakeTimeoutCallback();
          }
        } else if (shouldShake || shakeReset && canRetriggerShakeWhileShaking) {
          // if we should shake or retrigger a shake, add the shake timeout
          // and clear and delete any existing animation timeout
          _this2.addShakeTimeout();

          _this2.clearAndDeleteTimeouts(ANIMATION_TYPE.TRANSITION);
        }
      });
    }
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var newShake = nextProps.shake,
        canRetriggerShakeWhileShaking = nextProps.canRetriggerShakeWhileShaking;
    var _this$state2 = this.state,
        shakeCurrentlyReset = _this$state2.shakeReset,
        shake = _this$state2.shake;
    var shouldShake = newShake && !shake || newShake && shakeCurrentlyReset;
    var alreadyShaking = !!this.timeouts[ANIMATION_TYPE.SHAKE];
    var shakeReset = alreadyShaking && !!newShake;
    var shouldUpdate = [!(nextProps.message === this.props.message && nextProps.type === this.props.type && typeof this.timeouts[ANIMATION_TYPE.TRANSITION] !== 'undefined' && typeof this.timeouts[ANIMATION_TYPE.SHAKE] !== 'undefined' && this.state.transitionState === nextState.transitionState), nextState.animationReset !== this.state.animationReset, nextState.shakeReset !== this.state.shakeReset, shouldShake || shakeReset && canRetriggerShakeWhileShaking, this.props.shake && !newShake].some(function (condition) {
      return !!condition;
    });
    return shouldUpdate;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.animationReset || this.state.shakeReset) {
      this.setState({
        animationReset: false,
        shakeReset: false
      });
    }
  };

  _proto.onTransitionStateChange = function onTransitionStateChange(transitionState) {
    if (this.state.transitionState !== transitionState) {
      this.setState({
        transitionState: transitionState
      });
    }
  };

  _proto.clearAndDeleteTimeouts = function clearAndDeleteTimeouts(type) {
    clearTimeout(this.timeouts[type]);
    delete this.timeouts[type];
  };

  _proto.getClassNames = function getClassNames(prefix) {
    var _classnames;

    var _this$state3 = this.state,
        type = _this$state3.type,
        prevType = _this$state3.prevType,
        animating = _this$state3.animating,
        animationReset = _this$state3.animationReset;
    var noAnimation = this.props.noAnimation;
    var _this$animationType = this.animationType,
        iconToIcon = _this$animationType.iconToIcon,
        iconToHelp = _this$animationType.iconToHelp,
        helpToIcon = _this$animationType.helpToIcon,
        iconToNone = _this$animationType.iconToNone,
        noneToIcon = _this$animationType.noneToIcon,
        anyToNone = _this$animationType.anyToNone,
        noneToAny = _this$animationType.noneToAny;
    var isAnimating = animating && !animationReset;
    return classnames_default()('', (_classnames = {}, _classnames[prefix + "transition-reset"] = animationReset, _classnames["" + prefix + type] = type, _classnames["" + prefix + prevType + "-to-" + type] = isAnimating, _classnames[prefix + "icon-to-icon"] = isAnimating && iconToIcon, _classnames[prefix + "icon-to-help"] = isAnimating && iconToHelp, _classnames[prefix + "help-to-icon"] = isAnimating && helpToIcon, _classnames[prefix + "icon-to-none"] = isAnimating && iconToNone, _classnames[prefix + "none-to-icon"] = isAnimating && noneToIcon, _classnames[prefix + "any-to-none"] = isAnimating && anyToNone, _classnames[prefix + "none-to-any"] = isAnimating && noneToAny, _classnames[prefix + "no-animation"] = noAnimation, _classnames));
  };

  _proto.render = function render() {
    var _classnames2;

    var _this$state4 = this.state,
        message = _this$state4.message,
        prevMessage = _this$state4.prevMessage,
        type = _this$state4.type,
        prevType = _this$state4.prevType,
        animating = _this$state4.animating,
        shake = _this$state4.shake,
        transitionState = _this$state4.transitionState,
        animationReset = _this$state4.animationReset,
        shakeReset = _this$state4.shakeReset;
    var _this$props2 = this.props,
        inverse = _this$props2.inverse,
        noAnimation = _this$props2.noAnimation,
        id = _this$props2.id,
        className = _this$props2.className,
        ariaLive = _this$props2.ariaLive; // if animating out (i.e. going to no message), still show the previous message

    var messageToShow = animating && type === MESSAGE_TYPE.NONE ? prevMessage : message; // if animating out (i.e. going to no message), still show the previous type

    var typeToUse = inlineMessageUtil.getIconTypeToUse({
      type: type,
      prevType: prevType,
      animating: animating
    });
    var messageChanged = prevMessage !== messageToShow;
    var iconMarkup = inlineMessageUtil.getIconMarkup({
      type: type,
      prevType: prevType,
      animating: animating
    });
    var enterExitStyles = this.enterExitStyles[transitionState] || {};
    var rootClassNames = classnames_default()('InlineMessage', this.getClassNames('InlineMessage--'), (_classnames2 = {}, _classnames2[className] = !!className, _classnames2));
    var shakeWrapperClassNames = classnames_default()('InlineMessage__shake-wrapper', {
      'InlineMessage__shake-wrapper--shake': shake && !shakeReset,
      'text-white': inverse
    });
    var iconClassNames = classnames_default()('InlineMessage__icon', 'InlineMessage--small-text', 'small', this.getClassNames('InlineMessage__icon--'), {
      'text-info': typeToUse === MESSAGE_TYPE.INFO && !inverse,
      'text-success': typeToUse === MESSAGE_TYPE.SUCCESS && !inverse,
      'text-danger': typeToUse === MESSAGE_TYPE.ERROR && !inverse
    });
    var messageClassNames = classnames_default()('InlineMessage__message', 'InlineMessage--small-text', 'small', this.getClassNames('InlineMessage__message--'), {
      'InlineMessage__message--same-message': !messageChanged && type !== MESSAGE_TYPE.NONE
    });
    var typeRequiresAriaLive = [type === MESSAGE_TYPE.ERROR, type === MESSAGE_TYPE.SUCCESS, type === MESSAGE_TYPE.INFO, type === MESSAGE_TYPE.WARN].some(function (condition) {
      return !!condition;
    });
    var messageToShowIsString = typeof messageToShow === 'string';

    var messageProps = InlineMessage__extends({
      id: id,
      key: "message-" + (messageToShowIsString ? 'string' : 'node') + "-" + (animationReset ? '0' : '1'),
      className: messageClassNames
    }, typeRequiresAriaLive && messageToShow !== '' && {
      role: 'alert',
      'aria-live': ariaLive
    });

    return react_default.a.createElement(react_transition_group["CSSTransition"], {
      classNames: "InlineMessage-CSSTransition",
      timeout: noAnimation ? 0 : SETTINGS.TRANSITION_DURATION,
      in: type !== MESSAGE_TYPE.NONE,
      mountOnEnter: true,
      unmountOnExit: true,
      onEnter: this.onEnter,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }, react_default.a.createElement("div", {
      className: rootClassNames,
      style: enterExitStyles
    }, react_default.a.createElement("div", {
      className: shakeWrapperClassNames,
      key: "inline-message__shake-wrapper-" + (shakeReset ? '0' : '1')
    }, iconMarkup && react_default.a.createElement(esm["SVGIcon"], {
      className: iconClassNames,
      markup: iconMarkup,
      key: "icon-" + (animationReset ? '0' : '1')
    }), messageToShow && messageToShowIsString && react_default.a.createElement("span", InlineMessage__extends({}, messageProps, {
      dangerouslySetInnerHTML: {
        __html: messageToShow
      }
    })), messageToShow && !messageToShowIsString && react_default.a.createElement("div", messageProps, messageToShow))));
  };

  return InlineMessage;
}(react["Component"]);

InlineMessage_InlineMessage_InlineMessage.propTypes = {
  /** The message's id, required for a11y */
  id: prop_types_default.a.string.isRequired,

  /** The type of message */
  type: prop_types_default.a.oneOf(['help', 'info', 'warn', 'danger', 'success']),

  /** The content of the message */
  message: prop_types_default.a.node,

  /** Max line count for expand/collapse transition. This is used to transition the max-height
   * css property of the component when entering or leaving the collapsed (aka 'none') state.
   * Setting this value to 0 makes this height transition immediate, and will accomodate
   * a message with any number of lines. When greater than 0, this value should always be
   * greater than or equal to the actual line count. The default value of 3, works for 1,
   * 2, and 3 lines messages with the only minor difference being the effective transition
   * duration and delay per line. Choose 6 if you have 4-6 lines, and if you have a message longer
   * than 6 lines, you probably need something other than the inline message. */
  maxLineCount: prop_types_default.a.oneOf([0, 3, 6]),

  /** Should the message shake. */
  shake: prop_types_default.a.bool,

  /** Shake timeout callback. This callback is executed to let the consuming component
   * know when a shake has completed (used so the consuming component can update
   * its state to set the shake prop back to false). */
  shakeTimeoutCallback: prop_types_default.a.func,

  /** The top margin. This is used to write the inline-style to enable the
   * transistion of this value (if maxLineCount > 0)*/
  marginTop: prop_types_default.a.number,

  /** The bottom margin. This is used to write the inline-style to enable the
   * transistion of this value (if maxLineCount > 0)*/
  marginBottom: prop_types_default.a.number,

  /** Flag to make message text use white text for better a11y contrast when used on dark backgrounds */
  inverse: prop_types_default.a.bool,

  /** The aria-live value for the alert.
   * 'polite' - indicates that the screen reader should wait until the user is idle before presenting updates to the user
   * 'assertive' may interupt user's flow
   */
  ariaLive: prop_types_default.a.oneOf(['assertive', 'polite']),

  /** flag to animate if the type is the same but the message is different */
  animateIfJustMessageChanges: prop_types_default.a.bool,

  /** flag to determine if the shake can be retriggered while shaking */
  canRetriggerShakeWhileShaking: prop_types_default.a.bool,

  /** flag to disable all animation */
  noAnimation: prop_types_default.a.bool
};
InlineMessage_InlineMessage_InlineMessage.defaultProps = {
  type: 'help',
  message: '',
  maxLineCount: 3,
  shake: false,
  marginTop: 0,
  marginBottom: 0,
  inverse: false,
  ariaLive: 'polite',
  animateIfJustMessageChanges: true,
  canRetriggerShakeWhileShaking: true,
  noAnimation: false
};
/* harmony default export */ var esm_InlineMessage_InlineMessage = (InlineMessage_InlineMessage_InlineMessage);
//# sourceMappingURL=InlineMessage.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-alerts/lib/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Alert", function() { return esm_Alert_Alert; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AlertDanger", function() { return Alert_AlertDanger; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AlertInfo", function() { return Alert_AlertInfo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AlertSuccess", function() { return Alert_AlertSuccess; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "InlineMessage", function() { return esm_InlineMessage_InlineMessage; });






//# sourceMappingURL=index.js.map

/***/ }),

/***/ "bCL1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _HeaderSectionComponent = __webpack_require__("F1Vd");

var _HeaderSectionComponent2 = _interopRequireDefault(_HeaderSectionComponent);

var _TermsAndConditionsComponent = __webpack_require__("wXQb");

var _TermsAndConditionsComponent2 = _interopRequireDefault(_TermsAndConditionsComponent);

var _CalloutCardComponent = __webpack_require__("um2z");

var _CalloutCardComponent2 = _interopRequireDefault(_CalloutCardComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TermsAndConditionsPageComponent = function (_Component) {
    _inherits(TermsAndConditionsPageComponent, _Component);

    function TermsAndConditionsPageComponent(props) {
        _classCallCheck(this, TermsAndConditionsPageComponent);

        return _possibleConstructorReturn(this, (TermsAndConditionsPageComponent.__proto__ || Object.getPrototypeOf(TermsAndConditionsPageComponent)).call(this, props));
    }

    _createClass(TermsAndConditionsPageComponent, [{
        key: 'render',
        value: function render() {
            var options = { 'sitename': this.props.siteName };
            var cardContent = _react2.default.createElement(_TermsAndConditionsComponent2.default, {
                lingua: this.props.lingua,
                siteName: this.props.siteName,
                isWaiting: this.props.isWaiting,
                updatePage: this.props.updatePage,
                onClose: this.props.onClose,
                emailAddress: this.props.emailAddress,
                site: this.props.site
            });
            return _react2.default.createElement(
                'div',
                { className: 'TermsAndConditionsPageComponent border-border-color' },
                _react2.default.createElement(_HeaderSectionComponent2.default, { header: this.props.lingua.read('lex.header.terms.conditions', options) }),
                _react2.default.createElement(_CalloutCardComponent2.default, { content: cardContent, error: '', errorTitle: '' })
            );
        }
    }]);

    return TermsAndConditionsPageComponent;
}(_react.Component);

exports.default = TermsAndConditionsPageComponent;
//# sourceMappingURL=TermsAndConditionsPageComponent.js.map

/***/ }),

/***/ "bMgG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.headerLinkClick = exports.trigger = exports.linkLocations = exports.namedEvents = exports.PAGE_VIEW = exports.GENERIC_EVENT = exports.edap = undefined;

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var edap = exports.edap = (0, _edapWrapper2.default)();

var GENERIC_EVENT = exports.GENERIC_EVENT = 'generic.event';
var PAGE_VIEW = exports.PAGE_VIEW = 'pageview';

var namedEvents = exports.namedEvents = {
    HEADER_LINK_CLICK: 'header.link.click'
};

var linkLocations = exports.linkLocations = {
    HEADER_LINK_OWNER_LOGIN: 'header.login.owner',
    HEADER_LINK_TRAVELER_LOGIN: 'header.login.traveler'
};

var trigger = exports.trigger = function trigger(name, data, options) {
    edap.push({
        name: name,
        data: data,
        options: options
    });
};

var headerLinkClick = exports.headerLinkClick = function headerLinkClick(linkLocation) {
    trigger(namedEvents.HEADER_LINK_CLICK, {
        actionlocation: linkLocation
    });
};
//# sourceMappingURL=edap.js.map

/***/ }),

/***/ "bU6Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DASHBOARD__16 = void 0;
var DASHBOARD__16 = '<svg data-id="SVG_DASHBOARD__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="currentcolor" stroke="none" d="M7 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/><path stroke-linecap="round" stroke-linejoin="round" d="M1 10a7 7 0 0 1 14 0M3.5 10a4.5 4.5 0 0 1 6.7-4m2 2.4c.2.5.3 1 .3 1.6m-2.3-4L8 10M15 10v1.2c0 .6-.5 1.2-1.1 1.2H2c-.6 0-1.1-.6-1.1-1.2V10"/></g></svg>';
exports.DASHBOARD__16 = DASHBOARD__16;

/***/ }),

/***/ "bYe6":
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "bf7X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bh3H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bzaB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Login = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _edap = __webpack_require__("bMgG");

var _reactDropdown = __webpack_require__("CVj+");

var _reactSvg = __webpack_require__("CWk1");

var _CHEVRON_DOWN__ = __webpack_require__("kTPm");

var _PERSON__ = __webpack_require__("52QJ");

var _login = __webpack_require__("yoR0");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loginRE = /(def%26service%3D){1}(.*\.com)?.*/;

var Login = exports.Login = function (_React$Component) {
    _inherits(Login, _React$Component);

    function Login() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Login);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Login.__proto__ || Object.getPrototypeOf(Login)).call.apply(_ref, [this].concat(args))), _this), _this.fireEdap = function (isTravelerLogin, isOwnerLogin) {
            var actionlocation = isTravelerLogin ? _edap.linkLocations.HEADER_LINK_TRAVELER_LOGIN : _edap.linkLocations.HEADER_LINK_OWNER_LOGIN;
            if (isTravelerLogin || isOwnerLogin) {
                (0, _edap.headerLinkClick)(actionlocation);
            }
        }, _this.createClickHandler = function (item) {
            return function (event) {
                if (!item.link) {
                    return;
                }
                var didClickOnTravelerLogin = (0, _login.clickedOnTravelerLogin)(item.cssClass);
                var didClickOnOwnerLogin = (0, _login.clickedOnOwnerLogin)(item.cssClass);

                _this.fireEdap(didClickOnTravelerLogin, didClickOnOwnerLogin);

                if (_this.props.travelerLoginClickHandler && didClickOnTravelerLogin) {
                    event.stopPropagation();
                    event.preventDefault();
                    _this.props.travelerLoginClickHandler();
                    return;
                }

                // CAS Login URLs need to be double encoded because of how their params are structured:
                // https://{DOMAIN}/auth/traveler/login?service=https://{DOMAIN}/exp/sso/auth?lt=traveler&context=def&service={DOUBLE_ENCODED_RETURN_URL}&kmsi=true
                var doubleEncodedURI = encodeURIComponent(encodeURIComponent(window.location.pathname + window.location.search));

                // if login, perform specific link update
                var newLink = item.link.replace(loginRE, '$1' + doubleEncodedURI + '&kmsi=true');

                // if we generate a new link, user has navigated to a sub URL in the same application
                // and we should redirect them there.  Otherwise let default user-agent behavior handle
                // rendered link
                if (newLink !== item.link) {
                    event.stopPropagation();
                    event.preventDefault();
                    window.location.assign(newLink);
                }
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Login, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.props.items) {
                return null;
            }

            var _props = this.props,
                items = _props.items,
                label = _props.label;

            var id = 'site-header__login';

            // NOTE:
            // This allows for testing login functionality locally, as the link url
            // provided by the service redirects to stage.homeaway.com rather than
            // to localhost.
            // NOTE: For development / test
            // items[0].link = 'https://cas-test.homeaway.com/auth/traveler/login?service=http%3A%2F%2Flocalhost:8080%2Fexp%2Fsso%2Fauth%3Flt%3Dtraveler%26context%3Ddef%26service%3D%252F&kmsi=true';
            // NOTE: For stage
            // items[0].link = 'https://cas-stage.homeaway.com/auth/traveler/login?service=http%3A%2F%2Flocalhost:8080%2Fexp%2Fsso%2Fauth%3Flt%3Dtraveler%26context%3Ddef%26service%3D%252F&kmsi=true';


            var toggle = _react2.default.createElement(
                'button',
                {
                    'aria-expanded': 'false',
                    'aria-haspopup': 'true',
                    className: 'site-header-nav__toggle Dropdown__toggle',
                    id: id
                },
                _react2.default.createElement(_reactSvg.SVGIcon, { inlineFlex: true, markup: _PERSON__.PERSON__16 }),
                _react2.default.createElement(
                    'span',
                    { className: 'site-header-nav__icon-label' },
                    label
                ),
                _react2.default.createElement(_reactSvg.SVGIcon, { className: 'Dropdown__toggle-icon', inlineFlex: true, markup: _CHEVRON_DOWN__.CHEVRON_DOWN__16 })
            );

            return _react2.default.createElement(
                _reactDropdown.Dropdown,
                { className: 'site-header-nav__dropdown', customToggle: toggle, dropdownRight: true, id: id, label: label },
                items.map(function (item, index) {
                    return _react2.default.createElement(
                        'li',
                        { key: index, role: 'none' },
                        _react2.default.createElement(
                            'a',
                            { 'data-bypass': 'true', href: item.link, onClick: _this2.createClickHandler(item), role: 'menuitem' },
                            item.text
                        )
                    );
                })
            );
        }
    }]);

    return Login;
}(_react2.default.Component);
//# sourceMappingURL=Login.js.map

/***/ }),

/***/ "c0JP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDropdown = __webpack_require__("CVj+");

var _edap = __webpack_require__("6kQN");

var _edap2 = _interopRequireDefault(_edap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CountrySelector = function (_Component) {
    _inherits(CountrySelector, _Component);

    /* istanbul ignore next */
    function CountrySelector(props) {
        _classCallCheck(this, CountrySelector);

        var _this = _possibleConstructorReturn(this, (CountrySelector.__proto__ || Object.getPrototypeOf(CountrySelector)).call(this, props));

        _this.getCountryNameByCode(_this.props.countryCode);
        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    _createClass(CountrySelector, [{
        key: 'handleChange',
        value: function handleChange(countryCode) {
            this.getCountryNameByCode(countryCode);
            this.props.onChange(countryCode);
        }
    }, {
        key: 'handleDropdownShow',
        value: function handleDropdownShow() {
            (0, _edap2.default)({
                eventaction: 'display country dropdown clicked'
            });
        }
    }, {
        key: 'getCountryNameByCode',
        value: function getCountryNameByCode(countryCode) {
            var currentCountry = this.props.countries.filter(function (country) {
                return country.countryCode === countryCode;
            })[0];
            this.countryName = currentCountry ? currentCountry.countryName : '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                title = _props.title,
                countryCode = _props.countryCode,
                countries = _props.countries;

            return _react2.default.createElement(
                'div',
                { className: 'preference-selector preference-selector--country form-group' },
                _react2.default.createElement(
                    'div',
                    { className: 'preference-selector__title' },
                    title
                ),
                _react2.default.createElement(
                    _reactDropdown.Dropdown,
                    {
                        srOnlyLabel: true,
                        label: 'Country Selector',
                        buttonChildren: _react2.default.createElement(
                            'span',
                            { className: 'preference-selector__selected-option' },
                            _react2.default.createElement('i', { className: 'option-country-flag flag-' + countryCode, 'aria-hidden': true }),
                            this.countryName
                        ),
                        id: 'country-selector',
                        name: 'country-selector',
                        onDropdownShow: this.handleDropdownShow
                    },
                    countries.map(function (country) {
                        return _react2.default.createElement(_reactDropdown.DropdownItem, {
                            text: _react2.default.createElement(
                                'a',
                                null,
                                _react2.default.createElement('i', { className: 'option-country-flag flag-' + country.countryCode, 'aria-hidden': true }),
                                country.countryName
                            ),
                            key: country.countryCode,
                            onClick: function onClick() {
                                return _this2.handleChange(country.countryCode);
                            } // eslint-disable-line react/jsx-no-bind
                        });
                    })
                )
            );
        }
    }]);

    return CountrySelector;
}(_react.Component);

CountrySelector.propTypes = {
    title: _propTypes2.default.string,
    countryCode: _propTypes2.default.string,
    countries: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        countryCode: _propTypes2.default.string,
        countryName: _propTypes2.default.string
    })),
    onChange: _propTypes2.default.func
};
CountrySelector.defaultProps = {
    title: 'Country',
    countryCode: 'jp',
    countries: [{ countryCode: 'jp', countryName: '日本' }, { countryCode: 'us', countryName: 'United States' }],
    onChange: function onChange() {} };
exports.default = CountrySelector;
//# sourceMappingURL=CountrySelector.js.map

/***/ }),

/***/ "cF5y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _ButtonBase = _interopRequireDefault(__webpack_require__("N7cN"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ButtonPrimary(props) {
  var buttonClasses = (0, _classnames.default)('btn-primary', props.className);
  return _react.default.createElement(_ButtonBase.default, _extends({}, props, {
    className: buttonClasses
  }));
}

ButtonPrimary.propTypes = _extends({}, _ButtonBase.default.propTypes);
ButtonPrimary.defaultProps = _extends({}, _ButtonBase.default.defaultProps);
var _default = ButtonPrimary;
exports.default = _default;
//# sourceMappingURL=ButtonPrimary.js.map

/***/ }),

/***/ "cGdw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("rplX");

function buildRequest(method, payload) {
    var additionalHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var standardHeaders = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    var allHeaders = Object.assign(standardHeaders, additionalHeaders);

    var request = {
        method: method,
        headers: allHeaders.headers,
        credentials: 'same-origin'
    };
    if (payload) {
        request.body = JSON.stringify(payload);
    }
    return request;
}

function apiGet(api, payload, headers) {
    return fetch(api, buildRequest('GET', payload, headers));
}

function apiPost(api, payload, headers) {
    return fetch(api, buildRequest('POST', payload, headers));
}

module.exports = {
    apiGet: apiGet, apiPost: apiPost
};
//# sourceMappingURL=api.client.js.map

/***/ }),

/***/ "ci09":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUITCASE__16 = void 0;
var SUITCASE__16 = '<svg data-id="SVG_SUITCASE__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4.28h12.5c.83 0 1.5.67 1.5 1.5v8.33H2.5a1.5 1.5 0 0 1-1.5-1.5V6.97M4.06 14.11V4.27M11.94 14.11V4.27M4.91 4.28l1.42-2.62h3.34l1.42 2.62"/></g></svg>';
exports.SUITCASE__16 = SUITCASE__16;

/***/ }),

/***/ "d4xY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("rplX");

__webpack_require__("/Tvs");

var _AuthAccountTypes = __webpack_require__("ku0b");

var _AuthAccountTypes2 = _interopRequireDefault(_AuthAccountTypes);

var _GoogleAuthComponent = __webpack_require__("ZGnZ");

var _GoogleAuthComponent2 = _interopRequireDefault(_GoogleAuthComponent);

var _FacebookAuthComponent = __webpack_require__("I71r");

var _FacebookAuthComponent2 = _interopRequireDefault(_FacebookAuthComponent);

var _CreatePasswordComponent = __webpack_require__("G0gq");

var _CreatePasswordComponent2 = _interopRequireDefault(_CreatePasswordComponent);

var _ExpediaAuthComponent = __webpack_require__("T/3Q");

var _ExpediaAuthComponent2 = _interopRequireDefault(_ExpediaAuthComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SocialLoginPageDisplayComponent = function (_Component) {
    _inherits(SocialLoginPageDisplayComponent, _Component);

    function SocialLoginPageDisplayComponent(props) {
        _classCallCheck(this, SocialLoginPageDisplayComponent);

        var _this = _possibleConstructorReturn(this, (SocialLoginPageDisplayComponent.__proto__ || Object.getPrototypeOf(SocialLoginPageDisplayComponent)).call(this, props));

        var initialState = {
            emailAddress: _this.props.emailAddress,
            password: '',
            loggedIn: false,
            googleToken: null,
            facebookToken: null,
            expediaToken: null
        };
        _this.displayFacebook = _this.displayFacebook.bind(_this);
        _this.hasAccount = _this.hasAccount.bind(_this);
        _this.displayGoogle = _this.displayGoogle.bind(_this);
        _this.displayExpedia = _this.displayExpedia.bind(_this);

        var token = props.token;

        if (_this.hasAccount(_AuthAccountTypes2.default.GOOGLE)) {
            _this.state = _extends({}, initialState, {
                googleToken: token
            });
        } else if (_this.hasAccount(_AuthAccountTypes2.default.FACEBOOK)) {
            _this.state = _extends({}, initialState, {
                facebookToken: token
            });
        } else {
            _this.state = _extends({}, initialState, {
                expediaToken: token
            });
        }
        return _this;
    }

    _createClass(SocialLoginPageDisplayComponent, [{
        key: 'hasAccount',
        value: function hasAccount(account) {
            return this.props.authAccountType.some(function (t) {
                return t === account;
            });
        }
    }, {
        key: 'displayExpedia',
        value: function displayExpedia() {
            if (this.hasAccount(_AuthAccountTypes2.default.EXPEDIA)) {
                return _react2.default.createElement(_ExpediaAuthComponent2.default, {
                    authStatus: true,
                    lingua: this.props.lingua,
                    handleError: this.props.handleError,
                    onClose: this.props.onClose,
                    setAuthJson: this.props.setAuthJson,
                    performBulkPageUpdate: this.props.performBulkPageUpdate,
                    site: this.props.site,
                    useNewEndpoints: this.props.useNewEndpoints,
                    token: this.state.expediaToken,
                    emailAddress: this.state.emailAddress
                });
            }
            return null;
        }
    }, {
        key: 'displayFacebook',
        value: function displayFacebook() {
            if (this.hasAccount(_AuthAccountTypes2.default.FACEBOOK)) {
                return _react2.default.createElement(_FacebookAuthComponent2.default, {
                    authStatus: true,
                    lingua: this.props.lingua,
                    handleError: this.props.handleError,
                    onClose: this.props.onClose,
                    setAuthJson: this.props.setAuthJson,
                    performBulkPageUpdate: this.props.performBulkPageUpdate,
                    site: this.props.site,
                    useNewEndpoints: this.props.useNewEndpoints,
                    token: this.state.facebookToken,
                    emailAddress: this.state.emailAddress
                });
            }
            return null;
        }
    }, {
        key: 'displayGoogle',
        value: function displayGoogle() {
            if (this.hasAccount(_AuthAccountTypes2.default.GOOGLE)) {
                return _react2.default.createElement(_GoogleAuthComponent2.default, {
                    authStatus: true,
                    lingua: this.props.lingua,
                    handleError: this.props.handleError,
                    onClose: this.props.onClose,
                    setAuthJson: this.props.setAuthJson,
                    performBulkPageUpdate: this.props.performBulkPageUpdate,
                    site: this.props.site,
                    useNewEndpoints: this.props.useNewEndpoints,
                    token: this.state.googleToken,
                    emailAddress: this.state.emailAddress
                });
            }
            return null;
        }
    }, {
        key: 'displayCreatePassword',
        value: function displayCreatePassword() {
            if (this.hasAccount(_AuthAccountTypes2.default.GOOGLE) || this.hasAccount(_AuthAccountTypes2.default.FACEBOOK) || this.hasAccount(_AuthAccountTypes2.default.EXPEDIA)) {
                return _react2.default.createElement(_CreatePasswordComponent2.default, { lingua: this.props.lingua, updatePage: this.props.updatePage, handleError: this.props.handleError, service: this.props.service, emailAddress: this.state.emailAddress,
                    displayButton: !!this.props.multiUserEnabled
                });
            }
            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var header = this.props.lingua.read('lex.social.login.card.header2');
            var muHeader = this.props.lingua.read('lex.social.login.card.muHeader');

            if (this.props.multiUserEnabled) {
                return _react2.default.createElement(
                    'div',
                    { className: 'text-center' },
                    _react2.default.createElement(
                        'div',
                        { className: 'Existing-social-mu' },
                        ' ',
                        muHeader,
                        ' '
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        ' ',
                        this.displayCreatePassword(),
                        ' '
                    )
                );
            }
            return _react2.default.createElement(
                'div',
                { className: 'text-center' },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'Select-your-social-a' },
                        ' ',
                        header,
                        ' '
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'SocialButtons' },
                    this.displayExpedia(),
                    this.displayGoogle(),
                    this.displayFacebook()
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    ' ',
                    this.displayCreatePassword(),
                    ' '
                )
            );
        }
    }]);

    return SocialLoginPageDisplayComponent;
}(_react.Component);

exports.default = SocialLoginPageDisplayComponent;
//# sourceMappingURL=SocialLoginDisplayComponent.js.map

/***/ }),

/***/ "dMLz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @name
 * dedupeLogs
 * @private
 * @description
 * Determines which logs are unique based on message content, line number,
 * column number, and url.
 * @param {array} logs
 * @returns {array}
 */

function dedupeLogs(logs) {
    var logsObj = logs.reduce(function (memo, log) {
        var key = JSON.stringify(log.message) + ', ' + log.lineNumber + ', ' + log.columnNumber + ', ' + log.url;
        if (!memo[key]) {
            memo[key] = log;
        }
        return memo;
    }, {});

    return Object.keys(logsObj).map(function (key) {
        return logsObj[key];
    });
}

module.exports = dedupeLogs;
//# sourceMappingURL=dedupeLogs.js.map

/***/ }),

/***/ "dlC0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DASHBOARD__ = __webpack_require__("bU6Y");

var _GEAR__ = __webpack_require__("0NKa");

var _HEART__ = __webpack_require__("ROVI");

var _LOG_OUT__ = __webpack_require__("Vswj");

var _MAIL__ = __webpack_require__("6Ssj");

var _PERSON__ = __webpack_require__("52QJ");

var _SUITCASE__ = __webpack_require__("ci09");

exports.default = {
    'dashboard': _DASHBOARD__.DASHBOARD__16,
    'door': _LOG_OUT__.LOG_OUT__16,
    'heart': _HEART__.HEART__16,
    'inbox': _MAIL__.MAIL__16,
    'settings': _GEAR__.GEAR__16,
    'suitcase': _SUITCASE__.SUITCASE__16,
    'user': _PERSON__.PERSON__16
};
//# sourceMappingURL=traveler-svgs.js.map

/***/ }),

/***/ "f6Le":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
 **/

module.exports = __webpack_require__("ME9r").default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "f8jN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dedupeLogs = __webpack_require__("dMLz");

/**
 * @name
 * postLogs
 * @private
 * @description
 * Posts logs to a given route.  On success or failure, fires the callback.
 * @param {string} route
 * @param {array} logs
 * @param {string=} logType
 * @param {object} token
 * @param {string} token.name
 * @param {string} token.value
 * @param {function} callback
 */

function postLogs(route, logs, logType, token, callback) {
    var payload = {};

    if (token.value) {
        payload[token.name] = token.value;
    }

    if (logType !== 'exception') {
        payload.logs = dedupeLogs(logs);
    } else {
        payload.errorLogs = dedupeLogs(logs);
    }

    var xhr = new XMLHttpRequest();
    xhr.open('POST', route, true);
    xhr.setRequestHeader('Content-type', 'application/json');
    if (token.value) {
        xhr.setRequestHeader('X-CSRF-Token', token.value);
    }
    xhr.onerror = function xhrError() {
        return callback(xhr.status);
    };
    xhr.onreadystatechange = function xhrStateChange() {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status >= 200 && xhr.status < 400) {
            callback(null);
            return;
        }
        return;
    };
    xhr.send(JSON.stringify(payload));
}

module.exports = postLogs;
//# sourceMappingURL=postLogs.js.map

/***/ }),

/***/ "fXoq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fjAN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fu/O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g3iV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Scratchpad = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactSvg = __webpack_require__("CWk1");

var _HEART__ = __webpack_require__("ROVI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scratchpad = exports.Scratchpad = function (_React$Component) {
    _inherits(Scratchpad, _React$Component);

    function Scratchpad() {
        _classCallCheck(this, Scratchpad);

        return _possibleConstructorReturn(this, (Scratchpad.__proto__ || Object.getPrototypeOf(Scratchpad)).apply(this, arguments));
    }

    _createClass(Scratchpad, [{
        key: 'render',
        value: function render() {
            var label = this.props.label;


            return _react2.default.createElement(
                'div',
                { className: 'site-header-nav__scratchpad', 'data-bypass': 'true' },
                _react2.default.createElement(_reactSvg.SVGIcon, { inlineFlex: true, markup: _HEART__.HEART__16 }),
                _react2.default.createElement(
                    'span',
                    { className: 'site-header-nav__icon-label' },
                    label
                )
            );
        }
    }]);

    return Scratchpad;
}(_react2.default.Component);
//# sourceMappingURL=Scratchpad.js.map

/***/ }),

/***/ "gGW8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gkR1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_React$Component) {
  _inherits(Script, _React$Component);

  // A dictionary mapping script URL to a boolean value indicating if the script
  // has failed to load.


  // A dictionary mapping script URLs to a dictionary mapping
  // component key to component for all components that are waiting
  // for the script to load.
  function Script(props) {
    _classCallCheck(this, Script);

    var _this = _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).call(this, props));

    _this.scriptLoaderId = 'id' + _this.constructor.idCount++; // eslint-disable-line space-unary-ops, no-plusplus
    return _this;
  }

  // A counter used to generate a unique id for each component that uses
  // ScriptLoaderMixin.


  // A dictionary mapping script URL to a boolean value indicating if the script
  // has already been loaded.


  _createClass(Script, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onError = _props.onError,
          onLoad = _props.onLoad,
          url = _props.url;


      if (this.constructor.loadedScripts[url]) {
        onLoad();
        return;
      }

      if (this.constructor.erroredScripts[url]) {
        onError();
        return;
      }

      // If the script is loading, add the component to the script's observers
      // and return. Otherwise, initialize the script's observers with the component
      // and start loading the script.
      if (this.constructor.scriptObservers[url]) {
        this.constructor.scriptObservers[url][this.scriptLoaderId] = this.props;
        return;
      }

      this.constructor.scriptObservers[url] = _defineProperty({}, this.scriptLoaderId, this.props);

      this.createScript();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var url = this.props.url;

      var observers = this.constructor.scriptObservers[url];

      // If the component is waiting for the script to load, remove the
      // component from the script's observers before unmounting the component.
      if (observers) {
        delete observers[this.scriptLoaderId];
      }
    }
  }, {
    key: 'createScript',
    value: function createScript() {
      var _this2 = this;

      var _props2 = this.props,
          onCreate = _props2.onCreate,
          url = _props2.url,
          attributes = _props2.attributes;

      var script = document.createElement('script');

      onCreate();

      // add 'data-' or non standard attributes to the script tag
      if (attributes) {
        Object.keys(attributes).forEach(function (prop) {
          return script.setAttribute(prop, attributes[prop]);
        });
      }

      script.src = url;

      // default async to true if not set with custom attributes
      if (!script.hasAttribute('async')) {
        script.async = 1;
      }

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(shouldRemoveObserver) {
        var observers = _this2.constructor.scriptObservers[url];
        Object.keys(observers).forEach(function (key) {
          if (shouldRemoveObserver(observers[key])) {
            delete _this2.constructor.scriptObservers[url][_this2.scriptLoaderId];
          }
        });
      };
      script.onload = function () {
        _this2.constructor.loadedScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onLoad();
          return true;
        });
      };

      script.onerror = function () {
        _this2.constructor.erroredScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onError();
          return true;
        });
      };

      document.body.appendChild(script);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Script;
}(_react2.default.Component);

Script.propTypes = {
  attributes: _propTypes.PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onCreate: _propTypes.PropTypes.func,
  onError: _propTypes.PropTypes.func.isRequired,
  onLoad: _propTypes.PropTypes.func.isRequired,
  url: _propTypes.PropTypes.string.isRequired
};
Script.defaultProps = {
  attributes: {},
  onCreate: function onCreate() {},
  onError: function onError() {},
  onLoad: function onLoad() {} };
Script.scriptObservers = {};
Script.loadedScripts = {};
Script.erroredScripts = {};
Script.idCount = 0;
exports.default = Script;
module.exports = exports['default'];

/***/ }),

/***/ "h8D/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* istanbul ignore next */
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (search, this_len) {
        if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
    };
}

/* istanbul ignore next */
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (search, pos) {
        return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    };
}
//# sourceMappingURL=string-polyfill.js.map

/***/ }),

/***/ "hWpz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "heEr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _ButtonIconBase = _interopRequireDefault(__webpack_require__("ICDg"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ButtonIconOverlay(props) {
  var buttonClasses = (0, _classnames.default)('btn-overlay', props.className);
  return _react.default.createElement(_ButtonIconBase.default, _extends({}, props, {
    className: buttonClasses
  }));
}

ButtonIconOverlay.propTypes = _extends({}, _ButtonIconBase.default.propTypes);
ButtonIconOverlay.defaultProps = _extends({}, _ButtonIconBase.default.defaultProps);
var _default = ButtonIconOverlay;
exports.default = _default;
//# sourceMappingURL=ButtonIconOverlay.js.map

/***/ }),

/***/ "hyOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("GiK3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/FormInput.css
var esm_FormInput = __webpack_require__("Rn6f");
var FormInput_default = /*#__PURE__*/__webpack_require__.n(esm_FormInput);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/FormInput.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* eslint react/no-danger:0 */




/**
 * FormInput Component
**/

var FormInput_FormInput =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(FormInput, _Component);

  function FormInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onAnimationStart = function (_ref) {
      var target = _ref.target,
          animationName = _ref.animationName;

      // eslint-disable-line no-unused-vars
      switch (animationName) {
        case 'onAutoFillCancel':
          _this.setState({
            isAutoFilled: false
          });

          return false;

        case 'onAutoFillStart':
        default:
          _this.setState({
            isAutoFilled: true
          });

          return true;
      }
    };

    _this.focus = function () {
      _this.input.focus();
    };

    _this.handleChange = function (event) {
      if (_this.state.isDirty !== !!event.target.value) {
        _this.setState({
          isDirty: !!event.target.value
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.state = {
      isAutoFilled: false,
      isDirty: false
    };
    return _this;
  }

  var _proto = FormInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.input) {
      this.input.addEventListener('webkitAnimationStart', this.onAnimationStart);
      this.input.addEventListener('animationstart', this.onAnimationStart);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.input.removeEventListener('webkitAnimationStart', this.onAnimationStart);
    this.input.removeEventListener('animationstart', this.onAnimationStart);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.state.isDirty !== !!nextProps.value && !this.state.isAutoFilled) {
      this.setState({
        isDirty: !!nextProps.value
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        label = _this$props.label,
        leftContent = _this$props.leftContent,
        rightContent = _this$props.rightContent,
        contentClickable = _this$props.contentClickable,
        className = _this$props.className,
        helpText = _this$props.helpText,
        inverse = _this$props.inverse,
        errorMsg = _this$props.errorMsg,
        srOnlyLabel = _this$props.srOnlyLabel,
        inputClassName = _this$props.inputClassName,
        rest = _objectWithoutProperties(_this$props, ["label", "leftContent", "rightContent", "contentClickable", "className", "helpText", "inverse", "errorMsg", "srOnlyLabel", "inputClassName"]);

    var notEmpty = this.state.isDirty || this.state.isAutoFilled || !!this.props.value || this.props.type === 'number' && this.props.value === 0 || !!this.props.defaultValue;
    var parentClasses = classnames_default()(className, {
      'form-group': true,
      'floating-label': !srOnlyLabel,
      'not-empty': !!notEmpty,
      'empty': !notEmpty,
      'has-icon': !!leftContent,
      'has-feedback': !!rightContent,
      'has-error': !!errorMsg
    });
    var labelClasses = classnames_default()({
      'has-icon': !!leftContent,
      'sr-only': srOnlyLabel
    });
    var inputClasses = classnames_default()('form-control', inputClassName);
    var message = errorMsg || helpText;
    var messageId = this.props.id + "__help";

    var inputProps = _extends({
      className: inputClasses,
      'aria-label': label,
      'aria-invalid': !!errorMsg,
      ref: function ref(c) {
        return _this2.input = c;
      },
      onChange: this.handleChange
    }, message && {
      'aria-describedby': messageId
    }, rest);

    var helpProps = _extends({
      className: classnames_default()('help-block', {
        'text-white': inverse
      })
    }, errorMsg && {
      role: 'alert',
      'aria-live': 'polite'
    });

    return react_default.a.createElement("div", {
      className: parentClasses
    }, react_default.a.createElement("input", inputProps), react_default.a.createElement("label", {
      className: labelClasses,
      htmlFor: this.props.id
    }, label), leftContent && react_default.a.createElement("span", {
      className: classnames_default()('form-control-icon', {
        'is-clickable': contentClickable
      })
    }, leftContent), rightContent && react_default.a.createElement("span", {
      className: classnames_default()('form-control-feedback', {
        'is-clickable': contentClickable
      })
    }, rightContent), message && typeof message === 'string' && react_default.a.createElement("span", _extends({}, helpProps, {
      id: messageId,
      dangerouslySetInnerHTML: {
        __html: message
      }
    })), message && typeof message !== 'string' && react_default.a.createElement("div", _extends({}, helpProps, {
      id: messageId
    }), message));
  };

  return FormInput;
}(react["Component"]);

FormInput_FormInput.propTypes = {
  /** The Input's id, required for a11y */
  id: prop_types_default.a.string.isRequired,

  /** The Input's label, required for a11y */
  label: prop_types_default.a.node.isRequired,

  /** The actual content of the input */
  value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),

  /** Input's type */
  type: prop_types_default.a.oneOf(['text', 'password', 'email', 'number', 'tel']),

  /** Want to pass a CSS class to the input? This is your property. */
  inputClassName: prop_types_default.a.string,

  /** For form controls with no visible label, set this to true. Make sure to still add a value to the label property. For screen readers. */
  srOnlyLabel: prop_types_default.a.bool,

  /** Add content to the left of the text. This can be a string, element, or component */
  leftContent: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.element]),

  /** Add content to the right side of the input box. This can be a string, element, or component */
  rightContent: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.element]),

  /** If you are sticking content into the input that needs to accept mouse interactions, set this to true. */
  contentClickable: prop_types_default.a.bool,

  /** When populated with a string, this will display a help message beneath the input */
  helpText: prop_types_default.a.node,

  /** When populated with a string, this will turn the border red and display a validation error beneath the input. */
  errorMsg: prop_types_default.a.node,

  /** Flag to make helpText and errorMsg use white text for better a11y contrast when used on dark backgrounds */
  inverse: prop_types_default.a.bool,

  /** Called when the value property changes */
  onChange: prop_types_default.a.func
};
FormInput_FormInput.defaultProps = {
  srOnlyLabel: false,
  contentClickable: false,
  type: 'text',
  inputClassName: ''
};
/* harmony default export */ var lib_esm_FormInput = (FormInput_FormInput);
//# sourceMappingURL=FormInput.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-svg/lib/esm/index.js
var esm = __webpack_require__("CWk1");
var esm_default = /*#__PURE__*/__webpack_require__.n(esm);

// EXTERNAL MODULE: ./node_modules/@homeaway/svg-defs/lib/esm/index.js + 313 modules
var lib_esm = __webpack_require__("QnUD");

// EXTERNAL MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/CheckRadioBase.css
var esm_CheckRadioBase = __webpack_require__("fu/O");
var CheckRadioBase_default = /*#__PURE__*/__webpack_require__.n(esm_CheckRadioBase);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/CheckRadioBase.js
function CheckRadioBase__extends() { CheckRadioBase__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CheckRadioBase__extends.apply(this, arguments); }

function CheckRadioBase__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = CheckRadioBase__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function CheckRadioBase__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function CheckRadioBase__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }







/**
 * CheckRadioBase
 *
 * This is the base component for RadioButtons and Checkboxes.
 */

var CheckRadioBase_CheckRadioBase =
/*#__PURE__*/
function (_Component) {
  CheckRadioBase__inheritsLoose(CheckRadioBase, _Component);

  function CheckRadioBase(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleChange = function (event) {
      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    return _this;
  }

  var _proto = CheckRadioBase.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.input) {
      this.input.indeterminate = this.props.indeterminate;
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.indeterminate !== this.props.indeterminate) {
      this.input.indeterminate = this.props.indeterminate;
    }
  };

  _proto.render = function render() {
    var _classNames,
        _classNames2,
        _classNames3,
        _this2 = this;

    var _this$props = this.props,
        label = _this$props.label,
        checked = _this$props.checked,
        type = _this$props.type,
        error = _this$props.error,
        className = _this$props.className,
        inline = _this$props.inline,
        size = _this$props.size,
        children = _this$props.children,
        onMouseUp = _this$props.onMouseUp,
        onTouchEnd = _this$props.onTouchEnd,
        indeterminate = _this$props.indeterminate,
        rest = CheckRadioBase__objectWithoutProperties(_this$props, ["label", "checked", "type", "error", "className", "inline", "size", "children", "onMouseUp", "onTouchEnd", "indeterminate"]);

    var parentClasses = classnames_default()(className, (_classNames = {
      'form-group': true,
      'CRB': true
    }, _classNames["CRB--" + type] = true, _classNames['CRB--inline'] = inline, _classNames["CRB--" + size] = size, _classNames['has-error'] = !!error, _classNames['CRB--disabled'] = !!this.props.disabled, _classNames));
    var inputClasses = classnames_default()('CRB__input', (_classNames2 = {}, _classNames2['CRB__input--error'] = !!error, _classNames2));
    var labelClasses = classnames_default()('CRB__label', (_classNames3 = {}, _classNames3['CRB__label--error'] = !!error, _classNames3));
    return react_default.a.createElement("div", {
      className: parentClasses,
      role: "checkbox",
      "aria-checked": checked,
      onTouchEnd: onTouchEnd,
      onMouseUp: onMouseUp
    }, react_default.a.createElement("label", {
      className: labelClasses
    }, react_default.a.createElement("input", CheckRadioBase__extends({
      ref:
      /* istanbul ignore next */
      function ref(e) {
        _this2.input = e;
      },
      type: type,
      className: inputClasses
    }, rest, {
      checked: checked,
      onChange: this.handleChange
    })), react_default.a.createElement("div", {
      className: "CRB__toggle"
    }, type === 'checkbox' && !this.props.disabled && !indeterminate && this.props.checked && react_default.a.createElement(esm["SVGIcon"], {
      inlineFlex: true,
      className: "CRB__svg",
      markup: size === 'sm' ? lib_esm["CHECK__12"] : lib_esm["CHECK__16"]
    }), type === 'checkbox' && indeterminate && react_default.a.createElement(esm["SVGIcon"], {
      inlineFlex: true,
      className: "CRB__svg",
      markup: size === 'sm' ? lib_esm["MINUS__12"] : lib_esm["MINUS__16"]
    })), react_default.a.createElement("span", {
      className: "label-text"
    }, label)), children);
  };

  return CheckRadioBase;
}(react["Component"]);

CheckRadioBase_CheckRadioBase.propTypes = {
  /** Text label, can also contain other content if you need it. */
  label: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.element]),

  /** Mark the component as checked */
  checked: prop_types_default.a.bool,

  /** If you intend to use these inline (horizontal). */
  inline: prop_types_default.a.bool,

  /** Set to true to turn it red, such as when it is required */
  error: prop_types_default.a.bool,

  /** Size variation. Default is 24px width/height; 'sm' will change both to 16px */
  size: prop_types_default.a.oneOf(['sm']),

  /** Called when the checked property changes */
  onChange: prop_types_default.a.func,

  /** Ignore, part of the base component */
  type: prop_types_default.a.oneOf(['radio', 'checkbox'])
};
CheckRadioBase_CheckRadioBase.defaultProps = {};
/* harmony default export */ var lib_esm_CheckRadioBase = (CheckRadioBase_CheckRadioBase);
//# sourceMappingURL=CheckRadioBase.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/Checkbox.css
var Checkbox = __webpack_require__("q+4R");
var Checkbox_default = /*#__PURE__*/__webpack_require__.n(Checkbox);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/Checkbox.js
function Checkbox__extends() { Checkbox__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Checkbox__extends.apply(this, arguments); }






function Checkbox_Checkbox(props) {
  return react_default.a.createElement(lib_esm_CheckRadioBase, Checkbox__extends({
    type: "checkbox"
  }, props));
}

Checkbox_Checkbox.propTypes = Checkbox__extends({
  /** Mark the Checkbox as indeterminate */
  indeterminate: prop_types_default.a.bool
}, lib_esm_CheckRadioBase.propTypes);
Checkbox_Checkbox.defaultProps = Checkbox__extends({
  indeterminate: false
}, lib_esm_CheckRadioBase.defaultProps);
/* harmony default export */ var esm_Checkbox = (Checkbox_Checkbox);
//# sourceMappingURL=Checkbox.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/RadioButton.css
var RadioButton = __webpack_require__("JRJL");
var RadioButton_default = /*#__PURE__*/__webpack_require__.n(RadioButton);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/RadioButton.js
function RadioButton__extends() { RadioButton__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return RadioButton__extends.apply(this, arguments); }





function RadioButton_RadioButton(props) {
  return react_default.a.createElement(lib_esm_CheckRadioBase, RadioButton__extends({
    type: "radio"
  }, props));
}

RadioButton_RadioButton.propTypes = RadioButton__extends({}, lib_esm_CheckRadioBase.propTypes);
RadioButton_RadioButton.defaultProps = RadioButton__extends({}, lib_esm_CheckRadioBase.defaultProps);
/* harmony default export */ var esm_RadioButton = (RadioButton_RadioButton);
//# sourceMappingURL=RadioButton.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/RadioGroup.js
function RadioGroup__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var RadioGroup_RadioGroup =
/*#__PURE__*/
function (_Component) {
  RadioGroup__inheritsLoose(RadioGroup, _Component);

  function RadioGroup() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = RadioGroup.prototype;

  _proto.render = function render() {
    var _this = this;

    return react_default.a.createElement("div", {
      id: this.props.name,
      "aria-label": this.props.ariaLabel,
      role: "radiogroup"
    }, this.props.children.map(
    /* istanbul ignore next */
    function (child, i) {
      return react_default.a.cloneElement(child, {
        name: _this.props.name,
        key: "radio-" + _this.props.name + "-" + i
      });
    }));
  };

  return RadioGroup;
}(react["Component"]);

RadioGroup_RadioGroup.propTypes = {
  /** name property that gets passed on to the inputs. Should be similar to a variable name (i.e. creditCardChoices) */
  name: prop_types_default.a.string.isRequired,

  /** Radio group's label to be read by screen readers */
  ariaLabel: prop_types_default.a.string.isRequired
};
/* harmony default export */ var esm_RadioGroup = (RadioGroup_RadioGroup);
//# sourceMappingURL=RadioGroup.js.map
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__("y1vT");
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/FormTextArea.css
var esm_FormTextArea = __webpack_require__("Vrhc");
var FormTextArea_default = /*#__PURE__*/__webpack_require__.n(esm_FormTextArea);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/FormTextArea.js
function FormTextArea__extends() { FormTextArea__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FormTextArea__extends.apply(this, arguments); }

function FormTextArea__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = FormTextArea__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function FormTextArea__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function FormTextArea__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint react/no-danger:0 */





/**
 * FormTextArea Component
**/
// the values are used for computations related to autoExpand functionality
// these are default values that will be override upon componentDidMount if
// autoExpand feature is enabled, using the computesStyles from the textarea

var DEFAULT_COMPUTED_STYLE_VALUES = {
  borderWidth: 1,
  lineHeight: 24,
  maximumHeight: 0,
  paddingBottom: 8,
  paddingTop: 34
};

var FormTextArea_FormTextArea =
/*#__PURE__*/
function (_Component) {
  FormTextArea__inheritsLoose(FormTextArea, _Component);

  function FormTextArea(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleChange = function (event) {
      if (_this.state.isDirty !== !!event.target.value) {
        _this.setState({
          isDirty: !!event.target.value
        });
      } // controlled components will autoExpand via componentDidUpdate


      if (_this.props.autoExpand && typeof _this.props.value !== 'string') {
        _this.autoExpand();
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.handleFocus = function (event) {
      if (!_this.state.hasFocus) {
        _this.setState({
          hasFocus: true
        });
      }

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      if (_this.state.hasFocus) {
        _this.setState({
          hasFocus: false
        });
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.state = {
      isDirty: false,
      hasFocus: false,
      minRows: _this.props.rows || 0
    };
    _this.debouncedResize = lodash_debounce_default()(_this.onResize, 250, {
      maxWait: 1000
    }).bind(_assertThisInitialized(_assertThisInitialized(_this))); // stored if autoExpand and (maxRows or maxHeight) configured for use.
    // is used to toggle overflow from hidden to auto when max height is reached

    _this.computedMaxHeight = 0;
    return _this;
  }

  var _proto = FormTextArea.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.textArea && this.props.autoExpand) {
      this.initializeAutoExpand({
        maxHeight: this.props.maxHeight,
        minRows: this.state.minRows,
        maxRows: this.props.maxRows
      });
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.state.isDirty !== !!nextProps.value) {
      this.setState({
        isDirty: !!nextProps.value
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var valueChanged = this.props.value !== prevProps.value;

    if (this.props.autoExpand && valueChanged) {
      this.autoExpand();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.autoExpand && typeof window !== 'undefined') {
      window.removeEventListener('resize', this.debouncedResize);
    }
  };

  _proto.onResize = function onResize() {
    this.autoExpand();
  };

  _proto.autoExpand = function autoExpand() {
    // Set the height to 0, so we can get the correct content height via scrollHeight
    // Also, running this through state changes causes a race condition when decreasing scrollHeight.
    this.textArea.style.height = '0px'; // set height to scrollHeight, but add border-width * 2 since that is not reported in scrollHeight
    // but is used in box-sizing: border-box to determine height of textarea element

    var newHeight = this.textArea.scrollHeight + this.computedStyleValues.borderWidth * 2;
    this.textArea.style.height = newHeight + "px"; // if computedMaxHeight > 0, check to make sure overflow is appropriate

    if (this.computedMaxHeight > 0) {
      var overflow = this.textArea.style.overflow;

      if (overflow === 'hidden' && newHeight > this.computedMaxHeight) {
        this.textArea.style.overflow = 'auto';
      } else if (overflow === 'auto' && newHeight < this.computedMaxHeight) {
        this.textArea.style.overflow = 'hidden';
      }
    }
  };

  _proto.initializeAutoExpand = function initializeAutoExpand(_ref) {
    var _ref$maxHeight = _ref.maxHeight,
        maxHeight = _ref$maxHeight === void 0 ? 'none' : _ref$maxHeight,
        _ref$minRows = _ref.minRows,
        minRows = _ref$minRows === void 0 ? 0 : _ref$minRows,
        _ref$maxRows = _ref.maxRows,
        maxRows = _ref$maxRows === void 0 ? 0 : _ref$maxRows;

    // eslint-disable-line complexity
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.debouncedResize);
    }

    if (maxHeight) {
      this.textArea.style.maxHeight = maxHeight;
    } // set this.computedStyleValues with computed styles, passing in DEFAULT_COMPUTED_STYLE_VALUES
    // as default values. do this after setting maxHeight, so we can get a computed max-height, if set.


    this.computedStyleValues = this.getComputedStyleValues(DEFAULT_COMPUTED_STYLE_VALUES);

    if (!isNaN(this.computedStyleValues.maxHeight)) {
      this.computedMaxHeight = this.computedStyleValues.maxHeight;
    }

    if (minRows > 1) {
      this.textArea.style.minHeight = this.getHeightFromRows(minRows, this.computedStyleValues) + "px";
    }

    if (!this.props.maxHeight && maxRows > 0) {
      var maxHeightFromRows = this.getHeightFromRows(maxRows, this.computedStyleValues);
      this.textArea.style.maxHeight = maxHeightFromRows + "px";
      this.computedMaxHeight = maxHeightFromRows;
    }

    this.textArea.style.overflow = 'hidden';
    this.autoExpand();
  };

  _proto.getHeightFromRows = function getHeightFromRows(rows, computedStyleValues) {
    return rows * computedStyleValues.lineHeight + computedStyleValues.paddingTop + computedStyleValues.paddingBottom + computedStyleValues.borderWidth * 2;
  };

  _proto.getComputedStyleValues = function getComputedStyleValues(defaults) {
    if (this.textArea && typeof window !== 'undefined') {
      var computedStyle = window.getComputedStyle(this.textArea);
      return {
        borderWidth: this.getStyleValue('border-width', computedStyle, defaults.borderWidth),
        lineHeight: this.getStyleValue('line-height', computedStyle, defaults.lineHeight),
        maxHeight: this.getStyleValue('max-height', computedStyle, NaN),
        paddingBottom: this.getStyleValue('padding-bottom', computedStyle, defaults.paddingBottom),
        paddingTop: this.getStyleValue('padding-top', computedStyle, defaults.paddingTop)
      };
    }

    return defaults;
  };

  _proto.getStyleValue = function getStyleValue(property, computedStyle, defaultValue) {
    var value = parseInt(computedStyle.getPropertyValue(property), 10);
    return !isNaN(value) ? value : defaultValue;
  };
  /** Can be called exernally to force focus */


  _proto.focus = function focus() {
    this.textArea.focus();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        label = _this$props.label,
        className = _this$props.className,
        helpText = _this$props.helpText,
        inverse = _this$props.inverse,
        errorMsg = _this$props.errorMsg,
        srOnlyLabel = _this$props.srOnlyLabel,
        autoExpand = _this$props.autoExpand,
        rest = FormTextArea__objectWithoutProperties(_this$props, ["label", "className", "helpText", "inverse", "errorMsg", "srOnlyLabel", "autoExpand"]);

    var hasError = !!errorMsg;
    var notEmpty = this.state.isDirty || this.props.value;
    var parentClasses = classnames_default()(className, {
      'form-group': true,
      'floating-label': !srOnlyLabel,
      'not-empty': notEmpty,
      'empty': !notEmpty,
      'has-error': hasError
    }); // note that below, the disabled prop has not been destructured since it needs to
    // get passed through with ...rest to the textarea element to be used as an attribute

    var labelClasses = classnames_default()('FormTextArea__floating-label', {
      'sr-only': srOnlyLabel,
      'FormTextArea__floating-label--has-error': hasError && !this.state.hasFocus,
      'FormTextArea__floating-label--disabled': this.props.disabled
    });
    var textAreaClasses = classnames_default()('FormTextArea__textarea form-control', {
      'FormTextArea__textarea--auto-expand': autoExpand
    });
    var message = errorMsg || helpText;
    var messageId = this.props.id + "__help";

    var textareaProps = FormTextArea__extends({
      className: textAreaClasses,
      'aria-label': label,
      ref: function ref(c) {
        _this2.textArea = c;
      },
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur
    }, message && {
      'aria-describedby': messageId
    }, rest);

    var helpProps = FormTextArea__extends({
      className: classnames_default()('help-block', {
        'text-white': inverse
      })
    }, errorMsg && {
      role: 'alert',
      'aria-live': 'polite'
    }); // These props are invalid in the native textarea, so pop them off.


    delete textareaProps.maxHeight;
    delete textareaProps.maxRows;
    return react_default.a.createElement("div", {
      className: parentClasses
    }, react_default.a.createElement("textarea", textareaProps), react_default.a.createElement("label", {
      className: labelClasses,
      htmlFor: this.props.id
    }, label), message && react_default.a.createElement("span", FormTextArea__extends({}, helpProps, {
      id: messageId,
      dangerouslySetInnerHTML: {
        __html: message
      }
    })));
  };

  return FormTextArea;
}(react["Component"]);

FormTextArea_FormTextArea.propTypes = {
  /** The textarea's id, required for a11y */
  id: prop_types_default.a.string.isRequired,

  /** The textarea's label, required for a11y */
  label: prop_types_default.a.string.isRequired,

  /** The actual content of the textarea */
  value: prop_types_default.a.string,

  /** The height, in number of lines, to make the textarea. This is also the minimum size for autoExpand textareas */
  rows: prop_types_default.a.number,

  /** A flag to make the textarea control expand its height to fit the content */
  autoExpand: prop_types_default.a.bool,

  /** The height as a string, in a CSS unit (px, em, vh...) to limit the textarea's height. Can be left blank, zero, or negative for no limit. */
  maxHeight: prop_types_default.a.string,

  /** The maximum height, in number of lines, to make the textarea. This will be trumped by maxHeight */
  maxRows: prop_types_default.a.number,

  /** For form controls with no visible label, set this to true. Make sure to still add a value to the label property. For screen readers. */
  srOnlyLabel: prop_types_default.a.bool,

  /** When populated with a string, this will display a help message beneath the input */
  helpText: prop_types_default.a.string,

  /** When populated with a string, this will turn the border red and display a validation error beneath the input */
  errorMsg: prop_types_default.a.string,

  /** Flag to make helpText and errorMsg use white text for better a11y contrast when used on dark backgrounds */
  inverse: prop_types_default.a.bool,

  /** Called when the value property changes */
  onChange: prop_types_default.a.func,

  /** Called when the textarea gains focus */
  onFocus: prop_types_default.a.func,

  /** Called when textarea loses focus */
  onBlur: prop_types_default.a.func
};
FormTextArea_FormTextArea.defaultProps = {
  autoExpand: false,
  srOnlyLabel: false
};
/* harmony default export */ var lib_esm_FormTextArea = (FormTextArea_FormTextArea);
//# sourceMappingURL=FormTextArea.js.map
// EXTERNAL MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/Switch.css
var esm_Switch = __webpack_require__("rM/n");
var Switch_default = /*#__PURE__*/__webpack_require__.n(esm_Switch);

// CONCATENATED MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/Switch.js
function Switch__extends() { Switch__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Switch__extends.apply(this, arguments); }

function Switch__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Switch__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Switch__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Switch__inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }







/**
 * CheckRadioBase
 *
 * This is the base component for RadioButtons and Checkboxes.
 */

var Switch_Switch =
/*#__PURE__*/
function (_Component) {
  Switch__inheritsLoose(Switch, _Component);

  function Switch(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _classNames;

    var _this$props = this.props,
        label = _this$props.label,
        checked = _this$props.checked,
        id = _this$props.id,
        size = _this$props.size,
        useSVG = _this$props.useSVG,
        className = _this$props.className,
        onMouseUp = _this$props.onMouseUp,
        onTouchEnd = _this$props.onTouchEnd,
        rest = Switch__objectWithoutProperties(_this$props, ["label", "checked", "id", "size", "useSVG", "className", "onMouseUp", "onTouchEnd"]);

    var parentClasses = classnames_default()(className, (_classNames = {
      'switch': true
    }, _classNames["switch--" + size] = size, _classNames['disabled'] = !!this.props.disabled, _classNames));
    return react_default.a.createElement("div", {
      className: parentClasses,
      role: "switch",
      "aria-checked": checked,
      onTouchEnd: onTouchEnd,
      onMouseUp: onMouseUp
    }, react_default.a.createElement("input", Switch__extends({
      type: "checkbox",
      id: id,
      onChange: this.props.onChange,
      checked: checked
    }, rest)), react_default.a.createElement("label", {
      htmlFor: id
    }, useSVG && react_default.a.createElement(esm["SVGIcon"], {
      inline: true,
      className: "switch-checked text-white",
      markup: size === 'sm' ? lib_esm["CHECK__16"] : lib_esm["CHECK__24"]
    }), useSVG && react_default.a.createElement(esm["SVGIcon"], {
      inline: true,
      className: "switch-unchecked text-white",
      markup: size === 'sm' ? lib_esm["CLOSE__16"] : lib_esm["CLOSE__24"]
    }), react_default.a.createElement("div", {
      className: "switch-toggle"
    })), react_default.a.createElement("label", {
      htmlFor: id
    }, label));
  };

  return Switch;
}(react["Component"]);

Switch_Switch.propTypes = {
  /** Text label, can also contain other content if you need it. */
  label: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.element]),

  /** Mark the component as checked */
  checked: prop_types_default.a.bool,

  /** id attribute for label */
  id: prop_types_default.a.string.isRequired,

  /** Size variation from Baseline. Currently only one of: 'sm' */
  size: prop_types_default.a.oneOf(['sm']),

  /** Called when the checked property changes */
  onChange: prop_types_default.a.func,

  /** Should on and off state display SVG checkmark and X. */
  useSVG: prop_types_default.a.bool
};
Switch_Switch.defaultProps = {
  onChange:
  /* istanbul ignore next */
  function onChange() {},
  useSVG: true
};
/* harmony default export */ var lib_esm_Switch = (Switch_Switch);
//# sourceMappingURL=Switch.js.map
// CONCATENATED MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormInput", function() { return lib_esm_FormInput; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Checkbox", function() { return esm_Checkbox; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RadioButton", function() { return esm_RadioButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RadioGroup", function() { return esm_RadioGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormTextArea", function() { return lib_esm_FormTextArea; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Switch", function() { return lib_esm_Switch; });







//# sourceMappingURL=index.js.map

/***/ }),

/***/ "iOK6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "juNs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k4AA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
 **/

var AbacusClientUtils = __webpack_require__("OWqW").default;

exports.initialize = AbacusClientUtils.initialize;
exports.evaluateExperiment = AbacusClientUtils.evaluateExperiment;
exports.evaluateAllExperiments = AbacusClientUtils.evaluateAllExperiments;
exports.evaluateExperimentAndLog = AbacusClientUtils.evaluateExperimentAndLog;
exports.logExperiment = AbacusClientUtils.logExperiment;

module.exports = AbacusClientUtils;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "k4Yh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Logo = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__("Wf0s");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Logo = exports.Logo = function (_React$Component) {
    _inherits(Logo, _React$Component);

    function Logo() {
        _classCallCheck(this, Logo);

        return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
    }

    _createClass(Logo, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'site-header-logo' },
                this.parterLogoLink,
                this.logoLink
            );
        }
    }, {
        key: 'logoLink',
        get: function get() {
            var _props = this.props,
                altText = _props.altText,
                hasSearch = _props.hasSearch,
                image = _props.image,
                link = _props.link,
                partnerLogo = _props.partnerLogo,
                text = _props.text;

            var className = (0, _classnames2.default)('site-header-logo__link', 'flex-item', { 'has-search': hasSearch }, { 'hidden-xs': hasSearch || !!partnerLogo });

            return _react2.default.createElement(
                'a',
                { className: className, href: link, title: text },
                _react2.default.createElement('img', { alt: altText, className: 'site-header-logo__img img-responsive', role: 'presentation', src: image })
            );
        }

        /* istanbul ignore next */

    }, {
        key: 'parterLogoLink',
        get: function get() {
            if (!this.props.partnerLogo) {
                return null;
            }

            var _props$partnerLogo = this.props.partnerLogo,
                image = _props$partnerLogo.image,
                link = _props$partnerLogo.link,
                text = _props$partnerLogo.text;


            return _react2.default.createElement(
                'a',
                { className: 'site-header-logo__link has-partner-divider', href: link, title: text },
                _react2.default.createElement('img', { alt: 'partner logo', className: 'site-header-logo__img', src: image })
            );
        }
    }]);

    return Logo;
}(_react2.default.Component);
//# sourceMappingURL=Logo.js.map

/***/ }),

/***/ "kTPm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHEVRON_DOWN__16 = void 0;
var CHEVRON_DOWN__16 = '<svg data-id="SVG_CHEVRON_DOWN__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M3 6l5 4.6L13 6"/></svg>';
exports.CHEVRON_DOWN__16 = CHEVRON_DOWN__16;

/***/ }),

/***/ "kaHf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ku0b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var AuthAccountTypes = {
    FACEBOOK: 'LOGIN_FACEBOOK',
    GOOGLE: 'LOGIN_GOOGLE',
    UMS: 'LOGIN_UMS',
    SIGNUP: 'SIGNUP',
    EXPEDIA: 'LOGIN_EXPEDIA',

    isValid: function isValid(account) {
        return _typeof(this.GOOGLE) === account || this.FACEBOOK === account || this.UMS === account || this.SIGNUP === account || this.EXPEDIA === account;
    },
    isNotUndefined: function isNotUndefined(account) {
        return typeof account !== 'undefined';
    }
};
exports.default = AuthAccountTypes;
//# sourceMappingURL=AuthAccountTypes.js.map

/***/ }),

/***/ "kyi2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lNQ5":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "mOwr":
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),

/***/ "mbC/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mbiX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("UVcR");

var _reactButtons = __webpack_require__("WAAH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SuccessComponent = function (_Component) {
    _inherits(SuccessComponent, _Component);

    function SuccessComponent(props) {
        _classCallCheck(this, SuccessComponent);

        var _this = _possibleConstructorReturn(this, (SuccessComponent.__proto__ || Object.getPrototypeOf(SuccessComponent)).call(this, props));

        _this.close = _this.close.bind(_this);
        return _this;
    }

    _createClass(SuccessComponent, [{
        key: 'close',
        value: function close() {
            this.props.onClose();
        }
    }, {
        key: 'getHeader',
        value: function getHeader() {
            var header = void 0;
            switch (this.props.successContext) {
                case 'passwordchange':
                    header = this.props.lingua.read('lex.header.success.simple');
                    break;
                case 'success':
                    header = this.props.lingua.read('lex.header.confirmed.account');
                    break;
                default:
                    var options = { 'firstName': this.props.firstName };
                    header = this.props.lingua.read('lex.header.success', options);
                    break;
            }
            return header;
        }
    }, {
        key: 'getTitle',
        value: function getTitle() {
            var title = void 0;
            switch (this.props.successContext) {
                case 'passwordchange':
                    title = this.props.lingua.read('lex.password.change.success');
                    break;
                case 'success':
                    title = this.props.lingua.read('lex.account.confirm.title');
                    break;
                default:
                    title = this.props.lingua.read('lex.signup.success.subtitle');
                    break;
            }
            return title;
        }
    }, {
        key: 'render',
        value: function render() {
            var header = this.getHeader();
            var title = this.getTitle();
            return _react2.default.createElement(
                'div',
                { className: 'SuccessComponent text-center' },
                _react2.default.createElement(
                    'div',
                    { className: 'SvgImage' },
                    _react2.default.createElement(
                        'svg',
                        { width: '72', height: '72', xmlns: 'http://www.w3.org/2000/svg' },
                        _react2.default.createElement(
                            'g',
                            { stroke: '#0067DB', fill: 'none', fillRule: 'evenodd' },
                            _react2.default.createElement('circle', { strokeOpacity: '.2', cx: '36', cy: '36', r: '35.5' }),
                            _react2.default.createElement('path', { strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M24 38l10 8 14-20' })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'h3',
                        { className: 'Header' },
                        header
                    )
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'SuccessPadding lead' },
                    title
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'SuccessButton' },
                    _react2.default.createElement(
                        'form',
                        null,
                        _react2.default.createElement(_reactButtons.ButtonPrimary, { label: this.props.successContext === 'success' ? this.props.lingua.read('lex.account.confirm.button') : this.props.lingua.read('button.continue'), onClick: this.close })
                    )
                )
            );
        }
    }]);

    return SuccessComponent;
}(_react.Component);

exports.default = SuccessComponent;
//# sourceMappingURL=SuccessComponent.js.map

/***/ }),

/***/ "miw2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mjTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o6oS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "odsh":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.homeawayStabMessageReader = mod.exports;
    }
})(this, function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    /**
     * `MessageReader` provides an interface for reading messages
     * compiled with `grunt-messageformat`. For example:
     *
     * In messages-en_US_VRBO.js:
     *   MessageReader.registerMessages({...}, 'stabHit', 'en_US_VRBO');
     *
     * In your app:
     *   MessageReader.read('shared.stab.hit.book');
     */

    var messageCache = {};
    var loggingEnabled = true;
    var currentLocale = void 0;
    var currentCategory = void 0;

    /**
     * Output a message in the console using `console.error`.
     * @private
     * @param  {String} locale   Ex: en_US_HA
     * @param  {String} category Ex: stabHit
     * @param  {String} key      Ex: shared.stab.hit.submit
     * @param  {Object} options  Ex: {REVIEWS: 5}
     */
    function logError(error) {
        if (!loggingEnabled) {
            return;
        }

        var message = error.message + "\nMessage Cache: %o";

        console.error(message, messageCache); // eslint-disable-line no-console
    }

    /**
     * Traverse the message cache to retrieve a message.
     * @private
     * @param  {String} locale   Ex: en_US_HA
     * @param  {String} category Ex: stabHit
     * @param  {String} key      Ex: shared.stab.hit.submit
     * @return {String|Boolean}
     */
    function getMessage(locale, category, key) {
        var message = messageCache[locale];

        if (message) {
            message = message[category];

            if (message) {
                message = message[key];

                if (message) {
                    return message;
                }

                throw new Error("Key \"" + key + "\" was not found in \"" + locale + "." + category + "\".");
            } else {
                throw new Error("Could not lookup \"" + key + "\" because category \"" + category + "\" was not found in locale \"" + locale + "\".");
            }
        } else {
            throw new Error("Could not lookup \"" + key + "\" because locale \"" + locale + "\" was not found.");
        }
    }

    /**
     * Enable error logging
     * @public
     * @param  {Boolean} isEnabled True to enable logging; False to disable logging;
     */
    function enableLogging() {
        var isEnabled = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

        loggingEnabled = isEnabled;
    }

    /**
     * Register a set of translations with the Message Reader
     *
     * Ex:
     * `translations`
     * {
     *     "search.app.button.hide.regions": "Hide regions",
     *     "search.app.button.view.region": "View Regions",
     *     "search.app.button.view.regions": "View regions",
     *     "search.app.tabs.filter": "Filter",
     *     "search.app.tabs.list": "List",
     *     "search.app.tabs.map": "Map"
     * }
     *
     * @public
     * @param  {Object} translations An object representing a set of translations
     * @param  {String} category     Ex: stabHit
     * @param  {String} locale       Ex: en_US_HA
     */
    function registerMessages(translations, category, locale) {
        if (!messageCache[locale]) {
            messageCache[locale] = {};
        }

        messageCache[locale][category] = translations;
    }

    /**
     * Specify a default locale to use when reading messages without specifying a locale;
     * @public
     * @param {String} locale Ex: en_US_HA
     */
    function setLocale(locale) {
        currentLocale = locale;
    }

    /**
     * Specify a default locale to use when reading messages without specifying a locale;
     * @public
     * @param {String} category Ex: stabHit
     */
    function setCategory(category) {
        currentCategory = category;
    }

    /**
     * Read a message by passing a key and replacement value
     * @public
     * @param  {String} key      Ex: shared.stab.hit.submit
     * @param  {Object} options  Ex: {REVIEWS: 5}
     * @param  {String} category Defaults to default category. Ex: stabHit
     * @param  {String} locale   Defaults to default locale. Ex: en_US_HA
     * @return {String}
     */
    function read(key, options) {
        var category = arguments.length <= 2 || arguments[2] === undefined ? currentCategory : arguments[2];
        var locale = arguments.length <= 3 || arguments[3] === undefined ? currentLocale : arguments[3];

        var message = void 0;

        try {
            message = getMessage(locale, category, key);
        } catch (error) {
            logError(error);
        }

        if (message) {
            return message(options);
        }

        return "???" + key + "???";
    }

    /**
     * Check whether a message exists given it's key.
     * @public
     * @param  {String} key      Ex: shared.stab.hit.submit
     * @param  {String} category Defaults to default category. Ex: stabHit
     * @param  {String} locale   Defaults to default locale. Ex: en_US_HA
     * @return {Boolean}
     */
    function exists(key) {
        var category = arguments.length <= 1 || arguments[1] === undefined ? currentCategory : arguments[1];
        var locale = arguments.length <= 2 || arguments[2] === undefined ? currentLocale : arguments[2];

        var message = void 0;

        try {
            message = getMessage(locale, category, key);
        } catch (error) {
            return false;
        }

        return !!message;
    }

    exports.enableLogging = enableLogging;
    exports.registerMessages = registerMessages;
    exports.setLocale = setLocale;
    exports.setCategory = setCategory;
    exports.read = read;
    exports.exists = exists;
});
//# sourceMappingURL=main.js.map
;

//# sourceMappingURL=stab-message-reader.js.map

/***/ }),

/***/ "pAW9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHEVRON_LEFT__16 = void 0;
var CHEVRON_LEFT__16 = '<svg data-id="SVG_CHEVRON_LEFT__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M10 13L5.4 8 10 3"/></svg>';
exports.CHEVRON_LEFT__16 = CHEVRON_LEFT__16;

/***/ }),

/***/ "pV0F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pick":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resize = resize;
exports.clearResize = clearResize;
exports.scroll = scroll;
exports.clearScroll = clearScroll;
exports.mousemove = mousemove;
exports.clearMousemove = clearMousemove;
exports.throttle = throttle;
/**
 * @homeaway/raf-optimized
 * Inspired by https://developer.mozilla.org/en-US/docs/Web/Events/resize
 *
 **/

var _clientWidth = -1;
var _clientHeight = -1;
var _scrollTop = -1;
var _scrollLeft = -1;
var _mouseX = -1;
var _mouseY = -1;
var _resizeQueue = [];
var _scrollQueue = [];
var _mouseQueue = [];
var _init = false;

/**
 * addThrottleHandler()
 * add request animation frame throttled event handler function
 * @param {*} type
 * @param {*} callback
 * @param {*} obj
 */
var addThrottleHandler = exports.addThrottleHandler = function addThrottleHandler(type, callback, obj) {
    if (typeof obj !== 'undefined' || typeof window !== 'undefined') {
        obj = obj || window;
        if (!obj.addEventListener) {
            return false;
        }
        var running = false;
        var func = function func(originalEvent) {
            if (running) {
                return;
            }
            running = true;
            requestAnimationFrame(function () {
                callback(originalEvent);
                running = false;
            });
        };
        obj.addEventListener(type, func);
        return function () {
            obj.removeEventListener(type, func);
        };
    }
    return false;
};

function init() {
    if (_init === true) {
        return true;
    }
    if (typeof window === 'undefined') {
        return false;
    }

    var supportWindowScrollObj = window.scrollY !== undefined;

    function getClientWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    function getClientHeight() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }

    function getClientScrollTop() {
        return supportWindowScrollObj ? window.scrollY : document.documentElement.scrollTop || document.body.scrollTop;
    }

    function getClientScrollLeft() {
        return supportWindowScrollObj ? window.scrollX : document.documentElement.scrollLeft || document.body.scrollLeft;
    }

    _clientWidth = getClientWidth();
    _clientHeight = getClientHeight();
    _scrollTop = getClientScrollTop();
    _scrollLeft = getClientScrollLeft();

    function handleResize() {
        if (_resizeQueue.length > 0) {
            var clientWidth = getClientWidth();
            var clientHeight = getClientHeight();
            var didResize = !!(_clientWidth !== clientWidth || _clientHeight !== clientHeight);

            if (didResize) {
                for (var i = 0; i < _resizeQueue.length; i++) {
                    _resizeQueue[i]({
                        width: clientWidth,
                        height: clientHeight
                    });
                }
            }
            _clientWidth = clientWidth;
            _clientHeight = clientHeight;
        }
    }

    function handleScroll() {
        if (_scrollQueue.length > 0) {
            var scrollTop = getClientScrollTop();
            var scrollLeft = getClientScrollLeft();
            var didVerticalScroll = scrollTop !== _scrollTop;
            var didHorizontalScroll = scrollLeft !== _scrollLeft;
            var direction = (didVerticalScroll ? scrollTop > _scrollTop ? 'down' : 'up' : null) || (didHorizontalScroll ? scrollLeft > _scrollLeft ? 'right' : 'left' : null);

            if (didVerticalScroll || didHorizontalScroll) {
                for (var i = 0; i < _scrollQueue.length; i++) {
                    _scrollQueue[i]({ scrollTop: scrollTop, scrollLeft: scrollLeft, direction: direction });
                }
            }
            _scrollTop = scrollTop;
            _scrollLeft = scrollLeft;
        }
    }

    function handleMouseMove(event) {
        if (_mouseQueue.length > 0) {
            var mouseX = event.x;
            var mouseY = event.y;

            var didVerticalMouse = mouseY !== _mouseY;
            var didHorizontalMouse = mouseX !== _mouseX;
            var distance = Math.abs(mouseY - _mouseY) + Math.abs(mouseX - _mouseX);

            var direction = (didVerticalMouse ? mouseY > _mouseY ? 'down' : 'up' : 'none') + ':' + (didHorizontalMouse ? mouseX > _mouseX ? 'right' : 'left' : 'none');

            if (didVerticalMouse || didHorizontalMouse) {
                for (var i = 0; i < _mouseQueue.length; i++) {
                    _mouseQueue[i]({ mouseX: mouseX, mouseY: mouseY, direction: direction, distance: distance });
                }
            }
            _mouseX = mouseX;
            _mouseY = mouseY;
        }
    }

    /* init - you can init any event */
    addThrottleHandler('resize', handleResize);
    addThrottleHandler('scroll', handleScroll);
    addThrottleHandler('mousemove', handleMouseMove);

    /* Do not re-initialize this */
    _init = true;

    return true;
}

/**
 * resize()
 * {function} cb - function to be called when rAF optimized resize event occurs
 * TODO: support unregister
 */
function resize(cb) {
    if (typeof cb !== 'function' || init() === false) {
        return false;
    }
    _resizeQueue.push(cb);

    return function removeCallback() {
        var index = _resizeQueue.indexOf(cb);

        if (index >= 0) {
            _resizeQueue.splice(index, 1);
            return true;
        }
        return false;
    };
}

/**
 * clearResize()
 * Clears resize queue
 */
function clearResize() {
    _resizeQueue = [];
}

/**
 * scroll()
 * {function} cb - function to be called when rAF optimized scroll event occurs
 * TODO: support unregister
 */
function scroll(cb) {
    if (typeof cb !== 'function' || init() === false) {
        return false;
    }
    _scrollQueue.push(cb);

    return function removeCallback() {
        var index = _scrollQueue.indexOf(cb);

        if (index >= 0) {
            _scrollQueue.splice(index, 1);
            return true;
        }
        return false;
    };
}

/**
 * clearScroll()
 * Clears the scroll queue
 */
function clearScroll() {
    _scrollQueue = [];
}

/**
 * mousemove()
 * {function} cb - function to be called when mousemove occurs
 */
function mousemove(cb) {
    if (typeof cb !== 'function' || init() === false) {
        return false;
    }
    _mouseQueue.push(cb);

    return function removeCallback() {
        var index = _mouseQueue.indexOf(cb);

        if (index >= 0) {
            _mouseQueue.splice(index, 1);
            return true;
        }
        return false;
    };
}

/**
 * clearScroll()
 * Clears the scroll queue
 */
function clearMousemove() {
    _mouseQueue = [];
}

/**
 * throttle()
 * Simple throttle function
 * @param {*} fn
 * @param {*} wait
 */
function throttle(fn, wait) {
    var time = Date.now();
    return function () {
        if (time + wait - Date.now() < 0) {
            fn();
            time = Date.now();
        }
    };
}

// Export API to window object
if (typeof window !== 'undefined' && !window.rafoptimized) {
    window.rafoptimized = {
        scroll: scroll,
        resize: resize,
        mousemove: mousemove,
        addThrottleHandler: addThrottleHandler
    };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "q+4R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q2Bk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q6wk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qGti":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternalTools = exports.SiteHeader = undefined;

var _SiteHeader = __webpack_require__("CtGM");

var _SiteHeader2 = _interopRequireDefault(_SiteHeader);

var _SiteHeaderConnector = __webpack_require__("41N5");

var _InternalTools = __webpack_require__("ULDB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SiteHeaderConnector.SiteHeaderConnector;
exports.SiteHeader = _SiteHeader2.default;
exports.InternalTools = _InternalTools.InternalTools;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "qwsy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class mirrors EvaluationData in @homeaway/abacus.
 *
 * @see {@link https://github.homeawaycorp.com/experimentation-platform/node-abacus/blob/master/API.md#EvaluationData|Evaluation Data docs}
 * @see {@link https://github.homeawaycorp.com/experimentation-platform/node-abacus/blob/master/lib/experiment/evaluation-data.js|Evaluation Data code}
 */
var EvaluationData =
/**
 * Creates an EvaluationData object based on supplied context.
 *
 * @param {Object} context - experiment evaluation data
 */
function EvaluationData(context) {
    _classCallCheck(this, EvaluationData);

    if (context instanceof EvaluationData) {
        return context;
    }

    for (var attr in context) {
        if (context.hasOwnProperty(attr)) {
            this[attr] = context[attr];
        }
    }
};

exports.default = EvaluationData;
//# sourceMappingURL=EvaluationData.js.map

/***/ }),

/***/ "r3Qk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _ButtonBase = _interopRequireDefault(__webpack_require__("N7cN"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

__webpack_require__("bh3H");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Button(props) {
  var buttonClasses = (0, _classnames.default)('btn-default', props.className);
  return _react.default.createElement(_ButtonBase.default, _extends({}, props, {
    className: buttonClasses
  }));
}

Button.propTypes = _extends({}, _ButtonBase.default.propTypes);
Button.defaultProps = _extends({}, _ButtonBase.default.defaultProps);
var _default = Button;
exports.default = _default;
//# sourceMappingURL=Button.js.map

/***/ }),

/***/ "r9xh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("TFtr");

var _reactButtons = __webpack_require__("WAAH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResetPasswordComponent = function (_Component) {
    _inherits(ResetPasswordComponent, _Component);

    function ResetPasswordComponent(props) {
        _classCallCheck(this, ResetPasswordComponent);

        var _this = _possibleConstructorReturn(this, (ResetPasswordComponent.__proto__ || Object.getPrototypeOf(ResetPasswordComponent)).call(this, props));

        _this.returnToLogin = _this.returnToLogin.bind(_this);
        return _this;
    }

    _createClass(ResetPasswordComponent, [{
        key: 'returnToLogin',
        value: function returnToLogin() {
            this.props.updatePage('login');
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'ResetPassword text-center' },
                _react2.default.createElement(
                    'div',
                    { className: 'Padding' },
                    _react2.default.createElement(
                        'svg',
                        { width: '56', height: '44', xmlns: 'http://www.w3.org/2000/svg' },
                        _react2.default.createElement(
                            'g',
                            { stroke: '#323F4D', strokeWidth: '1.5', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round' },
                            _react2.default.createElement('path', { d: 'M1 1l26.293 26.293a1 1 0 0 0 1.414 0L55 1' }),
                            _react2.default.createElement('path', { d: 'M1 1h54v39a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V1z' })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'h3',
                        { className: 'Header text-400' },
                        this.props.lingua.read('lex.password.reset.title')
                    )
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'Padding lead' },
                    this.props.lingua.read('lex.password.reset.subtitle')
                ),
                _react2.default.createElement(_reactButtons.ButtonPrimary, { label: this.props.lingua.read('lex.password.reset.button'), onClick: this.returnToLogin })
            );
        }
    }]);

    return ResetPasswordComponent;
}(_react.Component);

exports.default = ResetPasswordComponent;
//# sourceMappingURL=ResetPasswordComponent.js.map

/***/ }),

/***/ "rM/n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rMWW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
**/

module.exports = __webpack_require__("ZhlV").default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "rOao":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactAlerts = __webpack_require__("anT4");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorViewComponent = function (_Component) {
    _inherits(ErrorViewComponent, _Component);

    function ErrorViewComponent(props) {
        _classCallCheck(this, ErrorViewComponent);

        return _possibleConstructorReturn(this, (ErrorViewComponent.__proto__ || Object.getPrototypeOf(ErrorViewComponent)).call(this, props));
    }

    _createClass(ErrorViewComponent, [{
        key: 'render',
        value: function render() {
            var content = '';
            if (this.props.error !== '') {
                content = _react2.default.createElement(_reactAlerts.AlertDanger, { title: this.props.errorTitle, msg: this.props.error, svg: 'svg-alert-danger' });
            }
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                content
            );
        }
    }]);

    return ErrorViewComponent;
}(_react.Component);

exports.default = ErrorViewComponent;
//# sourceMappingURL=ErrorViewComponent.js.map

/***/ }),

/***/ "rnpr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "rplX":
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ "s3LP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Tray = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _TransitionGroup = __webpack_require__("tW2u");

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransition = __webpack_require__("4JXe");

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _FlagsMenu = __webpack_require__("2YJb");

var _HelpMenu = __webpack_require__("Rhre");

var _TrayMenu = __webpack_require__("TrFK");

__webpack_require__("RcS0");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tray = exports.Tray = function (_React$Component) {
    _inherits(Tray, _React$Component);

    function Tray() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Tray);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tray.__proto__ || Object.getPrototypeOf(Tray)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            activeMenu: 'tray'
        }, _this.transitionProps = {
            backdrop: {
                classNames: {
                    enter: 'site-header-tray__backdrop--enter',
                    enterActive: 'site-header-tray__backdrop--enter-active',
                    exit: 'site-header-tray__backdrop--exit',
                    exitActive: 'site-header-tray__backdrop--exit-active'
                },
                timeout: 250
            },
            menu: {
                classNames: {
                    enter: 'site-header-tray__menu--enter',
                    enterActive: 'site-header-tray__menu--enter-active',
                    exit: 'site-header-tray__menu--exit',
                    exitActive: 'site-header-tray__menu--exit-active'
                },
                timeout: 500
            }
        }, _this.handleClickBackdrop = function () {
            _this.props.handleToggleOpen();
            _this.setActiveMenu('tray');
        }, _this.setActiveMenu = function () {
            var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tray';

            _this.setState({
                activeMenu: menu
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Tray, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: this.className },
                _react2.default.createElement(
                    _TransitionGroup2.default,
                    { component: 'div' },
                    this.props.isOpen && _react2.default.createElement(
                        _CSSTransition2.default,
                        this.transitionProps.backdrop,
                        _react2.default.createElement('div', {
                            className: 'site-header-tray__backdrop',
                            onClick: this.handleClickBackdrop,
                            onKeyPress: this.handleClickBackdrop,
                            role: 'none'
                        })
                    )
                ),
                _react2.default.createElement(
                    _TransitionGroup2.default,
                    { className: 'site-header-tray__container', component: 'div' },
                    this.state.activeMenu === 'tray' && _react2.default.createElement(
                        _CSSTransition2.default,
                        this.transitionProps.menu,
                        _react2.default.createElement(_TrayMenu.TrayMenu, {
                            countryCode: this.props.countryCode,
                            currencyCode: this.props.currencyCode,
                            extraNav: this.props.extraNav,
                            feedbackComponent: this.props.feedbackComponent,
                            flags: this.props.flags,
                            globalizationSelector: this.props.globalizationSelector,
                            handleTravelerLogin: this.handleClickBackdrop,
                            help: this.props.help,
                            inbox: this.props.inbox,
                            languageCode: this.props.languageCode,
                            login: this.props.login,
                            lyp: this.props.lyp,
                            renderCountryLanguageSelector: this.props.renderCountryLanguageSelector,
                            renderCurrencySelector: this.props.renderCurrencySelector,
                            scratchpad: this.props.scratchpad,
                            setActiveMenu: this.setActiveMenu,
                            traveler: this.props.traveler
                        })
                    ),
                    this.state.activeMenu === 'flag' && _react2.default.createElement(
                        _CSSTransition2.default,
                        this.transitionProps.menu,
                        _react2.default.createElement(_FlagsMenu.FlagsMenu, {
                            flags: this.props.flags,
                            setActiveMenu: this.setActiveMenu
                        })
                    ),
                    this.state.activeMenu === 'help' && _react2.default.createElement(
                        _CSSTransition2.default,
                        this.transitionProps.menu,
                        _react2.default.createElement(_HelpMenu.HelpMenu, {
                            help: this.props.help,
                            setActiveMenu: this.setActiveMenu
                        })
                    )
                )
            );
        }
    }, {
        key: 'className',
        get: function get() {
            return (0, _classnames2.default)('site-header-tray', { 'site-header-tray--open': this.props.isOpen });
        }
    }]);

    return Tray;
}(_react2.default.Component);
//# sourceMappingURL=Tray.js.map

/***/ }),

/***/ "suT3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDropdown = __webpack_require__("CVj+");

var _edap = __webpack_require__("6kQN");

var _edap2 = _interopRequireDefault(_edap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurrencySelector = function (_Component) {
    _inherits(CurrencySelector, _Component);

    /* istanbul ignore next */
    function CurrencySelector(props) {
        _classCallCheck(this, CurrencySelector);

        var _this = _possibleConstructorReturn(this, (CurrencySelector.__proto__ || Object.getPrototypeOf(CurrencySelector)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    _createClass(CurrencySelector, [{
        key: 'handleChange',
        value: function handleChange(event, currency) {
            event.preventDefault();
            var currencyCodeSelected = currency.code;
            this.props.onChange(currencyCodeSelected);
        }
    }, {
        key: 'handleDropdownShow',
        value: function handleDropdownShow() {
            (0, _edap2.default)({
                eventaction: 'display currency dropdown clicked'
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                title = _props.title,
                currency = _props.currency,
                disclaimer = _props.disclaimer,
                currencyList = _props.currencyList;

            return _react2.default.createElement(
                'div',
                { className: 'currency-selector preference-selector form-group' },
                _react2.default.createElement(
                    'div',
                    { className: 'preference-selector__title' },
                    title
                ),
                _react2.default.createElement(
                    _reactDropdown.Dropdown,
                    {
                        srOnlyLabel: true,
                        label: 'Currency Selector',
                        buttonChildren: _react2.default.createElement(
                            'div',
                            { className: 'preference-selector__option media' },
                            _react2.default.createElement(
                                'div',
                                { className: 'option-currency-code media-left media-middle' },
                                currency.code
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'option-currency-name media-body' },
                                currency.name + ' (' + currency.symbol + ')'
                            )
                        ),
                        id: 'currency-selector',
                        name: 'currency-selector',
                        onDropdownShow: this.handleDropdownShow
                    },
                    currencyList.map(function (c) {
                        return _react2.default.createElement(_reactDropdown.DropdownItem, {
                            link: '#',
                            text: _react2.default.createElement(
                                'div',
                                { className: 'preference-selector__option media' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'option-currency-code media-left media-middle' },
                                    c.code
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'option-currency-name media-body' },
                                    c.name
                                )
                            ),
                            key: c.code,
                            onClick: function onClick(event) {
                                return _this2.handleChange(event, c);
                            } // eslint-disable-line react/jsx-no-bind
                        });
                    })
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'help-block preference-selector__disclaimer' },
                    disclaimer
                )
            );
        }
    }]);

    return CurrencySelector;
}(_react.Component);

CurrencySelector.propTypes = {
    currencyList: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        code: _propTypes2.default.string,
        symbol: _propTypes2.default.string,
        name: _propTypes2.default.string
    })),
    title: _propTypes2.default.string,
    disclaimer: _propTypes2.default.string,
    code: _propTypes2.default.string,
    onChange: _propTypes2.default.func
};
CurrencySelector.defaultProps = {
    title: 'Currency',
    disclaimer: 'Please note: You will still be charged in the owner\'s currency.',
    currency: { code: 'USD', symbol: 'US$', name: 'US Dollar' },
    currencyList: [],
    onChange: function onChange() {} };
exports.default = CurrencySelector;
//# sourceMappingURL=CurrencySelector.js.map

/***/ }),

/***/ "t0XK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var brandsNotRequiringTC = new Set(['homeaway_us', 'vrbo', 'vr', 'homeaway_ca', 'homeaway_mx']);

function isTCRequired(brand) {
    if (brandsNotRequiringTC.has(brand)) {
        return false;
    }
    return true;
}
module.exports = {
    isTCRequired: isTCRequired
};
//# sourceMappingURL=ums.settings.js.map

/***/ }),

/***/ "tW2u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _reactLifecyclesCompat = __webpack_require__("R8mX");

var _ChildMapping = __webpack_require__("1olO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "tjWm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _ButtonBase = _interopRequireDefault(__webpack_require__("N7cN"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ButtonOverlay(props) {
  var buttonClasses = (0, _classnames.default)('btn-overlay', props.className);
  return _react.default.createElement(_ButtonBase.default, _extends({}, props, {
    className: buttonClasses
  }));
}

ButtonOverlay.propTypes = _extends({}, _ButtonBase.default.propTypes);
ButtonOverlay.defaultProps = _extends({}, _ButtonBase.default.defaultProps);
var _default = ButtonOverlay;
exports.default = _default;
//# sourceMappingURL=ButtonOverlay.js.map

/***/ }),

/***/ "um2z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("pV0F");

var _ErrorViewComponent = __webpack_require__("rOao");

var _ErrorViewComponent2 = _interopRequireDefault(_ErrorViewComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalloutCardComponent = function (_Component) {
    _inherits(CalloutCardComponent, _Component);

    function CalloutCardComponent() {
        _classCallCheck(this, CalloutCardComponent);

        return _possibleConstructorReturn(this, (CalloutCardComponent.__proto__ || Object.getPrototypeOf(CalloutCardComponent)).apply(this, arguments));
    }

    _createClass(CalloutCardComponent, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'CalloutCardComponent box-shadow--nav' },
                _react2.default.createElement(_ErrorViewComponent2.default, { error: this.props.error, errorTitle: this.props.errorTitle }),
                this.props.content
            );
        }
    }]);

    return CalloutCardComponent;
}(_react.Component);

exports.default = CalloutCardComponent;
//# sourceMappingURL=CalloutCardComponent.js.map

/***/ }),

/***/ "vF2h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vuNg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("+iKg");

var _reactFormComponents = __webpack_require__("hyOf");

var _reactLoadingOverlay = __webpack_require__("/vpO");

var _reactButtons = __webpack_require__("WAAH");

var _api = __webpack_require__("cGdw");

var _password = __webpack_require__("Wgkp");

var _edapWrapper = __webpack_require__("xEA1");

var _edapWrapper2 = _interopRequireDefault(_edapWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SignUpComponent = function (_Component) {
    _inherits(SignUpComponent, _Component);

    function SignUpComponent(props) {
        _classCallCheck(this, SignUpComponent);

        var _this = _possibleConstructorReturn(this, (SignUpComponent.__proto__ || Object.getPrototypeOf(SignUpComponent)).call(this, props));

        _this.state = {
            emailAddress: _this.props.emailAddress,
            firstName: '',
            lastName: '',
            password: '',
            loggedIn: false,
            errorMsg: '',
            enablePasswordHint: false,
            loading: false
        };

        _this.handleChange = _this.handleChange.bind(_this);
        _this.submitForm = _this.submitForm.bind(_this);
        _this.checkStatus = _this.checkStatus.bind(_this);
        _this.validateFields = _this.validateFields.bind(_this);
        _this.triggerSubmit = _this.triggerSubmit.bind(_this);
        _this.editEmail = _this.editEmail.bind(_this);
        return _this;
    }

    _createClass(SignUpComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.firstNameInput) {
                this.firstNameInput.focus();
            }
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: {
                    actionlocation: this.props.actionLocation,
                    eventaction: 'signup.visible',
                    eventcategory: 'lex',
                    eventlabel: 'ums'
                }
            });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.stopPropagation();
            event.preventDefault();
        }
    }, {
        key: 'handleChange',
        value: function handleChange(event) {
            this.setState(_defineProperty({}, event.target.name, event.target.value));
            if (event.target.name === 'password') {
                if (event.target.value !== '') {
                    this.setState({ enablePasswordHint: true });
                } else {
                    this.setState({ enablePasswordHint: false });
                }
            }
        }
    }, {
        key: 'handleError',
        value: function handleError(error) {
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: { eventaction: 'signup.failure', eventcategory: 'lex', eventlabel: 'ums', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.props.handleError(error);
        }
    }, {
        key: 'signUpSuccess',
        value: function signUpSuccess(json) {
            this.props.setEmail(this.state.emailAddress);
            this.props.setFirstName(this.state.firstName);
            this.setState({ loggedIn: true });
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: { eventaction: 'signup.success', eventcategory: 'lex', eventlabel: 'ums', publicuuid: json.publicUuid, actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            (0, _edapWrapper2.default)().push({
                name: 'login.success',
                data: { loginsource: 'lex', logintype: 'ums', publicuuid: json.publicUuid, actionLocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            this.props.setAuthJson(json);
            this.props.updatePage('success');
        }
    }, {
        key: 'checkStatus',
        value: function checkStatus(response) {
            var _this2 = this;

            switch (response.status) {
                case 200:
                    response.json().then(function (json) {
                        _this2.signUpSuccess(json);
                    });
                    break;
                case 400:
                    this.props.disableLoading();
                    var errorMessage = '';
                    /* istanbul ignore next */
                    response.json().then(function (json) {
                        if (json.errors) {
                            var error = '';
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = json.errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    error = _step.value;

                                    var options = error === 'ums.validation.password.length' ? _password.pwdLengthOptions : null;
                                    errorMessage += (errorMessage.length ? ' ' : '') + _this2.props.lingua.read(error, options, 'validation');
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }

                            _this2.setState({ errorMsg: errorMessage });
                            _this2.handleError(errorMessage);
                        } else {
                            _this2.handleError(_this2.props.lingua.read('lex.email.rejected'));
                        }
                    });
                    break;
                case 401:
                    this.props.disableLoading();
                    this.handleError(this.props.lingua.read('error.authentication.credentials.bad'));
                    break;
                case 409:
                    // this should never happen since you would only get to this component after checking for existing user but just in case
                    this.props.disableLoading();
                    this.handleError(this.props.lingua.read('ums.validation.email.unavailable'));
                    break;
                default:
                    this.props.disableLoading();
                    this.handleError(this.props.lingua.read('error.generic'));
                    break;
            }
        }
    }, {
        key: 'triggerSubmit',
        value: function triggerSubmit(e) {
            var _this3 = this;

            e.preventDefault();
            this.props.enableLoading();
            setTimeout(function () {
                _this3.submitForm();
            }, 800);
        }
    }, {
        key: 'submitForm',
        value: function submitForm() {
            if (!this.validatePassword(true)) {
                this.props.disableLoading();
                return;
            }
            (0, _edapWrapper2.default)().push({
                name: 'generic.event',
                data: { eventaction: 'signup.attempt', eventcategory: 'lex', eventlabel: 'ums', actionlocation: this.props.actionLocation },
                options: { 'delayProcessing': true }
            });
            if (this.props.useNewEndpoints) {
                (0, _api.apiPost)('/auth/aam/v3/register', {
                    userName: this.state.emailAddress,
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    secret: this.state.password,
                    authType: 'HOMEAWAY',
                    rememberMe: false
                }).then(this.checkStatus);
            } else {
                (0, _api.apiPost)('/auth/v2/register', {
                    emailAddress: this.state.emailAddress,
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    password: this.state.password,
                    registrationType: 'TRAVELER',
                    service: this.props.service,
                    source: this.props.site
                }).then(this.checkStatus);
            }
        }
    }, {
        key: 'editEmail',
        value: function editEmail(e) {
            e.stopPropagation();
            e.preventDefault();
            this.props.updatePage('initial');
        }
    }, {
        key: 'validatePassword',
        value: function validatePassword(displayErrors) {
            var passwordValid = (0, _password.validate)({ p: this.state.password }, _password.validatePasswordConstraint);
            if (displayErrors && passwordValid && passwordValid.p.length > 0) {
                var error = void 0;
                var errorMessage = '';
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = passwordValid.p[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        error = _step2.value;

                        error = error.substr(2);
                        var options = error === 'ums.validation.password.length' ? _password.pwdLengthOptions : null;
                        errorMessage += (errorMessage.length ? ' ' : '') + this.props.lingua.read(error, options, 'validation');
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                this.setState({ errorMsg: errorMessage });
                this.props.handleError(errorMessage);
            }
            return !passwordValid;
        }
    }, {
        key: 'validateFields',
        value: function validateFields() {
            if (this.state.firstName === '' || this.state.lastName === '' || this.state.password === '' || !this.validatePassword(false)) {
                return false;
            }
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var passwordFieldClasses = 'form-group floating-label ' + (this.state.password === '' ? '' : 'not-empty') + ' has-feedback ' + (this.state.errorMsg === '' ? '' : 'has-error');
            return _react2.default.createElement(
                'div',
                { className: 'SignUpComponent text-center' },
                _react2.default.createElement(
                    'form',
                    { onSubmit: this.triggerSubmit, noValidate: true },
                    _react2.default.createElement(
                        'p',
                        { className: 'email-display' },
                        this.state.emailAddress
                    ),
                    !this.props.multiUserEnabled && _react2.default.createElement(
                        'a',
                        { onClick: this.editEmail, className: 'edit-email', href: '' },
                        this.props.lingua.read('lex.email.edit')
                    ),
                    _react2.default.createElement(_reactFormComponents.FormInput, {
                        id: 'lex-first-name',
                        className: 'first-name',
                        name: 'firstName',
                        label: this.props.lingua.read('form.placeholder.firstName'),
                        value: this.state.firstName,
                        onChange: this.handleChange,
                        type: 'text',
                        autoComplete: 'firstName',
                        ref: function ref(input) {
                            _this4.firstNameInput = input;
                        }
                    }),
                    _react2.default.createElement(_reactFormComponents.FormInput, {
                        id: 'lex-lastName',
                        name: 'lastName',
                        label: this.props.lingua.read('form.placeholder.lastName'),
                        value: this.state.lastName,
                        onChange: this.handleChange,
                        type: 'text',
                        autoComplete: 'lastName'
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: passwordFieldClasses },
                        _react2.default.createElement(
                            'label',
                            null,
                            this.props.lingua.read('lex.password.prompt')
                        ),
                        _react2.default.createElement('input', { type: this.props.passwordType, className: 'form-control', 'aria-label': this.props.lingua.read('lex.password.prompt'),
                            name: 'password', onChange: this.handleChange, value: this.state.password, autoComplete: 'new-password'
                        }),
                        _react2.default.createElement(
                            'span',
                            { className: 'PasswordShow', onClick: this.props.showHidePassword },
                            this.props.passwordType === 'input' ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: this.state.errorMsg === '' ? '' : 'help-block' },
                            this.state.errorMsg
                        )
                    ),
                    this.state.enablePasswordHint && _react2.default.createElement(
                        'label',
                        { className: 'text-left' },
                        this.props.lingua.read('lex.password.requirements', _password.pwdLengthOptions)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'Signup_button' },
                        _react2.default.createElement(
                            _reactButtons.ButtonPrimary,
                            { type: 'submit', label: this.props.lingua.read('account.signup.link.text'), disabled: !this.validateFields() },
                            _react2.default.createElement(_reactLoadingOverlay.LoadingOverlay, { loading: this.props.isWaiting })
                        )
                    )
                )
            );
        }
    }]);

    return SignUpComponent;
}(_react.Component);

exports.default = SignUpComponent;
//# sourceMappingURL=SignUpComponent.js.map

/***/ }),

/***/ "wXQb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("mbC/");

var _reactButtons = __webpack_require__("WAAH");

var _reactLoadingOverlay = __webpack_require__("/vpO");

var _reactFormComponents = __webpack_require__("hyOf");

var _api = __webpack_require__("cGdw");

var _clientLogger = __webpack_require__("29Zd");

var _clientLogger2 = _interopRequireDefault(_clientLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TermsAndConditionsComponent = function (_Component) {
    _inherits(TermsAndConditionsComponent, _Component);

    function TermsAndConditionsComponent(props) {
        _classCallCheck(this, TermsAndConditionsComponent);

        var _this = _possibleConstructorReturn(this, (TermsAndConditionsComponent.__proto__ || Object.getPrototypeOf(TermsAndConditionsComponent)).call(this, props));

        _this.state = {
            emailAddress: _this.props.emailAddress,
            site: _this.props.site,
            TandCSwitch: _this.props.TandCSwitch,
            updatePage: _this.props.updatePage
        };
        _this.handleTCClicked = _this.handleTCClicked.bind(_this);
        _this.handleToggleClicked = _this.handleToggleClicked.bind(_this);
        return _this;
    }

    _createClass(TermsAndConditionsComponent, [{
        key: 'checkStatus',
        value: function checkStatus(response) {
            switch (response.status) {
                case 200:
                    return response.json();
                default:
                    _clientLogger2.default.logError('An error has occurred : ' + response.status + ' - ' + response.statusText);
                    break;
            }
            return null;
        }
    }, {
        key: 'handleTCClicked',
        value: function handleTCClicked() {
            if (this.state.TandCSwitch) {
                var statusRequest = {
                    'emailAddress': this.state.emailAddress,
                    'site': this.state.site,
                    'sourceUrl': window.location.href,
                    'source': 'lightbox.signup.inquiry'
                };
                // update this so we don't have to worry about rolling back the edge rule in test and stage
                var url = '/newsletter-subscriptions/v1/subscriptions';
                (0, _api.apiPost)(url, statusRequest).then(this.checkStatus);
            }
            this.state.updatePage('postTandC');
        }
    }, {
        key: 'handleToggleClicked',
        value: function handleToggleClicked(event) {
            this.setState(_defineProperty({}, event.target.name, event.target.checked));
        }
    }, {
        key: 'render',
        value: function render() {
            var buttonLabel = this.props.lingua.read('lex.button.accept.terms.conditions');
            var options = { 'siteName': this.props.siteName };
            var text = this.props.lingua.read('lex.signup.termsandcondtions');
            return _react2.default.createElement(
                'div',
                { className: 'TermsAndConditionsComponent text-center' },
                _react2.default.createElement(
                    'form',
                    { className: 'TermsAndComponentForm' },
                    _react2.default.createElement(
                        'div',
                        { className: 'terms-and-conditions', href: '' },
                        _react2.default.createElement('label', { dangerouslySetInnerHTML: { __html: text } })
                    ),
                    _react2.default.createElement(
                        _reactButtons.ButtonPrimary,
                        { label: buttonLabel, onClick: this.handleTCClicked, className: 'btn-lg' },
                        _react2.default.createElement(_reactLoadingOverlay.LoadingOverlay, { loading: this.props.isWaiting })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'vacation-ideas-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'vacation-ideas', href: '' },
                            this.props.lingua.read('lex.signup.vacation.ideas', options)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'tc-toggle-switch' },
                            _react2.default.createElement(_reactFormComponents.Switch, {
                                name: 'TandCSwitch',
                                id: 'toggle-switch',
                                className: 'toggle',
                                onChange: this.handleToggleClicked,
                                size: 'sm'
                            })
                        )
                    )
                )
            );
        }
    }]);

    return TermsAndConditionsComponent;
}(_react.Component);

exports.default = TermsAndConditionsComponent;
//# sourceMappingURL=TermsAndConditionsComponent.js.map

/***/ }),

/***/ "wt6h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xEA1":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod);
        global.index = mod.exports;
    }
})(this, function (module) {
    'use strict';

    var edapArray = [];

    // If edap does not exist, define array so push() method can raise the event
    if (typeof window !== 'undefined' && window !== null) {
        window.edap = window.edap || edapArray;
    }

    var edap = function edap() {
        if (typeof window !== 'undefined' && window !== null) {
            return window.edap;
        }
        return edapArray;
    };

    module.exports = edap;
});

/***/ }),

/***/ "xRp3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _HeaderSectionComponent = __webpack_require__("F1Vd");

var _HeaderSectionComponent2 = _interopRequireDefault(_HeaderSectionComponent);

var _TandCComponent = __webpack_require__("/s9T");

var _TandCComponent2 = _interopRequireDefault(_TandCComponent);

var _CalloutCardComponent = __webpack_require__("um2z");

var _CalloutCardComponent2 = _interopRequireDefault(_CalloutCardComponent);

var _LogInComponent = __webpack_require__("7guQ");

var _LogInComponent2 = _interopRequireDefault(_LogInComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginPageComponent = function (_Component) {
    _inherits(LoginPageComponent, _Component);

    function LoginPageComponent(props) {
        _classCallCheck(this, LoginPageComponent);

        var _this = _possibleConstructorReturn(this, (LoginPageComponent.__proto__ || Object.getPrototypeOf(LoginPageComponent)).call(this, props));

        _this.state = {
            emailAddress: _this.props.emailAddress,
            currentPage: _this.props.currentPage,
            error: '',
            errorTitle: ''
        };
        _this.handleError = _this.handleError.bind(_this);
        return _this;
    }

    _createClass(LoginPageComponent, [{
        key: 'handleError',
        value: function handleError(error, errorTitle) {
            this.setState({ error: error, errorTitle: errorTitle });
        }
    }, {
        key: 'render',
        value: function render() {
            var options = { 'siteName': this.props.siteName };
            var cardContent = _react2.default.createElement(_LogInComponent2.default, {
                actionLocation: this.props.actionLocation,
                lingua: this.props.lingua,
                emailAddress: this.props.emailAddress,
                service: this.props.service,
                handleError: this.handleError,
                onClose: this.props.onClose,
                updatePage: this.props.updatePage,
                passwordType: this.props.passwordType,
                showHidePassword: this.props.showHidePassword,
                isWaiting: this.props.isWaiting,
                enableLoading: this.props.enableLoading,
                disableLoading: this.props.disableLoading,
                setAuthJson: this.props.setAuthJson,
                useNewEndpoints: this.props.useNewEndpoints,
                multiUserEnabled: this.props.multiUserEnabled
            });
            return _react2.default.createElement(
                'div',
                { className: 'LoginPageComponent border-border-color' },
                _react2.default.createElement(_HeaderSectionComponent2.default, { header: this.props.lingua.read('lex.header.initial', options) }),
                _react2.default.createElement(_CalloutCardComponent2.default, { content: cardContent, error: this.state.error, errorTitle: this.state.errorTitle }),
                _react2.default.createElement(_TandCComponent2.default, { lingua: this.props.lingua, multiUserEnabled: this.props.multiUserEnabled })
            );
        }
    }]);

    return LoginPageComponent;
}(_react.Component);

exports.default = LoginPageComponent;
//# sourceMappingURL=LoginPageComponent.js.map

/***/ }),

/***/ "xWqb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LanguageSelector = __webpack_require__("/3uU");

var _LanguageSelector2 = _interopRequireDefault(_LanguageSelector);

var _CountrySelector = __webpack_require__("c0JP");

var _CountrySelector2 = _interopRequireDefault(_CountrySelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CountryLanguageSelector = function (_Component) {
    _inherits(CountryLanguageSelector, _Component);

    /* istanbul ignore next */
    function CountryLanguageSelector(props) {
        _classCallCheck(this, CountryLanguageSelector);

        return _possibleConstructorReturn(this, (CountryLanguageSelector.__proto__ || Object.getPrototypeOf(CountryLanguageSelector)).call(this, props));
    }

    _createClass(CountryLanguageSelector, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                translations = _props.translations,
                countries = _props.countries,
                languages = _props.languages,
                countryCode = _props.countryCode,
                languageCode = _props.languageCode,
                handleCountrySelectorChange = _props.handleCountrySelectorChange,
                handleLanguageSelectorChange = _props.handleLanguageSelectorChange;

            var languageSelectorOnly = this.props.languageSelectorOnly || this.props.countries.length === 1;

            return _react2.default.createElement(
                'div',
                null,
                !languageSelectorOnly && _react2.default.createElement(_CountrySelector2.default, {
                    title: translations.chooseCountry,
                    countryCode: countryCode,
                    countries: countries,
                    onChange: handleCountrySelectorChange
                }),
                _react2.default.createElement(_LanguageSelector2.default, {
                    title: translations.chooseLanguage,
                    languageCode: languageCode,
                    languages: languages,
                    onChange: handleLanguageSelectorChange
                })
            );
        }
    }]);

    return CountryLanguageSelector;
}(_react.Component);

CountryLanguageSelector.propTypes = {
    countries: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        countryCode: _propTypes2.default.string,
        countryName: _propTypes2.default.string,
        siteUrl: _propTypes2.default.string,
        languages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            languageCode: _propTypes2.default.string,
            languageName: _propTypes2.default.string
        }))
    })),
    languages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        languageCode: _propTypes2.default.string,
        languageName: _propTypes2.default.string
    })),
    translations: _propTypes2.default.shape({
        chooseCountry: _propTypes2.default.string,
        chooseLanguage: _propTypes2.default.string
    }),
    countryCode: _propTypes2.default.string,
    languageCode: _propTypes2.default.string,
    handleCountrySelectorChange: _propTypes2.default.func,
    handleLanguageSelectorChange: _propTypes2.default.func,
    languageSelectorOnly: _propTypes2.default.bool
};
CountryLanguageSelector.defaultProps = {
    countries: [{ countryCode: 'jp', countryName: '日本' }, { countryCode: 'us', countryName: 'United States' }],
    languages: [],
    translations: {
        chooseCountry: 'Country',
        chooseLanguage: 'Language'
    },
    countryCode: 'us',
    languageCode: 'en',
    handleCountrySelectorChange: function handleCountrySelectorChange() {},
    handleLanguageSelectorChange: function handleLanguageSelectorChange() {} };
exports.default = CountryLanguageSelector;
//# sourceMappingURL=CountryLanguageSelector.js.map

/***/ }),

/***/ "xXc5":
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "xjgv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _ButtonIconBase = _interopRequireDefault(__webpack_require__("ICDg"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ButtonIconPrimary(props) {
  var buttonClasses = (0, _classnames.default)('btn-primary', props.className);
  return _react.default.createElement(_ButtonIconBase.default, _extends({}, props, {
    className: buttonClasses
  }));
}

ButtonIconPrimary.propTypes = _extends({}, _ButtonIconBase.default.propTypes);
ButtonIconPrimary.defaultProps = _extends({}, _ButtonIconBase.default.defaultProps);
var _default = ButtonIconPrimary;
exports.default = _default;
//# sourceMappingURL=ButtonIconPrimary.js.map

/***/ }),

/***/ "y+XB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y1vT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "y3TV":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "yQn5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yoR0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function clickedOnTravelerLogin(user) {
    if (user && user.includes('traveler')) {
        return true;
    }
    return false;
}

function clickedOnOwnerLogin(user) {
    if (user && user.includes('owner')) {
        return true;
    }
    return false;
}

module.exports = {
    clickedOnTravelerLogin: clickedOnTravelerLogin,
    clickedOnOwnerLogin: clickedOnOwnerLogin
};
//# sourceMappingURL=login.utils.js.map

/***/ }),

/***/ "ysCC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zW/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("GiK3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__("O27J");
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules
var es = __webpack_require__("2KeS");

// CONCATENATED MODULE: ./src/universal/reducers/reducer_session.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* harmony default export */ var reducer_session = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case 'SET_SESSION':
            return _extends({}, state, { id: action.payload });
        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/universal/reducers/reducer_site.js
var reducer_site__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* harmony default export */ var reducer_site = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case 'SET_SITE':
            return reducer_site__extends({}, state, { id: action.payload });
        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/universal/reducers/reducer_serviceUrl.js
var reducer_serviceUrl__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* harmony default export */ var reducer_serviceUrl = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case 'SET_SERVICE_URL':
            return reducer_serviceUrl__extends({}, state, { id: action.payload });
        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/universal/reducers/reducer_experiments.js
var reducer_experiments__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* harmony default export */ var reducer_experiments = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case 'SET_EXPERIMENTS':
            return reducer_experiments__extends({}, state, { id: action.payload });
        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/universal/reducers/reducer_ticket.js
var reducer_ticket__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* harmony default export */ var reducer_ticket = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case 'SET_TICKET':
            return reducer_ticket__extends({}, state, { id: action.payload });
        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/universal/reducers/reducer_landingPage.js
var reducer_landingPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* harmony default export */ var reducer_landingPage = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case 'SET_LANDINGPAGE':
            return reducer_landingPage__extends({}, state, { id: action.payload });
        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/universal/reducers/all.js








/**
 * Connect reducers to the redux store.
 */

/* istanbul ignore next */
var reducers = Object(es["combineReducers"])({
    session: reducer_session,
    site: reducer_site,
    serviceUrl: reducer_serviceUrl,
    experiments: reducer_experiments,
    ticket: reducer_ticket,
    landingPage: reducer_landingPage
});

/* harmony default export */ var reducers_all = (reducers);
// EXTERNAL MODULE: ./node_modules/@homeaway/redux-middleware-adapter/lib/index.js
var lib = __webpack_require__("UNM8");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/universal/actions/actions.js
var actions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* istanbul ignore next */
var ACTIONS = {
    FETCH_PAGE1_DATA_SUCCESS: 'FETCH_PAGE1_DATA_SUCCESS',
    FETCH_PAGE1_DATA_ERROR: 'FETCH_PAGE1_DATA_ERROR',

    TRIGGER_EDAP_PAGEVIEW: 'TRIGGER_EDAP_PAGEVIEW',
    TRIGGER_EDAP_EVENT: 'TRIGGER_EDAP_EVENT',

    POST_NAME: 'POST_NAME',
    POST_NAME_SUCCESS: 'POST_NAME_SUCCESS',
    POST_NAME_ERROR: 'POST_NAME_ERROR'
};

/* istanbul ignore next */
var ACTION_CREATORS = {
    fetchPage1DataSuccess: function fetchPage1DataSuccess(response) {
        return {
            type: ACTIONS.FETCH_PAGE1_DATA_SUCCESS,
            payload: {
                response: response
            }
        };
    },
    fetchPage1DataError: function fetchPage1DataError(response) {
        return {
            type: ACTIONS.FETCH_PAGE1_DATA_ERROR,
            payload: {
                response: response
            }
        };
    },
    triggerEdapPageView: function triggerEdapPageView() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PAGEVIEW
        };
    },
    triggerEdapEvent: function triggerEdapEvent(eventName, eventData, options) {
        return {
            type: ACTIONS.TRIGGER_EDAP_EVENT,
            payload: {
                eventName: eventName,
                eventData: eventData,
                options: options
            }
        };
    },
    postName: function postName(name) {
        return {
            type: ACTIONS.POST_NAME,
            payload: {
                name: name
            }
        };
    },
    postNameSuccess: function postNameSuccess(resp) {
        return {
            type: ACTIONS.POST_NAME_SUCCESS,
            payload: {
                resp: resp
            }
        };
    },
    postNameError: function postNameError() {
        return {
            type: ACTIONS.POST_NAME_ERROR
        };
    }
};

/* harmony default export */ var actions = (actions__extends({}, ACTIONS, ACTION_CREATORS));
// CONCATENATED MODULE: ./src/universal/middleware/edap.js

// Responds to TRIGGER_EDAP_EVENT action
function triggerEdapEvent(store) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { payload: { eventName: '', eventData: {}, options: {} } };

    if (typeof window === 'undefined') {
        return;
    }

    var payload = action.payload;


    window.edap.push(function (edapInstance) {
        edapInstance.trigger(payload.eventName, payload.eventData, payload.options);
    });
}

// responds to TRIGGER_EDAP_PAGEVIEW action
function triggerEdapPageView() {
    if (typeof window === 'undefined') {
        return;
    }

    window.edap.push(function (edapInstance) {
        edapInstance.trigger('pageview');
    });
}


// EXTERNAL MODULE: ./node_modules/superagent/lib/client.js
var client = __webpack_require__("GG98");
var client_default = /*#__PURE__*/__webpack_require__.n(client);

// CONCATENATED MODULE: ./src/universal/middleware/postName.js



// responds to POST_NAME action
function postName(store, action) {
    /**
     * An example POST. The important thing here is the inclusion of the CSRF
     * token, or crumb. We are using the hapi library 'crumb' on the server to
     * enable this workflow. The POST will fail if the crumb is not included.
     *
     * Ideally, you'd create a generic api utility module that wraps superagent
     * and adds the crumb to all POSTs.
     */

    // Make api call and then dispatch once response comes back
    client_default.a.post('/temp/api/name').send({
        name: action.payload.name,
        crumb: window.ha.crumb // Important to send CSRF token with request
    }).end(function (error, response) {
        if (error) {
            store.dispatch(actions.postNameError());
        } else {
            store.dispatch(actions.postNameSuccess(response));
        }
    });
}

/* harmony default export */ var middleware_postName = (postName);
// CONCATENATED MODULE: ./src/universal/middleware/all.js





/**
 * The middleware directory holds functions that are meant to be called
 * when certain redux actions are dispatched. This is a pattern for consolidating
 * business logic and simplifying side effects handling, such as async api calls.
 *
 * It is a simpler alternative to redux-sagas, but accomplishes the same thing.
 * This is a cleaner pattern than redux-thunk or redux-promises.
 *
 * There is one true redux middleware, called the middlewareAdapter that allows us to
 * register middleware functions that hold our business logic. Each function is paired with
 * one action. When that action is dispatched, the function is called. The registrations
 * below are pairing up action-to-function.
 *
 * The functions, themselves, are passed the store and the action. They can dispatch
 * additional actions, as needed.
 *
 * Example:
 *  function doFetchData(store, action) {
 *      request('/api/getData').then((resp) => {
 *          store.dispatch(fetchSuccess(resp));
 *      });
 *  }
 *
 * registerMiddleware(FETCH_DATA, doFetchData);
 *
 * Once the above is setup, a component could dispatch the FETCH_DATA action creator,
 * our doFetchData function would therefore be called and when it succeeded in fetching
 * the data, dispatches the fetchSuccess action creator with the payload, presumably to
 * populate a reducer. More details here:
 * https://github.homeawaycorp.com/Catalyst/node-redux-middleware-adapter
 */

/* istanbul ignore next */
function registerAllMiddleware() {
  // List out all middleware functions and the action that they respond to
  Object(lib["registerMiddleware"])(actions.TRIGGER_EDAP_PAGEVIEW, triggerEdapPageView);
  Object(lib["registerMiddleware"])(actions.TRIGGER_EDAP_EVENT, triggerEdapEvent);
  Object(lib["registerMiddleware"])(actions.POST_NAME, middleware_postName);
}

/* harmony default export */ var middleware_all = (registerAllMiddleware);
// CONCATENATED MODULE: ./src/universal/store.js





/**
 * Initialize the redux store.
 *   - connects middleware and reducers
 *   - configures the chrome extension for redux
 */

/* istanbul ignore next */
function createStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // Each middleware function is registered with the middlewareAdapter and
    // is assigned an action to respond to. See './middleware/all'
    middleware_all();

    var composeEnhancers = es["compose"];

    // Setup redux devtools chrome extension, if available and correct env
    // if (typeof window !== 'undefined' && initialState.system.environment === 'development') {
    //     composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    // }

    var createStoreWithMiddleware = composeEnhancers(Object(es["applyMiddleware"])(lib["middlewareAdapter"]))(es["createStore"]);

    return createStoreWithMiddleware(reducers_all, initialState);
}


// EXTERNAL MODULE: ./node_modules/react-hot-loader/lib/AppContainer.js
var lib_AppContainer = __webpack_require__("lx7a");
var AppContainer_default = /*#__PURE__*/__webpack_require__.n(lib_AppContainer);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var react_redux_es = __webpack_require__("RH2O");

// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__("Trj0");
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/history/node_modules/warning/browser.js
var browser = __webpack_require__("rnpr");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var invariant_browser = __webpack_require__("crWv");
var invariant_browser_default = /*#__PURE__*/__webpack_require__.n(invariant_browser);

// CONCATENATED MODULE: ./node_modules/resolve-pathname/index.js
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ var resolve_pathname = (resolvePathname);
// CONCATENATED MODULE: ./node_modules/value-equal/index.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ var value_equal = (valueEqual);
// CONCATENATED MODULE: ./node_modules/history/es/PathUtils.js
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};
// CONCATENATED MODULE: ./node_modules/history/es/LocationUtils.js
var LocationUtils__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var LocationUtils_createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = LocationUtils__extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = resolve_pathname(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var LocationUtils_locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && value_equal(a.state, b.state);
};
// CONCATENATED MODULE: ./node_modules/history/es/createTransitionManager.js


var createTransitionManager_createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    browser_default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          browser_default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ var es_createTransitionManager = (createTransitionManager_createTransitionManager);
// CONCATENATED MODULE: ./node_modules/history/es/DOMUtils.js
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};
// CONCATENATED MODULE: ./node_modules/history/es/createBrowserHistory.js
var createBrowserHistory__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var createBrowserHistory__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory_createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  invariant_browser_default()(canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    browser_default()(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = stripBasename(path, basename);

    return LocationUtils_createLocation(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = es_createTransitionManager();

  var setState = function setState(nextState) {
    createBrowserHistory__extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + createPath(location);
  };

  var push = function push(path, state) {
    browser_default()(!((typeof path === 'undefined' ? 'undefined' : createBrowserHistory__typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = LocationUtils_createLocation(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        browser_default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    browser_default()(!((typeof path === 'undefined' ? 'undefined' : createBrowserHistory__typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = LocationUtils_createLocation(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        browser_default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      addEventListener(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) addEventListener(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      removeEventListener(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) removeEventListener(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ var es_createBrowserHistory = (createBrowserHistory_createBrowserHistory);
// CONCATENATED MODULE: ./node_modules/history/es/createHashHistory.js
var createHashHistory__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var createHashHistory_HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory_createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  invariant_browser_default()(canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    browser_default()(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = stripBasename(path, basename);

    return LocationUtils_createLocation(path);
  };

  var transitionManager = es_createTransitionManager();

  var setState = function setState(nextState) {
    createHashHistory__extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && LocationUtils_locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  };

  var push = function push(path, state) {
    browser_default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = LocationUtils_createLocation(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        browser_default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    browser_default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = LocationUtils_createLocation(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    browser_default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      addEventListener(window, createHashHistory_HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      removeEventListener(window, createHashHistory_HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ var es_createHashHistory = (createHashHistory_createHashHistory);
// CONCATENATED MODULE: ./node_modules/history/es/createMemoryHistory.js
var createMemoryHistory__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var createMemoryHistory__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory_createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = es_createTransitionManager();

  var setState = function setState(nextState) {
    createMemoryHistory__extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? LocationUtils_createLocation(entry, undefined, createKey()) : LocationUtils_createLocation(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = createPath;

  var push = function push(path, state) {
    browser_default()(!((typeof path === 'undefined' ? 'undefined' : createMemoryHistory__typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = LocationUtils_createLocation(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    browser_default()(!((typeof path === 'undefined' ? 'undefined' : createMemoryHistory__typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = LocationUtils_createLocation(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ var es_createMemoryHistory = (createMemoryHistory_createMemoryHistory);
// CONCATENATED MODULE: ./node_modules/history/es/index.js









// CONCATENATED MODULE: ./node_modules/react-router/es/Router.js
var Router__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router_Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: Router__extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    invariant_browser_default()(children == null || react_default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    warning_default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? react_default.a.Children.only(children) : null;
  };

  return Router;
}(react_default.a.Component);

Router_Router.propTypes = {
  history: prop_types_default.a.object.isRequired,
  children: prop_types_default.a.node
};
Router_Router.contextTypes = {
  router: prop_types_default.a.object
};
Router_Router.childContextTypes = {
  router: prop_types_default.a.object.isRequired
};


/* harmony default export */ var es_Router = (Router_Router);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Router.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Router = (es_Router);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/BrowserRouter.js
function BrowserRouter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BrowserRouter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BrowserRouter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter_BrowserRouter = function (_React$Component) {
  BrowserRouter__inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    BrowserRouter__classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = BrowserRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = es_createBrowserHistory(_this.props), _temp), BrowserRouter__possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return react_default.a.createElement(react_router_dom_es_Router, { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(react_default.a.Component);

BrowserRouter_BrowserRouter.propTypes = {
  basename: prop_types_default.a.string,
  forceRefresh: prop_types_default.a.bool,
  getUserConfirmation: prop_types_default.a.func,
  keyLength: prop_types_default.a.number,
  children: prop_types_default.a.node
};


/* harmony default export */ var es_BrowserRouter = (BrowserRouter_BrowserRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/HashRouter.js
function HashRouter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HashRouter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HashRouter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter_HashRouter = function (_React$Component) {
  HashRouter__inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    HashRouter__classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HashRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = es_createHashHistory(_this.props), _temp), HashRouter__possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return react_default.a.createElement(react_router_dom_es_Router, { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(react_default.a.Component);

HashRouter_HashRouter.propTypes = {
  basename: prop_types_default.a.string,
  getUserConfirmation: prop_types_default.a.func,
  hashType: prop_types_default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: prop_types_default.a.node
};


/* harmony default export */ var es_HashRouter = (HashRouter_HashRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Link.js
var Link__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Link__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Link__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Link__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link_Link = function (_React$Component) {
  Link__inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    Link__classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Link__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), Link__possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    invariant_browser_default()(this.context.router, "You should not use <Link> outside a <Router>");

    invariant_browser_default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? LocationUtils_createLocation(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return react_default.a.createElement("a", Link__extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(react_default.a.Component);

Link_Link.propTypes = {
  onClick: prop_types_default.a.func,
  target: prop_types_default.a.string,
  replace: prop_types_default.a.bool,
  to: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]).isRequired,
  innerRef: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.func])
};
Link_Link.defaultProps = {
  replace: false
};
Link_Link.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      push: prop_types_default.a.func.isRequired,
      replace: prop_types_default.a.func.isRequired,
      createHref: prop_types_default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ var es_Link = (Link_Link);
// CONCATENATED MODULE: ./node_modules/react-router/es/MemoryRouter.js
function MemoryRouter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MemoryRouter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MemoryRouter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter_MemoryRouter = function (_React$Component) {
  MemoryRouter__inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    MemoryRouter__classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = MemoryRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = es_createMemoryHistory(_this.props), _temp), MemoryRouter__possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return react_default.a.createElement(es_Router, { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(react_default.a.Component);

MemoryRouter_MemoryRouter.propTypes = {
  initialEntries: prop_types_default.a.array,
  initialIndex: prop_types_default.a.number,
  getUserConfirmation: prop_types_default.a.func,
  keyLength: prop_types_default.a.number,
  children: prop_types_default.a.node
};


/* harmony default export */ var es_MemoryRouter = (MemoryRouter_MemoryRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/MemoryRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_MemoryRouter = (es_MemoryRouter);
// EXTERNAL MODULE: ./node_modules/path-to-regexp/index.js
var path_to_regexp = __webpack_require__("Ygqm");
var path_to_regexp_default = /*#__PURE__*/__webpack_require__.n(path_to_regexp);

// CONCATENATED MODULE: ./node_modules/react-router/es/matchPath.js


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var matchPath_compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = path_to_regexp_default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = matchPath_compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ var es_matchPath = (matchPath);
// CONCATENATED MODULE: ./node_modules/react-router/es/Route.js
var Route__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Route__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Route__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Route__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Route_isEmptyChildren = function isEmptyChildren(children) {
  return react_default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route_Route = function (_React$Component) {
  Route__inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    Route__classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Route__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), Route__possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: Route__extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    invariant_browser_default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return es_matchPath(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    warning_default()(!(this.props.component && this.props.children && !Route_isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    warning_default()(!(this.props.render && this.props.children && !Route_isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    warning_default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    warning_default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? react_default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !Route_isEmptyChildren(children)) return react_default.a.Children.only(children);

    return null;
  };

  return Route;
}(react_default.a.Component);

Route_Route.propTypes = {
  computedMatch: prop_types_default.a.object, // private, from <Switch>
  path: prop_types_default.a.string,
  exact: prop_types_default.a.bool,
  strict: prop_types_default.a.bool,
  sensitive: prop_types_default.a.bool,
  component: prop_types_default.a.func,
  render: prop_types_default.a.func,
  children: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.node]),
  location: prop_types_default.a.object
};
Route_Route.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.object.isRequired,
    route: prop_types_default.a.object.isRequired,
    staticContext: prop_types_default.a.object
  })
};
Route_Route.childContextTypes = {
  router: prop_types_default.a.object.isRequired
};


/* harmony default export */ var es_Route = (Route_Route);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Route.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Route = (es_Route);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/NavLink.js
var NavLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var NavLink__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function NavLink__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink_NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = NavLink__objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : NavLink__typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return react_default.a.createElement(react_router_dom_es_Route, {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return react_default.a.createElement(es_Link, NavLink__extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? NavLink__extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink_NavLink.propTypes = {
  to: es_Link.propTypes.to,
  exact: prop_types_default.a.bool,
  strict: prop_types_default.a.bool,
  location: prop_types_default.a.object,
  activeClassName: prop_types_default.a.string,
  className: prop_types_default.a.string,
  activeStyle: prop_types_default.a.object,
  style: prop_types_default.a.object,
  isActive: prop_types_default.a.func,
  "aria-current": prop_types_default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink_NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ var es_NavLink = (NavLink_NavLink);
// CONCATENATED MODULE: ./node_modules/react-router/es/Prompt.js
function Prompt__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Prompt__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Prompt__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt_Prompt = function (_React$Component) {
  Prompt__inherits(Prompt, _React$Component);

  function Prompt() {
    Prompt__classCallCheck(this, Prompt);

    return Prompt__possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    invariant_browser_default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(react_default.a.Component);

Prompt_Prompt.propTypes = {
  when: prop_types_default.a.bool,
  message: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.string]).isRequired
};
Prompt_Prompt.defaultProps = {
  when: true
};
Prompt_Prompt.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      block: prop_types_default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ var es_Prompt = (Prompt_Prompt);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Prompt.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Prompt = (es_Prompt);
// CONCATENATED MODULE: ./node_modules/react-router/es/generatePath.js


var generatePath_patternCache = {};
var generatePath_cacheLimit = 10000;
var generatePath_cacheCount = 0;

var generatePath_compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = generatePath_patternCache[cacheKey] || (generatePath_patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = path_to_regexp_default.a.compile(pattern);

  if (generatePath_cacheCount < generatePath_cacheLimit) {
    cache[pattern] = compiledGenerator;
    generatePath_cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = generatePath_compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ var es_generatePath = (generatePath);
// CONCATENATED MODULE: ./node_modules/react-router/es/Redirect.js
var Redirect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Redirect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Redirect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Redirect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect_Redirect = function (_React$Component) {
  Redirect__inherits(Redirect, _React$Component);

  function Redirect() {
    Redirect__classCallCheck(this, Redirect);

    return Redirect__possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    invariant_browser_default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = LocationUtils_createLocation(prevProps.to);
    var nextTo = LocationUtils_createLocation(this.props.to);

    if (LocationUtils_locationsAreEqual(prevTo, nextTo)) {
      warning_default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return es_generatePath(to, computedMatch.params);
      } else {
        return Redirect__extends({}, to, {
          pathname: es_generatePath(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(react_default.a.Component);

Redirect_Redirect.propTypes = {
  computedMatch: prop_types_default.a.object, // private, from <Switch>
  push: prop_types_default.a.bool,
  from: prop_types_default.a.string,
  to: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]).isRequired
};
Redirect_Redirect.defaultProps = {
  push: false
};
Redirect_Redirect.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      push: prop_types_default.a.func.isRequired,
      replace: prop_types_default.a.func.isRequired
    }).isRequired,
    staticContext: prop_types_default.a.object
  }).isRequired
};


/* harmony default export */ var es_Redirect = (Redirect_Redirect);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Redirect.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Redirect = (es_Redirect);
// CONCATENATED MODULE: ./node_modules/react-router/es/StaticRouter.js
var StaticRouter__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function StaticRouter__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function StaticRouter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StaticRouter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function StaticRouter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var StaticRouter_addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return StaticRouter__extends({}, location, {
    pathname: StaticRouter_addLeadingSlash(basename) + location.pathname
  });
};

var StaticRouter_stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = StaticRouter_addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return StaticRouter__extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var StaticRouter_createURL = function createURL(location) {
  return typeof location === "string" ? location : createPath(location);
};

var StaticRouter_staticHandler = function staticHandler(methodName) {
  return function () {
    invariant_browser_default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter_StaticRouter = function (_React$Component) {
  StaticRouter__inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    StaticRouter__classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = StaticRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return StaticRouter_addLeadingSlash(_this.props.basename + StaticRouter_createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, LocationUtils_createLocation(location));
      context.url = StaticRouter_createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, LocationUtils_createLocation(location));
      context.url = StaticRouter_createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), StaticRouter__possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = StaticRouter__objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: StaticRouter_stripBasename(basename, LocationUtils_createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: StaticRouter_staticHandler("go"),
      goBack: StaticRouter_staticHandler("goBack"),
      goForward: StaticRouter_staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return react_default.a.createElement(es_Router, StaticRouter__extends({}, props, { history: history }));
  };

  return StaticRouter;
}(react_default.a.Component);

StaticRouter_StaticRouter.propTypes = {
  basename: prop_types_default.a.string,
  context: prop_types_default.a.object.isRequired,
  location: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object])
};
StaticRouter_StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter_StaticRouter.childContextTypes = {
  router: prop_types_default.a.object.isRequired
};


/* harmony default export */ var es_StaticRouter = (StaticRouter_StaticRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/StaticRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_StaticRouter = (es_StaticRouter);
// CONCATENATED MODULE: ./node_modules/react-router/es/Switch.js
function Switch__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Switch__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Switch__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch_Switch = function (_React$Component) {
  Switch__inherits(Switch, _React$Component);

  function Switch() {
    Switch__classCallCheck(this, Switch);

    return Switch__possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    invariant_browser_default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    warning_default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    warning_default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    react_default.a.Children.forEach(children, function (element) {
      if (match == null && react_default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = es_matchPath(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? react_default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(react_default.a.Component);

Switch_Switch.contextTypes = {
  router: prop_types_default.a.shape({
    route: prop_types_default.a.object.isRequired
  }).isRequired
};
Switch_Switch.propTypes = {
  children: prop_types_default.a.node,
  location: prop_types_default.a.object
};


/* harmony default export */ var es_Switch = (Switch_Switch);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Switch.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Switch = (es_Switch);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/generatePath.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_generatePath = (es_generatePath);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/matchPath.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_matchPath = (es_matchPath);
// EXTERNAL MODULE: ./node_modules/react-router/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__("4/3X");
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// CONCATENATED MODULE: ./node_modules/react-router/es/withRouter.js
var withRouter__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function withRouter__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter_withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = withRouter__objectWithoutProperties(props, ["wrappedComponentRef"]);

    return react_default.a.createElement(es_Route, {
      children: function children(routeComponentProps) {
        return react_default.a.createElement(Component, withRouter__extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: prop_types_default.a.func
  };

  return hoist_non_react_statics_cjs_default()(C, Component);
};

/* harmony default export */ var es_withRouter = (withRouter_withRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/withRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_withRouter = (es_withRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/index.js




























// CONCATENATED MODULE: ./src/universal/actions/action_session.js
/* eslint-disable no-console */
function setSession(session) {
    console.log('setSession:', session);
    return {
        type: 'SET_SESSION',
        payload: session
    };
}
// EXTERNAL MODULE: ./src/universal/components/SessionDetails/SessionDetails.less
var SessionDetails_SessionDetails = __webpack_require__("juNs");
var SessionDetails_default = /*#__PURE__*/__webpack_require__.n(SessionDetails_SessionDetails);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-form-components/lib/esm/index.js + 7 modules
var esm = __webpack_require__("hyOf");

// CONCATENATED MODULE: ./src/universal/components/SessionDetails/SessionDetails.js
function SessionDetails__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SessionDetails__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SessionDetails__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/jsx-no-bind */




var SessionDetails_SessionDetails_SessionDetails = function (_Component) {
    SessionDetails__inherits(SessionDetails, _Component);

    function SessionDetails(props) {
        SessionDetails__classCallCheck(this, SessionDetails);

        var _this = SessionDetails__possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            sessionId: ''
        };
        return _this;
    }

    SessionDetails.prototype.render = function render() {
        var userInfo = react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
                'h1',
                null,
                ' ',
                'Details of your current session',
                ' '
            ),
            react_default.a.createElement(
                'form',
                { role: 'form' },
                react_default.a.createElement(esm["FormInput"], {
                    name: 'principalUUID',
                    label: 'You are impersonator with UUID:',
                    value: this.props.session.principalUuid,
                    readOnly: true
                }),
                react_default.a.createElement(esm["FormInput"], {
                    name: 'subjectUUID',
                    label: 'You are impersonating subject UUID:',
                    value: this.props.session.subjectUuid,
                    readOnly: true
                })
            )
        );
        return userInfo;
    };

    return SessionDetails;
}(react["Component"]);

/* harmony default export */ var components_SessionDetails_SessionDetails = (SessionDetails_SessionDetails_SessionDetails);
// CONCATENATED MODULE: ./src/universal/components/SessionCheckContainer/SessionCheckContainer.js
var _dec, _class;

function SessionCheckContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SessionCheckContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SessionCheckContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-unused-vars */






function mapStateToProps(state) {
    // Each container component will likely only pull in the state that
    // it cares about. Doing so will eliminate unnecessary rerenders.
    return { session: state.session };
}

function mapDispatchToProps(dispatch) {
    return Object(es["bindActionCreators"])({ setSession: setSession }, dispatch);
}

var SessionCheckContainer_SessionCheckContainer = (_dec = Object(react_redux_es["connect"])(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
    SessionCheckContainer__inherits(SessionCheckContainer, _Component);

    function SessionCheckContainer() {
        SessionCheckContainer__classCallCheck(this, SessionCheckContainer);

        return SessionCheckContainer__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SessionCheckContainer.prototype.render = function render() {
        if (this.props.session && this.props.session.isImpersonating === true) {
            return react_default.a.createElement(components_SessionDetails_SessionDetails, this.props);
        }
        return react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
                'h1',
                null,
                ' ',
                'Session found but not impersonating',
                ' '
            )
        );
    };

    return SessionCheckContainer;
}(react["Component"])) || _class);


/* harmony default export */ var components_SessionCheckContainer_SessionCheckContainer = (SessionCheckContainer_SessionCheckContainer);
// CONCATENATED MODULE: ./src/universal/actions/action_site.js
/* eslint-disable no-console */
function setSite(site) {
    console.log('setSite:', site);
    return {
        type: 'SET_SITE',
        payload: site
    };
}
// EXTERNAL MODULE: ./src/universal/components/BirdhouseContainer/BirdhouseContainer.less
var BirdhouseContainer_BirdhouseContainer = __webpack_require__("UVdu");
var BirdhouseContainer_default = /*#__PURE__*/__webpack_require__.n(BirdhouseContainer_BirdhouseContainer);

// EXTERNAL MODULE: ./node_modules/@homeaway/react-lex/lib/transpiled/index.js
var transpiled = __webpack_require__("rMWW");
var transpiled_default = /*#__PURE__*/__webpack_require__.n(transpiled);

// EXTERNAL MODULE: ./node_modules/@homeaway/abacus-client-utils/lib/transpiled/index.js
var lib_transpiled = __webpack_require__("k4AA");
var lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(lib_transpiled);

// CONCATENATED MODULE: ./src/universal/components/BirdhouseComponent/BirdhouseComponent.js
function BirdhouseComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BirdhouseComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BirdhouseComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var BirdhouseComponent_BirdhouseComponent = function (_Component) {
    BirdhouseComponent__inherits(BirdhouseComponent, _Component);

    function BirdhouseComponent(props) {
        BirdhouseComponent__classCallCheck(this, BirdhouseComponent);

        var _this = BirdhouseComponent__possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            serviceUrl: _this.props.serviceUrl
        };
        _this.componentDidMount = _this.componentDidMount.bind(_this);
        _this.redirectPostLogin = _this.redirectPostLogin.bind(_this);
        return _this;
    }

    BirdhouseComponent.prototype.componentDidMount = function componentDidMount() {};

    BirdhouseComponent.prototype.redirectPostLogin = function redirectPostLogin() {
        if (typeof window !== 'undefined') {
            var url = void 0;
            if (this.props.landingPage === 'success') {
                url = this.state.serviceUrl;
            } else {
                url = '/auth/traveler/login?service=' + encodeURIComponent(this.state.serviceUrl) + (this.props.ticket === '' ? '&authui=false' : '');
            }
            window.location.href = url;
        }
    };

    BirdhouseComponent.prototype.render = function render() {
        lib_transpiled_default.a.initialize(this.props.experiments);
        var myExperiment = lib_transpiled_default.a.evaluateExperimentAndLog('HA_IDA_V3_LOGIN_TEST');
        var useNewEndpoints = false;
        if (myExperiment && myExperiment.value === 1) {
            useNewEndpoints = true;
        }
        var expediaExperiment = lib_transpiled_default.a.evaluateExperimentAndLog('HA_IDA_EXPEDIA_ICON_TEST');
        var expediaIconDisplayed = false;
        if (expediaExperiment && expediaExperiment.value === 1) {
            expediaIconDisplayed = true;
        }
        // Check to see if we are being server side rendered
        var service = typeof window !== 'undefined' ? window.location.href : '';
        return react_default.a.createElement(
            'div',
            { className: 'BirdhouseComponent' },
            react_default.a.createElement(transpiled_default.a, {
                service: service,
                locale: this.props.site.locale,
                site: this.props.site.siteName,
                siteName: this.props.site.siteReadableName,
                handleLoginSuccess: this.redirectPostLogin,
                useNewEndpoints: useNewEndpoints,
                expediaIconDisplayed: expediaIconDisplayed,
                serverConfigRendering: true,
                ticketId: this.props.ticket,
                landingPage: this.props.landingPage
            })
        );
    };

    return BirdhouseComponent;
}(react["Component"]);

/* harmony default export */ var components_BirdhouseComponent_BirdhouseComponent = (BirdhouseComponent_BirdhouseComponent);
// EXTERNAL MODULE: ./node_modules/@homeaway/react-site-header/lib/transpiled/index.js
var react_site_header_lib_transpiled = __webpack_require__("qGti");
var react_site_header_lib_transpiled_default = /*#__PURE__*/__webpack_require__.n(react_site_header_lib_transpiled);

// CONCATENATED MODULE: ./src/universal/components/BirdhouseContainer/BirdhouseContainer.js
var BirdhouseContainer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var BirdhouseContainer__dec, BirdhouseContainer__class;

function BirdhouseContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BirdhouseContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BirdhouseContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function BirdhouseContainer_mapStateToProps(state) {
    // Each container component will likely only pull in the state that
    // it cares about. Doing so will eliminate unnecessary rerenders.
    return {
        site: state.site,
        serviceUrl: state.serviceUrl,
        experiments: state.experiments,
        ticket: state.ticket,
        landingPage: state.landingPage
    };
}

function BirdhouseContainer_mapDispatchToProps(dispatch) {
    return Object(es["bindActionCreators"])({ setSite: setSite, triggerEdapEvent: actions.triggerEdapEvent }, dispatch);
}

var BirdhouseContainer_BirdhouseContainer_BirdhouseContainer = (BirdhouseContainer__dec = Object(react_redux_es["connect"])(BirdhouseContainer_mapStateToProps, BirdhouseContainer_mapDispatchToProps), BirdhouseContainer__dec(BirdhouseContainer__class = function (_Component) {
    BirdhouseContainer__inherits(BirdhouseContainer, _Component);

    function BirdhouseContainer() {
        BirdhouseContainer__classCallCheck(this, BirdhouseContainer);

        return BirdhouseContainer__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    BirdhouseContainer.prototype.componentDidMount = function componentDidMount() {
        window.ha.userTiming.mark('primary.action.rendered');
    };

    BirdhouseContainer.prototype.render = function render() {
        var siteHeaderProps = {
            dataUrl: '/traveler/api/header',
            siteName: this.props.site.siteName
        };

        return react_default.a.createElement(
            'div',
            { className: 'center-block text-center BirdhouseContainer' },
            react_default.a.createElement(react_site_header_lib_transpiled_default.a, BirdhouseContainer__extends({}, siteHeaderProps, { withoutTray: true, withoutNav: true, withoutListYourProperty: true })),
            react_default.a.createElement(components_BirdhouseComponent_BirdhouseComponent, { site: this.props.site,
                serviceUrl: this.props.serviceUrl,
                triggerEdapEvent: this.props.triggerEdapEvent,
                experiments: this.props.experiments,
                ticket: this.props.ticket,
                landingPage: this.props.landingPage
            })
        );
    };

    return BirdhouseContainer;
}(react["Component"])) || BirdhouseContainer__class);


/* harmony default export */ var components_BirdhouseContainer_BirdhouseContainer = (BirdhouseContainer_BirdhouseContainer_BirdhouseContainer);
// CONCATENATED MODULE: ./src/universal/Root.js






/**
 * Basic provider wrapping. This has been externalized in order to
 * enable hot module replacement features.
 */

/* istanbul ignore next */
function Root(_ref) {
    var store = _ref.store;

    return react_default.a.createElement(
        react_redux_es["Provider"],
        { store: store },
        react_default.a.createElement(
            es_BrowserRouter,
            null,
            react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(react_router_dom_es_Route, { path: '/auth/ui/sessionCheck', component: components_SessionCheckContainer_SessionCheckContainer }),
                react_default.a.createElement(react_router_dom_es_Route, { path: '/auth/ui/login', component: components_BirdhouseContainer_BirdhouseContainer }),
                react_default.a.createElement(react_router_dom_es_Route, { path: '/auth/ui/resetPassword', component: components_BirdhouseContainer_BirdhouseContainer }),
                react_default.a.createElement(react_router_dom_es_Route, { path: '/auth/ui/confirmEmail', component: components_BirdhouseContainer_BirdhouseContainer })
            )
        )
    );
}

/* harmony default export */ var universal_Root = (Root);
// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var fetch = __webpack_require__("rplX");
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);

// CONCATENATED MODULE: ./src/universal/index.js






// Polyfills


/**
 * Main client-side entry point. This is not used during
 * server-side rendering, only after the javascript bundle
 * has been loaded into the browser.
 */

// Initial state as set by the server-side render
var universal_initialState = window.__INITIAL_STATE__;

var universal_store = createStore(universal_initialState);

react_dom_default.a.render(react_default.a.createElement(
    AppContainer_default.a,
    { store: universal_store },
    react_default.a.createElement(universal_Root, { store: universal_store })
), document.getElementById('root'));

// Hot module replacement in development env only
if (false) {
    module.hot.accept('./Root', function () {
        var RootRequired = require('./Root').default;
        ReactDOM.unmountComponentAtNode(document.getElementById('root'));
        ReactDOM.hydrate(React.createElement(
            AppContainer,
            { store: universal_store },
            React.createElement(RootRequired, { store: universal_store })
        ), document.getElementById('root'));
        console.log('[HMR] Rendered at ' + new Date().toLocaleTimeString()); // eslint-disable-line
    });
}

/***/ }),

/***/ "zYMv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Traveler = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var React = _interopRequireWildcard(_react);

var _reactDropdown = __webpack_require__("CVj+");

var _reactSvg = __webpack_require__("CWk1");

var _CHEVRON_DOWN__ = __webpack_require__("kTPm");

var _travelerSvgs = __webpack_require__("dlC0");

var _travelerSvgs2 = _interopRequireDefault(_travelerSvgs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var travelerRE = /service=(\w+\%3A\%2F\%2F[\.\w]+).*/;

var Traveler = exports.Traveler = function (_React$Component) {
    _inherits(Traveler, _React$Component);

    function Traveler() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Traveler);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Traveler.__proto__ || Object.getPrototypeOf(Traveler)).call.apply(_ref, [this].concat(args))), _this), _this.createClickHandler = function (item) {
            return function (event) {
                if (!item.link) {
                    return false;
                }

                // skip sub URL logic as link has already been manually updated
                if (item.linkUpdated) {
                    return true;
                }

                // CAS Logout URLs need to be single enocded because of how their params are structured:
                // https://{DOMAIN}/haod/auth/signout.html?service={SINGLE_ENCODED_RETURN_URL}
                var singleEncodedURI = encodeURIComponent(window.location.pathname + window.location.search);

                // if traveler logged in, perform specific link update
                var newLink = item.link.replace(travelerRE, 'service=$1' + singleEncodedURI);

                // if we generate a new link, user has navigated to a sub URL in the same application
                // and we should redirect them there.  Otherwise let default user-agent behavior handle
                // rendered link
                if (newLink !== item.link) {
                    event.stopPropagation();
                    event.preventDefault();
                    window.location.assign(newLink);
                }

                return true;
            };
        }, _this.renderItem = function (item, index) {
            if (item.cssClass === 'divider') {
                return React.createElement(_reactDropdown.DropdownItem, { className: 'divider', key: index });
            }

            return React.createElement(_reactDropdown.DropdownItem, {
                dataBypass: true,
                key: index,
                link: item.link,
                onClick: _this.createClickHandler(item),
                svgMarkup: _travelerSvgs2.default[item.icon],
                text: item.text
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Traveler, [{
        key: 'render',
        value: function render() {
            if (!this.props.items) {
                return null;
            }

            var id = 'site-header__traveler';

            var toggle = React.createElement(
                'button',
                {
                    'aria-expanded': 'false',
                    'aria-haspopup': 'true',
                    className: 'site-header-nav__toggle Dropdown__toggle',
                    id: id
                },
                React.createElement('img', {
                    alt: 'avatar',
                    'aria-hidden': 'true',
                    className: 'site-header-nav__avatar img-circle',
                    src: this.props.avatar.image
                }),
                React.createElement(
                    'span',
                    { className: 'site-header-nav__icon-label' },
                    this.props.label
                ),
                React.createElement(_reactSvg.SVGIcon, { className: 'Dropdown__toggle-icon', inlineFlex: true, markup: _CHEVRON_DOWN__.CHEVRON_DOWN__16 })
            );

            return React.createElement(
                _reactDropdown.Dropdown,
                {
                    className: 'site-header-nav__dropdown',
                    customToggle: toggle,
                    dropdownRight: true,
                    id: id,
                    label: this.props.label
                },
                this.props.items.map(this.renderItem)
            );
        }
    }]);

    return Traveler;
}(React.Component);
//# sourceMappingURL=Traveler.js.map

/***/ })

},["zW/i"]);


// WEBPACK FOOTER //
// bundle.4d010db11985cc5508cc.js